export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Email: { input: any; output: any; }
  StringInput: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum AceFormCompanyType {
  Both = 'Both',
  Commercial = 'Commercial',
  Residential = 'Residential'
}

export type AceFormInput = {
  AttendanceDate: Scalars['String']['input'];
  AttendeeRole: Scalars['String']['input'];
  CompanyIndustry: Scalars['String']['input'];
  CompanyMainProductCategory?: InputMaybe<Scalars['String']['input']>;
  CompanyName: Scalars['String']['input'];
  CompanySize: Scalars['String']['input'];
  CompanySpecialisation?: InputMaybe<Array<Scalars['String']['input']>>;
  CompanyType: AceFormCompanyType;
  CompanyWebsite: Scalars['String']['input'];
  Email: Scalars['Email']['input'];
  FirstName: Scalars['StringInput']['input'];
  LastName: Scalars['StringInput']['input'];
  Phone: Scalars['StringInput']['input'];
  SubmissionType?: InputMaybe<AceFormSubmissionType>;
};

export enum AceFormSubmissionType {
  Exhibitor = 'Exhibitor',
  Professional = 'Professional'
}

export type AiImage = {
  __typename?: 'AIImage';
  fileKey: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum AiTone {
  Formal = 'Formal',
  Humorous = 'Humorous',
  Imaginative = 'Imaginative',
  Informal = 'Informal',
  Persuasive = 'Persuasive',
  Playful = 'Playful'
}

export type ApConversionsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Information about pagination in a connection. */
export type ApPageInfo = {
  __typename?: 'APPageInfo';
  ID: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ArFileData = {
  __typename?: 'ARFileData';
  AndroidFile?: Maybe<Scalars['String']['output']>;
  EnablePan: Scalars['Boolean']['output'];
  EnableShadow: Scalars['Boolean']['output'];
  EnableZoom: Scalars['Boolean']['output'];
  HDRIFile?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  MaxDistance: Scalars['Float']['output'];
  MinDistance: Scalars['Float']['output'];
  TargetY: Scalars['Float']['output'];
  WebFile?: Maybe<Scalars['String']['output']>;
  iOSFile?: Maybe<Scalars['String']['output']>;
};

export type AboutModule_MilestonesConnection = {
  __typename?: 'AboutModule_MilestonesConnection';
  edges: Array<AboutModule_MilestonesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AboutModule_MilestonesConnectionEdge = {
  __typename?: 'AboutModule_MilestonesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Milestone;
};

export type AboutModule_MilestonesSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type AcceptDesignBoardInvite = {
  __typename?: 'AcceptDesignBoardInvite';
  AlreadyAccepted: Scalars['Boolean']['output'];
  DesignBoard?: Maybe<DesignBoard>;
};

export type AcceptEnquiryConversationInvite = {
  __typename?: 'AcceptEnquiryConversationInvite';
  Accepted?: Maybe<Scalars['Boolean']['output']>;
  AlreadyAccepted: Scalars['Boolean']['output'];
  Link: Scalars['String']['output'];
  Professional: Professional;
};

export type Accordion = {
  __typename?: 'Accordion';
  Content?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Summary?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type AccordionModule = ModuleType & {
  __typename?: 'AccordionModule';
  Accordions: Module_AccordionsConnection;
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};


export type AccordionModuleAccordionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Module_AccordionsSortFields>;
};

/** Represents a user's account deletion request with grace period tracking */
export type AccountDeletionRequest = {
  __typename?: 'AccountDeletionRequest';
  /** Number of days remaining in the 30-day grace period */
  DaysRemaining: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  MemberID: Scalars['Int']['output'];
  /** The reason for account deletion (nullable) */
  Reason?: Maybe<AccountDeletionRequestReason>;
  /** Timestamp when the deletion was requested */
  RequestedAt: Scalars['String']['output'];
  /** Timestamp when the account was restored (null if still pending) */
  RestoredAt?: Maybe<Scalars['String']['output']>;
};

/** A predefined reason that users can select when requesting account deletion */
export type AccountDeletionRequestReason = DataObject & {
  __typename?: 'AccountDeletionRequestReason';
  ID: Scalars['Int']['output'];
  /** Human-readable reason label */
  Label: Scalars['String']['output'];
  /** Display order for sorting reasons (lower numbers appear first) */
  SortOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type AccountDeletionRequestResponse = AccountDeletionRequest | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Archipro-internal conversions. */
export type AdConversions = {
  Downloads: Scalars['Int']['output'];
  EmailReveals: Scalars['Int']['output'];
  Enquiries: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  LocationReveals: Scalars['Int']['output'];
  PhoneReveals: Scalars['Int']['output'];
  Referrals: Scalars['Int']['output'];
  Saves: Scalars['Int']['output'];
  Shares: Scalars['Int']['output'];
  TotalPageViews: Scalars['Int']['output'];
  TotalTime: Scalars['Int']['output'];
  VideoPlays: Scalars['Int']['output'];
};

export type AdEngagements = {
  ID: Scalars['String']['output'];
};

/** Locations . */
export type AdLocations = {
  ID: Scalars['String']['output'];
  Locations: Array<LocationData>;
};

export type AdPerformance = {
  EngagementRate?: Maybe<Scalars['Float']['output']>;
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  Reach: Scalars['Int']['output'];
};

/** A CardType string that can be attached to a card. */
export enum AdResultReadyAdType {
  Facebook = 'Facebook',
  FacebookAd = 'FacebookAd',
  Hubspot = 'Hubspot',
  InstagramMedia = 'InstagramMedia'
}

/** The payload for the \"Your ad results are ready\" card. */
export type AdResultsReadyCardPayload = {
  __typename?: 'AdResultsReadyCardPayload';
  /** Identifier of the ad. You should be able to combine this with the the result type to figure out the URL of the report. */
  AdIdentifier: Scalars['String']['output'];
  /** The start time of the ad. */
  AdStartTime?: Maybe<Scalars['String']['output']>;
  /** The title of the ad. */
  AdTitle: Scalars['String']['output'];
  /** The type of ad. */
  AdType: AdResultReadyAdType;
  /** The number of ads in the campaign. */
  CampaignAdCount?: Maybe<Scalars['Int']['output']>;
  /** The UTM title of the campaign. */
  CampaignUTMTitle?: Maybe<Scalars['String']['output']>;
};

export type AddEnquiryConversationMessageInput = {
  /** ID of the conversation you are adding a message to */
  ID: Scalars['ID']['input'];
  Message: FileAttachmentMessageInput;
  /** ID of the professional the member is on */
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the message to reply to or forward. Must be a `TextMessage` or `FileAttachmentMessage`. */
  ReplyToID?: InputMaybe<Scalars['Int']['input']>;
};

export type AddFacetOptionInput = {
  /** ID of the facet to add the option too. */
  FacetOptionID: Scalars['Int']['input'];
  URLSegment: Scalars['StringInput']['input'];
};

export type AddOnCartPackCheckoutPreference = {
  __typename?: 'AddOnCartPackCheckoutPreference';
  /** When Mode is attach_existing, the target SubscriptionPack id; otherwise null */
  ExistingSubscriptionPackID?: Maybe<Scalars['Int']['output']>;
  /** Last selected BM premium checkout pack option (persisted on AddOnCart); defaults to new monthly when unset */
  Mode: SubscriptionPackCheckoutMode;
  /** False on production (Director::isLive): New Daily pack checkout is for team-server testing only; UI should hide the option and server normalises persisted new_daily to new_monthly */
  NewDailyCheckoutOffered: Scalars['Boolean']['output'];
};

/** BM premium-feature catalogue row serialised from {@see \Archipro\Component\AddOn\DTO\AddOnItemDTO}; used for premiumFeatureSlides, premiumFeatureInstallations, and premiumFeatureCart (browse rows omit PurchasedAddOnID and installation StartDate/EndDate). */
export type AddOnItemDto = {
  __typename?: 'AddOnItemDTO';
  /** Catalogue discriminator when set — `per_unit`, `one_off`, `duration`, `fixed_date`; null for legacy recurring pack slides. */
  AddOnKind?: Maybe<Scalars['String']['output']>;
  /** When true, staff may select this SKU in CMS add-on operations. */
  CanBeAdded: Scalars['Boolean']['output'];
  /** When true, the SKU appears in BM browse, cart, and checkout. */
  CanBePurchased: Scalars['Boolean']['output'];
  /** Staged quantity in the BM premium cart for this SKU; null for slides and installations queries. */
  CartQty?: Maybe<Scalars['Int']['output']>;
  Description: Scalars['String']['output'];
  Detail: Scalars['String']['output'];
  /** Installation merged exclusive end (Y-m-d); set for premiumFeatureInstallations rows, null for slides/cart rows. */
  EndDate?: Maybe<Scalars['String']['output']>;
  FeatureType: Scalars['String']['output'];
  /** Max exclusive Y-m-d end over those waive-eligible rows; used with checkout proration so multiple {@see PurchasedAddOn} rows merge correctly. */
  FirstSegmentWaiveExclusiveEndDate?: Maybe<Scalars['String']['output']>;
  /** Min inclusive Y-m-d start over rows eligible for first-segment waived checkout pricing (in entitlement, not on pack); null when none. */
  FirstSegmentWaiveInclusiveStartDate?: Maybe<Scalars['String']['output']>;
  ImageUrl: Scalars['String']['output'];
  /** True when today (client market) falls inside a merged entitlement window for this SKU when not solely subscribed via pack. */
  IsEntitlementActive: Scalars['Boolean']['output'];
  /** When true, this slide may appear on the membership overview carousel (see premiumFeatureSlides; at most 10 highlight rows server-side). */
  IsHighLight: Scalars['Boolean']['output'];
  /** True when this SKU is on SubscriptionPack recurring billing for the client; from merged {@see PurchasedAddOn} context. */
  IsSubscribed: Scalars['Boolean']['output'];
  /** Latest exclusive Y-m-d end among merged premium rows for this SKU when applicable; otherwise null. */
  MergedDisplayEndDate?: Maybe<Scalars['String']['output']>;
  /** Earliest inclusive Y-m-d start among merged premium rows for this SKU when applicable; otherwise null for browse-only rows. */
  MergedDisplayStartDate?: Maybe<Scalars['String']['output']>;
  /** Monthly catalogue price in major currency units (same basis as PricePerMonth). */
  Price: Scalars['Float']['output'];
  /** Major-currency price per calendar day when the catalogue sets a per-day pack rate; null when not applicable. */
  PricePerDay?: Maybe<Scalars['Float']['output']>;
  PricePerMonth: Scalars['Int']['output'];
  /** Major-currency unit price when the slide is `per_unit` or `one_off`; null when not applicable. */
  PricePerQty?: Maybe<Scalars['Float']['output']>;
  /** Canonical installation row id when this row is from premiumFeatureInstallations; null for browse-only premiumFeatureSlides and premiumFeatureCart rows. */
  PurchasedAddOnID?: Maybe<Scalars['Int']['output']>;
  SKU: Scalars['String']['output'];
  /** Installation merged inclusive start (Y-m-d); set for premiumFeatureInstallations rows, null for slides/cart rows. */
  StartDate?: Maybe<Scalars['String']['output']>;
  ThumbnailUrl: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  /** Aggregated active purchased units for `per_unit` installations (sum of Qty); null when not applicable. */
  TotalPurchasedQty?: Maybe<Scalars['Int']['output']>;
  VideoUrl?: Maybe<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  Address1?: Maybe<Scalars['String']['output']>;
  Address2?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Company?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  Default?: Maybe<Scalars['Boolean']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  Phone?: Maybe<Scalars['String']['output']>;
  PostalCode?: Maybe<Scalars['String']['output']>;
  Region?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Suburb?: Maybe<Scalars['String']['output']>;
  Surname?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type AddressDetailResult = {
  __typename?: 'AddressDetailResult';
  Address1?: Maybe<Scalars['String']['output']>;
  Address2?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  Postcode?: Maybe<Scalars['String']['output']>;
  Region?: Maybe<Scalars['String']['output']>;
  Suburb?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  Address1?: InputMaybe<Scalars['StringInput']['input']>;
  Address2?: InputMaybe<Scalars['StringInput']['input']>;
  City?: InputMaybe<Scalars['StringInput']['input']>;
  Company?: InputMaybe<Scalars['StringInput']['input']>;
  Country?: InputMaybe<Scalars['StringInput']['input']>;
  Default?: InputMaybe<Scalars['Boolean']['input']>;
  FirstName: Scalars['StringInput']['input'];
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  PostalCode?: InputMaybe<Scalars['StringInput']['input']>;
  State?: InputMaybe<Scalars['StringInput']['input']>;
  Suburb?: InputMaybe<Scalars['StringInput']['input']>;
  Surname: Scalars['StringInput']['input'];
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};

export type AddressResult = {
  __typename?: 'AddressResult';
  Address?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
};

export enum AddressTypeEnum {
  BillingAddress = 'BILLING_ADDRESS',
  DeliveryAddress = 'DELIVERY_ADDRESS'
}

export type AdvertisingEnquireModule = ModuleType & {
  __typename?: 'AdvertisingEnquireModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  IntroText?: Maybe<Scalars['String']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type AdvertisingFormInput = {
  CompanyName: Scalars['StringInput']['input'];
  CompanyWebsite: Scalars['StringInput']['input'];
  Email: Scalars['StringInput']['input'];
  FirstName: Scalars['StringInput']['input'];
  Phone: Scalars['StringInput']['input'];
};

export type AirtableAdSchedule = {
  __typename?: 'AirtableAdSchedule';
  ApproveURL?: Maybe<Scalars['String']['output']>;
  ContentDue?: Maybe<Scalars['String']['output']>;
  FormURLOrPlacementStatus?: Maybe<Scalars['String']['output']>;
  LiveDate: Scalars['String']['output'];
  PlacementDetails: Scalars['String']['output'];
  PlacementNotes?: Maybe<Scalars['String']['output']>;
  Proofs: Array<Proof>;
  RecordURL: Scalars['String']['output'];
  RequestChangesURL?: Maybe<Scalars['String']['output']>;
  ShowProofs?: Maybe<Scalars['Int']['output']>;
  Type: Scalars['String']['output'];
};

export type AirtableAdScheduleModel = {
  __typename?: 'AirtableAdScheduleModel';
  Future: Array<AirtableAdSchedule>;
  Past: Array<AirtableAdSchedule>;
};

export type AlsoFromProductsConnection = {
  __typename?: 'AlsoFromProductsConnection';
  edges: Array<AlsoFromProductsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AlsoFromProductsConnectionEdge = {
  __typename?: 'AlsoFromProductsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Product;
};

export type AnalyticsCheckoutSession = {
  __typename?: 'AnalyticsCheckoutSession';
  SessionId?: Maybe<Scalars['String']['output']>;
};

export enum AnalyticsStatusEnum {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Free = 'FREE',
  Scheduled = 'SCHEDULED',
  Visible = 'VISIBLE'
}

export type AnalyticsSubscription = {
  __typename?: 'AnalyticsSubscription';
  Active: Scalars['Boolean']['output'];
  Cancelled: Scalars['Boolean']['output'];
  PeriodEnd: Scalars['String']['output'];
  Status: AnalyticsSubscriptionEnum;
};

export enum AnalyticsSubscriptionEnum {
  Active = 'ACTIVE',
  Failed = 'FAILED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum AppliedSpecialtyDiscountEnum {
  Member = 'MEMBER',
  Trade = 'TRADE'
}

export type ArcherComment = {
  __typename?: 'ArcherComment';
  ActionData?: Maybe<Scalars['String']['output']>;
  Actioned?: Maybe<Scalars['Boolean']['output']>;
  ActionedBy?: Maybe<Member>;
  ActionedOn?: Maybe<Scalars['String']['output']>;
  Applied?: Maybe<Scalars['Boolean']['output']>;
  Author?: Maybe<Member>;
  CommentLevel?: Maybe<ArcherCommentLevelEnum>;
  CommentType?: Maybe<ArcherCommentTypeEnum>;
  Content: Scalars['String']['output'];
  Created: Scalars['String']['output'];
  Deleted?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  Product?: Maybe<Product>;
  Replies: RepliesConnection;
  Section?: Maybe<ArcherHighlightSectionEnum>;
  Title: Scalars['String']['output'];
};


export type ArcherCommentRepliesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum ArcherCommentLevelEnum {
  AutomaticUpdate = 'AUTOMATIC_UPDATE',
  Error = 'ERROR',
  ReviewAndAction = 'REVIEW_AND_ACTION',
  UserCreated = 'USER_CREATED'
}

export enum ArcherCommentTypeEnum {
  BulkImprovement = 'BULK_IMPROVEMENT',
  CategoryEnhancement = 'CATEGORY_ENHANCEMENT',
  DescriptionEnhancement = 'DESCRIPTION_ENHANCEMENT',
  SearchTagEnhancement = 'SEARCH_TAG_ENHANCEMENT',
  SeoDescriptionEnhancement = 'SEO_DESCRIPTION_ENHANCEMENT',
  SeoTitleEnhancement = 'SEO_TITLE_ENHANCEMENT',
  SpecificationsExtraction = 'SPECIFICATIONS_EXTRACTION',
  TitleEnhancement = 'TITLE_ENHANCEMENT',
  UserSuggestion = 'USER_SUGGESTION'
}

export type ArcherCommentsConnection = {
  __typename?: 'ArcherCommentsConnection';
  edges: Array<ArcherCommentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArcherCommentsConnectionEdge = {
  __typename?: 'ArcherCommentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArcherComment;
};

export enum ArcherHighlightSectionEnum {
  PricingAndVariants = 'PRICING_AND_VARIANTS',
  ProductAssets = 'PRODUCT_ASSETS',
  ProductAttributes = 'PRODUCT_ATTRIBUTES',
  ProductDescription = 'PRODUCT_DESCRIPTION',
  ProductDetails = 'PRODUCT_DETAILS',
  ProductDownloads = 'PRODUCT_DOWNLOADS',
  ProductTitle = 'PRODUCT_TITLE',
  SearchTagsAndSeo = 'SEARCH_TAGS_AND_SEO'
}

export type ArcherReply = {
  __typename?: 'ArcherReply';
  Author?: Maybe<Member>;
  Comment?: Maybe<ArcherComment>;
  Content: Scalars['String']['output'];
  Created: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
};

export type Article = ContentBuilder & DesignBoardPinTarget & DirectoryItem & IApprovable & ICreatable & IHasProfessional & IHomePinable & IPublishable & SortableItem & {
  __typename?: 'Article';
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']['output']>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
  AssociatedPages: Article_AssociatedPagesConnection;
  Author?: Maybe<Member>;
  AvailabilityZones: Array<Zone>;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  ByArchipro?: Maybe<Scalars['Boolean']['output']>;
  Categories: Array<Category>;
  ClassName: Scalars['String']['output'];
  Clones?: Maybe<Array<DirectoryItem>>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentArea: ContentArea;
  ContentBlocks?: Maybe<Array<ContentBlock>>;
  ContentBuilderType: ContentBuilderTypeEnum;
  ContentComment?: Maybe<Scalars['String']['output']>;
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']['output']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  CreatedTimestamp: Scalars['Int']['output'];
  DataQualityRating: Scalars['Float']['output'];
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  Disable: Scalars['Boolean']['output'];
  EmbeddedData?: Maybe<Scalars['String']['output']>;
  Embeddings?: Maybe<Scalars['String']['output']>;
  FacebookPreviewImage?: Maybe<Scalars['String']['output']>;
  FirstPublishedDate?: Maybe<Scalars['String']['output']>;
  HasClones: Scalars['Boolean']['output'];
  HasDownloads: Scalars['Boolean']['output'];
  HasPhotos: Scalars['Boolean']['output'];
  HasProducts: Scalars['Boolean']['output'];
  HasProjects: Scalars['Boolean']['output'];
  HasTags: Scalars['Boolean']['output'];
  HasVideos: Scalars['Boolean']['output'];
  HomePinned: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']['output']>;
  IntroText?: Maybe<Scalars['String']['output']>;
  IsCloned: Scalars['Boolean']['output'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean']['output'];
  IsFeature: Scalars['Boolean']['output'];
  /** True if published and activated */
  IsLive: Scalars['Boolean']['output'];
  IsManufacturer: Scalars['Boolean']['output'];
  IsTemplate: Scalars['Boolean']['output'];
  KPI?: Maybe<LibraryItemKpi>;
  LastEdited?: Maybe<Scalars['String']['output']>;
  LastEditedDate?: Maybe<Scalars['String']['output']>;
  LastEditedTimestamp: Scalars['Int']['output'];
  LegacyLink: Scalars['String']['output'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String']['output'];
  LiveDateTimestamp?: Maybe<Scalars['Int']['output']>;
  MemberSortOrder: Scalars['Int']['output'];
  Meta?: Maybe<Meta>;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String']['output'];
  ParentID: Scalars['Int']['output'];
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  PublicKPI?: Maybe<LibraryItemPublicKpi>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean']['output'];
  PublishDate?: Maybe<Scalars['String']['output']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']['output']>;
  ReadingMinutes: Scalars['Int']['output'];
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  Review?: Maybe<PageReview>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']['output']>;
  SampleMessagePlaceholder?: Maybe<Scalars['String']['output']>;
  SampleSubmitText?: Maybe<Scalars['String']['output']>;
  SampleText?: Maybe<Scalars['String']['output']>;
  SampleTitle?: Maybe<Scalars['String']['output']>;
  SamplesAddressRequired: Scalars['Boolean']['output'];
  SamplesAvailable: Scalars['Boolean']['output'];
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  SelfPublished: Scalars['Boolean']['output'];
  ShowsInElasticSearch: Scalars['Boolean']['output'];
  SortOrder: Scalars['Int']['output'];
  Teaser?: Maybe<Scalars['String']['output']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String']['output'];
  TopBanner?: Maybe<LibraryItemBanner>;
  URLSegment: Scalars['String']['output'];
  ViewsCount: Scalars['Int']['output'];
  Visibilities?: Maybe<Array<ArticleVisibility>>;
  Website?: Maybe<Scalars['String']['output']>;
  WebsiteShort?: Maybe<Scalars['String']['output']>;
  WebsiteUntracked: Scalars['String']['output'];
  WordCount: Scalars['Int']['output'];
  deprecated_Awards?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  libraryImageMarkerCount: LibraryImageMarkerCount;
};


export type ArticleApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type ArticleContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleLibraryImagesArgs = {
  IncludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticlePublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ArticleReadingMinutesArgs = {
  WithPageBuilder?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};


export type ArticleWordCountArgs = {
  WithPageBuilder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleAuthor = {
  FirstName: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  Surname?: Maybe<Scalars['String']['output']>;
};

export type ArticleAuthorsConnection = {
  __typename?: 'ArticleAuthorsConnection';
  edges: Array<ArticleAuthorsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArticleAuthorsConnectionEdge = {
  __typename?: 'ArticleAuthorsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleAuthor;
};

export type ArticleAuthorsFilters = {
  /** Filter Authors who has posted an article on a given professional */
  HasPosted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleCategory = ICategory & IHasItems & {
  __typename?: 'ArticleCategory';
  Articles: ArticleCategory_ArticlesConnection;
  CanonicalLink?: Maybe<Scalars['String']['output']>;
  Categories: ArticleCategory_CategoriesConnection;
  ContentTop: Scalars['String']['output'];
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']['output']>;
  ItemsCount: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  MenuTitle: Scalars['String']['output'];
  Parent?: Maybe<ArticleCategory>;
  Parents: ArticleCategory_ParentsConnection;
  PrettyTitle: Scalars['String']['output'];
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};


export type ArticleCategoryArticlesArgs = {
  filter?: InputMaybe<ArticleCategory_ArticlesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ArticleCategory_ArticlesSortFields>;
};


export type ArticleCategoryCategoriesArgs = {
  filter?: InputMaybe<ArticleCategory_CategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ArticleCategory_CategoriesSortFields>;
};


export type ArticleCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleCategoryItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};


export type ArticleCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticleCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};

export type ArticleCategory_ArticlesConnection = {
  __typename?: 'ArticleCategory_ArticlesConnection';
  edges: Array<ArticleCategory_ArticlesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArticleCategory_ArticlesConnectionEdge = {
  __typename?: 'ArticleCategory_ArticlesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Article;
};

export type ArticleCategory_ArticlesFilters = {
  /** Filters this type when CountryCode is in the provided value */
  CountryCode__in?: InputMaybe<Array<SupportedCountry>>;
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters this type when ItemID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when PublishDate is gt the provided value */
  PublishDate__gt?: InputMaybe<Scalars['String']['input']>;
  /** Filters this type when Visibility is find_in the provided value */
  Visibility__find_in?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleCategory_ArticlesSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Popularity?: InputMaybe<SortDirection>;
  PublishDate?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type ArticleCategory_CategoriesConnection = {
  __typename?: 'ArticleCategory_CategoriesConnection';
  edges: Array<ArticleCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArticleCategory_CategoriesConnectionEdge = {
  __typename?: 'ArticleCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleCategory;
};

export type ArticleCategory_CategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** category shows in Archizeen */
  ShowInArchizeen__eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** category shows in Navigation */
  ShowInNavigation__eq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArticleCategory_CategoriesSortFields = {
  Sort?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ArticleCategory_ParentsConnection = {
  __typename?: 'ArticleCategory_ParentsConnection';
  edges: Array<ArticleCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ArticleCategory_ParentsConnectionEdge = {
  __typename?: 'ArticleCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleCategory;
};

export type ArticleMutationResult = Article | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ArticlePin = {
  __typename?: 'ArticlePin';
  BoardID: Scalars['Int']['output'];
  BoardURLSegment: Scalars['String']['output'];
  CanDelete: Scalars['Boolean']['output'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int']['output'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LegacyLink?: Maybe<Scalars['String']['output']>;
  LibraryImageID?: Maybe<Scalars['Int']['output']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']['output']>;
  PageType?: Maybe<Scalars['String']['output']>;
  PageTypeID?: Maybe<Scalars['Int']['output']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  ProfessionalID?: Maybe<Scalars['Int']['output']>;
  ProfessionalLink?: Maybe<Scalars['String']['output']>;
  ProfessionalTitle?: Maybe<Scalars['String']['output']>;
  ProfessionalWebsite?: Maybe<Scalars['String']['output']>;
  SubTitle: Scalars['String']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export enum ArticleVisibility {
  Disabled = 'Disabled',
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly',
  Scheduled = 'Scheduled'
}

export type Article_AssociatedPagesConnection = {
  __typename?: 'Article_AssociatedPagesConnection';
  edges: Array<Article_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Article_AssociatedPagesConnectionEdge = {
  __typename?: 'Article_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type ArticlesConnection = {
  __typename?: 'ArticlesConnection';
  ID: Scalars['String']['output'];
  edges: Array<ArticlesConnectionEdge>;
  nodes: Array<Article>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ArticlesConnectionEdge = {
  __typename?: 'ArticlesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Article;
};

export type ArticlesSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  DataQualityRating?: InputMaybe<SortDirection>;
  FirstPublishedDate?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  PublishDate?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  WasPublished?: InputMaybe<SortDirection>;
};

export type AssociatedPage = {
  __typename?: 'AssociatedPage';
  Zone: Zone;
  ZonePage?: Maybe<AssociatedZonePage>;
};

export type AssociatedZonePage = {
  __typename?: 'AssociatedZonePage';
  ID: Scalars['Int']['output'];
  Link?: Maybe<Scalars['String']['output']>;
};

export type AssociationsConnection = {
  __typename?: 'AssociationsConnection';
  edges: Array<AssociationsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AssociationsConnectionEdge = {
  __typename?: 'AssociationsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Professional;
};

export enum AsyncTaskStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  InFlight = 'InFlight',
  New = 'New',
  Queued = 'Queued',
  Retrying = 'Retrying',
  Running = 'Running',
  Success = 'Success'
}

export type AttendeeListModule = ModuleType & {
  __typename?: 'AttendeeListModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  AttendeeList: Array<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  LeadingText?: Maybe<Scalars['String']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type Attendees_Connection = {
  __typename?: 'Attendees_Connection';
  edges: Array<Attendees_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Attendees_ConnectionEdge = {
  __typename?: 'Attendees_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalAttendee;
};

export type Attendees_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Attribute = {
  __typename?: 'Attribute';
  ID: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
  Options: AttributeOptionsListConnection;
  Professional?: Maybe<Professional>;
  SortOrder?: Maybe<Scalars['Int']['output']>;
  Title: Scalars['String']['output'];
};


export type AttributeOptionsArgs = {
  ProductID?: InputMaybe<Scalars['Int']['input']>;
  Professional?: InputMaybe<Scalars['StringInput']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AttributeOption = {
  __typename?: 'AttributeOption';
  Approved: Scalars['Boolean']['output'];
  Attribute?: Maybe<Attribute>;
  AttributeID: Scalars['Int']['output'];
  Code: Scalars['String']['output'];
  ColorCategories: ColorCategoriesConnection;
  CommonMaterials: CommonMaterialsConnection;
  /** Deprecated: No longer used, Use ProductColors instead. */
  DominantColor?: Maybe<Scalars['String']['output']>;
  Dot?: Maybe<ResponsiveImage>;
  ID: Scalars['Int']['output'];
  Image?: Maybe<ResponsiveImage>;
  Label: Scalars['String']['output'];
  /** Deprecated: No longer used, Use Label instead */
  Name: Scalars['String']['output'];
  Professional?: Maybe<Professional>;
  Swatch?: Maybe<ProductSwatch>;
};


export type AttributeOptionColorCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AttributeOptionCommonMaterialsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AttributeOptionsConnection = {
  __typename?: 'AttributeOptionsConnection';
  edges: Array<AttributeOptionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AttributeOptionsConnectionEdge = {
  __typename?: 'AttributeOptionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: AttributeOption;
};

export type AttributeOptionsListConnection = {
  __typename?: 'AttributeOptionsListConnection';
  edges: Array<AttributeOptionsListConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AttributeOptionsListConnectionEdge = {
  __typename?: 'AttributeOptionsListConnectionEdge';
  /** The node at the end of the collections edge */
  node: AttributeOption;
};

export type AttributeOptions_MaterialsConnection = {
  __typename?: 'AttributeOptions_MaterialsConnection';
  edges: Array<AttributeOptions_MaterialsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type AttributeOptions_MaterialsConnectionEdge = {
  __typename?: 'AttributeOptions_MaterialsConnectionEdge';
  /** The node at the end of the collections edge */
  node: AttributeOption;
};

export type AudienceAgeGender = {
  __typename?: 'AudienceAgeGender';
  label: Scalars['String']['output'];
  value: AudienceGender;
};

export type AudienceByIndustryBreakdownFilters = {
  EVENT_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  USER_INDUSTRY__IN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AudienceGender = {
  __typename?: 'AudienceGender';
  female?: Maybe<Scalars['Int']['output']>;
  male?: Maybe<Scalars['Int']['output']>;
  unknown?: Maybe<Scalars['Int']['output']>;
};

export type AudienceIndustriesFilters = {
  EVENT_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AudienceLocation = {
  __typename?: 'AudienceLocation';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type AudiencePlacement = {
  __typename?: 'AudiencePlacement';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type AudienceTypeBreakdownFilters = {
  EVENT_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AuthDebugClaims = {
  __typename?: 'AuthDebugClaims';
  audience: Scalars['String']['output'];
  expiresAt: Scalars['Int']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  issuedAt: Scalars['Int']['output'];
  issuer?: Maybe<Scalars['String']['output']>;
  jti?: Maybe<Scalars['String']['output']>;
  nbf?: Maybe<Scalars['Int']['output']>;
  professional: Scalars['String']['output'];
  rexp?: Maybe<Scalars['Int']['output']>;
  rid?: Maybe<Scalars['Int']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  subject?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AuthDebugMetadata = {
  __typename?: 'AuthDebugMetadata';
  expiresAt?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  issuedAt?: Maybe<Scalars['String']['output']>;
  professional: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export type AuthDebugResult = {
  __typename?: 'AuthDebugResult';
  claims?: Maybe<AuthDebugClaims>;
  metadata: AuthDebugMetadata;
};

export type AuthenticationException = {
  __typename?: 'AuthenticationException';
  ExpectedMember?: Maybe<PublicMember>;
};

export type AvailableMemberType = {
  __typename?: 'AvailableMemberType';
  email: Scalars['String']['output'];
  memberId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Award = SortableItem & {
  __typename?: 'Award';
  AwardedEntities: Award_AwardedEntitiesConnection;
  AwardingInstitutionTitle: Scalars['StringInput']['output'];
  Badge?: Maybe<LibraryImage>;
  ID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  Title: Scalars['StringInput']['output'];
  YearAwarded: Scalars['StringInput']['output'];
};


export type AwardAwardedEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Award_AwardedEntitiesConnection = {
  __typename?: 'Award_AwardedEntitiesConnection';
  edges: Array<Award_AwardedEntitiesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Award_AwardedEntitiesConnectionEdge = {
  __typename?: 'Award_AwardedEntitiesConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectoryItem;
};

export type B2BLeadInput = {
  BusinessName: Scalars['StringInput']['input'];
  BusinessWebsite: Scalars['StringInput']['input'];
  City: Scalars['StringInput']['input'];
  Email: Scalars['Email']['input'];
  FirstName: Scalars['StringInput']['input'];
  Industry: Scalars['StringInput']['input'];
  JobTitle: Scalars['StringInput']['input'];
  LastName: Scalars['StringInput']['input'];
  Message?: InputMaybe<Scalars['StringInput']['input']>;
  Phone: Scalars['StringInput']['input'];
  State: Scalars['StringInput']['input'];
};

export type B2BLeadResult = {
  __typename?: 'B2BLeadResult';
  Success: Scalars['Boolean']['output'];
};

export type BaReports = {
  __typename?: 'BAReports';
  APConversions?: Maybe<TableData>;
  AudienceByIndustryBreakdown: DataCollections;
  AudienceIndustries?: Maybe<TableData>;
  AudienceTypeBreakdown: DataCollections;
  BenchmarkAttentionShare: DataCollections;
  BenchmarkCategoryEngagement: DataCollections;
  BenchmarkCategoryHealth: DataCollections;
  BenchmarkLeadGenerate?: Maybe<RowData>;
  BenchmarkProductHealth?: Maybe<ChartCollection>;
  BenchmarkStats?: Maybe<RowData>;
  BenchmarkTierOnePerformance?: Maybe<TableData>;
  BenchmarkTierTwoPerformance?: Maybe<TableData>;
  CampaignFilter?: Maybe<TableData>;
  CompanyActivities?: Maybe<TableData>;
  CompanyActivityIndustries?: Maybe<TableData>;
  ConversionActivities: DataCollections;
  ConversionActivityOvertime: DataCollections;
  ConversionActivityTable?: Maybe<TableData>;
  ConversionAdsOvertime?: Maybe<ChartCollection>;
  ConversionContentTypes?: Maybe<TableData>;
  ConversionLocationOptions?: Maybe<TableData>;
  ConversionLocations?: Maybe<TableData>;
  ConversionOptions?: Maybe<TableData>;
  ConversionPageNames?: Maybe<TableData>;
  ConversionStats?: Maybe<RowData>;
  ConversionTableData?: Maybe<TableData>;
  ConversionTypes?: Maybe<TableData>;
  ConversionUserTypes?: Maybe<TableData>;
  ConversionsFromTags: DataCollections;
  CustomerLeadActivity?: Maybe<RowData>;
  CustomerLeadCategoryInterest: DataCollections;
  CustomerLeadConversionRate?: Maybe<RowData>;
  CustomerLeadConversions: DataCollections;
  CustomerLeadDetails?: Maybe<RowData>;
  CustomerLeadSummary?: Maybe<RowData>;
  CustomerLeadTopPageViews: DataCollections;
  DailyConversionActivities?: Maybe<TableData>;
  DailyReportActivities?: Maybe<TableData>;
  DailyReportEmailData?: Maybe<TableData>;
  DemographicLocations: DataCollections;
  DemographicStats?: Maybe<RowData>;
  DemographicUserDevices?: Maybe<RowData>;
  DemographicsAudienceLocation: Array<MapMaker>;
  DemographicsAudienceType: DataCollections;
  DemographicsAudienceTypeOptions?: Maybe<TableData>;
  DemographicsCategories?: Maybe<TableData>;
  DemographicsCategoryInterests: DataCollections;
  DemographicsContentTypeOptions?: Maybe<TableData>;
  DemographicsLocationOptions?: Maybe<TableData>;
  DemographicsProjectStage: DataCollections;
  DemographicsProjectType: DataCollections;
  DemographicsSummary?: Maybe<RowData>;
  DemographicsTotalTimeSpent: DataCollections;
  DemographicsUserEngagementOverTime: DataCollections;
  DigitalPublicationActivity?: Maybe<TableData>;
  DigitalPublicationAttentionShare?: Maybe<RowData>;
  DigitalPublicationAudience: DataCollections;
  DigitalPublicationAudienceRegion: DataCollections;
  DigitalPublicationList?: Maybe<TableData>;
  DigitalPublicationOpenClick?: Maybe<RowData>;
  DigitalPublicationPerformance?: Maybe<RowData>;
  DigitalPublicationPerformanceChartClick: DataCollections;
  DigitalPublicationPerformanceChartOpen: DataCollections;
  DigitalPublicationProfessionalCategory: DataCollections;
  DigitalPublicationProfessionalEngagement: DataCollections;
  DigitalPublicationProfessionalRegion: DataCollections;
  DigitalPublicationProfessionalUser: DataCollections;
  DigitalPublicationProfileConversionChart: DataCollections;
  DigitalPublicationReaderRegion: DataCollections;
  DigitalPublicationRecipient?: Maybe<TableData>;
  DigitalPublicationSingleMeta?: Maybe<TableData>;
  DigitalPublicationSummary?: Maybe<RowData>;
  DigitalPublicationTimespent?: Maybe<RowData>;
  EngagedCompanyStatsByIndustry?: Maybe<TableData>;
  ExposedCompanyStatsByIndustry?: Maybe<TableData>;
  GoogleSEOArchiproIndex?: Maybe<RowData>;
  GoogleSEOBreakdown: DataCollections;
  GoogleSEOPieChart: DataCollections;
  GoogleSEOSummary?: Maybe<RowData>;
  GoogleSEOTopPage?: Maybe<TableData>;
  GoogleSEOTopSearch?: Maybe<TableData>;
  ID: Scalars['Int']['output'];
  LeadFunnel: DataCollections;
  LeadFunnelConversionEvents?: Maybe<TableData>;
  LeadFunnelStats?: Maybe<RowData>;
  LeadFunnelUserScores: DataCollections;
  LeadFunnelUserSessions: DataCollections;
  LeadFunnelUserStatus: DataCollections;
  LeadFunnelUserTime: DataCollections;
  LeadFunnelUsers?: Maybe<TableData>;
  LibraryPageKPI?: Maybe<RowData>;
  LibraryPagePublicKPI?: Maybe<RowData>;
  MetaAdCampaignConversions: DataCollections;
  MetaAdCampaignEngagements: DataCollections;
  MetaAdCampaignProfileStats?: Maybe<RowData>;
  MetaAdCampaignReachLocations: Array<MapMaker>;
  MetaAdCampaignStats?: Maybe<RowData>;
  MetaAdsCampaignTable?: Maybe<TableData>;
  MetaAdsConversionBreakdown: DataCollections;
  MetaAdsEngagementBreakdown: DataCollections;
  MetaAdsStats?: Maybe<RowData>;
  MetaCampaigns?: Maybe<TableData>;
  MetaCampaignsByUTM?: Maybe<TableData>;
  MonthlyUserCount?: Maybe<RowData>;
  NativeDriverAdPerformance?: Maybe<RowData>;
  NativeDriverCampaigns?: Maybe<TableData>;
  NativeDriverDevice?: Maybe<RowData>;
  NativeDriverOverviewStat?: Maybe<RowData>;
  NativeDriverRegion: DataCollections;
  OldConversionTableData?: Maybe<TableData>;
  OldProfileTopPages?: Maybe<TableData>;
  OnsitePlacementBreakdown: DataCollections;
  OnsitePlacementLocationType: DataCollections;
  OnsitePlacementOverview?: Maybe<RowData>;
  OnsitePlacementTable?: Maybe<TableData>;
  OnsitePlacementUserDevices?: Maybe<RowData>;
  OverviewImpression: DataCollections;
  OverviewInteractions?: Maybe<RowData>;
  OverviewNewsletterStats?: Maybe<ChartCollection>;
  OverviewPackage?: Maybe<TableData>;
  OverviewPackageCampaigns?: Maybe<TableData>;
  OverviewPackageCampaignsDetails?: Maybe<TableData>;
  OverviewPackageOtherCampaigns?: Maybe<TableData>;
  OverviewPackageOtherCampaignsDetails?: Maybe<TableData>;
  OverviewPageView: DataCollections;
  OverviewProfilePageStats?: Maybe<ChartCollection>;
  OverviewSinceDate?: Maybe<Datum>;
  OverviewSocialAdStats?: Maybe<ChartCollection>;
  OverviewStats?: Maybe<RowData>;
  OverviewTotalConversion?: Maybe<TableData>;
  PageNames?: Maybe<TableData>;
  PageOwners?: Maybe<TableData>;
  PinterestBreakdown: DataCollections;
  PinterestCampaigns?: Maybe<TableData>;
  PinterestProfileConversion?: Maybe<RowData>;
  PinterestSummary?: Maybe<RowData>;
  PixelActivityByOrder?: Maybe<TableData>;
  PixelActivityBySession?: Maybe<TableData>;
  PixelActivityByUser?: Maybe<TableData>;
  PixelConversions?: Maybe<TableData>;
  PixelConversionsNonDistinct?: Maybe<TableData>;
  PixelForms?: Maybe<TableData>;
  PixelIndustryBreakdown: DataCollections;
  PixelRegionBreakdown: DataCollections;
  PixelReturningUserBreakdown: DataCollections;
  PixelRuleConversions?: Maybe<TableData>;
  PixelSmokeTest?: Maybe<Datum>;
  PixelStats?: Maybe<RowData>;
  PixelTopLandingPages?: Maybe<TableData>;
  PixelTopReferrals?: Maybe<TableData>;
  ProductNames?: Maybe<TableData>;
  ProductTagStats?: Maybe<RowData>;
  ProductTagTemporalStats?: Maybe<RowData>;
  ProfileCampaignsOverTime?: Maybe<ChartCollection>;
  ProfileConversionBreakdown: DataCollections;
  ProfileConversionTypes?: Maybe<TableData>;
  ProfileImpressionSources: DataCollections;
  ProfileIndustries?: Maybe<TableData>;
  ProfilePageNames?: Maybe<TableData>;
  ProfilePageTypeBreakdown: DataCollections;
  ProfilePageTypes?: Maybe<TableData>;
  ProfileStats?: Maybe<RowData>;
  ProfileStatsOverTime: DataCollections;
  ProfileTopPages?: Maybe<TableData>;
  ProfileTrafficSources: DataCollections;
  SalesConversions?: Maybe<TableData>;
  TaggedProductsByRecord?: Maybe<TableData>;
  TaggedRecords?: Maybe<TableData>;
  TopClickedTags?: Maybe<TableData>;
};


export type BaReportsApConversionsArgs = {
  filters?: InputMaybe<ApConversionsFilters>;
};


export type BaReportsAudienceByIndustryBreakdownArgs = {
  filters?: InputMaybe<AudienceByIndustryBreakdownFilters>;
};


export type BaReportsAudienceIndustriesArgs = {
  filters?: InputMaybe<AudienceIndustriesFilters>;
};


export type BaReportsAudienceTypeBreakdownArgs = {
  filters?: InputMaybe<AudienceTypeBreakdownFilters>;
};


export type BaReportsBenchmarkAttentionShareArgs = {
  filters?: InputMaybe<BenchmarkAttentionShareFilters>;
};


export type BaReportsBenchmarkCategoryEngagementArgs = {
  filters?: InputMaybe<BenchmarkCategoryEngagementFilters>;
};


export type BaReportsBenchmarkCategoryHealthArgs = {
  filters?: InputMaybe<BenchmarkCategoryHealthFilters>;
};


export type BaReportsBenchmarkLeadGenerateArgs = {
  filters?: InputMaybe<BenchmarkLeadGenerateFilters>;
};


export type BaReportsBenchmarkProductHealthArgs = {
  filters?: InputMaybe<BenchmarkProductHealthFilters>;
};


export type BaReportsBenchmarkStatsArgs = {
  filters?: InputMaybe<BenchmarkStatsFilters>;
};


export type BaReportsBenchmarkTierOnePerformanceArgs = {
  filters?: InputMaybe<BenchmarkTierOnePerformanceFilters>;
  sort?: InputMaybe<BenchmarkTierOnePerformanceSort>;
};


export type BaReportsBenchmarkTierTwoPerformanceArgs = {
  filters?: InputMaybe<BenchmarkTierTwoPerformanceFilters>;
};


export type BaReportsCampaignFilterArgs = {
  filters?: InputMaybe<CampaignFilterFilters>;
};


export type BaReportsCompanyActivitiesArgs = {
  filters?: InputMaybe<CompanyActivitiesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CompanyActivitiesSort>;
};


export type BaReportsCompanyActivityIndustriesArgs = {
  filters?: InputMaybe<CompanyActivityIndustriesFilters>;
};


export type BaReportsConversionActivitiesArgs = {
  filters?: InputMaybe<ConversionActivitiesFilters>;
};


export type BaReportsConversionActivityOvertimeArgs = {
  filters?: InputMaybe<ConversionActivityOvertimeFilters>;
};


export type BaReportsConversionActivityTableArgs = {
  filters?: InputMaybe<ConversionActivityTableFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ConversionActivityTableSort>;
};


export type BaReportsConversionAdsOvertimeArgs = {
  filters?: InputMaybe<ConversionAdsOvertimeFilters>;
};


export type BaReportsConversionContentTypesArgs = {
  filters?: InputMaybe<ConversionContentTypesFilters>;
};


export type BaReportsConversionLocationOptionsArgs = {
  filters?: InputMaybe<ConversionLocationOptionsFilters>;
};


export type BaReportsConversionLocationsArgs = {
  filters?: InputMaybe<ConversionLocationsFilters>;
};


export type BaReportsConversionOptionsArgs = {
  filters?: InputMaybe<ConversionOptionsFilters>;
};


export type BaReportsConversionPageNamesArgs = {
  filters?: InputMaybe<ConversionPageNamesFilters>;
};


export type BaReportsConversionStatsArgs = {
  filters?: InputMaybe<ConversionStatsFilters>;
};


export type BaReportsConversionTableDataArgs = {
  filters?: InputMaybe<ConversionTableDataFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BaReportsConversionUserTypesArgs = {
  filters?: InputMaybe<ConversionUserTypesFilters>;
};


export type BaReportsConversionsFromTagsArgs = {
  filters?: InputMaybe<ConversionsFromTagsFilters>;
};


export type BaReportsCustomerLeadActivityArgs = {
  filters?: InputMaybe<CustomerLeadActivityFilters>;
};


export type BaReportsCustomerLeadCategoryInterestArgs = {
  filters?: InputMaybe<CustomerLeadCategoryInterestFilters>;
};


export type BaReportsCustomerLeadConversionRateArgs = {
  filters?: InputMaybe<CustomerLeadConversionRateFilters>;
};


export type BaReportsCustomerLeadConversionsArgs = {
  filters?: InputMaybe<CustomerLeadConversionsFilters>;
};


export type BaReportsCustomerLeadDetailsArgs = {
  filters?: InputMaybe<CustomerLeadDetailsFilters>;
};


export type BaReportsCustomerLeadSummaryArgs = {
  filters?: InputMaybe<CustomerLeadSummaryFilters>;
};


export type BaReportsCustomerLeadTopPageViewsArgs = {
  filters?: InputMaybe<CustomerLeadTopPageViewsFilters>;
};


export type BaReportsDailyReportActivitiesArgs = {
  filters?: InputMaybe<DailyReportActivitiesFilters>;
};


export type BaReportsDemographicLocationsArgs = {
  filters?: InputMaybe<DemographicLocationsFilters>;
};


export type BaReportsDemographicStatsArgs = {
  filters?: InputMaybe<DemographicStatsFilters>;
};


export type BaReportsDemographicUserDevicesArgs = {
  filters?: InputMaybe<DemographicUserDevicesFilters>;
};


export type BaReportsDemographicsAudienceLocationArgs = {
  filters?: InputMaybe<DemographicsAudienceLocationFilters>;
};


export type BaReportsDemographicsAudienceTypeArgs = {
  filters?: InputMaybe<DemographicsAudienceTypeFilters>;
};


export type BaReportsDemographicsAudienceTypeOptionsArgs = {
  filters?: InputMaybe<DemographicsAudienceTypeOptionsFilters>;
};


export type BaReportsDemographicsCategoriesArgs = {
  filters?: InputMaybe<DemographicsCategoriesFilters>;
};


export type BaReportsDemographicsCategoryInterestsArgs = {
  filters?: InputMaybe<DemographicsCategoryInterestsFilters>;
};


export type BaReportsDemographicsContentTypeOptionsArgs = {
  filters?: InputMaybe<DemographicsContentTypeOptionsFilters>;
};


export type BaReportsDemographicsLocationOptionsArgs = {
  filters?: InputMaybe<DemographicsLocationOptionsFilters>;
};


export type BaReportsDemographicsProjectStageArgs = {
  filters?: InputMaybe<DemographicsProjectStageFilters>;
};


export type BaReportsDemographicsProjectTypeArgs = {
  filters?: InputMaybe<DemographicsProjectTypeFilters>;
};


export type BaReportsDemographicsSummaryArgs = {
  filters?: InputMaybe<DemographicsSummaryFilters>;
};


export type BaReportsDemographicsTotalTimeSpentArgs = {
  filters?: InputMaybe<DemographicsTotalTimeSpentFilters>;
};


export type BaReportsDemographicsUserEngagementOverTimeArgs = {
  filters?: InputMaybe<DemographicsUserEngagementOverTimeFilters>;
};


export type BaReportsDigitalPublicationActivityArgs = {
  filters?: InputMaybe<DigitalPublicationActivityFilters>;
};


export type BaReportsDigitalPublicationAttentionShareArgs = {
  filters?: InputMaybe<DigitalPublicationAttentionShareFilters>;
};


export type BaReportsDigitalPublicationAudienceArgs = {
  filters?: InputMaybe<DigitalPublicationAudienceFilters>;
};


export type BaReportsDigitalPublicationAudienceRegionArgs = {
  filters?: InputMaybe<DigitalPublicationAudienceRegionFilters>;
};


export type BaReportsDigitalPublicationListArgs = {
  filters?: InputMaybe<DigitalPublicationListFilters>;
};


export type BaReportsDigitalPublicationOpenClickArgs = {
  filters?: InputMaybe<DigitalPublicationOpenClickFilters>;
};


export type BaReportsDigitalPublicationPerformanceArgs = {
  filters?: InputMaybe<DigitalPublicationPerformanceFilters>;
};


export type BaReportsDigitalPublicationPerformanceChartClickArgs = {
  filters?: InputMaybe<DigitalPublicationPerformanceChartClickFilters>;
};


export type BaReportsDigitalPublicationPerformanceChartOpenArgs = {
  filters?: InputMaybe<DigitalPublicationPerformanceChartOpenFilters>;
};


export type BaReportsDigitalPublicationProfessionalCategoryArgs = {
  filters?: InputMaybe<DigitalPublicationProfessionalCategoryFilters>;
};


export type BaReportsDigitalPublicationProfessionalEngagementArgs = {
  filters?: InputMaybe<DigitalPublicationProfessionalEngagementFilters>;
};


export type BaReportsDigitalPublicationProfessionalRegionArgs = {
  filters?: InputMaybe<DigitalPublicationProfessionalRegionFilters>;
};


export type BaReportsDigitalPublicationProfessionalUserArgs = {
  filters?: InputMaybe<DigitalPublicationProfessionalUserFilters>;
};


export type BaReportsDigitalPublicationProfileConversionChartArgs = {
  filters?: InputMaybe<DigitalPublicationProfileConversionChartFilters>;
};


export type BaReportsDigitalPublicationReaderRegionArgs = {
  filters?: InputMaybe<DigitalPublicationReaderRegionFilters>;
};


export type BaReportsDigitalPublicationRecipientArgs = {
  filters?: InputMaybe<DigitalPublicationRecipientFilters>;
};


export type BaReportsDigitalPublicationSingleMetaArgs = {
  filters?: InputMaybe<DigitalPublicationSingleMetaFilters>;
};


export type BaReportsDigitalPublicationSummaryArgs = {
  filters?: InputMaybe<DigitalPublicationSummaryFilters>;
};


export type BaReportsDigitalPublicationTimespentArgs = {
  filters?: InputMaybe<DigitalPublicationTimespentFilters>;
};


export type BaReportsEngagedCompanyStatsByIndustryArgs = {
  filters?: InputMaybe<EngagedCompanyStatsByIndustryFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EngagedCompanyStatsByIndustrySort>;
};


export type BaReportsExposedCompanyStatsByIndustryArgs = {
  filters?: InputMaybe<ExposedCompanyStatsByIndustryFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ExposedCompanyStatsByIndustrySort>;
};


export type BaReportsGoogleSeoArchiproIndexArgs = {
  filters?: InputMaybe<GoogleSeoArchiproIndexFilters>;
};


export type BaReportsGoogleSeoBreakdownArgs = {
  filters?: InputMaybe<GoogleSeoBreakdownFilters>;
};


export type BaReportsGoogleSeoPieChartArgs = {
  filters?: InputMaybe<GoogleSeoPieChartFilters>;
};


export type BaReportsGoogleSeoSummaryArgs = {
  filters?: InputMaybe<GoogleSeoSummaryFilters>;
};


export type BaReportsGoogleSeoTopPageArgs = {
  filters?: InputMaybe<GoogleSeoTopPageFilters>;
  sort?: InputMaybe<GoogleSeoTopPageSort>;
};


export type BaReportsGoogleSeoTopSearchArgs = {
  filters?: InputMaybe<GoogleSeoTopSearchFilters>;
  sort?: InputMaybe<GoogleSeoTopSearchSort>;
};


export type BaReportsLeadFunnelArgs = {
  filters?: InputMaybe<LeadFunnelFilters>;
};


export type BaReportsLeadFunnelStatsArgs = {
  filters?: InputMaybe<LeadFunnelStatsFilters>;
};


export type BaReportsLeadFunnelUserScoresArgs = {
  filters?: InputMaybe<LeadFunnelUserScoresFilters>;
};


export type BaReportsLeadFunnelUserSessionsArgs = {
  filters?: InputMaybe<LeadFunnelUserSessionsFilters>;
};


export type BaReportsLeadFunnelUserStatusArgs = {
  filters?: InputMaybe<LeadFunnelUserStatusFilters>;
};


export type BaReportsLeadFunnelUserTimeArgs = {
  filters?: InputMaybe<LeadFunnelUserTimeFilters>;
};


export type BaReportsLeadFunnelUsersArgs = {
  filters?: InputMaybe<LeadFunnelUsersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LeadFunnelUsersSort>;
};


export type BaReportsLibraryPageKpiArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BaReportsLibraryPagePublicKpiArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BaReportsMetaAdCampaignConversionsArgs = {
  filters?: InputMaybe<MetaAdCampaignConversionsFilters>;
};


export type BaReportsMetaAdCampaignEngagementsArgs = {
  filters?: InputMaybe<MetaAdCampaignEngagementsFilters>;
};


export type BaReportsMetaAdCampaignProfileStatsArgs = {
  filters?: InputMaybe<MetaAdCampaignProfileStatsFilters>;
};


export type BaReportsMetaAdCampaignReachLocationsArgs = {
  filters?: InputMaybe<MetaAdCampaignReachLocationsFilters>;
};


export type BaReportsMetaAdCampaignStatsArgs = {
  filters?: InputMaybe<MetaAdCampaignStatsFilters>;
};


export type BaReportsMetaAdsCampaignTableArgs = {
  filters?: InputMaybe<MetaAdsCampaignTableFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MetaAdsCampaignTableSort>;
};


export type BaReportsMetaAdsConversionBreakdownArgs = {
  filters?: InputMaybe<MetaAdsConversionBreakdownFilters>;
};


export type BaReportsMetaAdsEngagementBreakdownArgs = {
  filters?: InputMaybe<MetaAdsEngagementBreakdownFilters>;
};


export type BaReportsMetaAdsStatsArgs = {
  filters?: InputMaybe<MetaAdsStatsFilters>;
};


export type BaReportsMetaCampaignsArgs = {
  filters?: InputMaybe<MetaCampaignsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BaReportsMetaCampaignsByUtmArgs = {
  filters?: InputMaybe<MetaCampaignsByUtmFilters>;
};


export type BaReportsNativeDriverAdPerformanceArgs = {
  filters?: InputMaybe<NativeDriverAdPerformanceFilters>;
};


export type BaReportsNativeDriverCampaignsArgs = {
  filters?: InputMaybe<NativeDriverCampaignsFilters>;
};


export type BaReportsNativeDriverDeviceArgs = {
  filters?: InputMaybe<NativeDriverDeviceFilters>;
};


export type BaReportsNativeDriverOverviewStatArgs = {
  filters?: InputMaybe<NativeDriverOverviewStatFilters>;
};


export type BaReportsNativeDriverRegionArgs = {
  filters?: InputMaybe<NativeDriverRegionFilters>;
};


export type BaReportsOldConversionTableDataArgs = {
  filters?: InputMaybe<OldConversionTableDataFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OldConversionTableDataSort>;
};


export type BaReportsOldProfileTopPagesArgs = {
  filters?: InputMaybe<OldProfileTopPagesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OldProfileTopPagesSort>;
};


export type BaReportsOnsitePlacementBreakdownArgs = {
  filters?: InputMaybe<OnsitePlacementBreakdownFilters>;
};


export type BaReportsOnsitePlacementLocationTypeArgs = {
  filters?: InputMaybe<OnsitePlacementLocationTypeFilters>;
};


export type BaReportsOnsitePlacementOverviewArgs = {
  filters?: InputMaybe<OnsitePlacementOverviewFilters>;
};


export type BaReportsOnsitePlacementTableArgs = {
  filters?: InputMaybe<OnsitePlacementTableFilters>;
};


export type BaReportsOnsitePlacementUserDevicesArgs = {
  filters?: InputMaybe<OnsitePlacementUserDevicesFilters>;
};


export type BaReportsOverviewImpressionArgs = {
  filters?: InputMaybe<OverviewImpressionFilters>;
};


export type BaReportsOverviewInteractionsArgs = {
  filters?: InputMaybe<OverviewInteractionsFilters>;
};


export type BaReportsOverviewNewsletterStatsArgs = {
  filters?: InputMaybe<OverviewNewsletterStatsFilters>;
};


export type BaReportsOverviewPackageArgs = {
  filters?: InputMaybe<OverviewPackageFilters>;
};


export type BaReportsOverviewPackageCampaignsArgs = {
  filters?: InputMaybe<OverviewPackageCampaignsFilters>;
};


export type BaReportsOverviewPackageCampaignsDetailsArgs = {
  filters?: InputMaybe<OverviewPackageCampaignsDetailsFilters>;
};


export type BaReportsOverviewPackageOtherCampaignsArgs = {
  filters?: InputMaybe<OverviewPackageOtherCampaignsFilters>;
};


export type BaReportsOverviewPackageOtherCampaignsDetailsArgs = {
  filters?: InputMaybe<OverviewPackageOtherCampaignsDetailsFilters>;
};


export type BaReportsOverviewPageViewArgs = {
  filters?: InputMaybe<OverviewPageViewFilters>;
};


export type BaReportsOverviewProfilePageStatsArgs = {
  filters?: InputMaybe<OverviewProfilePageStatsFilters>;
};


export type BaReportsOverviewSocialAdStatsArgs = {
  filters?: InputMaybe<OverviewSocialAdStatsFilters>;
};


export type BaReportsOverviewStatsArgs = {
  filters?: InputMaybe<OverviewStatsFilters>;
};


export type BaReportsOverviewTotalConversionArgs = {
  filters?: InputMaybe<OverviewTotalConversionFilters>;
};


export type BaReportsPinterestBreakdownArgs = {
  filters?: InputMaybe<PinterestBreakdownFilters>;
};


export type BaReportsPinterestCampaignsArgs = {
  filters?: InputMaybe<PinterestCampaignsFilters>;
};


export type BaReportsPinterestSummaryArgs = {
  filters?: InputMaybe<PinterestSummaryFilters>;
};


export type BaReportsPixelActivityByOrderArgs = {
  filters?: InputMaybe<PixelActivityByOrderFilters>;
};


export type BaReportsPixelActivityBySessionArgs = {
  filters?: InputMaybe<PixelActivityBySessionFilters>;
};


export type BaReportsPixelActivityByUserArgs = {
  filters?: InputMaybe<PixelActivityByUserFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BaReportsPixelConversionsArgs = {
  filters?: InputMaybe<PixelConversionsFilters>;
};


export type BaReportsPixelConversionsNonDistinctArgs = {
  filters?: InputMaybe<PixelConversionsNonDistinctFilters>;
};


export type BaReportsPixelIndustryBreakdownArgs = {
  filters?: InputMaybe<PixelIndustryBreakdownFilters>;
};


export type BaReportsPixelRegionBreakdownArgs = {
  filters?: InputMaybe<PixelRegionBreakdownFilters>;
};


export type BaReportsPixelReturningUserBreakdownArgs = {
  filters?: InputMaybe<PixelReturningUserBreakdownFilters>;
};


export type BaReportsPixelRuleConversionsArgs = {
  filters?: InputMaybe<PixelRuleConversionsFilters>;
};


export type BaReportsPixelSmokeTestArgs = {
  filters?: InputMaybe<PixelSmokeTestFilters>;
};


export type BaReportsPixelStatsArgs = {
  filters?: InputMaybe<PixelStatsFilters>;
};


export type BaReportsPixelTopLandingPagesArgs = {
  filters?: InputMaybe<PixelTopLandingPagesFilters>;
};


export type BaReportsPixelTopReferralsArgs = {
  filters?: InputMaybe<PixelTopReferralsFilters>;
};


export type BaReportsProductTagStatsArgs = {
  filters?: InputMaybe<ProductTagStatsFilters>;
};


export type BaReportsProductTagTemporalStatsArgs = {
  filters?: InputMaybe<ProductTagTemporalStatsFilters>;
};


export type BaReportsProfileCampaignsOverTimeArgs = {
  filters?: InputMaybe<ProfileCampaignsOverTimeFilters>;
};


export type BaReportsProfileConversionBreakdownArgs = {
  filters?: InputMaybe<ProfileConversionBreakdownFilters>;
};


export type BaReportsProfileConversionTypesArgs = {
  filters?: InputMaybe<ProfileConversionTypesFilters>;
};


export type BaReportsProfileImpressionSourcesArgs = {
  filters?: InputMaybe<ProfileImpressionSourcesFilters>;
};


export type BaReportsProfileIndustriesArgs = {
  filters?: InputMaybe<ProfileIndustriesFilters>;
};


export type BaReportsProfilePageNamesArgs = {
  filters?: InputMaybe<ProfilePageNamesFilters>;
};


export type BaReportsProfilePageTypeBreakdownArgs = {
  filters?: InputMaybe<ProfilePageTypeBreakdownFilters>;
};


export type BaReportsProfilePageTypesArgs = {
  filters?: InputMaybe<ProfilePageTypesFilters>;
};


export type BaReportsProfileStatsArgs = {
  filters?: InputMaybe<ProfileStatsFilters>;
};


export type BaReportsProfileStatsOverTimeArgs = {
  filters?: InputMaybe<ProfileStatsOverTimeFilters>;
};


export type BaReportsProfileTopPagesArgs = {
  filters?: InputMaybe<ProfileTopPagesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfileTopPagesSort>;
};


export type BaReportsProfileTrafficSourcesArgs = {
  filters?: InputMaybe<ProfileTrafficSourcesFilters>;
};


export type BaReportsSalesConversionsArgs = {
  filters?: InputMaybe<SalesConversionsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BaReportsTaggedProductsByRecordArgs = {
  filters?: InputMaybe<TaggedProductsByRecordFilters>;
};


export type BaReportsTaggedRecordsArgs = {
  filters?: InputMaybe<TaggedRecordsFilters>;
  sort?: InputMaybe<TaggedRecordsSort>;
};


export type BaReportsTopClickedTagsArgs = {
  filters?: InputMaybe<TopClickedTagsFilters>;
};

export enum BmDateRange {
  Last3Months = 'Last3Months',
  Last6Months = 'Last6Months',
  LastMonth = 'LastMonth',
  LastYear = 'LastYear'
}

/** Public Professional projection plus the live-ticket count stamped to that Professional for this event. Used by the Business Manager Exhibitors tab and the Tickets \"Professional\" filter. */
export type BmEventExhibitor = {
  __typename?: 'BMEventExhibitor';
  CompanyLogo?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  LogoBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** When true (default), booth staff at this event share one mobile Leads list for this exhibitor. When false, each team member only sees contacts they personally scanned. */
  SharedLeads: Scalars['Boolean']['output'];
  /** Count of non-soft-deleted EventTickets where ProfessionalID matches this exhibitor for this event (all ticket types). */
  TicketCount: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  URLSegment?: Maybe<Scalars['String']['output']>;
};

/** Lightweight option entry describing a member who has issued tickets for the event. Used to populate the BM tickets \"Issued by\" filter. */
export type BmEventIssuer = {
  __typename?: 'BMEventIssuer';
  DisplayName: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
};

/** Curated subset of EventDetails fields editable from the Business Manager Settings tab. Each field is optional; only supplied fields are written. */
export type BmEventSettingsInput = {
  AllowExhibitorGuestInvites?: InputMaybe<Scalars['Boolean']['input']>;
  AllowExhibitorTeamMemberInvites?: InputMaybe<Scalars['Boolean']['input']>;
  AllowProfessionalTeamMemberInvites?: InputMaybe<Scalars['Boolean']['input']>;
  AutoIssueTicketsForNewHomeownerSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  AutoIssueTicketsForNewProfessionalSubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Market code (NZ, AU, US). Empty string clears the value. */
  Country?: InputMaybe<Scalars['String']['input']>;
  DisplayTitle?: InputMaybe<Scalars['String']['input']>;
  Location?: InputMaybe<Scalars['String']['input']>;
  MaxGuestInvitesPerExhibitor?: InputMaybe<Scalars['Int']['input']>;
  MaxGuestInvitesPerRegistrant?: InputMaybe<Scalars['Int']['input']>;
  MaxTeamMemberInvitesPerExhibitor?: InputMaybe<Scalars['Int']['input']>;
  MaxTeamMemberInvitesPerProfessional?: InputMaybe<Scalars['Int']['input']>;
  /** One of draft, active, closed, finished. */
  RegistrationStatus?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated wrapper around event submissions for a Business Manager event. */
export type BmEventSubmissionsResult = {
  __typename?: 'BMEventSubmissionsResult';
  /** Submissions for the current page after filters and sort. */
  Items: Array<EventSubmission>;
  /** Total number of submissions matching the filters (ignoring pagination). */
  TotalCount: Scalars['Int']['output'];
};

/** Paginated wrapper around event tickets for a Business Manager event. */
export type BmEventTicketsResult = {
  __typename?: 'BMEventTicketsResult';
  /** Tickets for the current page after filters and sort. */
  Items: Array<EventTicket>;
  /** Total number of tickets matching the filters (ignoring pagination). */
  TotalCount: Scalars['Int']['output'];
};

/** Per-viewer derived ticket-issuing eligibility for a Business Manager event, scoped to the BM-context Professional. Combines event flags, viewer role (owner / exhibitor / professional / staff-admin), and per-Professional caps. */
export type BmEventViewerTicketEligibility = {
  __typename?: 'BMEventViewerTicketEligibility';
  /** Ticket-type strings the viewer may issue right now (after applying flags + caps). Empty when none. */
  AvailableTypes: Array<Scalars['String']['output']>;
  /** Remaining Homeowner-type guest tickets the viewer's Professional may issue. Null when uncapped (cap = 0 or path not allowed). */
  RemainingExhibitorGuestSlots?: Maybe<Scalars['Int']['output']>;
  /** Remaining Exhibitor-type tickets the viewer's Professional may issue. Null when uncapped (cap = 0 or path not allowed). */
  RemainingExhibitorTeamMemberSlots?: Maybe<Scalars['Int']['output']>;
  /** Remaining Professional-type tickets the viewer's Professional may issue. Null when uncapped (cap = 0 or path not allowed). */
  RemainingProfessionalTeamMemberSlots?: Maybe<Scalars['Int']['output']>;
  /** Ticket-type strings the viewer may revoke on this event (role + flag matrix only — caps do not constrain revoke). Owner-team and staff-admin get every type; exhibitor / professional get the same set they may issue. Drives the per-row Revoke button display so the UI gate matches the server. */
  RevokableTypes: Array<Scalars['String']['output']>;
};

/** Response payload returned by the bm ticket issuance mutations. */
export type BmIssueEventTicketResult = {
  __typename?: 'BMIssueEventTicketResult';
  /** True when a new ticket was created; false when an existing live ticket was reused. */
  Created: Scalars['Boolean']['output'];
  /** The ticket that was created (or already existed) when the operation succeeded. */
  Ticket?: Maybe<EventTicket>;
};

/** Lightweight Professional summary used by Business Manager search pickers (e.g. choosing the exhibitor Professional when issuing an Exhibitor ticket). */
export type BmProfessionalLookup = {
  __typename?: 'BMProfessionalLookup';
  CompanyLogo?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  LogoBackgroundColor?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  URLSegment?: Maybe<Scalars['String']['output']>;
};

/** Response payload returned by the bm ticket revoke mutation. */
export type BmRevokeEventTicketResult = {
  __typename?: 'BMRevokeEventTicketResult';
  /** The ID of the ticket that was revoked. Returned so clients can evict the record from cache. */
  ID: Scalars['ID']['output'];
  /** True when the ticket was soft-deleted by this call. */
  Revoked: Scalars['Boolean']['output'];
};

/** Response payload after queueing bulk ticket QR emails. */
export type BmSendEventTicketQrEmailsResult = {
  __typename?: 'BMSendEventTicketQrEmailsResult';
  /** Number of per-ticket send jobs queued. */
  QueuedCount: Scalars['Int']['output'];
  /** Tickets excluded because they lacked a recipient email or were outside the request. */
  SkippedCount: Scalars['Int']['output'];
};

/** Response payload returned by the bm event settings update mutation. */
export type BmUpdateEventSettingsResult = {
  __typename?: 'BMUpdateEventSettingsResult';
  /** The updated event so Apollo can normalise the cache without a follow-up fetch. */
  Event: EventDetails;
};

export type BackgroundImages_Connection = {
  __typename?: 'BackgroundImages_Connection';
  edges: Array<BackgroundImages_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BackgroundImages_ConnectionEdge = {
  __typename?: 'BackgroundImages_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImageFile;
};

export type BackgroundImages_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type BannerModule = ModuleType & {
  __typename?: 'BannerModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export enum BannerSegmentEnum {
  Aboutus = 'ABOUTUS',
  Articles = 'ARTICLES',
  Carousel = 'CAROUSEL',
  Contact = 'CONTACT',
  Network = 'NETWORK',
  Products = 'PRODUCTS',
  Projects = 'PROJECTS',
  Videos = 'VIDEOS'
}

export type BenchmarkAttentionShareFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type BenchmarkCategoryEngagementFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BenchmarkCategoryHealthFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BenchmarkLeadGenerateFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  LEADS_MONTH__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BenchmarkProductHealthFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type BenchmarkStatsFilters = {
  CATEGORY_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BenchmarkTierOnePerformanceFilters = {
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BenchmarkTierOnePerformanceSort = {
  AVG_PRODUCTS_PER_PROFESSIONAL?: InputMaybe<PrioritySort>;
  CATEGORY?: InputMaybe<PrioritySort>;
  TOTAL_PRODUCTS_IN_CATEGORY?: InputMaybe<PrioritySort>;
  YOUR_CATEGORY_HEALTH_SCORE?: InputMaybe<PrioritySort>;
  YOUR_CATEGORY_OWNERSHIP?: InputMaybe<PrioritySort>;
  YOUR_PRODUCT_COUNT?: InputMaybe<PrioritySort>;
  YOUR_SHARE_OF_ATTENTION_TIME?: InputMaybe<PrioritySort>;
  YOUR_SHARE_OF_PAGE_VIEWS?: InputMaybe<PrioritySort>;
};

export type BenchmarkTierTwoPerformanceFilters = {
  MONTH_OF_YEAR__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  PARENT_CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

/** Membership billing payment methods list and Stripe.js publishable key */
export type BillingPaymentMethodsPayload = {
  __typename?: 'BillingPaymentMethodsPayload';
  CanManage: Scalars['Boolean']['output'];
  CompletedSetupPaymentMethodID?: Maybe<Scalars['String']['output']>;
  MainCurrencyCode: Scalars['String']['output'];
  Methods: Array<MembershipPaymentMethod>;
  PublishableKey?: Maybe<Scalars['String']['output']>;
  StripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type BillingRecipientResponse = NotAuthorizedError | NotFoundError | ServerError | TeamMember | UserError;

/** Tag categorising a billing recipient for notification routing (DecisionMaker, AccountsAndBilling, Marketing). */
export enum BillingRecipientTag {
  AccountsAndBilling = 'AccountsAndBilling',
  DecisionMaker = 'DecisionMaker',
  Marketing = 'Marketing'
}

/** Stripe SetupIntent for adding a membership billing card (same shape as ecommerce SetupIntent) */
export type BillingSetupIntent = {
  __typename?: 'BillingSetupIntent';
  ClientSecret: Scalars['String']['output'];
  ID: Scalars['String']['output'];
};

export type BillingSetupIntentResponse = BillingSetupIntent | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type BlacklistedFields = {
  __typename?: 'BlacklistedFields';
  items?: Maybe<Array<Scalars['String']['output']>>;
};

export type BlockUsersResponse = BlockUsersResult | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** The result of the `blockUsers` mutation. */
export type BlockUsersResult = {
  __typename?: 'BlockUsersResult';
  /** The IDs of the users added to the block list. */
  BlockedMemberIDs: Array<Scalars['Int']['output']>;
};

/** Indicators that help assess project completeness and readiness for public display. */
export type BmProjectQuality = {
  __typename?: 'BmProjectQuality';
  /** True when the project was created via the profile builder. */
  CreatedViaProfileBuilder: Scalars['Boolean']['output'];
  /** True when every visible gallery image has a photo credit (professional or name). */
  HasPhotographyCredit: Scalars['Boolean']['output'];
  /** True when the project has at least one Project team member (project team step) or a tagged professional linked to the project. */
  HasProjectTeam: Scalars['Boolean']['output'];
  /** Number of gallery images shown on the project page (non-banner, on-page, file present). */
  VisibleImageCount: Scalars['Int']['output'];
  /** True when at least one visible gallery image is below the minimum short-edge resolution. */
  WarningLowResolutionImage: Scalars['Boolean']['output'];
  /** True when the project has visible images and at least one is missing a photo credit. */
  WarningMissingPhotographyCredit: Scalars['Boolean']['output'];
  /** True when the project description is shorter than the configured minimum length. */
  WarningShortDescription: Scalars['Boolean']['output'];
};

export type BookCalendarEventInput = {
  /** Company name actually provided by the user (for storage, null if not provided) */
  clientCompany?: InputMaybe<Scalars['String']['input']>;
  /** Email of the client director's connected calendar */
  clientDirectorEmail: Scalars['String']['input'];
  /** Email of the client booking the event */
  clientEmail: Scalars['String']['input'];
  /** Full name of the client booking the event */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the company booking the event (for display/event creation, may include fallbacks) */
  company: Scalars['String']['input'];
  /** Detailed description of the event */
  customMessage?: InputMaybe<Scalars['String']['input']>;
  /** Duration of the event in minutes */
  duration: Scalars['Int']['input'];
  /** Name/title of the event (optional - generated from session if not provided) */
  eventName?: InputMaybe<Scalars['String']['input']>;
  /** Location of the event */
  locationString?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organizer professional member */
  organizerId: Scalars['Int']['input'];
  /** Event ID to reschedule (if provided, updates existing event instead of creating new) */
  originalEventId?: InputMaybe<Scalars['String']['input']>;
  /** Array of minutes before the event to send reminders (e.g. [1440, 60, 30] for 1 day, 1 hour, 30 minutes) */
  reminderMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Optional ID of the calendar session for this booking */
  sessionId?: InputMaybe<Scalars['Int']['input']>;
  /** Start time of the event in ISO format */
  startTime: Scalars['String']['input'];
  /** Brief summary of the event */
  summary?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone name for Outlook bookings (e.g. \"Pacific/Auckland\") */
  timezoneName?: InputMaybe<Scalars['String']['input']>;
};

export type BookCalendarEventResult = {
  __typename?: 'BookCalendarEventResult';
  /** Error message if booking failed */
  error?: Maybe<Scalars['String']['output']>;
  /** ID of the created calendar event */
  eventId?: Maybe<Scalars['String']['output']>;
  /** Whether the event was successfully booked */
  success: Scalars['Boolean']['output'];
};

export type BookingByEventId = {
  __typename?: 'BookingByEventId';
  /** Company name of the client */
  clientCompany: Scalars['String']['output'];
  /** Email of the client who booked the event */
  clientEmail: Scalars['String']['output'];
  /** Name of the client who booked the event */
  clientName: Scalars['String']['output'];
  /** Event ID (Google or Outlook) */
  eventId: Scalars['String']['output'];
  /** ID of the organizer member who owns the calendar */
  organizerId?: Maybe<Scalars['Int']['output']>;
  /** ID of the calendar session */
  sessionId?: Maybe<Scalars['Int']['output']>;
};

export type BooleanResult = {
  __typename?: 'BooleanResult';
  Message?: Maybe<Scalars['String']['output']>;
  Success: Scalars['Boolean']['output'];
};

export type BrandImpressionTopPerformer = {
  __typename?: 'BrandImpressionTopPerformer';
  DirectoryItem: DirectoryItem;
  ID: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  Rank: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  TotalImpressions: Scalars['Int']['output'];
};

export type BuildHub = {
  __typename?: 'BuildHub';
  AvailableStages: Array<BuildHubStage>;
  Brief?: Maybe<BuildHubBrief>;
  Budget?: Maybe<BuildHubBudget>;
  BuildStage?: Maybe<Scalars['String']['output']>;
  CanComment: Scalars['Boolean']['output'];
  CanCreate: Scalars['Boolean']['output'];
  CanDelete: Scalars['Boolean']['output'];
  CanEdit: Scalars['Boolean']['output'];
  CanEditCollaborator: Scalars['Boolean']['output'];
  Collaborators: Array<BuildHubCollaborator>;
  Created: Scalars['String']['output'];
  CurrentUserRole?: Maybe<BuildHubRoleEnum>;
  EndDate?: Maybe<Scalars['String']['output']>;
  /** Linked HDE EventDetails ID when this BuildHub was created from an HDE flow (0 if none) */
  HdeEventID?: Maybe<Scalars['Int']['output']>;
  ID: Scalars['ID']['output'];
  Inspirations: InspirationGroupsConnection;
  IsOwner: Scalars['Boolean']['output'];
  IsPersonalWorkspace: Scalars['Boolean']['output'];
  LastActivity?: Maybe<Scalars['String']['output']>;
  LastEdited: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  Location?: Maybe<Scalars['String']['output']>;
  LocationData?: Maybe<PlaceDetailType>;
  MainDescription?: Maybe<Scalars['String']['output']>;
  Milestones: Array<BuildHubMilestone>;
  Owner: Member;
  ProjectScope?: Maybe<Scalars['String']['output']>;
  ProjectType?: Maybe<BuildHubTypeEnum>;
  StartDate?: Maybe<Scalars['String']['output']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  TimelineSettings?: Maybe<BuildHubTimelineSettings>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  UnreadCount: Scalars['Int']['output'];
};


export type BuildHubInspirationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<InspirationsSimpleSortFields>;
};

export type BuildHubBrief = {
  __typename?: 'BuildHubBrief';
  HTMLContent?: Maybe<Scalars['String']['output']>;
  RawContent?: Maybe<Scalars['String']['output']>;
};

export type BuildHubBudget = {
  __typename?: 'BuildHubBudget';
  Currency: Scalars['String']['output'];
  Max: Scalars['Float']['output'];
  Min: Scalars['Float']['output'];
};

export type BuildHubBudgetOption = {
  __typename?: 'BuildHubBudgetOption';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type BuildHubCollaborator = {
  __typename?: 'BuildHubCollaborator';
  Caption?: Maybe<Scalars['String']['output']>;
  CustomCompanyName?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  InvitedByMemberID?: Maybe<Scalars['Int']['output']>;
  LastInviteLink?: Maybe<Scalars['String']['output']>;
  LastInviteSent?: Maybe<Scalars['String']['output']>;
  Member?: Maybe<Member>;
  Role?: Maybe<BuildHubRoleEnum>;
  SortOrder: Scalars['Int']['output'];
  TeamMember?: Maybe<TeamMember>;
};

/** Successful result of a bulk collaborator add, containing per-email results */
export type BuildHubCollaboratorAddResponse = {
  __typename?: 'BuildHubCollaboratorAddResponse';
  Results: Array<BuildHubCollaboratorInviteResult>;
};

/** Per-email result from a bulk collaborator invite operation */
export type BuildHubCollaboratorInviteResult = {
  __typename?: 'BuildHubCollaboratorInviteResult';
  Email: Scalars['String']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  Success: Scalars['Boolean']['output'];
};

export type BuildHubCollaboratorResponse = BuildHubCollaborator | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type BuildHubComment = {
  __typename?: 'BuildHubComment';
  Author: Member;
  Created: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  LastEdited: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  LinkedFiles: Array<BuildHubDocument>;
  Message: Scalars['String']['output'];
  Replies?: Maybe<Array<BuildHubComment>>;
  Target: BuildHubDocument;
  Thread?: Maybe<BuildHubComment>;
};

export type BuildHubCommentResponse = BuildHubComment | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type BuildHubConnection = {
  __typename?: 'BuildHubConnection';
  edges: Array<BuildHubConnectionEdge>;
  nodes: Array<BuildHub>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildHubConnectionEdge = {
  __typename?: 'BuildHubConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildHub;
};

export type BuildHubDocument = {
  Breadcrumbs: Scalars['String']['output'];
  BuildHub: BuildHub;
  CanComment: Scalars['Boolean']['output'];
  CanCreate: Scalars['Boolean']['output'];
  CanDelete: Scalars['Boolean']['output'];
  CanEdit: Scalars['Boolean']['output'];
  Children: Array<BuildHubDocument>;
  Collaborators: Array<BuildHubDocumentCollaborator>;
  Comments: Array<BuildHubComment>;
  CommentsCount: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  EffectiveAccessMode: Scalars['String']['output'];
  EffectiveAccessRole: Scalars['String']['output'];
  FollowersCount: Scalars['Int']['output'];
  FutureTeamMemberRole: Scalars['String']['output'];
  GeneralAccessMode: Scalars['String']['output'];
  GeneralAccessRole: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  InheritPermissions: Scalars['Boolean']['output'];
  IsCollaborator: Scalars['Boolean']['output'];
  IsFile: Scalars['Boolean']['output'];
  IsFolder: Scalars['Boolean']['output'];
  IsFollower: Scalars['Boolean']['output'];
  LastActivity?: Maybe<Scalars['String']['output']>;
  LastEdited: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  NegativeReactionsCount: Scalars['Int']['output'];
  Owner: Member;
  Parent?: Maybe<BuildHubDocument>;
  PositiveReactionsCount: Scalars['Int']['output'];
  Private: Scalars['Boolean']['output'];
  Reactions: Array<BuildHubReaction>;
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  UnreadCount: Scalars['Int']['output'];
};

export type BuildHubDocumentAccessInput = {
  FutureTeamMemberRole?: InputMaybe<Scalars['String']['input']>;
  GeneralAccessMode: Scalars['String']['input'];
  GeneralAccessRole: Scalars['String']['input'];
  InheritPermissions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildHubDocumentCollaborator = {
  __typename?: 'BuildHubDocumentCollaborator';
  BuildHubDocument: BuildHubDocument;
  Email: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  Image?: Maybe<Scalars['String']['output']>;
  LastInviteLink?: Maybe<Scalars['String']['output']>;
  Member?: Maybe<Member>;
  Name: Scalars['String']['output'];
  Role: BuildHubDocumentRoleEnum;
  SortOrder: Scalars['Int']['output'];
};

export type BuildHubDocumentCollaboratorAddResult = BuildHubCollaboratorAddResponse | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type BuildHubDocumentCollaboratorInput = {
  Email: Scalars['String']['input'];
  Message?: InputMaybe<Scalars['String']['input']>;
  Role: Scalars['String']['input'];
};

export type BuildHubDocumentResponse = InspirationGroup | InspirationItem | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Roles BuildHub Document Collaborators can take on. */
export enum BuildHubDocumentRoleEnum {
  Commenter = 'Commenter',
  Editor = 'Editor',
  Viewer = 'Viewer'
}

export type BuildHubMilestone = {
  __typename?: 'BuildHubMilestone';
  BuildHubID: Scalars['Int']['output'];
  Date?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  IsCompleted: Scalars['Boolean']['output'];
  IsDisabled?: Maybe<Scalars['Boolean']['output']>;
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};

/** Filter options for project ownership. */
export enum BuildHubOwnershipFilterEnum {
  All = 'All',
  Collaborating = 'Collaborating',
  Owned = 'Owned'
}

export type BuildHubProjectScope = {
  __typename?: 'BuildHubProjectScope';
  budgetOptions: Array<BuildHubBudgetOption>;
  description: Scalars['String']['output'];
  emoji: Scalars['String']['output'];
  label: Scalars['String']['output'];
  stages: Array<BuildHubStageOption>;
  value: Scalars['String']['output'];
};

export type BuildHubReaction = {
  __typename?: 'BuildHubReaction';
  ByBuildHubOwner: Scalars['Boolean']['output'];
  ByDocumentOwner: Scalars['Boolean']['output'];
  Collaborator?: Maybe<BuildHubCollaborator>;
  Created: Scalars['String']['output'];
  Document: BuildHubDocument;
  ID: Scalars['ID']['output'];
  LastEdited: Scalars['String']['output'];
  Member: Member;
  Polarity: ReactionPolarityEnum;
  Reaction: ReactionTypeEnum;
};

export type BuildHubReactionResponse = BuildHubReaction | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type BuildHubResponse = BuildHub | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Roles BuildHub Collaborators can take on. */
export enum BuildHubRoleEnum {
  Admin = 'Admin',
  Editor = 'Editor',
  Viewer = 'Viewer'
}

export type BuildHubStage = {
  __typename?: 'BuildHubStage';
  Assignee?: Maybe<BuildHubCollaborator>;
  AssigneeID?: Maybe<Scalars['Int']['output']>;
  BuildHubID: Scalars['Int']['output'];
  CompletionDate?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  IsActive: Scalars['Boolean']['output'];
  IsCompleted: Scalars['Boolean']['output'];
  IsDisabled?: Maybe<Scalars['Boolean']['output']>;
  Progress?: Maybe<Scalars['Int']['output']>;
  SortOrder: Scalars['Int']['output'];
  StartDate?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};

export type BuildHubStageConfiguration = {
  __typename?: 'BuildHubStageConfiguration';
  commercial: Array<BuildHubProjectScope>;
  internal: Array<BuildHubProjectScope>;
  residential: Array<BuildHubProjectScope>;
};

export type BuildHubStageInput = {
  assigneeID?: InputMaybe<Scalars['Int']['input']>;
  completionDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  urlSegment: Scalars['String']['input'];
};

export type BuildHubStageOption = {
  __typename?: 'BuildHubStageOption';
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  urlSegment: Scalars['String']['output'];
};

export type BuildHubTimelineSettings = {
  __typename?: 'BuildHubTimelineSettings';
  BuildHubID: Scalars['Int']['output'];
  HighlightNonWorkingDays: Scalars['Boolean']['output'];
  ID: Scalars['ID']['output'];
  ShowGridLines: Scalars['Boolean']['output'];
  ShowMinorGridLines: Scalars['Boolean']['output'];
  ShowNonWorkingDays: Scalars['Boolean']['output'];
  ViewMode: Scalars['String']['output'];
  WorkingDays: Scalars['String']['output'];
};

/** The different markets the Build can be targeted at. */
export enum BuildHubTypeEnum {
  Commercial = 'Commercial',
  Internal = 'Internal',
  Residential = 'Residential'
}

export type BuildHubsFilterInput = {
  /** When set to a positive BuildHub ID, only that BuildHub is returned */
  BuildHubID?: InputMaybe<Scalars['Int']['input']>;
  /** When set to a positive EventDetails ID, only BuildHubs linked to that HDE event are returned */
  HdeEventID?: InputMaybe<Scalars['Int']['input']>;
  /** Filter projects by ownership role */
  Ownership?: InputMaybe<BuildHubOwnershipFilterEnum>;
  /** Filter projects by title containing the search string */
  TitleContains?: InputMaybe<Scalars['String']['input']>;
};

export type BuildingGuide = DirectoryItem & IApprovable & ICreatable & IHasProfessional & IHomePinable & IPublishable & SortableItem & {
  __typename?: 'BuildingGuide';
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']['output']>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
  AssociatedPages: BuildingGuide_AssociatedPagesConnection;
  Author?: Maybe<Member>;
  AvailabilityZones: Array<Zone>;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  ByArchipro?: Maybe<Scalars['Boolean']['output']>;
  CallToActions: Array<CallToAction>;
  CanonicalLink?: Maybe<Scalars['String']['output']>;
  Categories: Array<Category>;
  Clones?: Maybe<Array<DirectoryItem>>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentBlocks?: Maybe<Array<ContentBlock>>;
  ContentComment?: Maybe<Scalars['String']['output']>;
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']['output']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  CreatedTimestamp: Scalars['Int']['output'];
  DataQualityRating: Scalars['Float']['output'];
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  Disable: Scalars['Boolean']['output'];
  FacebookPreviewImage?: Maybe<Scalars['String']['output']>;
  FirstPublishedDate?: Maybe<Scalars['String']['output']>;
  HasClones: Scalars['Boolean']['output'];
  HasDownloads: Scalars['Boolean']['output'];
  HasPhotos: Scalars['Boolean']['output'];
  HasProducts: Scalars['Boolean']['output'];
  HasProjects: Scalars['Boolean']['output'];
  HasTags: Scalars['Boolean']['output'];
  HasVideos: Scalars['Boolean']['output'];
  HomePinned: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']['output']>;
  IntroText?: Maybe<Scalars['String']['output']>;
  IsCloned: Scalars['Boolean']['output'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean']['output'];
  IsFeature: Scalars['Boolean']['output'];
  /** True if published and activated */
  IsLive: Scalars['Boolean']['output'];
  IsManufacturer: Scalars['Boolean']['output'];
  IsTemplate: Scalars['Boolean']['output'];
  LastEditedDate?: Maybe<Scalars['String']['output']>;
  LastEditedTimestamp: Scalars['Int']['output'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String']['output'];
  LiveDateTimestamp?: Maybe<Scalars['Int']['output']>;
  MemberSortOrder: Scalars['Int']['output'];
  Meta?: Maybe<Meta>;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String']['output'];
  ParentID: Scalars['Int']['output'];
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean']['output'];
  PublishDate?: Maybe<Scalars['String']['output']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']['output']>;
  ReadingMinutes: Scalars['Int']['output'];
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']['output']>;
  SampleMessagePlaceholder?: Maybe<Scalars['String']['output']>;
  SampleSubmitText?: Maybe<Scalars['String']['output']>;
  SampleText?: Maybe<Scalars['String']['output']>;
  SampleTitle?: Maybe<Scalars['String']['output']>;
  SamplesAddressRequired: Scalars['Boolean']['output'];
  SamplesAvailable: Scalars['Boolean']['output'];
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  ShowsInElasticSearch: Scalars['Boolean']['output'];
  SortOrder: Scalars['Int']['output'];
  Teaser?: Maybe<Scalars['String']['output']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String']['output'];
  TopBanner?: Maybe<LibraryItemBanner>;
  URLSegment: Scalars['String']['output'];
  ViewsCount: Scalars['Int']['output'];
  Website?: Maybe<Scalars['String']['output']>;
  WebsiteShort?: Maybe<Scalars['String']['output']>;
  WebsiteUntracked: Scalars['String']['output'];
  WordCount: Scalars['Int']['output'];
  deprecated_Awards?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type BuildingGuideApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BuildingGuideBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type BuildingGuideContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BuildingGuideLibraryImagesArgs = {
  IncludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type BuildingGuideLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildingGuidePublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type BuildingGuideReadingMinutesArgs = {
  WithPageBuilder?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BuildingGuideViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};


export type BuildingGuideWordCountArgs = {
  WithPageBuilder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildingGuideCategory = ICategory & {
  __typename?: 'BuildingGuideCategory';
  BuildingGuides: BuildingGuideCategory_BuildingGuidesConnection;
  Categories: BuildingGuideCategory_CategoriesConnection;
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']['output']>;
  Link: Scalars['String']['output'];
  MenuTitle: Scalars['String']['output'];
  Parent?: Maybe<BuildingGuideCategory>;
  Parents: BuildingGuideCategory_ParentsConnection;
  PrettyTitle: Scalars['String']['output'];
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
  URLSegment?: Maybe<Scalars['String']['output']>;
};


export type BuildingGuideCategoryBuildingGuidesArgs = {
  IDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  Visibility?: InputMaybe<BuildingGuideVisibility>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BuildingGuideCategory_BuildingGuidesSortFields>;
};


export type BuildingGuideCategoryCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BuildingGuideCategory_CategoriesSortFields>;
};


export type BuildingGuideCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};


export type BuildingGuideCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BuildingGuideCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildingGuideCategory_BuildingGuidesConnection = {
  __typename?: 'BuildingGuideCategory_BuildingGuidesConnection';
  edges: Array<BuildingGuideCategory_BuildingGuidesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuideCategory_BuildingGuidesConnectionEdge = {
  __typename?: 'BuildingGuideCategory_BuildingGuidesConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildingGuide;
};

export type BuildingGuideCategory_BuildingGuidesSortFields = {
  Created?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type BuildingGuideCategory_CategoriesConnection = {
  __typename?: 'BuildingGuideCategory_CategoriesConnection';
  edges: Array<BuildingGuideCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuideCategory_CategoriesConnectionEdge = {
  __typename?: 'BuildingGuideCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildingGuideCategory;
};

export type BuildingGuideCategory_CategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type BuildingGuideCategory_ParentsConnection = {
  __typename?: 'BuildingGuideCategory_ParentsConnection';
  edges: Array<BuildingGuideCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuideCategory_ParentsConnectionEdge = {
  __typename?: 'BuildingGuideCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildingGuideCategory;
};

export type BuildingGuideCheckoutSession = {
  __typename?: 'BuildingGuideCheckoutSession';
  SessionId?: Maybe<Scalars['String']['output']>;
};

export type BuildingGuideDownload = {
  __typename?: 'BuildingGuideDownload';
  File: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type BuildingGuideSection = {
  __typename?: 'BuildingGuideSection';
  CheckList?: Maybe<Array<Array<BuildingGuideDownload>>>;
  Description: Scalars['String']['output'];
  Guides?: Maybe<Array<BuildingGuide>>;
  ID: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  SectionBackground?: Maybe<Scalars['String']['output']>;
  SortOrder: Scalars['Int']['output'];
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};

export type BuildingGuideSubscription = {
  __typename?: 'BuildingGuideSubscription';
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export enum BuildingGuideVisibility {
  Disabled = 'Disabled',
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly'
}

export type BuildingGuide_AssociatedPagesConnection = {
  __typename?: 'BuildingGuide_AssociatedPagesConnection';
  edges: Array<BuildingGuide_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BuildingGuide_AssociatedPagesConnectionEdge = {
  __typename?: 'BuildingGuide_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type BulkUploadError = {
  __typename?: 'BulkUploadError';
  code: UploadErrorCodeEnum;
  files: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type BulkUploadResult = {
  __typename?: 'BulkUploadResult';
  errors?: Maybe<Array<BulkUploadError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum BusinessFocusEnum {
  Commercial = 'Commercial',
  Mixed = 'Mixed',
  Residential = 'Residential',
  Unspecified = 'Unspecified'
}

export enum BusinessManagementActions {
  BmAdminDelete = 'BM_ADMIN_DELETE',
  BmAdminEdit = 'BM_ADMIN_EDIT',
  BmAdminView = 'BM_ADMIN_VIEW',
  BmAdvertAdminEdit = 'BM_ADVERT_ADMIN_EDIT',
  BmAnalyticsDelete = 'BM_ANALYTICS_DELETE',
  BmAnalyticsEdit = 'BM_ANALYTICS_EDIT',
  BmAnalyticsView = 'BM_ANALYTICS_VIEW',
  BmArticleDelete = 'BM_ARTICLE_DELETE',
  BmArticleEdit = 'BM_ARTICLE_EDIT',
  BmArticleView = 'BM_ARTICLE_VIEW',
  BmCategoryPlacementView = 'BM_CATEGORY_PLACEMENT_VIEW',
  BmContentApprove = 'BM_CONTENT_APPROVE',
  BmContentDelete = 'BM_CONTENT_DELETE',
  BmContentEdit = 'BM_CONTENT_EDIT',
  BmContentView = 'BM_CONTENT_VIEW',
  BmDirectEnquiryView = 'BM_DIRECT_ENQUIRY_VIEW',
  BmEnhancedConversionsView = 'BM_ENHANCED_CONVERSIONS_VIEW',
  BmImageExport = 'BM_IMAGE_EXPORT',
  BmImageImport = 'BM_IMAGE_IMPORT',
  BmInboxDelete = 'BM_INBOX_DELETE',
  BmInboxEdit = 'BM_INBOX_EDIT',
  BmInboxReply = 'BM_INBOX_REPLY',
  BmInboxRevealContact = 'BM_INBOX_REVEAL_CONTACT',
  BmInboxShare = 'BM_INBOX_SHARE',
  BmInboxUpdateStatus = 'BM_INBOX_UPDATE_STATUS',
  BmInboxView = 'BM_INBOX_VIEW',
  BmIntegrationsSettings = 'BM_INTEGRATIONS_SETTINGS',
  BmInvoiceDelete = 'BM_INVOICE_DELETE',
  BmInvoiceEdit = 'BM_INVOICE_EDIT',
  BmInvoiceExport = 'BM_INVOICE_EXPORT',
  BmInvoiceMarkPaid = 'BM_INVOICE_MARK_PAID',
  BmInvoiceRefund = 'BM_INVOICE_REFUND',
  BmInvoiceSend = 'BM_INVOICE_SEND',
  BmInvoiceView = 'BM_INVOICE_VIEW',
  BmLeadsScopeAll = 'BM_LEADS_SCOPE_ALL',
  BmLeadsScopeSelf = 'BM_LEADS_SCOPE_SELF',
  BmMarketingView = 'BM_MARKETING_VIEW',
  BmMembershipDelete = 'BM_MEMBERSHIP_DELETE',
  BmMembershipEdit = 'BM_MEMBERSHIP_EDIT',
  BmMembershipView = 'BM_MEMBERSHIP_VIEW',
  BmOrdersView = 'BM_ORDERS_VIEW',
  BmPageTemplateApply = 'BM_PAGE_TEMPLATE_APPLY',
  BmPageTemplateCreate = 'BM_PAGE_TEMPLATE_CREATE',
  BmPlatformSync = 'BM_PLATFORM_SYNC',
  BmProductsDelete = 'BM_PRODUCTS_DELETE',
  BmProductsEdit = 'BM_PRODUCTS_EDIT',
  BmProductsView = 'BM_PRODUCTS_VIEW',
  BmProductTaggingApprove = 'BM_PRODUCT_TAGGING_APPROVE',
  BmProductTaggingCreate = 'BM_PRODUCT_TAGGING_CREATE',
  BmProductTaggingDelete = 'BM_PRODUCT_TAGGING_DELETE',
  BmProfessionalCreate = 'BM_PROFESSIONAL_CREATE',
  BmProfileDelete = 'BM_PROFILE_DELETE',
  BmProfileEdit = 'BM_PROFILE_EDIT',
  BmProfileView = 'BM_PROFILE_VIEW',
  BmProjectDelete = 'BM_PROJECT_DELETE',
  BmProjectEdit = 'BM_PROJECT_EDIT',
  BmProjectView = 'BM_PROJECT_VIEW',
  BmQuoteDelete = 'BM_QUOTE_DELETE',
  BmQuoteEdit = 'BM_QUOTE_EDIT',
  BmQuoteSend = 'BM_QUOTE_SEND',
  BmQuoteTemplateDelete = 'BM_QUOTE_TEMPLATE_DELETE',
  BmQuoteTemplateEdit = 'BM_QUOTE_TEMPLATE_EDIT',
  BmQuoteTemplateView = 'BM_QUOTE_TEMPLATE_VIEW',
  BmQuoteView = 'BM_QUOTE_VIEW',
  BmSettingUpdate = 'BM_SETTING_UPDATE',
  BmStaffView = 'BM_STAFF_VIEW',
  BmSupportView = 'BM_SUPPORT_VIEW',
  BmTermsDelete = 'BM_TERMS_DELETE',
  BmTermsEdit = 'BM_TERMS_EDIT',
  BmTermsView = 'BM_TERMS_VIEW'
}

export type BusinessModule = ModuleType & {
  __typename?: 'BusinessModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  /** Business support blocks */
  BusinessSupportBlocks: BusinessSupportBlocks_Connection;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  IntroText?: Maybe<Scalars['String']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};


export type BusinessModuleBusinessSupportBlocksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BusinessSupportBlocks_SortFields>;
};

export type BusinessSupportBlock = ModuleType & {
  __typename?: 'BusinessSupportBlock';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type BusinessSupportBlocks_Connection = {
  __typename?: 'BusinessSupportBlocks_Connection';
  edges: Array<BusinessSupportBlocks_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BusinessSupportBlocks_ConnectionEdge = {
  __typename?: 'BusinessSupportBlocks_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: BusinessSupportBlock;
};

export type BusinessSupportBlocks_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type BusinessTerms = {
  __typename?: 'BusinessTerms';
  CanDelete: Scalars['Boolean']['output'];
  Category?: Maybe<BusinessTermsCategory>;
  Countries: Array<Country>;
  HasUnpublishedChanges: Scalars['Boolean']['output'];
  ID: Scalars['ID']['output'];
  LastEdited: Scalars['String']['output'];
  Professional: Professional;
  PublishHistory: Array<BusinessTermsPublishHistory>;
  PublishedLastEdited: Scalars['String']['output'];
  PublishedTerms?: Maybe<TokenisedField>;
  PublishedTermsLexical?: Maybe<Scalars['String']['output']>;
  PublishedTitle: Scalars['String']['output'];
  PublishedVersion: Scalars['Int']['output'];
  Terms?: Maybe<TokenisedField>;
  TermsLexical?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};

export type BusinessTermsCategory = {
  __typename?: 'BusinessTermsCategory';
  ID: Scalars['ID']['output'];
  Title?: Maybe<Scalars['String']['output']>;
};

export type BusinessTermsPublishHistory = {
  __typename?: 'BusinessTermsPublishHistory';
  HasSubstantiveLexical: Scalars['Boolean']['output'];
  ID: Scalars['ID']['output'];
  PublishedAt: Scalars['String']['output'];
  PublishedBy?: Maybe<Member>;
  Version: Scalars['Int']['output'];
};

export type BusinessTermsResponse = BusinessTerms | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** A specific version of BusinessTerms linked to an invoice/quote */
export type BusinessTermsVersion = {
  __typename?: 'BusinessTermsVersion';
  Category?: Maybe<BusinessTermsCategory>;
  ID: Scalars['ID']['output'];
  Terms?: Maybe<TokenisedField>;
  TermsLexical?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  URL: Scalars['String']['output'];
  Version: Scalars['Int']['output'];
};

export type BusinessType = SortableItem & {
  __typename?: 'BusinessType';
  ID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
  ProfessionalID: Scalars['Int']['output'];
};

export enum BusinessTypeEnum {
  Franchisee = 'franchisee',
  Manufacturer = 'manufacturer',
  ResellerStockist = 'resellerStockist',
  Retailer = 'retailer',
  Wholesaler = 'wholesaler'
}

export type BusinessTypesConnection = {
  __typename?: 'BusinessTypesConnection';
  edges: Array<BusinessTypesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type BusinessTypesConnectionEdge = {
  __typename?: 'BusinessTypesConnectionEdge';
  /** The node at the end of the collections edge */
  node: BusinessType;
};

export type BusinessTypesSortFields = {
  ID?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type CalendarAttendee = {
  __typename?: 'CalendarAttendee';
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  responseStatus?: Maybe<Scalars['String']['output']>;
};

export type CalendarAvailabilityResult = {
  __typename?: 'CalendarAvailabilityResult';
  customMessage?: Maybe<Scalars['String']['output']>;
  durations?: Maybe<Array<CalendarSessionDuration>>;
  emailReminders?: Maybe<Array<CalendarSessionEmailReminder>>;
  freeDaysByDuration: Array<FreeDaysByDurationType>;
  isActive: Scalars['Boolean']['output'];
  locationString?: Maybe<Scalars['String']['output']>;
  locationType: Scalars['String']['output'];
  meetingCover?: Maybe<Scalars['String']['output']>;
  meetingType: Scalars['String']['output'];
  oneOnOneTeamMember?: Maybe<TeamMember>;
  professional: Professional;
  sessionID: Scalars['Int']['output'];
  sessionTitle: Scalars['String']['output'];
  teamMembers: Array<TeamMember>;
  timezone: Scalars['String']['output'];
  urlSegment: Scalars['String']['output'];
};

export type CalendarConnection = {
  __typename?: 'CalendarConnection';
  accessToken?: Maybe<Scalars['String']['output']>;
  connectedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type CalendarConnectionSummary = {
  __typename?: 'CalendarConnectionSummary';
  connectedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  isExpired: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
};

export type CalendarDataType = {
  __typename?: 'CalendarDataType';
  archiproCalendarId?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<CalendarConnection>;
  error?: Maybe<Scalars['String']['output']>;
  events: Array<CalendarEvent>;
  permissions?: Maybe<CalendarPermissions>;
  success: Scalars['Boolean']['output'];
  tokenExpired?: Maybe<Scalars['Boolean']['output']>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  attendees: Array<CalendarAttendee>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Whether this event is a public holiday */
  isHoliday?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type CalendarPermissions = {
  __typename?: 'CalendarPermissions';
  canCreateCalendars: Scalars['Boolean']['output'];
  canCreateEvents: Scalars['Boolean']['output'];
  grantedScopes: Array<Scalars['String']['output']>;
  hasWriteAccess: Scalars['Boolean']['output'];
};

export type CalendarSession = {
  __typename?: 'CalendarSession';
  Availability?: Maybe<Array<CalendarSessionAvailability>>;
  Created: Scalars['String']['output'];
  CustomMessage?: Maybe<Scalars['String']['output']>;
  CustomizedReminder?: Maybe<Scalars['String']['output']>;
  Durations?: Maybe<Array<CalendarSessionDuration>>;
  EmailReminders?: Maybe<Array<CalendarSessionEmailReminder>>;
  ID: Scalars['Int']['output'];
  IsActive: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  LocationString?: Maybe<Scalars['String']['output']>;
  LocationType: Scalars['String']['output'];
  MeetingCover?: Maybe<Scalars['String']['output']>;
  MeetingType: Scalars['String']['output'];
  OneOnOneTeamMember?: Maybe<TeamMember>;
  Professional: Professional;
  SessionName: Scalars['String']['output'];
  TeamMembers?: Maybe<Array<TeamMember>>;
  Timezone: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  UnavailableDateRanges?: Maybe<Array<CalendarSessionUnavailableDateRange>>;
};

export type CalendarSessionAvailability = {
  __typename?: 'CalendarSessionAvailability';
  CalendarSession: CalendarSession;
  Created: Scalars['String']['output'];
  Day: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  IsChecked: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  TimeSlots?: Maybe<Array<CalendarSessionAvailabilitySlot>>;
};

export type CalendarSessionAvailabilityInput = {
  day: Scalars['String']['input'];
  isChecked: Scalars['Boolean']['input'];
  timeSlots: Array<CalendarSessionAvailabilitySlotInput>;
};

export type CalendarSessionAvailabilitySlot = {
  __typename?: 'CalendarSessionAvailabilitySlot';
  Availability: CalendarSessionAvailability;
  Created: Scalars['String']['output'];
  EndTime: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  LastEdited: Scalars['String']['output'];
  StartTime: Scalars['String']['output'];
};

export type CalendarSessionAvailabilitySlotInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CalendarSessionDuration = {
  __typename?: 'CalendarSessionDuration';
  CalendarSession: CalendarSession;
  Checked?: Maybe<Scalars['Boolean']['output']>;
  Created: Scalars['String']['output'];
  Duration: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  LastEdited: Scalars['String']['output'];
};

export type CalendarSessionDurationInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  duration: Scalars['Int']['input'];
};

export type CalendarSessionEmailReminder = {
  __typename?: 'CalendarSessionEmailReminder';
  CalendarSession: CalendarSession;
  Created: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  LastEdited: Scalars['String']['output'];
  ReminderMinutes: Scalars['Int']['output'];
};

export type CalendarSessionEmailReminderInput = {
  reminderMinutes: Scalars['Int']['input'];
};

export type CalendarSessionUnavailableDateRange = {
  __typename?: 'CalendarSessionUnavailableDateRange';
  CalendarSession: CalendarSession;
  Created: Scalars['String']['output'];
  EndDate: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  LastEdited: Scalars['String']['output'];
  StartDate: Scalars['String']['output'];
};

export type CalendarSessionUnavailableDateRangeInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type CalendarSessionsConnection = {
  __typename?: 'CalendarSessionsConnection';
  edges: Array<CalendarSessionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CalendarSessionsConnectionEdge = {
  __typename?: 'CalendarSessionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: CalendarSession;
};

export type CalendarSessionsFilters = {
  /** Filter calendar sessions that are active */
  IsActive__in?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter calendar sessions by meeting type */
  MeetingType__eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter calendar sessions by member ID (covers both round-robin and one-on-one sessions, as one-on-one team members are added to TeamMembers) */
  MemberID__in?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarSessionsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  IsActive?: InputMaybe<SortDirection>;
  SessionName?: InputMaybe<SortDirection>;
};

export type CallToAction = {
  __typename?: 'CallToAction';
  ID: Scalars['Int']['output'];
  Link?: Maybe<Scalars['String']['output']>;
  Subtitle: Scalars['String']['output'];
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
};

export type CallToActionModule = ModuleType & {
  __typename?: 'CallToActionModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<EmailLink>;
  DesktopContent?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  MobileContent?: Maybe<Scalars['String']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type CampaignFilterFilters = {
  CAMPAIGN_SOURCE__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignFormFooterModule = ModuleType & {
  __typename?: 'CampaignFormFooterModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  FormEmbedURL?: Maybe<Scalars['String']['output']>;
  FormTitle?: Maybe<Scalars['String']['output']>;
  HeroImage?: Maybe<ResponsiveVariantImage>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export type CampaignHeaderModule = ModuleType & {
  __typename?: 'CampaignHeaderModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  FormEmbedURL?: Maybe<Scalars['String']['output']>;
  FormTitle?: Maybe<Scalars['String']['output']>;
  HeroImage?: Maybe<ResponsiveVariantImage>;
  ID: Scalars['ID']['output'];
  LeftImage?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export type CancelCalendarEventInput = {
  /** Event ID (Google or Outlook event ID) */
  eventId: Scalars['String']['input'];
  /** Optional provider ('google' or 'outlook'). If not provided, will be inferred from booking record. */
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type CancelCalendarEventResult = {
  __typename?: 'CancelCalendarEventResult';
  /** Error message if cancellation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the event was successfully cancelled */
  success: Scalars['Boolean']['output'];
};

export type CaptionCtaModule = ModuleType & {
  __typename?: 'CaptionCTAModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SecondaryCTA?: Maybe<SiteTreeLink>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  SubTitle?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

/** Card attached to a professional informing them of key pieces of information. */
export type Card = {
  __typename?: 'Card';
  CardType: CardType;
  Created: Scalars['String']['output'];
  DismissedAt?: Maybe<Scalars['String']['output']>;
  DismissedBy?: Maybe<TeamMember>;
  Expiry?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  LastEdited?: Maybe<Scalars['String']['output']>;
  Payload?: Maybe<CardPayload>;
  Professional: Professional;
  State: CardState;
  ViewedAt?: Maybe<Scalars['String']['output']>;
  ViewedBy?: Maybe<TeamMember>;
};

export type CardConnection = {
  __typename?: 'CardConnection';
  edges: Array<CardConnectionEdge>;
  nodes: Array<Card>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CardConnectionEdge = {
  __typename?: 'CardConnectionEdge';
  /** The node at the end of the collections edge */
  node: Card;
};

/** The payload for a card varies based on its type. */
export type CardPayload = {
  __typename?: 'CardPayload';
  AdResultsReady?: Maybe<AdResultsReadyCardPayload>;
  Article?: Maybe<Article>;
  Content?: Maybe<Scalars['String']['output']>;
  Enquiry?: Maybe<Enquiry>;
  Product?: Maybe<Product>;
  Professional?: Maybe<Professional>;
  Project?: Maybe<Project>;
  /** Relative public URL to the tagged library item with scrollToImageID (unlisted product tag cards). */
  TaggedOnRelativePath?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
};

/** The result type for a card mutation */
export type CardResult = Card | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Possible state in which an individual Card can be in. */
export enum CardState {
  Completed = 'Completed',
  Dismissed = 'Dismissed',
  Read = 'Read',
  Unread = 'Unread'
}

/** A Type that can be attached to a card. */
export type CardType = {
  __typename?: 'CardType';
  CardType: CardTypeEnum;
  Category: CardTypeCategory;
  Dismissible: Scalars['Boolean']['output'];
  Priority: Scalars['Int']['output'];
  Status: CardTypeStatus;
};

/** Category for a CardType. Can be use to group card type together. */
export enum CardTypeCategory {
  Analytics = 'Analytics',
  Content = 'Content',
  Leads = 'Leads',
  Milestones = 'Milestones',
  Network = 'Network',
  Profile = 'Profile'
}

/** A CardType string that can be attached to a card. */
export enum CardTypeEnum {
  AddBusinessAboutContentCardType = 'AddBusinessAboutContentCardType',
  AddBusinessEmailCardType = 'AddBusinessEmailCardType',
  AddBusinessFocusCardType = 'AddBusinessFocusCardType',
  AddBusinessHomepageBannerCardType = 'AddBusinessHomepageBannerCardType',
  AddBusinessLocationCardType = 'AddBusinessLocationCardType',
  AddBusinessLogoCardType = 'AddBusinessLogoCardType',
  AddBusinessNetworkCardType = 'AddBusinessNetworkCardType',
  AddBusinessPageBannerCardType = 'AddBusinessPageBannerCardType',
  AddBusinessTeamMemberCardType = 'AddBusinessTeamMemberCardType',
  AddBusinessTypeCardType = 'AddBusinessTypeCardType',
  ArticlePromotedCardType = 'ArticlePromotedCardType',
  CardTypeWithPayloadAnd30DaysExpiry = 'CardTypeWithPayloadAnd30DaysExpiry',
  DigitalPublicationResultsReadyCardType = 'DigitalPublicationResultsReadyCardType',
  FacebookAdResultsReadyCardType = 'FacebookAdResultsReadyCardType',
  FirstDownloadCardType = 'FirstDownloadCardType',
  FirstEnquiryCardType = 'FirstEnquiryCardType',
  ProjectPromotedCardType = 'ProjectPromotedCardType',
  TagClickCardType = 'TagClickCardType',
  TagRequireApprovalCardType = 'TagRequireApprovalCardType',
  UnlistedProductTagCardType = 'UnlistedProductTagCardType',
  YouHaveBeenTaggedCardType = 'YouHaveBeenTaggedCardType'
}

/** Status for a CardType. Used to clarify the purpose of a CardType. */
export enum CardTypeStatus {
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning'
}

export type CardsSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  Priority?: InputMaybe<SortDirection>;
};

export type CartItem = {
  __typename?: 'CartItem';
  AvailableShippingMethods: Array<ShippingMethod>;
  ClickAndCollect: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Price: CurrencyAmount;
  Quantity: Scalars['Int']['output'];
  RetailPrice: CurrencyAmount;
  RetailSubTotal?: Maybe<CurrencyAmount>;
  Sample: Scalars['Boolean']['output'];
  Selected: Scalars['Boolean']['output'];
  ShippingCost: CurrencyAmount;
  ShippingMethod?: Maybe<ShippingMethod>;
  ShippingProvider?: Maybe<ShippingProviderEnum>;
  SpecialtyPriceType?: Maybe<SpecialtyPriceTypeEnum>;
  SubTotal: CurrencyAmount;
  ValidShipping: Scalars['Boolean']['output'];
  Variant: Variant;
};

export type CartSupplier = {
  __typename?: 'CartSupplier';
  AvailablePickupLocations: Array<LibraryLocation>;
  CartItems: Array<CartItem>;
  CartSupplierTotal: CurrencyAmount;
  Comment: Scalars['String']['output'];
  CostToFreeShipping?: Maybe<CurrencyAmount>;
  ID: Scalars['Int']['output'];
  ItemCount: Scalars['Int']['output'];
  ItemTotal: CurrencyAmount;
  LastShippingMethod?: Maybe<ShippingMethod>;
  PickupLocation?: Maybe<LibraryLocation>;
  PickupUsedLast: Scalars['Boolean']['output'];
  Selected: Scalars['Boolean']['output'];
  ShippingCost: CurrencyAmount;
  Supplier: Professional;
};

export type Category = {
  __typename?: 'Category';
  Breadcrumb: Scalars['String']['output'];
  Facets: Array<Facet>;
  ID: Scalars['Int']['output'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  ItemsCount: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  Parent?: Maybe<Category>;
  ParentID?: Maybe<Scalars['Int']['output']>;
  Parents?: Maybe<Array<Maybe<Category>>>;
  PrettyTitle: Scalars['String']['output'];
  RecommendedImage?: Maybe<ResponsiveImage>;
  Sort: Scalars['Int']['output'];
  SortOrder?: Maybe<Scalars['String']['output']>;
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};


export type CategoryBreadcrumbArgs = {
  Separator?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryRecommendedImageArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryPage = {
  __typename?: 'CategoryPage';
  ID?: Maybe<Scalars['String']['output']>;
  Link: Scalars['String']['output'];
  Parents: PrimaryCategory_ParentsConnection;
  PrettyTitle?: Maybe<Scalars['String']['output']>;
  Sort?: Maybe<Scalars['Int']['output']>;
  URLSegment?: Maybe<Scalars['String']['output']>;
};


export type CategoryPageParentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ChartCollection = {
  __typename?: 'ChartCollection';
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  Series: Array<ChartSeries>;
};

export type ChartPlot = {
  __typename?: 'ChartPlot';
  ExtraData?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  PeriodStartIso?: Maybe<Scalars['String']['output']>;
  X: Scalars['Float']['output'];
  Y: Scalars['Float']['output'];
  Z?: Maybe<Scalars['Float']['output']>;
};

export type ChartSeries = {
  __typename?: 'ChartSeries';
  ID: Scalars['String']['output'];
  Label?: Maybe<Scalars['String']['output']>;
  Values: Array<ChartPlot>;
};

export type ChildRegionsConnection = {
  __typename?: 'ChildRegionsConnection';
  edges: Array<ChildRegionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ChildRegionsConnectionEdge = {
  __typename?: 'ChildRegionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Region;
};

export type CloneTask = {
  __typename?: 'CloneTask';
  ClonedProfessional?: Maybe<Professional>;
  CreatedAt: Scalars['Date']['output'];
  ID: Scalars['Int']['output'];
  LastEditedAt: Scalars['Date']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  SourceProfessional?: Maybe<Professional>;
  Status: AsyncTaskStatus;
};

export type Collaborator = {
  __typename?: 'Collaborator';
  AvatarURL?: Maybe<Scalars['String']['output']>;
  CanEdit: Scalars['Boolean']['output'];
  Email: Scalars['String']['output'];
  HasAccepted: Scalars['Boolean']['output'];
  ID: Scalars['String']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  ProfileImageLink?: Maybe<Scalars['String']['output']>;
};

export type ColorCategoriesConnection = {
  __typename?: 'ColorCategoriesConnection';
  edges: Array<ColorCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ColorCategoriesConnectionEdge = {
  __typename?: 'ColorCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductColor;
};

export type ColumnDimension = {
  __typename?: 'ColumnDimension';
  BuilderHeight: Scalars['Int']['output'];
  BuilderWidth: Scalars['Int']['output'];
  Height: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  IsPortrait: Scalars['Boolean']['output'];
  MobileHeight: Scalars['Int']['output'];
  MobileWidth: Scalars['Int']['output'];
  TabletHeight: Scalars['Int']['output'];
  TabletWidth: Scalars['Int']['output'];
  Width: Scalars['Int']['output'];
};

export type ColumnsConnection = {
  __typename?: 'ColumnsConnection';
  edges: Array<ColumnsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ColumnsConnectionEdge = {
  __typename?: 'ColumnsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ModuleColumn;
};

export type ColumnsSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
};

export type CombinedUnreadNotifications = {
  __typename?: 'CombinedUnreadNotifications';
  CompanyInboxes: Array<CompanyInboxUnreadNotification>;
  DesignBoardPinCount: Scalars['Int']['output'];
  PersonalInboxCount: Scalars['Int']['output'];
  WebsiteNotificationCount: Scalars['Int']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  Attachments?: Maybe<Array<Maybe<MemberUpload>>>;
  CanDelete: Scalars['Boolean']['output'];
  Content: Scalars['String']['output'];
  Created: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  IsMember: Scalars['Boolean']['output'];
  Items: Array<DirectoryItem>;
  MadeByTeamMember: Scalars['Boolean']['output'];
  Member: Member;
  ReadStatus: Array<Maybe<ReadStatus>>;
};

export type CommonMaterialsConnection = {
  __typename?: 'CommonMaterialsConnection';
  edges: Array<CommonMaterialsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CommonMaterialsConnectionEdge = {
  __typename?: 'CommonMaterialsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Material;
};

/** Companies group contacts under a Professional and support custom data fields. */
export type Company = {
  __typename?: 'Company';
  /** Company primary address */
  Address?: Maybe<Scalars['String']['output']>;
  /** Second line of the company address */
  AddressLineTwo?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Contacts: CompanyContactsConnection;
  /** Company country */
  Country?: Maybe<Scalars['String']['output']>;
  /** Custom arbitrary data that can be saved against a Company and a CustomField that admins can create */
  CustomData?: Maybe<Array<CustomCompanyData>>;
  /** HubSpot URL for the company, if linked to HubSpot */
  HubspotURL?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  /** Legal/registered company name */
  LegalName?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  PostCode?: Maybe<Scalars['String']['output']>;
  Professional: Professional;
  Region?: Maybe<Scalars['String']['output']>;
  Suburb?: Maybe<Scalars['String']['output']>;
  Website?: Maybe<Scalars['String']['output']>;
};


/** Companies group contacts under a Professional and support custom data fields. */
export type CompanyContactsArgs = {
  filter?: InputMaybe<CompanyContactsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CompanyContactsSortFields>;
};

export type CompanyActivitiesFilters = {
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  IS_ENGAGED__EQUAL?: InputMaybe<Scalars['String']['input']>;
  QUARTER_START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyActivitiesSort = {
  COMPANY_NAME?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  DOMAIN?: InputMaybe<PrioritySort>;
  INDUSTRIES?: InputMaybe<PrioritySort>;
  LOCATIONS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  USERS?: InputMaybe<PrioritySort>;
};

export type CompanyActivityIndustriesFilters = {
  IS_ENGAGED__EQUAL?: InputMaybe<Scalars['String']['input']>;
  QUARTER_START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyContactsConnection = {
  __typename?: 'CompanyContactsConnection';
  edges: Array<CompanyContactsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CompanyContactsConnectionEdge = {
  __typename?: 'CompanyContactsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Contact;
};

export type CompanyContactsFilters = {
  EmailContains?: InputMaybe<Scalars['String']['input']>;
  NameStartsWith?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyContactsSortFields = {
  Created?: InputMaybe<SortDirection>;
  FirstName?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  Surname?: InputMaybe<SortDirection>;
};

export type CompanyInboxUnreadNotification = {
  __typename?: 'CompanyInboxUnreadNotification';
  ProfessionalID: Scalars['Int']['output'];
  UnreadConversationCount: Scalars['Int']['output'];
};

export type CompanyResponse = Company | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type Consignment = {
  __typename?: 'Consignment';
  ConsignmentReference?: Maybe<Scalars['String']['output']>;
  Dispatch?: Maybe<Dispatch>;
  EstimatedDispatch?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  LeadTime: Scalars['Int']['output'];
  LeadTimeUnit?: Maybe<LeadTimeUnitEnum>;
  OrderItems: OrderItemsConnection;
  Packages: PackagesConnection;
  PickupLocation?: Maybe<LibraryLocation>;
  ShippingProvider?: Maybe<Scalars['String']['output']>;
  ShippingProviderStatus?: Maybe<Scalars['String']['output']>;
  Status: ConsignmentStatusEnum;
  SupplierOrder: SupplierOrder;
};


export type ConsignmentOrderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConsignmentPackagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsignmentPackage = {
  __typename?: 'ConsignmentPackage';
  Barcode?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  Height: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  LabelNumber: Scalars['Int']['output'];
  Length: Scalars['Int']['output'];
  PackagingType: Scalars['String']['output'];
  Weight: Scalars['Int']['output'];
  Width: Scalars['Int']['output'];
};

export type ConsignmentPackageInput = {
  Height: Scalars['Int']['input'];
  Length: Scalars['Int']['input'];
  PackageType: Scalars['StringInput']['input'];
  Weight: Scalars['Float']['input'];
  Width: Scalars['Int']['input'];
};

export enum ConsignmentStatusEnum {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  Transit = 'TRANSIT'
}

export type ConsignmentsConnection = {
  __typename?: 'ConsignmentsConnection';
  edges: Array<ConsignmentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ConsignmentsConnectionEdge = {
  __typename?: 'ConsignmentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Consignment;
};

/** Contacts are unique by Email under a specific Professional, it can be imported from CRM or added manually */
export type Contact = {
  __typename?: 'Contact';
  /** Contact address field */
  Address?: Maybe<Scalars['String']['output']>;
  /** Second line of the contact address */
  AddressLineTwo?: Maybe<Scalars['String']['output']>;
  /** Contact city field */
  City?: Maybe<Scalars['String']['output']>;
  Company?: Maybe<Company>;
  /** Contact country field */
  Country?: Maybe<Scalars['String']['output']>;
  /** Custom arbitrary data that can be saved against a Contact and a CustomField that admins can create */
  CustomData?: Maybe<Array<CustomContactData>>;
  Email: Scalars['Email']['output'];
  FirstName?: Maybe<Scalars['String']['output']>;
  HasStripePaymentMethod: Scalars['Boolean']['output'];
  /** HubSpot URL for the contact, if linked to HubSpot */
  HubspotURL?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  /** Internal note about this contact, only ever visible to the owning Professional's team (gated by Contact.canEdit). Never shown to the contact themselves and never included in any public, contact-facing, email, HubSpot sync, or pixel/export surface. */
  InternalNote?: Maybe<Scalars['String']['output']>;
  JobTitle?: Maybe<Scalars['String']['output']>;
  /** The latest lead activity recorded for this contact. */
  LastLeadActivity?: Maybe<LeadActivity>;
  /** Timestamp of the latest lead activity for this contact. */
  LastLeadActivityAt?: Maybe<Scalars['String']['output']>;
  /** Channel of the latest lead activity for this contact. */
  LastLeadActivityChannel?: Maybe<LeadChannelEnum>;
  /** Type of the latest lead activity for this contact. */
  LastLeadActivityType?: Maybe<LeadActivityTypeEnum>;
  /** Paginated activity timeline for this contact. */
  LeadActivities: ContactLeadActivitiesConnection;
  /** Total number of recorded lead activities for this contact. */
  LeadActivityCount: Scalars['Int']['output'];
  /** Supplier-scoped workflow status for following up this contact. */
  LeadStatus?: Maybe<LeadStatusEnum>;
  Phone?: Maybe<Scalars['String']['output']>;
  PhotoSrc?: Maybe<Scalars['String']['output']>;
  /** Contact postcode field */
  PostCode?: Maybe<Scalars['String']['output']>;
  Professional: Professional;
  /** Contact region or state field */
  Region?: Maybe<Scalars['String']['output']>;
  /** BuildHub snapshots the contact has shared with the owning Professional (currently via HDE QR scans). Replaced in place on each subsequent scan of the same BuildHub. */
  SharedProjects: Array<ContactSharedProject>;
  /** Contact suburb field */
  Suburb?: Maybe<Scalars['String']['output']>;
  Surname?: Maybe<Scalars['String']['output']>;
};


/** Contacts are unique by Email under a specific Professional, it can be imported from CRM or added manually */
export type ContactLeadActivitiesArgs = {
  filter?: InputMaybe<ContactLeadActivitiesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ContactLeadActivitiesSortFields>;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  AllowsSharing: Scalars['Boolean']['output'];
  Email: Scalars['String']['output'];
  Phone: Scalars['String']['output'];
  Revealed: Scalars['Boolean']['output'];
};

export type ContactLeadActivitiesConnection = {
  __typename?: 'ContactLeadActivitiesConnection';
  edges: Array<ContactLeadActivitiesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ContactLeadActivitiesConnectionEdge = {
  __typename?: 'ContactLeadActivitiesConnectionEdge';
  /** The node at the end of the collections edge */
  node: LeadActivity;
};

export type ContactLeadActivitiesFilters = {
  /** Filters this type when Channel is eq the provided value */
  Channel__eq?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to activities recorded at a specific event (e.g. for the mobile leads list). */
  EventDetailsID__eq?: InputMaybe<Scalars['ID']['input']>;
  /** Filters this type when Type is eq the provided value */
  Type__eq?: InputMaybe<Scalars['String']['input']>;
};

export type ContactLeadActivitiesSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
};

export type ContactResponse = Contact | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Snapshot of a BuildHub project that a Contact shared with the owning Professional via HDE QR scan. Refreshed in place on each subsequent scan of the same (Contact, BuildHub) pair. */
export type ContactSharedProject = {
  __typename?: 'ContactSharedProject';
  /** ISO currency code captured with the budget snapshot (defaults to NZD when the BuildHub had no budget). */
  BudgetCurrency?: Maybe<Scalars['String']['output']>;
  /** Maximum budget amount in major units (e.g. dollars), in the project's stored currency. */
  BudgetMax?: Maybe<Scalars['Float']['output']>;
  /** Minimum budget amount in major units (e.g. dollars), in the project's stored currency. */
  BudgetMin?: Maybe<Scalars['Float']['output']>;
  /** The BuildHub the snapshot was taken from. Useful as a stable identifier across snapshot refreshes; the live BuildHub itself is intentionally not exposed here (Professionals do not have read access to it). */
  BuildHubID: Scalars['ID']['output'];
  FirstSharedAt?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  LastSharedAt?: Maybe<Scalars['String']['output']>;
  LocationCity?: Maybe<Scalars['String']['output']>;
  LocationCountry?: Maybe<Scalars['String']['output']>;
  LocationFullAddress?: Maybe<Scalars['String']['output']>;
  LocationRegion?: Maybe<Scalars['String']['output']>;
  LocationSuburb?: Maybe<Scalars['String']['output']>;
  ProjectScope?: Maybe<Scalars['String']['output']>;
  ProjectType?: Maybe<Scalars['String']['output']>;
  /** Channel that produced the snapshot (currently always \"HdeScan\"). */
  Source?: Maybe<Scalars['String']['output']>;
  /** Title of the active stage at the time of the snapshot. */
  StageTitle?: Maybe<Scalars['String']['output']>;
};

export type ContactUsMapModule = ModuleType & {
  __typename?: 'ContactUsMapModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export type ContentArea = {
  __typename?: 'ContentArea';
  BuilderModules: PageBuilderModulesConnection;
  ModuleImages: PageBuilderImagesConnection;
};


export type ContentAreaBuilderModulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PageBuilderModulesSortFields>;
};


export type ContentAreaModuleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentBlock = {
  __typename?: 'ContentBlock';
  BlogPostID: Scalars['Int']['output'];
  Content?: Maybe<Scalars['String']['output']>;
  Header?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  LibraryImage?: Maybe<LibraryImage>;
  LibraryVideo?: Maybe<LibraryVideo>;
  SortOrder: Scalars['Int']['output'];
  Type?: Maybe<Scalars['String']['output']>;
};

export type ContentBuilder = {
  ClassName: Scalars['String']['output'];
  ContentArea?: Maybe<ContentArea>;
  ContentBuilderType: ContentBuilderTypeEnum;
};

export enum ContentBuilderTypeEnum {
  Article = 'article',
  Email = 'email',
  Invoice = 'invoice',
  Project = 'project',
  Qbr = 'qbr'
}

export enum ContentLockFlexibilityFieldEnum {
  BackOrder = 'BackOrder',
  Categories = 'Categories',
  Colour = 'Colour',
  CustomSections = 'CustomSections',
  CustomVariantOptions = 'CustomVariantOptions',
  Description = 'Description',
  FileDownloads = 'FileDownloads',
  LeadTime = 'LeadTime',
  Link = 'Link',
  Material = 'Material',
  PackageSize = 'PackageSize',
  Price = 'Price',
  ProductImage = 'ProductImage',
  ProductVideos = 'ProductVideos',
  Publish = 'Publish',
  SeoDescription = 'SEODescription',
  SeoTitle = 'SEOTitle',
  SalePrice = 'SalePrice',
  Samples = 'Samples',
  SearchTags = 'SearchTags',
  Size = 'Size',
  Specifications = 'Specifications',
  Stock = 'Stock',
  StockType = 'StockType',
  Title = 'Title',
  VariantImage = 'VariantImage',
  Variants = 'Variants'
}

export enum ContentRejectReasonEnum {
  DataQuality = 'DATA_QUALITY',
  ImgQuality = 'IMG_QUALITY',
  ReqFields = 'REQ_FIELDS',
  SpecChars = 'SPEC_CHARS',
  Url = 'URL'
}

export enum ContentStatusEnum {
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export type ContentStatusUpdateResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | Product | ServerError | UserError;

export type Conversation = {
  ID: Scalars['ID']['output'];
  /** The archived status of this conversation for the current user. */
  IsArchived: Scalars['Boolean']['output'];
  /** The muted status of this conversation for the current user. */
  IsMuted: Scalars['Boolean']['output'];
  /** The participants in the conversation. */
  Participants: Array<Participant>;
  /** The number of the current user's unread messages in this conversation. */
  UnreadMessageCount: Scalars['Int']['output'];
};

export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges: Array<ConversationConnectionEdge>;
  nodes: Array<Conversation>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ConversationConnectionEdge = {
  __typename?: 'ConversationConnectionEdge';
  /** The node at the end of the collections edge */
  node: Conversation;
};

/** The available filters to filter conversations by. */
export type ConversationFilters = {
  __typename?: 'ConversationFilters';
  /** The BuildHub projects that can be used to filter conversations. */
  Projects: Array<BuildHub>;
};

/** The conversating settings for a user. */
export type ConversationSettings = {
  __typename?: 'ConversationSettings';
  /** Whether the current user can be added to new conversations or group chats. */
  AllowMessageRequests: Scalars['Boolean']['output'];
  /** Whether to play a sound when receiving new messages. */
  NotificationSoundEnabled: Scalars['Boolean']['output'];
};

/** pixel conversion V3 - Enum for conversion rule trigger types */
export enum ConversionActionEnum {
  ButtonClick = 'ButtonClick',
  FormFill = 'FormFill',
  PageView = 'PageView'
}

export type ConversionActivitiesFilters = {
  CONTENT__EQUAL?: InputMaybe<Scalars['String']['input']>;
  LOCATION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  TIME__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  USER_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type ConversionActivityOvertimeFilters = {
  TIME__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConversionActivityTableFilters = {
  CONTENT__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  LOCATION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  SITE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  TIME__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  USER_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type ConversionActivityTableSort = {
  CONTENT?: InputMaybe<PrioritySort>;
  CONVERSION?: InputMaybe<PrioritySort>;
  DETAILS?: InputMaybe<PrioritySort>;
  LOCATION?: InputMaybe<PrioritySort>;
  PAGE_NAME?: InputMaybe<PrioritySort>;
  SITE?: InputMaybe<PrioritySort>;
  STAGE?: InputMaybe<PrioritySort>;
  TIME?: InputMaybe<PrioritySort>;
  USER?: InputMaybe<PrioritySort>;
};

export type ConversionAdsOvertimeFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Conversion Category Info. */
export type ConversionCategory = {
  __typename?: 'ConversionCategory';
  Code: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  Title: Scalars['String']['output'];
};

export type ConversionContentTypesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Enum for grouping conversion configs */
export enum ConversionGroupByEnum {
  Conversion = 'conversion',
  ConversionType = 'conversionType',
  CreatedBy = 'createdBy',
  FunnelStage = 'funnelStage'
}

export type ConversionLocationOptionsFilters = {
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type ConversionLocationsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConversionOptionsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConversionPageNamesFilters = {
  EVENT_TIME__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** pixel conversion V3 - Enum for conversion rule pattern matches */
export enum ConversionPatternEnum {
  EndsWith = 'EndsWith',
  ExactMatch = 'ExactMatch',
  PartialMatch = 'PartialMatch',
  StartsWith = 'StartsWith'
}

/** pixel conversion V3 - conversion rule */
export type ConversionRule = {
  __typename?: 'ConversionRule';
  Action: ConversionActionEnum;
  Conversion: ConversionTypeEnum;
  ConversionsPreview?: Maybe<Scalars['Int']['output']>;
  CustomClassification?: Maybe<Scalars['String']['output']>;
  Enabled?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['ID']['output'];
  IsDefault?: Maybe<Scalars['Boolean']['output']>;
  Pattern: ConversionPatternEnum;
  ProfessionalID: Scalars['ID']['output'];
  Rule: Scalars['String']['output'];
  SortOrder: Scalars['Int']['output'];
};


/** pixel conversion V3 - conversion rule */
export type ConversionRuleConversionsPreviewArgs = {
  calculate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConversionRuleResponse = ConversionRule | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ConversionStatsFilters = {
  CONTENT__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  LOCATION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  SITE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  TIME__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  USER_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type ConversionTableDataFilters = {
  CONTENT_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  CONVERSION_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  EVENT_LOCATION__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  EVENT_TIME__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  PAGE_TITLE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  USER_CLASS_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Conversion Type Info. */
export type ConversionType = {
  __typename?: 'ConversionType';
  Code: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  Title: Scalars['String']['output'];
};

/** pixel conversion V3 - Enum for conversion types */
export enum ConversionTypeEnum {
  Custom = 'Custom',
  DirectEnquiry = 'DirectEnquiry',
  Download = 'Download',
  Ecommerce = 'Ecommerce',
  EmailReveal = 'EmailReveal',
  LocationReveal = 'LocationReveal',
  PhoneReveal = 'PhoneReveal',
  Registration = 'Registration',
  SampleRequest = 'SampleRequest',
  Save = 'Save'
}

export type ConversionUserTypesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ConversionsFromTagsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  Latitude: Scalars['Float']['output'];
  Longitude: Scalars['Float']['output'];
};

export type CoordinateInput = {
  Latitude: Scalars['Float']['input'];
  Longitude: Scalars['Float']['input'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  Latitude: Scalars['Float']['output'];
  Longitude: Scalars['Float']['output'];
};

export type Countries_Connection = {
  __typename?: 'Countries_Connection';
  edges: Array<Countries_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Countries_ConnectionEdge = {
  __typename?: 'Countries_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: Country;
};

export type Countries_Filters = {
  /** Filter countries that support shipping for ecommerce */
  Dispatchable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fetch supported countries only, set it true if unsure. */
  Supported__eq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Countries_SortFields = {
  Code?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type Country = {
  __typename?: 'Country';
  /** Whether member dashboard Guides surfaces are available. */
  AllowMemberGuides: Scalars['Boolean']['output'];
  /** Whether member orders surfaces are available. */
  AllowMemberOrders: Scalars['Boolean']['output'];
  /** Whether member My Tickets surfaces are available. */
  AllowMemberTickets: Scalars['Boolean']['output'];
  /** Whether the product directory is available in this market. */
  AllowProducts: Scalars['Boolean']['output'];
  Code: Scalars['String']['output'];
  /** Cookie consent mode for this market (none, notice, opt-in). */
  ConsentMode: Scalars['String']['output'];
  Domain: Scalars['String']['output'];
  /** Whether Global Privacy Control browser signals should be honoured. */
  HonourGlobalPrivacyControl: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  /** Distance display system for this market (metric or imperial). */
  MeasurementSystem: Scalars['String']['output'];
  /** E.164 dialling prefix for this market (e.g. +64). */
  PhoneCountryCode?: Maybe<Scalars['String']['output']>;
  RegionLabel: Scalars['String']['output'];
  Regions: Array<Region>;
  /** Whether the Home Design Evening link appears in top-nav surfaces. */
  ShowHDENavLink: Scalars['Boolean']['output'];
  Title: Scalars['String']['output'];
};

export type Courier = {
  __typename?: 'Courier';
  Country?: Maybe<Country>;
  HelpText?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  JSValidationRegex: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  /** TrackingURLFormat, if it is empty, the tracking code also need to be a URL. */
  TrackingURLFormat?: Maybe<Scalars['String']['output']>;
};

export type CreateCalendarSessionInput = {
  availability: Array<CalendarSessionAvailabilityInput>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  customizedReminder?: InputMaybe<Scalars['String']['input']>;
  durations: Array<CalendarSessionDurationInput>;
  emailReminders: Array<CalendarSessionEmailReminderInput>;
  isActive: Scalars['Boolean']['input'];
  locationString?: InputMaybe<Scalars['String']['input']>;
  locationType: Scalars['String']['input'];
  meetingCover?: InputMaybe<Scalars['String']['input']>;
  meetingType: Scalars['String']['input'];
  oneOnOneTeamMemberId?: InputMaybe<Scalars['Int']['input']>;
  professionalUrlSegment: Scalars['String']['input'];
  sessionName: Scalars['String']['input'];
  teamMembers: Array<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
  unavailableDateRanges: Array<CalendarSessionUnavailableDateRangeInput>;
};

export type CreateConversationMessageResponse = FileAttachmentMessage | NotAuthorizedError | NotFoundError | ServerError | TextMessage | UserError;

export type CreateConversationMessageType = FileAttachmentMessage | TextMessage;

export type CreateEnquiry = AuthenticationException | CreateEnquiryResult;

export type CreateEnquiryResult = {
  __typename?: 'CreateEnquiryResult';
  Conversation?: Maybe<EnquiryConversation>;
  Enquiries: Array<Maybe<Enquiry>>;
  GeneratedMember?: Maybe<Me>;
};

export type CreateFacetOptionInput = {
  /** ID of the facet to add the option to. */
  FacetID: Scalars['Int']['input'];
  /** The options name. */
  Name: Scalars['StringInput']['input'];
  /** IDs of the categories to add the option to. */
  ProductCategoryIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  ProfessionalURLSegment: Scalars['StringInput']['input'];
  URLSegment: Scalars['StringInput']['input'];
};

export type CreateNetworkParticipantCreateData = {
  /** ID of the network to add this new participant to */
  networkId: Scalars['ID']['input'];
  /** IDs of the professionals to add as franchise participants */
  participantIdentityIds: Array<Scalars['Int']['input']>;
};

export type CreateProfessionalAwardInput = {
  AwardingInstitutionTitle?: InputMaybe<Scalars['StringInput']['input']>;
  File?: InputMaybe<Scalars['Upload']['input']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']['input']>;
  Title: Scalars['StringInput']['input'];
  YearAwarded?: InputMaybe<Scalars['StringInput']['input']>;
};

export type CreateShoppingCartOrderResult = {
  __typename?: 'CreateShoppingCartOrderResult';
  NewMember: Scalars['Boolean']['output'];
  OrderID: Scalars['Int']['output'];
  PartialOrder: Scalars['Boolean']['output'];
};

export type CreateTeamRoleInput = {
  /** Name of the team role. If not provided, defaults to the default role name. */
  Name?: InputMaybe<Scalars['String']['input']>;
  /** ID of source role to duplicate permissions from. If not provided, creates a new team with all features set to NoAccess. */
  SourceRoleID?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  Amount: Scalars['Float']['output'];
  Currency: Scalars['String']['output'];
  LongFormat: Scalars['String']['output'];
  ShortFormat: Scalars['String']['output'];
  Symbol: Scalars['String']['output'];
};

/** Custom arbitrary data on a Company saved from a CustomField */
export type CustomCompanyData = {
  __typename?: 'CustomCompanyData';
  Company: Company;
  CustomField: CustomField;
  ID: Scalars['ID']['output'];
  Value?: Maybe<Scalars['String']['output']>;
};

/** Custom arbitrary data on a Contact saved from a CustomField */
export type CustomContactData = {
  __typename?: 'CustomContactData';
  Contact: Contact;
  CustomField: CustomField;
  ID: Scalars['ID']['output'];
  Value?: Maybe<Scalars['String']['output']>;
};

/** CustomField is generic and is created at the Professional level */
export type CustomField = {
  __typename?: 'CustomField';
  ID: Scalars['ID']['output'];
  Label: Scalars['String']['output'];
  Professional: Professional;
  SortOrder: Scalars['Int']['output'];
  Type: Scalars['String']['output'];
  Visible: Scalars['Boolean']['output'];
};

export type CustomFieldInput = {
  FieldID: Scalars['ID']['input'];
  Value: Scalars['StringInput']['input'];
};

export type CustomFieldResponse = CustomField | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type CustomerLeadActivityFilters = {
  PROFESSIONAL_ID__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  USER_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLeadCategoryInterestFilters = {
  USER_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLeadConversionRateFilters = {
  PROFESSIONAL_ID__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  USER_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLeadConversionsFilters = {
  PROFESSIONAL_ID__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  USER_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLeadDetailsFilters = {
  USER_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLeadSummaryFilters = {
  USER_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerLeadTopPageViewsFilters = {
  SOURCE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  USER_ACTIVITY_PROFESSIONAL_ID__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  USER_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerTestimonial = {
  __typename?: 'CustomerTestimonial';
  Author?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Organisation?: Maybe<Scalars['String']['output']>;
  Photo?: Maybe<ResponsiveVariantImage>;
  Testimonial?: Maybe<Scalars['String']['output']>;
};

export type CustomerTestimonials_Connection = {
  __typename?: 'CustomerTestimonials_Connection';
  edges: Array<CustomerTestimonials_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type CustomerTestimonials_ConnectionEdge = {
  __typename?: 'CustomerTestimonials_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: CustomerTestimonial;
};

export type CustomerTestimonials_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Do_Not_Use_Hack = {
  __typename?: 'DO_NOT_USE_HACK';
  BuilderModules: PageBuilderModulesConnection;
  FlexibleModule?: Maybe<FlexibleModuleUnion>;
  HtmlColumn?: Maybe<HtmlColumn>;
  ModuleColumEnum?: Maybe<ModuleColumnEnum>;
  ModuleImages: PageBuilderImagesConnection;
  Notifications?: Maybe<WebsiteNotification>;
  SocialAd?: Maybe<SocialAdUnion>;
};


export type Do_Not_Use_HackBuilderModulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PageBuilderModulesSortFields>;
};


export type Do_Not_Use_HackModuleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DailyReportActivitiesFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DashboardAudienceResult = {
  __typename?: 'DashboardAudienceResult';
  AgeGroups: Array<GraphSegment>;
  ID: Scalars['String']['output'];
  InterestedCategories: Array<InterestedCategory>;
  OverviewAudience: OverviewAudience;
  Users: Array<GraphSegment>;
  UsersSummary?: Maybe<UsersSummary>;
};

export type DashboardOverviewResult = {
  __typename?: 'DashboardOverviewResult';
  AvgDailyUsers?: Maybe<Scalars['Int']['output']>;
  AvgInteractionsPerDay: Scalars['Int']['output'];
  CostPerClick: Scalars['Float']['output'];
  CostPerDay: Scalars['Float']['output'];
  CostPerImpression: Scalars['Float']['output'];
  ID: Scalars['String']['output'];
  NewsletterClickSeries: Array<GraphPoint>;
  NewsletterImpressionSeries: Array<GraphPoint>;
  OverviewSummaryNumbers: OverviewSummaryNumbers;
  ProfileClickSeries: Array<GraphPoint>;
  ProfileImpressionSeries: Array<GraphPoint>;
  SocialClickSeries: Array<GraphPoint>;
  SocialImpressionSeries: Array<GraphPoint>;
  SubscriptionCost?: Maybe<Scalars['Float']['output']>;
};

export type DashboardProfilePagesResult = {
  __typename?: 'DashboardProfilePagesResult';
  AgeGroups: Array<GraphSegment>;
  ClickSeries: Array<GraphPoint>;
  ConversionRate: Scalars['Float']['output'];
  EngagementSeries: Array<GraphPoint>;
  EngagementTopPerformers?: Maybe<Array<TopPerformer>>;
  Engagements: Array<GraphSegment>;
  ID: Scalars['String']['output'];
  ImpressionSeries: Array<GraphPoint>;
  ImpressionTopPerformers?: Maybe<Array<TopPerformer>>;
  InterestedCategories: Array<InterestedCategory>;
  PageViewTopPerformers?: Maybe<Array<TopPerformer>>;
  ProfilePagesSummary?: Maybe<ProfilePagesSummary>;
  PromotionalAds?: Maybe<PromotionalStats>;
  Users: Array<GraphSegment>;
  UsersSummary?: Maybe<UsersSummary>;
};

export type DashboardPublicationsResult = {
  __typename?: 'DashboardPublicationsResult';
  ID: Scalars['String']['output'];
  PublicationsSummary: PublicationsSummary;
};

export type DashboardSocialAdsResult = {
  __typename?: 'DashboardSocialAdsResult';
  ID: Scalars['String']['output'];
  SocialAdsSummary: SocialAdsSummary;
};

export type DataCollection = {
  __typename?: 'DataCollection';
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  Series: Array<DataSeries>;
};

export type DataCollections = {
  __typename?: 'DataCollections';
  Collections: Array<DataCollection>;
  ID: Scalars['String']['output'];
};

/** The common interface shared by all DataObject types */
export type DataObject = {
  id: Scalars['ID']['output'];
};

export type DataSeries = {
  __typename?: 'DataSeries';
  Data: Array<Datum>;
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export enum DateFormatEnum {
  Default = 'Default',
  Iso8601 = 'ISO8601'
}

export type Datum = {
  __typename?: 'Datum';
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  Subtitle?: Maybe<Scalars['String']['output']>;
  Type: DatumType;
  Value: Scalars['String']['output'];
};

export enum DatumType {
  Date = 'Date',
  Image = 'Image',
  Link = 'Link',
  Number = 'Number',
  Text = 'Text'
}

export type Days_Connection = {
  __typename?: 'Days_Connection';
  edges: Array<Days_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Days_ConnectionEdge = {
  __typename?: 'Days_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventDay;
};

export type Days_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type DeleteMessageResponse = DeletedMessage | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type DeleteVariantResult = {
  __typename?: 'DeleteVariantResult';
  ID: Scalars['Int']['output'];
  Message: Scalars['String']['output'];
  Success: Scalars['Boolean']['output'];
};

/** A message that has been deleted by the sender. */
export type DeletedMessage = Message & {
  __typename?: 'DeletedMessage';
  ConversationID: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  CreatedBy: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

export type DemographicLocationsFilters = {
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DemographicStatsFilters = {
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DemographicUserDevicesFilters = {
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DemographicsAudienceLocationFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsAudienceTypeFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsAudienceTypeOptionsFilters = {
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsCategoriesFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CITY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsCategoryInterestsFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsContentTypeOptionsFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CITY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsLocationOptionsFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DemographicsProjectStageFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsProjectTypeFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsSummaryFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsTotalTimeSpentFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DemographicsUserEngagementOverTimeFilters = {
  AUDIENCE_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CONTENT_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  COUNTRY_ABR__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  REGION__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DesignBoard = {
  __typename?: 'DesignBoard';
  CanDelete: Scalars['Boolean']['output'];
  CanEdit: Scalars['Boolean']['output'];
  Collaborators: Array<Collaborator>;
  CollaboratorsCount: Scalars['Int']['output'];
  Comments: Array<Comment>;
  CommentsCount: Scalars['Int']['output'];
  Content?: Maybe<Scalars['String']['output']>;
  DesignBoardPins: DesignBoardPinsConnection;
  FollowersCount: Scalars['Int']['output'];
  HasUnreadComments: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  IsCollaborator: Scalars['Boolean']['output'];
  IsFollower: Scalars['Boolean']['output'];
  IsOwner: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  Owner?: Maybe<Member>;
  Permission: DesignBoardPermission;
  /** Deprecated: Use DesignBoardPins connection instead */
  Pins: Array<Pin>;
  PinsCount: Scalars['Int']['output'];
  Public: Scalars['Boolean']['output'];
  Recommended: Array<DirectoryItem>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};


export type DesignBoardDesignBoardPinsArgs = {
  filter?: InputMaybe<DesignBoardPinsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DesignBoardPinsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type DesignBoardInvite = {
  __typename?: 'DesignBoardInvite';
  AcceptLink: Scalars['String']['output'];
  CreatedBy?: Maybe<Member>;
  DesignBoardTitle?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  InvitedMember?: Maybe<Member>;
};

export type DesignBoardNotification = WebsiteNotificationInterface & {
  __typename?: 'DesignBoardNotification';
  Action: WebsiteNotificationAction;
  Comment?: Maybe<Comment>;
  CreatedAt: Scalars['String']['output'];
  CreatedBy: Member;
  DesignBoard: DesignBoard;
  ID: Scalars['ID']['output'];
  Invite?: Maybe<DesignBoardInvite>;
  IsRead: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  PhotoTileURL?: Maybe<Scalars['String']['output']>;
  Pin?: Maybe<Pin>;
};

export type DesignBoardPermission = {
  __typename?: 'DesignBoardPermission';
  CanAddCollaborators: Scalars['Boolean']['output'];
  CanAddComments: Scalars['Boolean']['output'];
  CanAddPins: Scalars['Boolean']['output'];
  CanUploadFile: Scalars['Boolean']['output'];
  CanViewCollaborators: Scalars['Boolean']['output'];
  CanViewComments: Scalars['Boolean']['output'];
  CanViewPins: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
};

/** A pin on the design board */
export type DesignBoardPin = SortableItem & {
  __typename?: 'DesignBoardPin';
  Comments: Pin_CommentsConnection;
  CreatedBy?: Maybe<Member>;
  /** Design board associated with the pin */
  DesignBoard: DesignBoard;
  ID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  Subtitle: Scalars['String']['output'];
  /** The target of the pin */
  Target?: Maybe<DesignBoardPinTarget>;
  Title: Scalars['String']['output'];
  URLSearchParams?: Maybe<Scalars['String']['output']>;
};


/** A pin on the design board */
export type DesignBoardPinCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** Target for a DesignBoardPin */
export type DesignBoardPinTarget = {
  /** The ID of the target */
  ID: Scalars['Int']['output'];
};

export enum DesignBoardPinTargetType {
  Article = 'article',
  MemberUpload = 'memberUpload',
  Photo = 'photo',
  Product = 'product',
  Professional = 'professional',
  Project = 'project'
}

export type DesignBoardPinsConnection = {
  __typename?: 'DesignBoardPinsConnection';
  ID: Scalars['String']['output'];
  edges: Array<DesignBoardPinsConnectionEdge>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type DesignBoardPinsConnectionEdge = {
  __typename?: 'DesignBoardPinsConnectionEdge';
  /** The node at the end of the collections edge */
  node: DesignBoardPin;
};

export type DesignBoardPinsFilters = {
  /** Filter pins by target type */
  ByTargetType?: InputMaybe<DesignBoardPinTargetType>;
};

export type DesignBoardResult = DesignBoard | NotAuthenticatedError | NotAuthorizedError | NotFoundError;

export enum DesignBoardRole {
  Collaborator = 'collaborator',
  Follower = 'follower',
  Owner = 'owner',
  OwnerOrEditor = 'ownerOrEditor'
}

export type DesignBoardSetting = {
  __typename?: 'DesignBoardSetting';
  EnquiryReminderEmailEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  NotifyAllEnabled: Scalars['Boolean']['output'];
  WeeklyEmailEnabled: Scalars['Boolean']['output'];
};

export type DesignBoardsFilters = {
  /** Filter design boards by role */
  ByRole?: InputMaybe<DesignBoardRole>;
};

export type DesignBoardsPinsFilters = {
  /** Filter pins by target type */
  ByTargetType?: InputMaybe<DesignBoardPinTargetType>;
};

export type DesignBoardsPinsSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type DesignBoardsSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type DeviceData = {
  __typename?: 'DeviceData';
  Device: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Users: Scalars['String']['output'];
};

export type DiagramImage = SortableItem & {
  __typename?: 'DiagramImage';
  AltText?: Maybe<Scalars['String']['output']>;
  /** Aspect ratio of raw uploaded photo */
  AspectRatio: Scalars['Float']['output'];
  BannerSegment?: Maybe<BannerSegmentEnum>;
  /** Associated caption for this LibraryImage */
  Caption?: Maybe<Scalars['String']['output']>;
  Categories: Array<Category>;
  /** Clickable link for this photo */
  ClickableLink?: Maybe<Scalars['String']['output']>;
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  /** Crop Position in x-axis (if applicable) */
  CropPosX: Scalars['Int']['output'];
  /** Crop Position in y-axis (if applicable) */
  CropPosY: Scalars['Int']['output'];
  /** Return any of this user's Design Boards that contain this image */
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  /** Download link for this photo */
  DownloadLink?: Maybe<Scalars['String']['output']>;
  Format?: Maybe<Scalars['String']['output']>;
  /** Returns true if LibraryImage has tags */
  HasTags: Scalars['Boolean']['output'];
  /** Height of the photo after cropping it */
  HeightAfterCrop: Scalars['Int']['output'];
  /** Height of the photo before cropping it */
  HeightBeforeCrop: Scalars['Int']['output'];
  /** Does a LibraryImage need to hide resene tool */
  HideReseneTool?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the LibraryImage */
  ID: Scalars['Int']['output'];
  /** Is this image Landscape or Portrait? */
  ImageFormat: Scalars['String']['output'];
  /** If a LibraryImage has active tags */
  Interactive?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if LibraryImage is clearcut */
  IsClearCut: Scalars['Boolean']['output'];
  /** Returns true if LibraryImage should display as a half-width */
  IsHalfWidth: Scalars['Boolean']['output'];
  /** Returns true if LibraryImage has multiply filter */
  IsMultiplied: Scalars['Boolean']['output'];
  /** is raw image portrait, backend treats square image as portrait */
  IsPortrait: Scalars['Boolean']['output'];
  /** Returns true if LibraryImage is zoomed out */
  IsZoomedOut: Scalars['Boolean']['output'];
  /** LibraryImageFile for this LibraryImage */
  LibraryImageFile?: Maybe<LibraryImageFile>;
  /** SiteTreeID of related LibraryItem */
  LibraryImageFileID?: Maybe<Scalars['Int']['output']>;
  /** Return a list of tags on this photo */
  LibraryImageMarkers: Array<LibraryImageMarker>;
  /** DirectoryItem associated with this LibraryImage */
  LibraryItem?: Maybe<DirectoryItem>;
  /** SiteTreeID of related LibraryItem */
  LibraryItemID?: Maybe<Scalars['Int']['output']>;
  MemberSortOrder: Scalars['Int']['output'];
  MetaDescription?: Maybe<Scalars['String']['output']>;
  PhotoBrickPortrait?: Maybe<Scalars['String']['output']>;
  /** Professional to give Photo Credit for this image */
  PhotoCredit?: Maybe<Professional>;
  /** Name of the photo credit, can be a custom credit without a Professional */
  PhotoCreditName?: Maybe<Scalars['String']['output']>;
  PhotoListing?: Maybe<Scalars['String']['output']>;
  PhotoListingPreload?: Maybe<Scalars['String']['output']>;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  /** Professional associated with this LibraryImage */
  Professional?: Maybe<Professional>;
  ProfessionalID: Scalars['String']['output'];
  ProfessionalWebsite: Scalars['String']['output'];
  ProfessionalWebsiteShort: Scalars['String']['output'];
  /** Scroll Position in x-axis (if applicable) */
  ScrollPosX: Scalars['Int']['output'];
  /** Scroll Position in y-axis (if applicable) */
  ScrollPosY: Scalars['Int']['output'];
  SearchTags: LibraryImageSearchTagsConnection;
  SortOrder: Scalars['Int']['output'];
  Tags?: Maybe<Array<Maybe<LibraryImageMarker>>>;
  Thumbnail: ResponsiveImage;
  /** Title of the LibraryImage (usually internal) */
  Title: Scalars['String']['output'];
  /** Width for this photo */
  Width?: Maybe<Scalars['Int']['output']>;
  /** Width of the photo after cropping it */
  WidthAfterCrop: Scalars['Int']['output'];
  /** Width of the photo before cropping it */
  WidthBeforeCrop: Scalars['Int']['output'];
  /** Zoom percentage of photo (default 100) */
  ZoomFactor: Scalars['Int']['output'];
};


export type DiagramImageSearchTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DigitalPublication = Newsletter | NotFoundError | ServerError | UserError;

export type DigitalPublicationActivityFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationAttentionShareFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationAudienceFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationAudienceRegionFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationListFilters = {
  HOST_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationOpenClickFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationPerformanceChartClickFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationPerformanceChartOpenFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationPerformanceFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationProfessionalCategoryFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationProfessionalEngagementFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationProfessionalRegionFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationProfessionalUserFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationProfileConversionChartFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationReaderRegionFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationRecipientFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationSingleMetaFilters = {
  ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationSummaryFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DigitalPublicationTimespentFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalPublicationsConnection = {
  __typename?: 'DigitalPublicationsConnection';
  edges: Array<DigitalPublicationsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type DigitalPublicationsConnectionEdge = {
  __typename?: 'DigitalPublicationsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Newsletter;
};

export type DigitalPublicationsFilters = {
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when Month is eq the provided value */
  Month__eq?: InputMaybe<Scalars['Int']['input']>;
  /** Filters this type when Publish is eq the provided value */
  Publish__eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters this type when Type is eq the provided value */
  Type__eq?: InputMaybe<NewsletterTypeEnum>;
  /** Filters this type when UrlSegment is eq the provided value */
  UrlSegment__eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters this type when Year is eq the provided value */
  Year__eq?: InputMaybe<Scalars['Int']['input']>;
};

export type DigitalPublicationsSortFields = {
  Created?: InputMaybe<SortDirection>;
  Month?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  Type?: InputMaybe<SortDirection>;
  Year?: InputMaybe<SortDirection>;
};

export type DirectConversation = Conversation & {
  __typename?: 'DirectConversation';
  /** The BuildHub project associated with this conversation. */
  BuildHub?: Maybe<BuildHub>;
  ID: Scalars['ID']['output'];
  IsArchived: Scalars['Boolean']['output'];
  /** This conversation is a group chat. */
  IsGroupChat: Scalars['Boolean']['output'];
  IsMuted: Scalars['Boolean']['output'];
  Messages: DirectMessageConnection;
  /** The name of this conversation. */
  Name?: Maybe<Scalars['String']['output']>;
  Participants: Array<Participant>;
  /** The thumbnail of this conversation. */
  Thumbnail?: Maybe<MemberUpload>;
  UnreadMessageCount: Scalars['Int']['output'];
};


export type DirectConversationMessagesArgs = {
  After?: InputMaybe<Scalars['Int']['input']>;
  AfterID?: InputMaybe<Scalars['Int']['input']>;
  BeforeID?: InputMaybe<Scalars['Int']['input']>;
  IsMigratableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  SortDirection?: InputMaybe<SortDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DirectMessage = DeletedMessage | FileAttachmentMessage | SystemMessage | TextMessage;

export type DirectMessageConnection = {
  __typename?: 'DirectMessageConnection';
  edges: Array<DirectMessageConnectionEdge>;
  nodes: Array<DirectMessage>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type DirectMessageConnectionEdge = {
  __typename?: 'DirectMessageConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectMessage;
};

export type DirectParticipant = MemberParticipant | ProfessionalParticipant;

export type Directory = {
  __typename?: 'Directory';
  Article: DirectoryArticle;
  ArticleCategories: Directory_ArticleCategoriesConnection;
  ArticleCategory: DirectoryArticleCategory;
  BuildingGuide: DirectoryBuildingGuide;
  BuildingGuideCategories: Directory_BuildingGuideCategoriesConnection;
  BuildingGuideCategory: DirectoryBuildingGuideCategory;
  DigitalPublication: DigitalPublication;
  DigitalPublications: DigitalPublicationsConnection;
  HomePage: HomePage;
  Items: Directory_ItemsConnection;
  LegacyArticle: LegacyArticle;
  /** AI-generated labels for library images, grouped by LibraryImageID (ordered by AdminScore DESC and ID DESC, returns best label per image) */
  LibraryImageLabel: Directory_LibraryImageLabelConnection;
  Product: DirectoryProduct;
  ProductCategories: Directory_ProductCategoriesConnection;
  ProductCategory: DirectoryProductCategory;
  Professional: DirectoryProfessional;
  ProfessionalCategories: Directory_ProfessionalCategoriesConnection;
  ProfessionalCategory: DirectoryProfessionalCategory;
  Project: DirectoryProject;
  ProjectCategories: Directory_ProductCategoriesConnection;
  ProjectCategory: DirectoryProjectCategory;
  SearchSuggestion: Directory_SearchSuggestionsConnection;
};


export type DirectoryArticleArgs = {
  Link: Scalars['String']['input'];
  LiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  editIntent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DirectoryArticleCategoriesArgs = {
  filter?: InputMaybe<Directory_ArticleCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Directory_ArticleCategoriesSortFields>;
};


export type DirectoryArticleCategoryArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryBuildingGuideArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryBuildingGuideCategoriesArgs = {
  filter?: InputMaybe<Directory_BuildingGuideCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Directory_BuildingGuideCategoriesSortFields>;
};


export type DirectoryBuildingGuideCategoryArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryDigitalPublicationArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryDigitalPublicationsArgs = {
  filter?: InputMaybe<DigitalPublicationsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DigitalPublicationsSortFields>;
};


export type DirectoryItemsArgs = {
  filter?: InputMaybe<Directory_ItemsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectoryLegacyArticleArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryLibraryImageLabelArgs = {
  filter?: InputMaybe<LibraryImageLabelFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectoryProductArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryProductCategoriesArgs = {
  filter?: InputMaybe<Directory_ProductCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Directory_ProductCategoriesSortFields>;
};


export type DirectoryProductCategoryArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryProfessionalArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryProfessionalCategoriesArgs = {
  filter?: InputMaybe<Directory_ProfessionalCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Directory_ProfessionalCategoriesSortFields>;
};


export type DirectoryProfessionalCategoryArgs = {
  Link: Scalars['String']['input'];
};


export type DirectoryProjectArgs = {
  Link: Scalars['String']['input'];
  editIntent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DirectoryProjectCategoriesArgs = {
  filter?: InputMaybe<Directory_ProductCategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Directory_ProductCategoriesSortFields>;
};


export type DirectoryProjectCategoryArgs = {
  Link: Scalars['String']['input'];
};


export type DirectorySearchSuggestionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DirectoryArticle = Article | GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Redirect | ServerError | UserError;

export type DirectoryArticleCategory = ArticleCategory | GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Redirect | ServerError | UserError;

export type DirectoryBuildingGuide = BuildingGuide | GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Redirect | ServerError | UserError;

export type DirectoryBuildingGuideCategory = BuildingGuideCategory | GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Redirect | ServerError | UserError;

export type DirectoryFeaturedProject = {
  __typename?: 'DirectoryFeaturedProject';
  Created: Scalars['String']['output'];
  FeaturedByMemberName: Scalars['String']['output'];
  Project?: Maybe<Project>;
  ProjectID: Scalars['Int']['output'];
};

export type DirectoryHeader = {
  __typename?: 'DirectoryHeader';
  Content?: Maybe<Scalars['String']['output']>;
  ContentAlt?: Maybe<Scalars['String']['output']>;
  /** Teaser text */
  ContentTop?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  TitleAlt?: Maybe<Scalars['String']['output']>;
};


export type DirectoryHeaderContentAltArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryHeaderContentTopArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryHeaderTitleArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};

export type DirectoryItem = {
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']['output']>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
  AvailabilityZones: Array<Zone>;
  /** Deprecated. Use Banners instead */
  BannerImages?: Maybe<Array<LibraryImage>>;
  Categories: Array<Category>;
  Clones?: Maybe<Array<DirectoryItem>>;
  Content?: Maybe<Scalars['String']['output']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  FacebookPreviewImage?: Maybe<Scalars['String']['output']>;
  HasClones: Scalars['Boolean']['output'];
  HasDownloads: Scalars['Boolean']['output'];
  HasPhotos: Scalars['Boolean']['output'];
  HasProducts: Scalars['Boolean']['output'];
  HasProjects: Scalars['Boolean']['output'];
  HomePinned: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  InLibrary?: Maybe<Scalars['Boolean']['output']>;
  IsCloned: Scalars['Boolean']['output'];
  /** IsDraft will be set to true only until the page is published for the first time. */
  IsDraft: Scalars['Boolean']['output'];
  IsManufacturer: Scalars['Boolean']['output'];
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  Meta?: Maybe<Meta>;
  PageType: Scalars['String']['output'];
  ParentID: Scalars['Int']['output'];
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean']['output'];
  PublishDate?: Maybe<Scalars['String']['output']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']['output']>;
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  SortOrder: Scalars['Int']['output'];
  Teaser?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  Website?: Maybe<Scalars['String']['output']>;
  WebsiteShort?: Maybe<Scalars['String']['output']>;
  WebsiteUntracked?: Maybe<Scalars['String']['output']>;
};


export type DirectoryItemApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type DirectoryItemCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type DirectoryItemPublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};

export type DirectoryItemClonePageType = Article | NotAuthorizedError | NotFoundError | Product | Project | ServerError;

export enum DirectoryItemEnumType {
  Article = 'article',
  BuildingGuide = 'buildingGuide',
  Magazine = 'magazine',
  Photo = 'photo',
  Product = 'product',
  Professional = 'professional',
  Project = 'project'
}

export type DirectoryItemMutationResult = Article | NotAuthorizedError | NotFoundError | Product | Professional | Project | ServerError | UserError;

export enum DirectoryItemStatusEnum {
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  Live = 'Live',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly',
  Scheduled = 'Scheduled',
  SelfPublished = 'SelfPublished'
}

export type DirectoryItemSyncPageType = Article | NotAuthorizedError | NotFoundError | Product | Project | ServerError;

export type DirectoryItemUpdateUrlResultType = Article | NotAuthorizedError | NotFoundError | Product | Project | ServerError;

export enum DirectoryItemViewsCountRange {
  Annually = 'Annually',
  HalfYearly = 'HalfYearly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly'
}

export enum DirectoryItemsByCategoryListTypeEnum {
  ProductAlsofrom = 'PRODUCT_ALSOFROM',
  ProductProjects = 'PRODUCT_PROJECTS',
  ProfessionalAllprojects = 'PROFESSIONAL_ALLPROJECTS',
  ProfessionalArticles = 'PROFESSIONAL_ARTICLES',
  ProfessionalProducts = 'PROFESSIONAL_PRODUCTS',
  ProfessionalProjects = 'PROFESSIONAL_PROJECTS',
  ProfessionalRelatedprojects = 'PROFESSIONAL_RELATEDPROJECTS',
  ProjectAlsofrom = 'PROJECT_ALSOFROM',
  ProjectProducts = 'PROJECT_PRODUCTS',
  ProjectProfessionals = 'PROJECT_PROFESSIONALS'
}

export enum DirectoryItemsFilterEnum {
  All = 'All',
  Drafts = 'Drafts',
  InReview = 'InReview',
  IsFeatured = 'IsFeatured',
  Published = 'Published',
  Unpublished = 'Unpublished'
}

export enum DirectoryItemsStatusActions {
  Approve = 'approve',
  InLibrary = 'inLibrary',
  Publish = 'publish'
}

export type DirectoryModule = ModuleType & {
  __typename?: 'DirectoryModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  /** Sections in a directory module */
  DirectorySections: DirectorySections_Connection;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type DirectoryModuleDirectorySectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DirectorySections_SortFields>;
};

export type DirectoryPageMeta = {
  __typename?: 'DirectoryPageMeta';
  AvailabilityZones?: Maybe<Array<Maybe<Zone>>>;
  Canonical?: Maybe<Scalars['String']['output']>;
  CategoryCrumbs?: Maybe<Array<Maybe<Category>>>;
  /** Bottom CTA paragraph */
  ContentBottom?: Maybe<Scalars['String']['output']>;
  Description?: Maybe<Scalars['String']['output']>;
  DirectoryHeader?: Maybe<DirectoryHeader>;
  FAQSchemas?: Maybe<Array<Maybe<FaqSchema>>>;
  ID: Scalars['Int']['output'];
  /** Whether this page with the given single filter applied qualifies for search indexing (unique localised SEO content exists AND enough supply). Shares the predicate used by the sitemap and the internal link mesh. */
  IsIndexableFilterPage: Scalars['Boolean']['output'];
  MetaKeywords?: Maybe<Scalars['String']['output']>;
  MetaTitle?: Maybe<Scalars['String']['output']>;
  NoIndex?: Maybe<Scalars['Boolean']['output']>;
  Title: Scalars['String']['output'];
};


export type DirectoryPageMetaDescriptionArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryPageMetaFaqSchemasArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryPageMetaIsIndexableFilterPageArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryPageMetaMetaTitleArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};


export type DirectoryPageMetaTitleArgs = {
  Filters?: InputMaybe<DirectoryPageMetaFilters>;
};

export type DirectoryPageMetaFilters = {
  Color?: InputMaybe<Scalars['String']['input']>;
  Location?: InputMaybe<LocationFilterInput>;
  Material?: InputMaybe<Scalars['String']['input']>;
};

export type DirectoryProduct = GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Product | Redirect | ServerError | UserError;

export type DirectoryProductCategory = GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | ProductCategory | Redirect | ServerError | UserError;

export type DirectoryProfessional = GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Professional | Redirect | ServerError | UserError;

export type DirectoryProfessionalCategory = GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | ProfessionalCategory | Redirect | ServerError | UserError;

export type DirectoryProject = GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | Project | Redirect | ServerError | UserError;

export type DirectoryProjectCategory = GoneError | NotAuthenticatedError | NotAuthorizedError | NotFoundError | ProjectCategory | Redirect | ServerError | UserError;

export type DirectorySectionBlock = {
  __typename?: 'DirectorySectionBlock';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  /** Links in a directory section block */
  Links: DirectorySectionLinks_Connection;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type DirectorySectionBlockLinksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DirectorySectionLinks_SortFields>;
};

export type DirectorySectionLinks_Connection = {
  __typename?: 'DirectorySectionLinks_Connection';
  edges: Array<DirectorySectionLinks_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type DirectorySectionLinks_ConnectionEdge = {
  __typename?: 'DirectorySectionLinks_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ExternalLink;
};

export type DirectorySectionLinks_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type DirectorySections_Connection = {
  __typename?: 'DirectorySections_Connection';
  edges: Array<DirectorySections_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type DirectorySections_ConnectionEdge = {
  __typename?: 'DirectorySections_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectorySectionBlock;
};

export type DirectorySections_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Directory_ArticleCategoriesConnection = {
  __typename?: 'Directory_ArticleCategoriesConnection';
  edges: Array<Directory_ArticleCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_ArticleCategoriesConnectionEdge = {
  __typename?: 'Directory_ArticleCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleCategory;
};

export type Directory_ArticleCategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']['input']>;
};

export type Directory_ArticleCategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Directory_BuildingGuideCategoriesConnection = {
  __typename?: 'Directory_BuildingGuideCategoriesConnection';
  edges: Array<Directory_BuildingGuideCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_BuildingGuideCategoriesConnectionEdge = {
  __typename?: 'Directory_BuildingGuideCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: BuildingGuideCategory;
};

export type Directory_BuildingGuideCategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']['input']>;
};

export type Directory_BuildingGuideCategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Directory_ItemsConnection = {
  __typename?: 'Directory_ItemsConnection';
  edges: Array<Directory_ItemsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_ItemsConnectionEdge = {
  __typename?: 'Directory_ItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectoryItem;
};

export type Directory_ItemsFilters = {
  /** Filters this type when ID is in the provided value */
  ID__in: Array<Scalars['Int']['input']>;
};

export type Directory_LibraryImageLabelConnection = {
  __typename?: 'Directory_LibraryImageLabelConnection';
  edges: Array<Directory_LibraryImageLabelConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_LibraryImageLabelConnectionEdge = {
  __typename?: 'Directory_LibraryImageLabelConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImageLabel;
};

export type Directory_ProductCategoriesConnection = {
  __typename?: 'Directory_ProductCategoriesConnection';
  edges: Array<Directory_ProductCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_ProductCategoriesConnectionEdge = {
  __typename?: 'Directory_ProductCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductCategory;
};

export type Directory_ProductCategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']['input']>;
};

export type Directory_ProductCategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Directory_ProfessionalCategoriesConnection = {
  __typename?: 'Directory_ProfessionalCategoriesConnection';
  edges: Array<Directory_ProfessionalCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_ProfessionalCategoriesConnectionEdge = {
  __typename?: 'Directory_ProfessionalCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalCategory;
};

export type Directory_ProfessionalCategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters this type when ID is in the provided value */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when Title is eq the provided value */
  Title__eq?: InputMaybe<Scalars['String']['input']>;
};

export type Directory_ProfessionalCategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Directory_SearchSuggestionsConnection = {
  __typename?: 'Directory_SearchSuggestionsConnection';
  edges: Array<Directory_SearchSuggestionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Directory_SearchSuggestionsConnectionEdge = {
  __typename?: 'Directory_SearchSuggestionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: SearchSuggestion;
};

export type Dispatch = {
  __typename?: 'Dispatch';
  Created: Scalars['String']['output'];
  Delivered?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  LabelURL?: Maybe<Scalars['String']['output']>;
  OrderItems: Array<OrderItem>;
  ShippingProvider: Scalars['String']['output'];
  ShippingProviderName: Scalars['String']['output'];
  TrackingCode: Scalars['String']['output'];
  TrackingURL: Scalars['String']['output'];
};

export type DownloadableFile = {
  __typename?: 'DownloadableFile';
  ID: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type DuoImageModule = FlexibleModule & {
  __typename?: 'DuoImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type DuoImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type DuoParagraphModule = FlexibleModule & {
  __typename?: 'DuoParagraphModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type DuoParagraphModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type EcomCallToActionModule = ModuleType & {
  __typename?: 'EcomCallToActionModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export type EcomTestimonialModule = ModuleType & {
  __typename?: 'EcomTestimonialModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  /** List of testimonials */
  CustomerTestimonials: CustomerTestimonials_Connection;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};


export type EcomTestimonialModuleCustomerTestimonialsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CustomerTestimonials_SortFields>;
};

export type EcomWelcomeModule = ModuleType & {
  __typename?: 'EcomWelcomeModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type EditableImage = DiagramImage | LibraryImage;

export type EditorialAuthorsSimpleSortFields = {
  FirstName?: InputMaybe<SortDirection>;
};

export type EditorialAuthors_Connection = {
  __typename?: 'EditorialAuthors_Connection';
  edges: Array<EditorialAuthors_ConnectionEdge>;
  nodes: Array<ArticleAuthor>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type EditorialAuthors_ConnectionEdge = {
  __typename?: 'EditorialAuthors_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArticleAuthor;
};

/** Get all shipping products that are eligible for automated shipping */
export type EligibleShippingProducts = {
  __typename?: 'EligibleShippingProducts';
  EligibleCount: Scalars['Int']['output'];
  ProductCount: Scalars['Int']['output'];
};

export type EmailAssetListResponse = NotAuthorizedError | NotFoundError | ProfessionalEmailAssets | ServerError | UserError;

export type EmailAssetResponse = LibraryImage | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type EmailClient = {
  __typename?: 'EmailClient';
  Client: Scalars['String']['output'];
  Count: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
};

export type EmailDataBinding = {
  __typename?: 'EmailDataBinding';
  Created: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  LastEdited: Scalars['String']['output'];
  SourceClass: Scalars['String']['output'];
  SourceID?: Maybe<Scalars['Int']['output']>;
  Template: EmailTemplate;
};

export type EmailLink = {
  __typename?: 'EmailLink';
  ID: Scalars['ID']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  URL?: Maybe<Scalars['String']['output']>;
};

export type EmailMessage = {
  __typename?: 'EmailMessage';
  BCC?: Maybe<Scalars['String']['output']>;
  Content: Scalars['String']['output'];
  Created: Scalars['String']['output'];
  From: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  LastEdited: Scalars['String']['output'];
  Owner: Member;
  Preheader?: Maybe<Scalars['String']['output']>;
  Professional: Professional;
  Recipient: Contact;
  ReplyTo?: Maybe<Scalars['String']['output']>;
  Subject: Scalars['String']['output'];
};

export type EmailMessageResponse = EmailMessage | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type EmailTemplate = ContentBuilder & {
  __typename?: 'EmailTemplate';
  BackgroundColor?: Maybe<Scalars['String']['output']>;
  BorderRadius: Scalars['Int']['output'];
  CanCreate: Scalars['Boolean']['output'];
  CanDelete: Scalars['Boolean']['output'];
  CanEdit: Scalars['Boolean']['output'];
  CanSend: Scalars['Boolean']['output'];
  ClassName: Scalars['String']['output'];
  ContainerPadding: Scalars['Int']['output'];
  ContainerWidth: Scalars['String']['output'];
  ContainerWidthValue: Scalars['Int']['output'];
  ContentArea: ContentArea;
  ContentBuilderType: ContentBuilderTypeEnum;
  Created: Scalars['String']['output'];
  CustomFontFamily?: Maybe<Scalars['String']['output']>;
  DataBindings: Array<EmailDataBinding>;
  FontFamily: Scalars['String']['output'];
  FontSize: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  InnerBackgroundColor?: Maybe<Scalars['String']['output']>;
  InputConfigs: Array<EmailTemplateInputConfig>;
  LastEdited: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  Owner: Member;
  Preheader?: Maybe<Scalars['String']['output']>;
  Professional: Professional;
  Subject: Scalars['String']['output'];
  TextColor?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  UTM?: Maybe<Scalars['String']['output']>;
};

export type EmailTemplateInputConfig = {
  __typename?: 'EmailTemplateInputConfig';
  Alias: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  InputTypeKey: Scalars['String']['output'];
  IsRequired: Scalars['Boolean']['output'];
  SortOrder: Scalars['Int']['output'];
  Tokens: Array<Scalars['String']['output']>;
  TypeLabel: Scalars['String']['output'];
};

export type EmailTemplateInputConfigResponse = EmailTemplateInputConfig | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type EmailTemplateResponse = EmailTemplate | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type EmbeddedReport = {
  __typename?: 'EmbeddedReport';
  expiration: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reportType: Scalars['String']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EngagedCompanyStatsByIndustryFilters = {
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  QUARTER_START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EngagedCompanyStatsByIndustrySort = {
  AP_CATEGORY?: InputMaybe<PrioritySort>;
  COMPANIES?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  USERS?: InputMaybe<PrioritySort>;
};

export type EngagementEvent = {
  __typename?: 'EngagementEvent';
  City?: Maybe<Scalars['String']['output']>;
  Created: Scalars['String']['output'];
  DirectoryItem: DirectoryItem;
  ID: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  Name: EngagementEventName;
  Title: Scalars['String']['output'];
  UserID: Scalars['Int']['output'];
  UserIcon?: Maybe<Scalars['String']['output']>;
};

export enum EngagementEventName {
  All = 'All',
  Download = 'Download',
  Enquiry = 'Enquiry',
  Lead = 'Lead',
  PageView = 'PageView',
  Reveal = 'Reveal',
  Save = 'Save',
  Share = 'Share',
  VideoPlay = 'VideoPlay'
}

export type EngagementEventSummary = {
  __typename?: 'EngagementEventSummary';
  AverageSecondsOnPage: Scalars['Float']['output'];
  ConversionRate: Scalars['Float']['output'];
  ID: Scalars['String']['output'];
  Months: Scalars['Int']['output'];
  PageViewsCount: Scalars['Int']['output'];
  ProfessionalURL: Scalars['String']['output'];
};

export type EngagementEventsCount = {
  __typename?: 'EngagementEventsCount';
  All: Scalars['Int']['output'];
  Download: Scalars['Int']['output'];
  Enquiry: Scalars['Int']['output'];
  Lead: Scalars['Int']['output'];
  PageView: Scalars['Int']['output'];
  Reveal: Scalars['Int']['output'];
  Save: Scalars['Int']['output'];
  Share: Scalars['Int']['output'];
};

export type EngagementSummary = {
  __typename?: 'EngagementSummary';
  Clicks: Scalars['Int']['output'];
  Impressions: Scalars['Int']['output'];
};

export type EngagementTopPerformer = {
  __typename?: 'EngagementTopPerformer';
  ID: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  PageClicks: Scalars['Int']['output'];
  PhotoTile?: Maybe<Scalars['String']['output']>;
  Rank: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  TotalEngagements: Scalars['Int']['output'];
};

export type EngagementsOverTime = {
  __typename?: 'EngagementsOverTime';
  ClicksOverTime: Array<GraphPoint>;
  ID: Scalars['String']['output'];
  OpensOverTime: Array<GraphPoint>;
};

export type Enquiry = {
  __typename?: 'Enquiry';
  Branch?: Maybe<Professional>;
  Conversation?: Maybe<EnquiryConversation>;
  EnquiryType: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  Items: Array<SiteTree>;
  Member?: Maybe<Member>;
  Name: Scalars['String']['output'];
  Professional: Professional;
};

/** Who can send enquiries to this professional. */
export enum EnquiryAudienceEnum {
  Anybody = 'Anybody',
  NoEnquiries = 'NoEnquiries',
  SpecifiersOnly = 'SpecifiersOnly'
}

export type EnquiryConversation = Conversation & {
  __typename?: 'EnquiryConversation';
  /** Archived status of the inbox owner */
  Archived: Scalars['Boolean']['output'];
  HasAttachment: Scalars['Boolean']['output'];
  HasProfessionalResponse: Scalars['Boolean']['output'];
  ID: Scalars['ID']['output'];
  /** Important status of the inbox owner */
  Important: Scalars['Boolean']['output'];
  /** The initial enquiry that started this conversation */
  InitialEnquiry: Enquiry;
  IsArchived: Scalars['Boolean']['output'];
  IsMuted: Scalars['Boolean']['output'];
  LastCommentedOn: Scalars['String']['output'];
  LatestMessage: EnquiryMessage;
  LibraryItems: Array<DirectoryItem>;
  /** Mark as Done status of the inbox owner */
  MarkAsDone: Scalars['Boolean']['output'];
  /** The region of the member who enquiried */
  MemberRegion: Scalars['String']['output'];
  Messages: EnquiryMessageConnection;
  Participants: Array<EnquiryParticipant>;
  Permissions: Array<BusinessManagementActions>;
  Shared: Scalars['Boolean']['output'];
  UnreadMessageCount: Scalars['Int']['output'];
};


export type EnquiryConversationMessagesArgs = {
  BeforeID?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum EnquiryConversationFilterEnum {
  Archived = 'Archived',
  Branch = 'Branch',
  Important = 'Important',
  MarkAsDone = 'MarkAsDone',
  Unread = 'Unread'
}

export type EnquiryConversationInvite = {
  __typename?: 'EnquiryConversationInvite';
  AcceptLink: Scalars['String']['output'];
  CompanyInboxLink: Scalars['String']['output'];
  CreatedBy: Member;
  ID: Scalars['ID']['output'];
  InvitedMember: Member;
};

export type EnquiryConversationsFilterFieldsType = {
  field: EnquiryConversationFilterEnum;
  operator: EnquiryParticipantStatusOperatorEnum;
  value: Scalars['String']['input'];
};

export type EnquiryInput = {
  Attachments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  AutoCreateMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** ProfessionalID of the branch professional */
  Branch?: InputMaybe<Scalars['Int']['input']>;
  BuildHubFieldSelection?: InputMaybe<Scalars['String']['input']>;
  BuildHubID?: InputMaybe<Scalars['Int']['input']>;
  CreatedAt: Scalars['Float']['input'];
  DesignBoardID?: InputMaybe<Scalars['Int']['input']>;
  Email: Scalars['Email']['input'];
  EnquiryReasons?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Location?: InputMaybe<Scalars['StringInput']['input']>;
  Message?: InputMaybe<Scalars['String']['input']>;
  Name: Scalars['StringInput']['input'];
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  ShareContactDetails: Scalars['Boolean']['input'];
  SiteTreeIDs: Array<Scalars['Int']['input']>;
  /** Optional list of professional IDs. If provided, all SiteTreeIDs will be sent to each professional in this list. */
  TargetProfessionals?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The JSON-encoded location object */
  locationResponse?: InputMaybe<Scalars['StringInput']['input']>;
};

export type EnquiryMessage = DeletedMessage | FileAttachmentMessage | MemberEnquiryMessage | RevealContactDetailsMessage | TextMessage;

export type EnquiryMessageConnection = {
  __typename?: 'EnquiryMessageConnection';
  edges: Array<EnquiryMessageConnectionEdge>;
  nodes: Array<EnquiryMessage>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type EnquiryMessageConnectionEdge = {
  __typename?: 'EnquiryMessageConnectionEdge';
  /** The node at the end of the collections edge */
  node: EnquiryMessage;
};

export type EnquiryNotification = WebsiteNotificationInterface & {
  __typename?: 'EnquiryNotification';
  Action: WebsiteNotificationAction;
  Comment?: Maybe<Comment>;
  ConversationInvite?: Maybe<EnquiryConversationInvite>;
  CreatedAt: Scalars['String']['output'];
  CreatedBy: Member;
  Enquiry: Enquiry;
  ID: Scalars['ID']['output'];
  IsRead: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  PhotoTileURL?: Maybe<Scalars['String']['output']>;
};

export type EnquiryParticipant = Participant & {
  __typename?: 'EnquiryParticipant';
  Archived: Scalars['Boolean']['output'];
  ContactDetails: ContactDetails;
  DisableNotificationAndEmails: Scalars['Boolean']['output'];
  ID: Scalars['ID']['output'];
  Identity: ParticipantIdentity;
  Important: Scalars['Boolean']['output'];
  IsCollaborator: Scalars['Boolean']['output'];
  LastReadMessageDate?: Maybe<Scalars['String']['output']>;
  LastReadMessageID: Scalars['Int']['output'];
  MarkAsDone: Scalars['Boolean']['output'];
};

export enum EnquiryParticipantStatusOperatorEnum {
  Equal = 'Equal',
  Gt = 'Gt',
  NotEqual = 'NotEqual'
}

/** What project types to receive enquiries for. */
export enum EnquiryProjectTypeEnum {
  Any = 'Any',
  CommercialOnly = 'CommercialOnly',
  ResidentialOnly = 'ResidentialOnly'
}

export type Error = ErrorInterface & {
  __typename?: 'Error';
  Message: Scalars['String']['output'];
};

/** The result type for a CardConnection with error handling */
export type ErrorHandlingCardConnection = CardConnection | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ErrorInterface = {
  /** Implemented by all error types */
  Message: Scalars['String']['output'];
};

export type ErrorLoadingModule = FlexibleModule & {
  __typename?: 'ErrorLoadingModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type ErrorLoadingModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type EventDay = {
  __typename?: 'EventDay';
  Date?: Maybe<Scalars['String']['output']>;
  /** Date in ISO format (YYYY-MM-DD) for ICS and machine-readable use */
  DateISO?: Maybe<Scalars['String']['output']>;
  DateTimeDescription?: Maybe<Scalars['String']['output']>;
  EndTime?: Maybe<Scalars['String']['output']>;
  FootNotes?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  /** List of itineraries in an event day */
  Itineraries: Itineraries_Connection;
  StartTime?: Maybe<Scalars['String']['output']>;
  Summary?: Maybe<Scalars['String']['output']>;
};


export type EventDayItinerariesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Itineraries_SortFields>;
};

export type EventDetails = {
  __typename?: 'EventDetails';
  /** When true, BM team members of an exhibiting Professional can self-issue Homeowner-type \"guest\" tickets up to MaxGuestInvitesPerExhibitor. */
  AllowExhibitorGuestInvites: Scalars['Boolean']['output'];
  /** When true, BM team members of an exhibiting Professional can self-issue Exhibitor-type tickets up to MaxTeamMemberInvitesPerExhibitor. */
  AllowExhibitorTeamMemberInvites: Scalars['Boolean']['output'];
  /** When true, BM team members of an exhibiting Professional can self-issue Professional-type tickets up to MaxTeamMemberInvitesPerProfessional. */
  AllowProfessionalTeamMemberInvites: Scalars['Boolean']['output'];
  /** Hero image for the exhibitor app flow. */
  AppExhibitorHeroImage?: Maybe<LibraryImageFile>;
  /** Hero image for the homeowner app flow. */
  AppHomeownerHeroImage?: Maybe<LibraryImageFile>;
  Area?: Maybe<Scalars['String']['output']>;
  /** Persisted setting only; auto-issuance behaviour is implemented separately. When true, an Homeowner ticket will be auto-issued for each new Homeowner submission to this event. */
  AutoIssueTicketsForNewHomeownerSubmissions: Scalars['Boolean']['output'];
  /** Persisted setting only; auto-issuance behaviour is implemented separately. When true, a Professional ticket will be auto-issued for each new Professional submission to this event. */
  AutoIssueTicketsForNewProfessionalSubmissions: Scalars['Boolean']['output'];
  CalendarDate?: Maybe<Scalars['String']['output']>;
  CalendarEndTime?: Maybe<Scalars['String']['output']>;
  CalendarLocation?: Maybe<Scalars['String']['output']>;
  CalendarStartTime?: Maybe<Scalars['String']['output']>;
  CalendarSummary?: Maybe<Scalars['String']['output']>;
  CalendarTitle?: Maybe<Scalars['String']['output']>;
  /** Market code for this event (NZ, AU, US). Treat null/empty as NZ. */
  Country?: Maybe<Scalars['String']['output']>;
  DateTimeDescription?: Maybe<Scalars['String']['output']>;
  /** List of days in this event */
  Days: Days_Connection;
  DisplayTitle?: Maybe<Scalars['String']['output']>;
  /** Professionals selected to exhibit at this event. */
  ExhibitingProfessionals?: Maybe<Array<Professional>>;
  ID: Scalars['ID']['output'];
  Location?: Maybe<Scalars['String']['output']>;
  /** Structured exhibitor logistics payload for this HDE event. */
  Logistics?: Maybe<HdeExhibitorLogistics>;
  /** Cap on Homeowner-type guest tickets a single exhibiting Professional team can issue. 0 means unlimited. */
  MaxGuestInvitesPerExhibitor: Scalars['Int']['output'];
  /** Cap on Exhibitor-type tickets a single Professional team can issue. 0 means unlimited. */
  MaxTeamMemberInvitesPerExhibitor: Scalars['Int']['output'];
  /** Cap on Professional-type tickets a single Professional team can issue. 0 means unlimited. */
  MaxTeamMemberInvitesPerProfessional: Scalars['Int']['output'];
  PresentedBy?: Maybe<LibraryImageFile>;
  /** Headline presenter for this event; poster is managed on HDE exhibitor profile in BM Marketing. */
  PresentedByProfessional?: Maybe<Professional>;
  /** Owning professional whose Business Manager team can view and manage this event. */
  Professional?: Maybe<Professional>;
  /** Owning professional whose Business Manager team can manage this event. Defaults to PresentedByProfessionalID when blank. */
  ProfessionalID?: Maybe<Scalars['ID']['output']>;
  RegistrationFormTitle?: Maybe<Scalars['String']['output']>;
  /** Optional public registration URL surfaced as a \"Register here\" link in the BM Events page. */
  RegistrationPageLink?: Maybe<Scalars['String']['output']>;
  RegistrationStatus: EventRegistrationStatusEnum;
  /** IANA timezone for calendar exports (ICS, Google Calendar) */
  Timezone?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  /** Per-viewer derived flags + remaining ticket caps for the supplied BM-context ProfessionalID. Used to drive the Issue-ticket modal's available types and limits. */
  ViewerTicketEligibility: BmEventViewerTicketEligibility;
};


export type EventDetailsDaysArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Days_SortFields>;
};


export type EventDetailsViewerTicketEligibilityArgs = {
  ProfessionalID: Scalars['ID']['input'];
};

export type EventDetailsModule = ModuleType & {
  __typename?: 'EventDetailsModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  Event?: Maybe<EventDetails>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type EventHighlight = {
  __typename?: 'EventHighlight';
  BackgroundDesktop?: Maybe<LibraryImageFile>;
  BackgroundMobile?: Maybe<LibraryImageFile>;
  Description?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Link?: Maybe<Scalars['String']['output']>;
  ProfessionalName?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type EventItinerary = {
  __typename?: 'EventItinerary';
  Content?: Maybe<Scalars['String']['output']>;
  FromTime?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  /** List of speakers for this itinerary */
  Speakers: EventSpeakerConnection;
  TimeSlot?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  ToTime?: Maybe<Scalars['String']['output']>;
};


export type EventItinerarySpeakersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SpeakersSimpleSortFields>;
};

export type EventItineraryModule = ModuleType & {
  __typename?: 'EventItineraryModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  Event?: Maybe<EventDetails>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export type EventKeynoteSpeaker = {
  __typename?: 'EventKeynoteSpeaker';
  ID: Scalars['ID']['output'];
  Introduction?: Maybe<Scalars['String']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  ProfileImage?: Maybe<LibraryImageFile>;
  Role?: Maybe<Scalars['String']['output']>;
};

export type EventRegisterModule = ModuleType & {
  __typename?: 'EventRegisterModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  BackgroundDesktop?: Maybe<LibraryImageFile>;
  BackgroundMobile?: Maybe<LibraryImageFile>;
  Events: EventsConnection;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type EventRegisterModuleEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EventsSortFields>;
};

export enum EventRegistrationStatusEnum {
  Active = 'active',
  Closed = 'closed',
  Draft = 'draft',
  Finished = 'finished'
}

export type EventSpeaker = {
  __typename?: 'EventSpeaker';
  ID: Scalars['ID']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Role?: Maybe<Scalars['String']['output']>;
};

export type EventSpeakerConnection = {
  __typename?: 'EventSpeakerConnection';
  ID: Scalars['String']['output'];
  edges: Array<EventSpeakerConnectionEdge>;
  nodes: Array<EventSpeaker>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type EventSpeakerConnectionEdge = {
  __typename?: 'EventSpeakerConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventSpeaker;
};

/** A submission made by a homeowner, professional, or exhibitor to apply for an event. Subclasses (e.g. MGEEventSubmission) may add further form fields. */
export type EventSubmission = {
  __typename?: 'EventSubmission';
  /** Submission type label (e.g. Homeowner, Professional, Exhibitor). */
  ApplicationType?: Maybe<Scalars['String']['output']>;
  /** Datetime the submission was created, ISO format. */
  Created?: Maybe<Scalars['String']['output']>;
  /** Submitter's contact email (resolved from subclass when present). */
  Email?: Maybe<Scalars['String']['output']>;
  /** The event this submission was made for. */
  Event?: Maybe<EventDetails>;
  /** Submitter's first name (resolved from subclass when present). */
  FirstName?: Maybe<Scalars['String']['output']>;
  /** All non-base form fields from the actual submission subclass (e.g. MGEEventSubmission), with labels and stringified values. Empty values are omitted. */
  FormFields: Array<EventSubmissionFormField>;
  ID: Scalars['ID']['output'];
  /** Live tickets that have already been issued for this submission. */
  IssuedTickets: Array<EventTicket>;
  /** Submitter's last name (resolved from subclass when present). */
  LastName?: Maybe<Scalars['String']['output']>;
  /** Submitter's contact phone (resolved from subclass when present). */
  Phone?: Maybe<Scalars['String']['output']>;
  /** Current pipeline status of the submission. */
  Status?: Maybe<Scalars['String']['output']>;
};

/** A single form field captured on an event submission, with a human label and a stringified value. Used to render submission form responses generically across submission subclasses. */
export type EventSubmissionFormField = {
  __typename?: 'EventSubmissionFormField';
  /** Raw field name on the underlying DataObject. Useful for stable client-side keying or styling. */
  FieldName?: Maybe<Scalars['String']['output']>;
  /** Human-readable label for the field (uses field_labels when defined, otherwise a humanised fallback). */
  Label: Scalars['String']['output'];
  /** The stringified value the submitter provided. Booleans render as \"Yes\"/\"No\"; dates render as ISO datetimes. */
  Value?: Maybe<Scalars['String']['output']>;
};

export type EventTestimonial = {
  __typename?: 'EventTestimonial';
  Author?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Organisation?: Maybe<Scalars['String']['output']>;
  Testimonial?: Maybe<Scalars['String']['output']>;
};

/** A ticket issued to an attendee, professional, exhibitor or staff member for a specific event. */
export type EventTicket = {
  __typename?: 'EventTicket';
  /** Datetime the ticket was created, ISO format. */
  Created?: Maybe<Scalars['String']['output']>;
  /** Datetime the invite email was last sent/queued, ISO format. Null when no email has been dispatched. */
  EmailSentAt?: Maybe<Scalars['String']['output']>;
  EventDetails?: Maybe<EventDetails>;
  /** The originating submission this ticket was issued from, when applicable. */
  EventSubmission?: Maybe<EventSubmission>;
  ID: Scalars['ID']['output'];
  /** Email the ticket was issued to when no Member account existed yet. Empty string once a Member with this email signs up and the ticket is auto-claimed. */
  InvitedEmail?: Maybe<Scalars['String']['output']>;
  /** First name supplied at issuance when no Member account existed yet. */
  InvitedFirstName?: Maybe<Scalars['String']['output']>;
  /** Last name supplied at issuance when no Member account existed yet. */
  InvitedLastName?: Maybe<Scalars['String']['output']>;
  /** The staff/team member who issued the ticket. */
  IssuedBy?: Maybe<Member>;
  /** The member who holds this ticket. Null when the ticket is unclaimed (issued to an email that has not yet signed up); inspect InvitedEmail in that case. */
  Member?: Maybe<Member>;
  /** The professional this ticket is associated with, when applicable. */
  Professional?: Maybe<Professional>;
  /** Signed universal-link URL encoded into the ticket's QR code. Always served from the ticket's country-correct ArchiPro domain. */
  QrUrl: Scalars['String']['output'];
  /** InspirationItems the ticket holder has saved in the context of this event (any board, any project). Restricted to the ticket owner. */
  SavedItems: InspirationItemsConnection;
  /** Datetime the ticket was scanned on entry, ISO format. Null when not yet scanned. */
  ScanInTime?: Maybe<Scalars['String']['output']>;
  /** Datetime the ticket QR email was last sent/queued, ISO format. Null when no QR email has been dispatched. */
  TicketQrEmailSentAt?: Maybe<Scalars['String']['output']>;
  /** Ticket category (Homeowner, Professional, Exhibitor, Staff). */
  Type?: Maybe<Scalars['String']['output']>;
};


/** A ticket issued to an attendee, professional, exhibitor or staff member for a specific event. */
export type EventTicketSavedItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EventsConnection = {
  __typename?: 'EventsConnection';
  edges: Array<EventsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type EventsConnectionEdge = {
  __typename?: 'EventsConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventDetails;
};

export type EventsSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type ExceedLimitError = ErrorInterface & {
  __typename?: 'ExceedLimitError';
  Message: Scalars['String']['output'];
};

export type ExcludedPostcodesConnection = {
  __typename?: 'ExcludedPostcodesConnection';
  edges: Array<ExcludedPostcodesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ExcludedPostcodesConnectionEdge = {
  __typename?: 'ExcludedPostcodesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Postcode;
};

export type ExposedCompanyStatsByIndustryFilters = {
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  QUARTER_START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExposedCompanyStatsByIndustrySort = {
  AP_CATEGORY?: InputMaybe<PrioritySort>;
  COMPANIES?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  USERS?: InputMaybe<PrioritySort>;
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  ExternalUrl?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  OpenInNew?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

/** Scraped content from an external URL for InspirationItems */
export type ExternalUrlContent = {
  __typename?: 'ExternalUrlContent';
  ContentType: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  Domain: Scalars['String']['output'];
  ErrorMessage?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  ImageUrl?: Maybe<Scalars['String']['output']>;
  IsLocked: Scalars['Boolean']['output'];
  LastScrapedAt?: Maybe<Scalars['String']['output']>;
  ProductBrand?: Maybe<Scalars['String']['output']>;
  ProductCurrency?: Maybe<Scalars['String']['output']>;
  ProductPrice?: Maybe<Scalars['Float']['output']>;
  SourceUrl: Scalars['String']['output'];
  Status: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type FaqSchema = {
  __typename?: 'FAQSchema';
  Answer: Scalars['String']['output'];
  AnswerHTML: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  Question: Scalars['String']['output'];
  QuestionHTML: Scalars['String']['output'];
};

export type FacebookSocialAd = SocialAd & {
  __typename?: 'FacebookSocialAd';
  Audience: FacebookSocialAdAudience;
  BodyText: Scalars['String']['output'];
  Conversions: FacebookSocialAdConversions;
  Date: Scalars['String']['output'];
  DirectoryItem?: Maybe<DirectoryItem>;
  Engagements: FacebookSocialAdEngagements;
  ExternalID: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Image: Scalars['String']['output'];
  LocationBreakdown: FacebookSocialAdLocations;
  Performance: FacebookSocialAdPerformance;
  Permalink: Scalars['String']['output'];
  PreviewImage: Scalars['String']['output'];
  PreviewShareableLink: Scalars['String']['output'];
  Thumbnail: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  Top10: Scalars['Boolean']['output'];
  Type: Scalars['String']['output'];
};

export type FacebookSocialAdAudience = {
  __typename?: 'FacebookSocialAdAudience';
  AgeGender: Array<AudienceAgeGender>;
  ID: Scalars['String']['output'];
  Locations: Array<AudienceLocation>;
  Placements: Array<AudiencePlacement>;
};

export type FacebookSocialAdConversions = AdConversions & {
  __typename?: 'FacebookSocialAdConversions';
  Downloads: Scalars['Int']['output'];
  EmailReveals: Scalars['Int']['output'];
  Enquiries: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  LocationReveals: Scalars['Int']['output'];
  PhoneReveals: Scalars['Int']['output'];
  Referrals: Scalars['Int']['output'];
  Saves: Scalars['Int']['output'];
  Shares: Scalars['Int']['output'];
  TotalPageViews: Scalars['Int']['output'];
  TotalTime: Scalars['Int']['output'];
  VideoPlays: Scalars['Int']['output'];
};

export type FacebookSocialAdEngagements = AdEngagements & {
  __typename?: 'FacebookSocialAdEngagements';
  Comments: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Likes: Scalars['Int']['output'];
  Shares: Scalars['Int']['output'];
};

export type FacebookSocialAdLocations = AdLocations & {
  __typename?: 'FacebookSocialAdLocations';
  ID: Scalars['String']['output'];
  Locations: Array<LocationData>;
};

export type FacebookSocialAdPerformance = AdPerformance & {
  __typename?: 'FacebookSocialAdPerformance';
  ClickThroughRate?: Maybe<Scalars['Float']['output']>;
  Clicks: Scalars['Int']['output'];
  EngagementRate?: Maybe<Scalars['Float']['output']>;
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  Reach: Scalars['Int']['output'];
};

export type FacebookSocialCampaign = SocialAd & {
  __typename?: 'FacebookSocialCampaign';
  Audience: FacebookSocialCampaignAudience;
  BodyText: Scalars['String']['output'];
  CampaignAds: Array<Maybe<FacebookSocialAd>>;
  Conversions: FacebookSocialCampaignConversions;
  Date: Scalars['String']['output'];
  Engagements: FacebookSocialCampaignEngagements;
  ExternalID: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Image: Scalars['String']['output'];
  Performance: FacebookSocialCampaignPerformance;
  PreviewImage: Scalars['String']['output'];
  PreviewShareableLink: Scalars['String']['output'];
  Thumbnail: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  Top10: Scalars['Boolean']['output'];
  Type: Scalars['String']['output'];
};

export type FacebookSocialCampaignAudience = {
  __typename?: 'FacebookSocialCampaignAudience';
  AgeGender: Array<AudienceAgeGender>;
  ID: Scalars['String']['output'];
  Locations: Array<AudienceLocation>;
  Placements: Array<AudiencePlacement>;
};

export type FacebookSocialCampaignConversions = AdConversions & {
  __typename?: 'FacebookSocialCampaignConversions';
  Downloads: Scalars['Int']['output'];
  EmailReveals: Scalars['Int']['output'];
  Enquiries: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  LocationReveals: Scalars['Int']['output'];
  PhoneReveals: Scalars['Int']['output'];
  Referrals: Scalars['Int']['output'];
  Saves: Scalars['Int']['output'];
  Shares: Scalars['Int']['output'];
  TotalPageViews: Scalars['Int']['output'];
  TotalTime: Scalars['Int']['output'];
  VideoPlays: Scalars['Int']['output'];
};

export type FacebookSocialCampaignEngagements = AdEngagements & {
  __typename?: 'FacebookSocialCampaignEngagements';
  Comments: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Likes: Scalars['Int']['output'];
  Shares: Scalars['Int']['output'];
};

export type FacebookSocialCampaignPerformance = AdPerformance & {
  __typename?: 'FacebookSocialCampaignPerformance';
  ClickThroughRate?: Maybe<Scalars['Float']['output']>;
  Clicks: Scalars['Int']['output'];
  EngagementRate?: Maybe<Scalars['Float']['output']>;
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  Reach: Scalars['Int']['output'];
};

export type Facet = {
  __typename?: 'Facet';
  AllowInput: Scalars['Boolean']['output'];
  GroupName?: Maybe<Scalars['String']['output']>;
  HideByFlag?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  IsAiEnabled: Scalars['Boolean']['output'];
  IsDetailPageDisabled: Scalars['Boolean']['output'];
  IsGeneral: Scalars['Boolean']['output'];
  IsHidden: Scalars['Boolean']['output'];
  IsHighAdminOnly: Scalars['Boolean']['output'];
  IsMultiple: Scalars['Boolean']['output'];
  IsSearchUiDisabled: Scalars['Boolean']['output'];
  Label: Scalars['String']['output'];
  Name?: Maybe<Scalars['String']['output']>;
  Options: Array<FacetOption>;
  ShowByFlag?: Maybe<Scalars['String']['output']>;
  SortOrder: Scalars['Int']['output'];
};


export type FacetOptionsArgs = {
  Approved?: InputMaybe<Scalars['Boolean']['input']>;
  ProductCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ProfessionalURLSegment?: InputMaybe<Scalars['String']['input']>;
};

export type FacetOption = {
  __typename?: 'FacetOption';
  Approved: Scalars['Boolean']['output'];
  Facet: Facet;
  FacetID: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
  Professional?: Maybe<Professional>;
  SortOrder: Scalars['Int']['output'];
};

export type FeatureBooking = {
  __typename?: 'FeatureBooking';
  Description?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  Professional?: Maybe<Professional>;
  ScrollPosY: Scalars['Int']['output'];
  SiteTree?: Maybe<DirectoryItem>;
  StartDate: Scalars['String']['output'];
  Thumbnail?: Maybe<Scalars['String']['output']>;
};

export type FeatureCategory = {
  __typename?: 'FeatureCategory';
  Description?: Maybe<Scalars['String']['output']>;
  /** Feature definitions in this category */
  FeatureDefinitions: Array<FeatureDefinition>;
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};


export type FeatureCategoryFeatureDefinitionsArgs = {
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};

export type FeatureDefinition = {
  __typename?: 'FeatureDefinition';
  /** Feature description (if not empty, info icon will be shown in UI) */
  Description?: Maybe<Scalars['String']['output']>;
  Disabled: Scalars['Boolean']['output'];
  FeatureCategory: FeatureCategory;
  FeatureCategoryID: Scalars['Int']['output'];
  /** GraphQL enum value for this feature (derived from FeatureKey). Nullable to handle unknown feature keys. */
  FeatureEnum?: Maybe<FeatureEnum>;
  FeatureGrouping?: Maybe<FeatureGrouping>;
  FeatureGroupingID?: Maybe<Scalars['Int']['output']>;
  /** Feature identifier matching FeatureEnum values */
  FeatureKey: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  RequiresInvoicing: Scalars['Boolean']['output'];
  ShowForManufacturers: Scalars['Boolean']['output'];
  ShowForNonManufacturers: Scalars['Boolean']['output'];
  /** Human-readable feature name */
  Title: Scalars['String']['output'];
};

/** Feature enum for team member permissions (Quotes, Invoices, Templates, Terms, Admin). */
export enum FeatureEnum {
  Admin = 'Admin',
  Analytics = 'Analytics',
  Article = 'Article',
  Content = 'Content',
  Inbox = 'Inbox',
  Invoice = 'Invoice',
  Leads = 'Leads',
  Membership = 'Membership',
  Product = 'Product',
  Profile = 'Profile',
  Project = 'Project',
  Quote = 'Quote',
  QuoteTemplate = 'QuoteTemplate',
  Terms = 'Terms'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  CanToggle: Scalars['Boolean']['output'];
  Enabled: Scalars['Boolean']['output'];
  Name: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  ToggleArgs: Scalars['String']['output'];
};

export type FeatureGrouping = {
  __typename?: 'FeatureGrouping';
  Description?: Maybe<Scalars['String']['output']>;
  FeatureCategory: FeatureCategory;
  FeatureCategoryID: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  MaxPermissionLevel: Scalars['Int']['output'];
  PermissionLabels?: Maybe<Scalars['String']['output']>;
  PermissionLabelsTooltip?: Maybe<Scalars['String']['output']>;
  SortOrder: Scalars['Int']['output'];
};

export type FeaturePermissionInput = {
  Feature: FeatureEnum;
  PermissionLevel: PermissionLevelEnum;
};

export type FeatureShowcaseModule = ModuleType & {
  __typename?: 'FeatureShowcaseModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type FeaturedBrandPinItem = DataObject & {
  __typename?: 'FeaturedBrandPinItem';
  ID: Scalars['ID']['output'];
  Item: Professional;
  id: Scalars['ID']['output'];
};

export type FeaturedBrandPinToggleResultType = NotAuthorizedError | Professional | UserError;

export type FeaturedBrandPinsConnection = {
  __typename?: 'FeaturedBrandPinsConnection';
  edges: Array<FeaturedBrandPinsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FeaturedBrandPinsConnectionEdge = {
  __typename?: 'FeaturedBrandPinsConnectionEdge';
  /** The node at the end of the collections edge */
  node: FeaturedBrandPinItem;
};

export type FeaturedBrandPinsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
};

export type FeaturedDirectoryItem = Article | Newsletter | Product | Professional | Project;

export enum FeaturedItemContent {
  Archizeen = 'Archizeen',
  Article = 'Article',
  ExternalLink = 'ExternalLink',
  InternalLink = 'InternalLink',
  Product = 'Product',
  ProductDirectory = 'ProductDirectory',
  Professional = 'Professional',
  ProfessionalDirectory = 'ProfessionalDirectory',
  Project = 'Project',
  ProjectDirectory = 'ProjectDirectory'
}

export type FeaturedItemData = {
  __typename?: 'FeaturedItemData';
  AutoPlay?: Maybe<Scalars['Boolean']['output']>;
  CTAText?: Maybe<Scalars['String']['output']>;
  CountryCode?: Maybe<Scalars['String']['output']>;
  Cover?: Maybe<Scalars['String']['output']>;
  DirectoryHeroFullVideo?: Maybe<Scalars['String']['output']>;
  DirectoryHeroVideoID?: Maybe<Scalars['String']['output']>;
  DirectoryHeroVideoPlatform?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Item?: Maybe<DirectoryItem>;
  LinkContent: FeaturedItemContent;
  LinkURL: Scalars['String']['output'];
  ShortDescription?: Maybe<Scalars['String']['output']>;
  ShowOnChildPages?: Maybe<Scalars['Boolean']['output']>;
  SubheadingOverride?: Maybe<Scalars['String']['output']>;
  Subtitle?: Maybe<Scalars['String']['output']>;
  TargetCategoryPath?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  VideoMp4Url?: Maybe<Scalars['String']['output']>;
  VideoWebMUrl?: Maybe<Scalars['String']['output']>;
};


export type FeaturedItemDataAutoPlayArgs = {
  placement: FeaturedItemPlacement;
};


export type FeaturedItemDataCtaTextArgs = {
  placement: FeaturedItemPlacement;
};


export type FeaturedItemDataCoverArgs = {
  placement: FeaturedItemPlacement;
};


export type FeaturedItemDataVideoMp4UrlArgs = {
  placement: FeaturedItemPlacement;
};


export type FeaturedItemDataVideoWebMUrlArgs = {
  placement: FeaturedItemPlacement;
};

export enum FeaturedItemPlacement {
  DirectoryGrid = 'DirectoryGrid',
  DirectoryHero = 'DirectoryHero',
  Homepage = 'Homepage'
}

export type FeaturedProfessionalsConnection = {
  __typename?: 'FeaturedProfessionalsConnection';
  edges: Array<FeaturedProfessionalsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FeaturedProfessionalsConnectionEdge = {
  __typename?: 'FeaturedProfessionalsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Professional;
};

export type FeaturedProjectsConnection = {
  __typename?: 'FeaturedProjectsConnection';
  edges: Array<FeaturedProjectsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FeaturedProjectsConnectionEdge = {
  __typename?: 'FeaturedProjectsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Project;
};

export type FeaturesModule = ModuleType & {
  __typename?: 'FeaturesModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  /** List of testimonials */
  Features: Features_Connection;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  PrimaryImage?: Maybe<ResponsiveVariantImage>;
  SecondaryImage?: Maybe<ResponsiveVariantImage>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type FeaturesModuleFeaturesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Features_SortFields>;
};

export type Features_Connection = {
  __typename?: 'Features_Connection';
  edges: Array<Features_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Features_ConnectionEdge = {
  __typename?: 'Features_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductFeature;
};

export type Features_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** A message with file attachment(s) and optional text content. */
export type FileAttachmentMessage = Message & {
  __typename?: 'FileAttachmentMessage';
  Attachments: Array<MemberUpload>;
  Content: Scalars['String']['output'];
  ConversationID: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  CreatedBy: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  IsHTML: Scalars['Boolean']['output'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
  /** Emoji reactions on this message. */
  Reactions: Array<MessageReaction>;
  /** The message this message is replying to, if any. */
  ReplyTo?: Maybe<ReplyToMessageUnion>;
};

/** The message to create. Must contain at least one of Content or Attachments. */
export type FileAttachmentMessageInput = {
  /** Attachments to include in the message. */
  Attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Text content of the message. */
  Content?: InputMaybe<Scalars['String']['input']>;
  /** Whether the content is HTML or plain text. Defaults to `false`. */
  IsHTML?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileCategoriesConnection = {
  __typename?: 'FileCategoriesConnection';
  edges: Array<FileCategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FileCategoriesConnectionEdge = {
  __typename?: 'FileCategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: FileCategory;
};

export type FileCategoriesSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type FileCategory = {
  __typename?: 'FileCategory';
  Group: FileCategoryGroupEnum;
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};

/** Groups file categories into tiers for download gating on product pages. */
export enum FileCategoryGroupEnum {
  ProDesign = 'ProDesign',
  Safety = 'Safety',
  Specs = 'Specs'
}

export enum FindPlaceApiProviderEnum {
  Google = 'google',
  Mapbox = 'mapbox',
  ServiceableArea = 'serviceable_area'
}

export enum FindPlaceTypeEnum {
  Address = 'address',
  All = 'all',
  CheckboxTree = 'checkbox_tree',
  City = 'city',
  CityAndSuburb = 'city_and_suburb',
  Country = 'country',
  District = 'district',
  Division = 'division',
  Place = 'place',
  Postcode = 'postcode',
  Region = 'region',
  SearchFilter = 'search_filter',
  State = 'state',
  Suburb = 'suburb',
  SuburbMixed = 'suburb_mixed'
}

export type FlexibleModule = {
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type FlexibleModuleColumnsArgs = {
  sort?: InputMaybe<ColumnsSortFields>;
};

export enum FlexibleModuleEnum {
  DuoImageModule = 'DuoImageModule',
  DuoParagraphModule = 'DuoParagraphModule',
  ErrorLoadingModule = 'ErrorLoadingModule',
  FullPageImageModule = 'FullPageImageModule',
  FullPageImagesSliderModule = 'FullPageImagesSliderModule',
  HeadingModule = 'HeadingModule',
  HtmlModule = 'HtmlModule',
  ImageParagraphModule = 'ImageParagraphModule',
  InvoiceModule = 'InvoiceModule',
  OctaImageModule = 'OctaImageModule',
  QuadImageModule = 'QuadImageModule',
  QuoteModule = 'QuoteModule',
  SingleImageModule = 'SingleImageModule',
  SingleParagraphModule = 'SingleParagraphModule',
  SingleVideoModule = 'SingleVideoModule',
  TrioImageModule = 'TrioImageModule',
  VideoParagraphModule = 'VideoParagraphModule'
}

export type FlexibleModuleUnion = DuoImageModule | DuoParagraphModule | ErrorLoadingModule | FullPageImageModule | FullPageImagesSliderModule | HeadingModule | HtmlModule | ImageParagraphModule | InvoiceModule | MultiColumnModule | OctaImageModule | QuadImageModule | QuoteModule | SingleImageModule | SingleParagraphModule | SingleVideoModule | TrioImageModule | VideoParagraphModule;

/** Footer video content for the FooterV2 component */
export type FooterContent = {
  __typename?: 'FooterContent';
  /** Whether footer videos are enabled */
  enabled: Scalars['Boolean']['output'];
  /** Video configuration for the globe section */
  globeVideo?: Maybe<FooterVideoData>;
  /** Video configuration for the magazine section */
  magazineVideo?: Maybe<FooterVideoData>;
};

export type FooterLink = {
  __typename?: 'FooterLink';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Video configuration for a footer section */
export type FooterVideoData = {
  __typename?: 'FooterVideoData';
  /** Whether the video should autoplay (muted) */
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  /** URL for the video cover/poster image */
  coverImage?: Maybe<Scalars['String']['output']>;
  /** URL for the MP4 format video (fallback) */
  videoMp4?: Maybe<Scalars['String']['output']>;
  /** URL for the WebM format video (preferred) */
  videoWebM?: Maybe<Scalars['String']['output']>;
};

export type FramedPictureCarouselModule = ModuleType & {
  __typename?: 'FramedPictureCarouselModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  /** List picture frame items */
  FramedPictureItems: FramedPictureItems_Connection;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};


export type FramedPictureCarouselModuleFramedPictureItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FramedPictureItems_SortFields>;
};

export type FramedPictureContentModule = ModuleType & {
  __typename?: 'FramedPictureContentModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  BackgroundImage?: Maybe<ResponsiveVariantImage>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  Milestones: AboutModule_MilestonesConnection;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type FramedPictureContentModuleMilestonesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AboutModule_MilestonesSortFields>;
};

export type FramedPictureItem = {
  __typename?: 'FramedPictureItem';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type FramedPictureItems_Connection = {
  __typename?: 'FramedPictureItems_Connection';
  edges: Array<FramedPictureItems_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type FramedPictureItems_ConnectionEdge = {
  __typename?: 'FramedPictureItems_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: FramedPictureItem;
};

export type FramedPictureItems_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type FreeDayType = {
  __typename?: 'FreeDayType';
  date: Scalars['String']['output'];
  freeSlots: Array<FreeSlotType>;
};

export type FreeDaysByDurationType = {
  __typename?: 'FreeDaysByDurationType';
  duration: Scalars['Int']['output'];
  freeDays: Array<TimezoneFreeDaysType>;
};

export type FreeSlotType = {
  __typename?: 'FreeSlotType';
  availableMembers: Array<AvailableMemberType>;
  label: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
};

export type FullPageImageModule = FlexibleModule & {
  __typename?: 'FullPageImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type FullPageImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type FullPageImagesSliderModule = FlexibleModule & {
  __typename?: 'FullPageImagesSliderModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type FullPageImagesSliderModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

/** Funnel Stage Info. */
export type FunnelStage = {
  __typename?: 'FunnelStage';
  Code: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  Title: Scalars['String']['output'];
  UserScore: Scalars['Int']['output'];
};

export type GaAgeGroup = {
  __typename?: 'GAAgeGroup';
  From18To24: Scalars['Int']['output'];
  From25To34: Scalars['Int']['output'];
  From35To44: Scalars['Int']['output'];
  From45To54: Scalars['Int']['output'];
  From55To64: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Over65: Scalars['Int']['output'];
};

export type GaDailyItem = {
  __typename?: 'GADailyItem';
  Date: Scalars['String']['output'];
  Value: Scalars['Float']['output'];
};

export enum GaDailyItemEnum {
  Clicks = 'Clicks',
  Ctr = 'Ctr',
  Impressions = 'Impressions'
}

export type GaSummary = {
  __typename?: 'GASummary';
  AgeGroup: GaAgeGroup;
  AvgImpressions: Scalars['Float']['output'];
  BucketID: Scalars['String']['output'];
  Clicks: Scalars['Int']['output'];
  Ctr: Scalars['Float']['output'];
  From: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  IndexedPages: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
  Position: Scalars['Float']['output'];
  ProfessionalID: Scalars['Int']['output'];
  Sessions: Scalars['Int']['output'];
  To: Scalars['String']['output'];
  TopSearchQueries: Array<GaTopQuery>;
};

export type GaTopPerformingItem = {
  __typename?: 'GATopPerformingItem';
  AvgImpressions: Scalars['Float']['output'];
  BucketID: Scalars['String']['output'];
  Clicks: Scalars['Int']['output'];
  Ctr: Scalars['Float']['output'];
  From: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
  Position: Scalars['Float']['output'];
  ProfessionalID: Scalars['Int']['output'];
  Sessions: Scalars['Int']['output'];
  To: Scalars['String']['output'];
  URL: Scalars['String']['output'];
};

export type GaTopPerformingList = {
  __typename?: 'GATopPerformingList';
  ID: Scalars['String']['output'];
  /** Collection of records */
  nodes: Array<GaTopPerformingItem>;
  pageInfo: ApPageInfo;
};

export enum GaTopPerformingSortBy {
  AvgImpressions = 'AvgImpressions',
  Clicks = 'Clicks',
  Ctr = 'Ctr',
  Impression = 'Impression',
  Sessions = 'Sessions'
}

export type GaTopQuery = {
  __typename?: 'GATopQuery';
  Clicks: Scalars['Int']['output'];
  Impressions: Scalars['Int']['output'];
  Keyword: Scalars['String']['output'];
};

export type GalleryModule = ModuleType & {
  __typename?: 'GalleryModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Images: Images_Connection;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Thumbnails: Thumbnails_Connection;
  Title?: Maybe<Scalars['String']['output']>;
  UseSliderLayoutOnMobile: Scalars['Boolean']['output'];
};


export type GalleryModuleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Images_SortFields>;
};


export type GalleryModuleThumbnailsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Thumbnails_SortFields>;
};

export type GeneratedExternalLink = {
  __typename?: 'GeneratedExternalLink';
  Suffix: Scalars['String']['output'];
  Url: Scalars['String']['output'];
};

export type GeneratedExternalLinkInput = {
  /** Source external url to be resolvable against the professional */
  URL: Scalars['String']['input'];
  /** Professional to resolve the url to */
  URLSegment: Scalars['String']['input'];
  /** Add UTM campaign */
  UTMCampaign?: InputMaybe<Scalars['String']['input']>;
  /** Add UTM medium */
  UTMMedium?: InputMaybe<Scalars['String']['input']>;
  /** Add UTM source */
  UTMSource?: InputMaybe<Scalars['String']['input']>;
};

export type GenericNotification = WebsiteNotificationInterface & {
  __typename?: 'GenericNotification';
  Action: WebsiteNotificationAction;
  CTA: Scalars['String']['output'];
  CTA_ID?: Maybe<Scalars['Int']['output']>;
  CreatedAt: Scalars['String']['output'];
  CreatedBy: Member;
  ID: Scalars['ID']['output'];
  IsRead: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  Link?: Maybe<NotificationLink>;
  Message: Scalars['String']['output'];
  PhotoTileURL?: Maybe<Scalars['String']['output']>;
  PlatformNotification?: Maybe<Scalars['Boolean']['output']>;
  PushNotification?: Maybe<Scalars['Boolean']['output']>;
  Status?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type GetProductInstallersSimpleSortFields = {
  ID?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
};

export type GetProductInstallers_Connection = {
  __typename?: 'GetProductInstallers_Connection';
  ID: Scalars['String']['output'];
  edges: Array<GetProductInstallers_ConnectionEdge>;
  nodes: Array<Professional>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type GetProductInstallers_ConnectionEdge = {
  __typename?: 'GetProductInstallers_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: Professional;
};

export type GetProductsCsvInputType = {
  Filters?: InputMaybe<Array<ListDirectoryItemsFilter>>;
  Professional: Scalars['String']['input'];
  Title?: InputMaybe<Scalars['String']['input']>;
};

export type GoneError = ErrorInterface & {
  __typename?: 'GoneError';
  Message: Scalars['String']['output'];
};

export type GoogleAnalytics = {
  __typename?: 'GoogleAnalytics';
  DailyItems: Array<GaDailyItem>;
  Domain: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  Summary: GaSummary;
  TopPerforming: GaTopPerformingList;
};


export type GoogleAnalyticsDailyItemsArgs = {
  Type: GaDailyItemEnum;
};


export type GoogleAnalyticsTopPerformingArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Page?: InputMaybe<Scalars['Int']['input']>;
  SortBy?: InputMaybe<GaTopPerformingSortBy>;
};

export type GoogleSeoArchiproIndexFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GoogleSeoBreakdownFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GoogleSeoPieChartFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GoogleSeoSummaryFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GoogleSeoTopPageFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GoogleSeoTopPageSort = {
  BRAND_IMPRESSIONS?: InputMaybe<PrioritySort>;
  CLICKS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
};

export type GoogleSeoTopSearchFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GoogleSeoTopSearchSort = {
  CLICKS?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
};

export type GraphPoint = {
  __typename?: 'GraphPoint';
  Data: Scalars['Int']['output'];
  Date: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  PromotionalSpikeDetails?: Maybe<PromotionalSpikeDetails>;
};

export type GraphSegment = {
  __typename?: 'GraphSegment';
  Data: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Range: Scalars['String']['output'];
};

export type Guest = User & {
  __typename?: 'Guest';
  APID: Scalars['String']['output'];
  DesignBoard: DesignBoardResult;
  DesignBoards: ListDesignBoards_Connection;
  DesignBoardsPins: DesignBoardPinsConnection;
  EcommerceBookingURL: Scalars['String']['output'];
  Enrichment?: Maybe<Scalars['String']['output']>;
  FeatureFlags: Array<FeatureFlag>;
  ID: Scalars['Int']['output'];
  ShoppingCart?: Maybe<ShoppingCart>;
};


export type GuestDesignBoardArgs = {
  Link: Scalars['String']['input'];
};


export type GuestDesignBoardsArgs = {
  filter?: InputMaybe<DesignBoardsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DesignBoardsSimpleSortFields>;
};


export type GuestDesignBoardsPinsArgs = {
  filter?: InputMaybe<DesignBoardsPinsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DesignBoardsPinsSimpleSortFields>;
};

export type GuestHeroSlide = {
  __typename?: 'GuestHeroSlide';
  BackgroundImage?: Maybe<ResponsiveVariantImage>;
  Content?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  MobileScrollingEffect: Scalars['Boolean']['output'];
  PrimaryCTA?: Maybe<SiteTreeLink>;
  SecondaryCTA?: Maybe<SiteTreeLink>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type GuestHomeHeroModule = ModuleType & {
  __typename?: 'GuestHomeHeroModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  ShowWelcomeMessage: Scalars['Boolean']['output'];
  Slides: Module_GuestHeroSlidesConnection;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};


export type GuestHomeHeroModuleSlidesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Module_GuestHeroSlidesSortFields>;
};

export type GuestHomePage = {
  __typename?: 'GuestHomePage';
  ID: Scalars['ID']['output'];
  MetaData: Meta;
  Modules: Array<ModuleType>;
  PageBackgroundColor?: Maybe<Scalars['String']['output']>;
  PageTheme: ModulePageThemeEnum;
};

export type HdeEventOption = {
  __typename?: 'HDEEventOption';
  ID: Scalars['ID']['output'];
  Label: Scalars['String']['output'];
};

export type HdeExhibitorLogistics = {
  __typename?: 'HDEExhibitorLogistics';
  EventManager?: Maybe<TeamMember>;
  Loading?: Maybe<HdeExhibitorLogisticsLoading>;
  PackingChecklist: Array<Scalars['String']['output']>;
  Parking?: Maybe<Scalars['String']['output']>;
  Schedule: Array<HdeExhibitorLogisticsScheduleItem>;
  Stand?: Maybe<HdeExhibitorLogisticsStand>;
  Venue?: Maybe<HdeExhibitorLogisticsVenue>;
};

export type HdeExhibitorLogisticsLoading = {
  __typename?: 'HDEExhibitorLogisticsLoading';
  Entrance?: Maybe<Scalars['String']['output']>;
  MaxVehicleHeightMeters?: Maybe<Scalars['Float']['output']>;
  Notes: Array<Scalars['String']['output']>;
};

export type HdeExhibitorLogisticsScheduleItem = {
  __typename?: 'HDEExhibitorLogisticsScheduleItem';
  End?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Start?: Maybe<Scalars['String']['output']>;
};

export type HdeExhibitorLogisticsStand = {
  __typename?: 'HDEExhibitorLogisticsStand';
  AreaDescription?: Maybe<Scalars['String']['output']>;
  Label?: Maybe<Scalars['String']['output']>;
  Url?: Maybe<Scalars['String']['output']>;
};

export type HdeExhibitorLogisticsVenue = {
  __typename?: 'HDEExhibitorLogisticsVenue';
  AddressLines: Array<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
};

export type HdeExhibitorProfile = {
  __typename?: 'HDEExhibitorProfile';
  /** Absolute URL for the optional exhibitor brochure PDF */
  BrochureUrl?: Maybe<Scalars['String']['output']>;
  /** Linked HDE event for this exhibitor card */
  Event?: Maybe<EventDetails>;
  ExhibitorName?: Maybe<Scalars['String']['output']>;
  ExhibitorTitle?: Maybe<Scalars['String']['output']>;
  /** Absolute URL for the featured exhibitor banner image */
  FeaturedBannerUrl?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  SortOrder: Scalars['Int']['output'];
};

export type HdeGridCarouselModule = ModuleType & {
  __typename?: 'HDEGridCarouselModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  AtLabel?: Maybe<Scalars['String']['output']>;
  EventWordOne?: Maybe<Scalars['String']['output']>;
  EventWordThree?: Maybe<Scalars['String']['output']>;
  EventWordTwo?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  HeadingDesktop?: Maybe<Scalars['String']['output']>;
  HeadingMobile?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  MeetLabel?: Maybe<Scalars['String']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  Slides: HdeGridCarouselSlides_Connection;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type HdeGridCarouselModuleSlidesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HdeGridCarouselSlides_SortFields>;
};

export type HdeGridCarouselSlide = {
  __typename?: 'HDEGridCarouselSlide';
  ExhibitorName?: Maybe<Scalars['String']['output']>;
  ExhibitorTitle?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  SlideImage?: Maybe<Scalars['String']['output']>;
};

export type HdeGridCarouselSlides_Connection = {
  __typename?: 'HDEGridCarouselSlides_Connection';
  edges: Array<HdeGridCarouselSlides_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HdeGridCarouselSlides_ConnectionEdge = {
  __typename?: 'HDEGridCarouselSlides_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: HdeGridCarouselSlide;
};

export type HdeGridCarouselSlides_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type HdeInPageBannerModule = ModuleType & {
  __typename?: 'HDEInPageBannerModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  BannerVideo?: Maybe<Scalars['String']['output']>;
  BodyDesktop?: Maybe<Scalars['String']['output']>;
  BodyMobile?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  HeadlineLine1?: Maybe<Scalars['String']['output']>;
  HeadlineLine2?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type HasPaintPartner = {
  PaintPartner?: Maybe<PaintPartner>;
};

/** Aggregate HDE-scan counts at an event for the viewer's exhibitor Professional. Counts distinct contacts — a homeowner re-scanned (by the same staffer or another) is still counted once. Not affected by SharedLeads; the hdeEventLeads list may be narrower when shared leads are disabled. */
export type HdeEventLeadStats = {
  __typename?: 'HdeEventLeadStats';
  /** Subset of TotalScans the current viewer personally scanned at least once. A contact also scanned by a teammate still counts when the viewer was the scanner on at least one of the contact's HdeScan activities at this event. */
  ScansByMe: Scalars['Int']['output'];
  /** Distinct contacts with at least one HdeScan LeadActivity for the viewer's exhibitor Professional at this event (team-wide). Unchanged when SharedLeads is disabled on the exhibitor join. */
  TotalScans: Scalars['Int']['output'];
};

/** Normalised card payload for the HDE ticket-printer print sheet (97 x 147.5mm). Used by the Remix print routes. */
export type HdePrintCard = {
  __typename?: 'HdePrintCard';
  /** CSS background colour behind the logo badge (e.g. rgb(0, 0, 0)). Only present when LogoUrl is set. */
  LogoBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Company logo URL for the circular badge. Null when omitted. */
  LogoUrl?: Maybe<Scalars['String']['output']>;
  /** Top line in the tear-off panel (attendee name or library item title). */
  Primary: Scalars['String']['output'];
  /** Remix print template slug: staff, with-professional, or without-professional. */
  PrintTemplate: Scalars['String']['output'];
  /** Authenticated SVG QR endpoint for this card. */
  QrSvgUrl: Scalars['String']['output'];
  /** Bottom line (company name, or ticket Type when no Professional is stamped). */
  Secondary?: Maybe<Scalars['String']['output']>;
};

export type HeadingModule = FlexibleModule & {
  __typename?: 'HeadingModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type HeadingModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type HeadingTextModule = ModuleType & {
  __typename?: 'HeadingTextModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  HeadingLevel?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type HighlightsModule = ModuleType & {
  __typename?: 'HighlightsModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  /** Public section heading shown on the HDE page. */
  DisplayTitle?: Maybe<Scalars['String']['output']>;
  /** HDE events this highlights module is linked to */
  Events: HighlightsModuleEvents_Connection;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  /** List of event highlights */
  Highlights: Highlights_Connection;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type HighlightsModuleEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HighlightsModuleHighlightsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Highlights_SortFields>;
};

export type HighlightsModuleEvents_Connection = {
  __typename?: 'HighlightsModuleEvents_Connection';
  edges: Array<HighlightsModuleEvents_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HighlightsModuleEvents_ConnectionEdge = {
  __typename?: 'HighlightsModuleEvents_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventDetails;
};

export type Highlights_Connection = {
  __typename?: 'Highlights_Connection';
  edges: Array<Highlights_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Highlights_ConnectionEdge = {
  __typename?: 'Highlights_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventHighlight;
};

export type Highlights_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** Call-to-action button configuration with text and link */
export type HomeCtaData = {
  __typename?: 'HomeCTAData';
  /** URL or path that the CTA button links to */
  link?: Maybe<Scalars['String']['output']>;
  /** Text to display on the CTA button */
  text?: Maybe<Scalars['String']['output']>;
};

/** Content for the Essential Guides for your Project section on the homepage */
export type HomeContentCampaign = {
  __typename?: 'HomeContentCampaign';
  /** URL for the section background image */
  backgroundImage?: Maybe<Scalars['String']['output']>;
  /** Call-to-action button configuration */
  cta?: Maybe<HomeCtaData>;
  /** Section description text */
  description: Scalars['String']['output'];
  /** Array of guide items displayed in this section */
  guides?: Maybe<Array<Maybe<MarketingGuideItem>>>;
  /** Section title */
  title: Scalars['String']['output'];
};

/** Content for the homepage hero section, which is the first section of the homepage on the top of the page */
export type HomeHeroData = {
  __typename?: 'HomeHeroData';
  /** 2-letter country code for the hero data (e.g., NZ, AU) */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Call-to-action button configuration */
  cta?: Maybe<HomeCtaData>;
  /** Additional descriptive text */
  description?: Maybe<Scalars['String']['output']>;
  /** URL for the hero section background image */
  image?: Maybe<Scalars['String']['output']>;
  /** Text displayed before the rotating content */
  prefix: Scalars['String']['output'];
  /** Array of text elements that rotate in the display */
  rotateTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Text displayed after the rotating content */
  suffix?: Maybe<Scalars['String']['output']>;
  /** Video configuration for this section */
  video?: Maybe<HomeVideoData>;
};

/** Content for the homepage introduction section, which is the second section of the homepage on the top of the page */
export type HomeIntroData = {
  __typename?: 'HomeIntroData';
  /** 2-letter country code for the intro data (e.g., NZ, AU, US); empty for global fallback */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Call-to-action button configuration */
  cta?: Maybe<HomeCtaData>;
  /** Descriptive text content below the title */
  description?: Maybe<Scalars['String']['output']>;
  /** Array of bullet points or list items */
  listItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Main title text (HTML supported) */
  title: Scalars['String']['output'];
  /** Video configuration for this section */
  video?: Maybe<HomeVideoData>;
};

/** Content for the homepage media section, which is the third section of the homepage on the top of the page */
export type HomeMediaData = {
  __typename?: 'HomeMediaData';
  /** 2-letter country code for the media data (e.g., NZ, AU, US); empty for global fallback */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Call-to-action button configuration */
  cta?: Maybe<HomeCtaData>;
  /** Descriptive text content */
  description?: Maybe<Scalars['String']['output']>;
  /** Main title text (HTML supported) */
  title: Scalars['String']['output'];
  /** Video configuration for this section */
  video?: Maybe<HomeVideoData>;
};

export type HomePage = {
  __typename?: 'HomePage';
  /** This is for pinning suppliers & manufacturers to feature on the /products page. Works similarly to the pin to home page feature. */
  FeaturedBrandPins: FeaturedBrandPinsConnection;
  HomePins: HomePinsConnection;
  LastPublishedArticles: Array<Article>;
  ProjectsOfTheMonth: Array<Project>;
  TopProducts: Array<Product>;
  TrendingProfessionals: Array<Professional>;
};


export type HomePageFeaturedBrandPinsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FeaturedBrandPinsSortFields>;
};


export type HomePageHomePinsArgs = {
  filter?: InputMaybe<HomePinsFilters>;
  filters?: InputMaybe<HomePinsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<HomePinsSortFields>;
};

export enum HomePinFilter {
  Article = 'Article',
  Product = 'Product',
  Professional = 'Professional',
  Project = 'Project'
}

export type HomePinItem = DataObject & {
  __typename?: 'HomePinItem';
  ID: Scalars['ID']['output'];
  Item: Item;
  id: Scalars['ID']['output'];
};

export type HomePinToggleResultType = Article | ExceedLimitError | NotAuthorizedError | Product | Professional | Project | UserError;

export type HomePinsConnection = {
  __typename?: 'HomePinsConnection';
  edges: Array<HomePinsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HomePinsConnectionEdge = {
  __typename?: 'HomePinsConnectionEdge';
  /** The node at the end of the collections edge */
  node: HomePinItem;
};

export type HomePinsFilters = {
  /** Filters this type when ItemType is eq the provided value */
  ItemType__eq?: InputMaybe<HomePinFilter>;
};

export type HomePinsSortFields = {
  Created?: InputMaybe<SortDirection>;
};

/** Video configuration data supporting both MP4 and WebM formats, with separate mobile and desktop versions */
export type HomeVideoData = {
  __typename?: 'HomeVideoData';
  /** Whether the video should autoplay */
  autoplay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the video should loop */
  loop?: Maybe<Scalars['Boolean']['output']>;
  /** URL for the video cover image */
  videoCover?: Maybe<Scalars['String']['output']>;
  /** URL for the MP4 format video */
  videoMp4?: Maybe<Scalars['String']['output']>;
  /** URL for the WebM format video */
  videoWebM?: Maybe<Scalars['String']['output']>;
};

export type HomeownerBudget = DataObject & {
  __typename?: 'HomeownerBudget';
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type HomeownerBudgetConnection = {
  __typename?: 'HomeownerBudgetConnection';
  edges: Array<HomeownerBudgetConnectionEdge>;
  nodes: Array<HomeownerBudget>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HomeownerBudgetConnectionEdge = {
  __typename?: 'HomeownerBudgetConnectionEdge';
  /** The node at the end of the collections edge */
  node: HomeownerBudget;
};

export type HomeownerPurpose = DataObject & {
  __typename?: 'HomeownerPurpose';
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type HomeownerPurposeConnection = {
  __typename?: 'HomeownerPurposeConnection';
  edges: Array<HomeownerPurposeConnectionEdge>;
  nodes: Array<HomeownerPurpose>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HomeownerPurposeConnectionEdge = {
  __typename?: 'HomeownerPurposeConnectionEdge';
  /** The node at the end of the collections edge */
  node: HomeownerPurpose;
};

export type HomeownerStage = DataObject & {
  __typename?: 'HomeownerStage';
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type HomeownerStageConnection = {
  __typename?: 'HomeownerStageConnection';
  edges: Array<HomeownerStageConnectionEdge>;
  nodes: Array<HomeownerStage>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type HomeownerStageConnectionEdge = {
  __typename?: 'HomeownerStageConnectionEdge';
  /** The node at the end of the collections edge */
  node: HomeownerStage;
};

export type HostedVideoModule = ModuleType & {
  __typename?: 'HostedVideoModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  AutoPlay?: Maybe<Scalars['Boolean']['output']>;
  AutoPlayRedirect?: Maybe<Scalars['String']['output']>;
  AutoPlayRedirectRequireLogin?: Maybe<Scalars['Boolean']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
  VideoCover?: Maybe<ResponsiveVariantImage>;
  VideoMp4Url?: Maybe<Scalars['String']['output']>;
  VideoWebMUrl?: Maybe<Scalars['String']['output']>;
};

export type HtmlColumn = ModuleColumn & SortableItem & {
  __typename?: 'HtmlColumn';
  HtmlContent?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  IsEmpty: Scalars['Boolean']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleID: Scalars['Int']['output'];
  ParsedContent?: Maybe<Scalars['String']['output']>;
  ReadOnly: Scalars['Boolean']['output'];
  WordCount: Scalars['Int']['output'];
};

export type HtmlModule = FlexibleModule & {
  __typename?: 'HtmlModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type HtmlModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type HubspotCompany = {
  __typename?: 'HubspotCompany';
  ClientDirectorTeamMember?: Maybe<TeamMember>;
  HubspotID: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  Professional?: Maybe<Professional>;
};

export type HubspotContextInput = {
  hutk?: InputMaybe<Scalars['StringInput']['input']>;
  pageName: Scalars['StringInput']['input'];
  pageUri: Scalars['StringInput']['input'];
};

export type IApprovable = {
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
};


export type IApprovableApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};

export type ICategory = {
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']['output']>;
  Link: Scalars['String']['output'];
  MenuTitle: Scalars['String']['output'];
  Parent?: Maybe<ICategory>;
  PrettyTitle: Scalars['String']['output'];
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
  URLSegment?: Maybe<Scalars['String']['output']>;
};


export type ICategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};


export type ICategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};

export type ICreatable = {
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
};


export type ICreatableCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};

export type IFeaturedBrandPinable = {
  FeaturedBrandPinned: Scalars['Boolean']['output'];
};

export type IFileCategory = {
  FileCategories: FileCategoriesConnection;
};


export type IFileCategoryFileCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FileCategoriesSortFields>;
};

export type IHasItems = {
  /** Items count for the given zone */
  ItemsCount: Scalars['Int']['output'];
};


export type IHasItemsItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};

export type IHasProfessional = {
  Professional?: Maybe<Professional>;
};

export type IHomePinable = {
  HomePinned: Scalars['Boolean']['output'];
};

export type IPublishable = {
  PublishDate?: Maybe<Scalars['String']['output']>;
  PublishedByMember?: Maybe<Member>;
};


export type IPublishablePublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};

export type IRecentlyViewedTile = {
  RecentlyViewedImage?: Maybe<RecentlyViewedImage>;
};

export type IframeEmbedModule = ModuleType & {
  __typename?: 'IframeEmbedModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  EmbedLink?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  FrameHeight?: Maybe<Scalars['Int']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type ImageBannerModule = ModuleType & {
  __typename?: 'ImageBannerModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  BottomBackgroundTheme?: Maybe<Scalars['String']['output']>;
  DesktopImage?: Maybe<LibraryImageFile>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  MobileImage?: Maybe<LibraryImageFile>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  Offset?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
  TopBackgroundTheme?: Maybe<Scalars['String']['output']>;
  UseDesktopForMobile: Scalars['Boolean']['output'];
};

export type ImageCarouselItem = {
  __typename?: 'ImageCarouselItem';
  CaptionOne?: Maybe<Scalars['String']['output']>;
  CaptionTwo?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  ImageAspect?: Maybe<Scalars['String']['output']>;
};

export type ImageCenterResultType = AiImage | NotAuthorizedError | ServerError | UserError;

export type ImageColumn = ModuleColumn & SortableItem & {
  __typename?: 'ImageColumn';
  ColumnDimension?: Maybe<ColumnDimension>;
  ID: Scalars['Int']['output'];
  Image?: Maybe<LibraryImage>;
  IsEmpty: Scalars['Boolean']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleID: Scalars['Int']['output'];
  ProductID?: Maybe<Scalars['Int']['output']>;
  ReadOnly: Scalars['Boolean']['output'];
  ResponsiveImage?: Maybe<ResponsiveImage>;
  WordCount: Scalars['Int']['output'];
};

export type ImageDeletionResult = {
  __typename?: 'ImageDeletionResult';
  ID: Scalars['Int']['output'];
  Success: Scalars['Boolean']['output'];
};

export type ImageDimension = {
  __typename?: 'ImageDimension';
  Height: Scalars['Int']['output'];
  Width: Scalars['Int']['output'];
};

export type ImageExportCreateInputType = {
  DirectoryType: DirectoryItemEnumType;
  Filters?: InputMaybe<Array<ListDirectoryItemsFilter>>;
  Professional: Scalars['StringInput']['input'];
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};

export type ImageExportCreateResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ImageParagraphModule = FlexibleModule & {
  __typename?: 'ImageParagraphModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type ImageParagraphModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type ImageRemoveBackgroundResultType = AiImage | NotAuthorizedError | ServerError | UserError;

export type ImageTextCarouselModule = ModuleType & {
  __typename?: 'ImageTextCarouselModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  ImageCarouselItems: Module_ImageCarouselItemsConnection;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  Orientation: Scalars['String']['output'];
  SlimImageColumn: Scalars['Boolean']['output'];
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  TextCarouselItems: Module_TextCarouselItemsConnection;
  ThemeColour: ThemedElementColourType;
};


export type ImageTextCarouselModuleImageCarouselItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Module_ImageCarouselItemsSortFields>;
};


export type ImageTextCarouselModuleTextCarouselItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Module_TextCarouselItemsSortFields>;
};

export type ImageUpscaleResultType = AiImage | NotAuthorizedError | ServerError | UserError;

export type Images_Connection = {
  __typename?: 'Images_Connection';
  edges: Array<Images_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Images_ConnectionEdge = {
  __typename?: 'Images_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImageFile;
};

export type Images_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** A order dispatch to be imported */
export type ImportDispatch = {
  ID: Scalars['StringInput']['input'];
  OrderItems: Array<ImportOrderItem>;
  ShippingProvider?: InputMaybe<Scalars['StringInput']['input']>;
  TrackingURL?: InputMaybe<Scalars['StringInput']['input']>;
};

/** The format of an imported download */
export type ImportDownload = {
  Category?: InputMaybe<Scalars['StringInput']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  Url: Scalars['StringInput']['input'];
};

export type ImportError = {
  __typename?: 'ImportError';
  Error: Scalars['String']['output'];
  Reference?: Maybe<Scalars['String']['output']>;
  Source?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type ImportMap = {
  __typename?: 'ImportMap';
  Fields: Array<ImportMapField>;
  Professional: Scalars['String']['output'];
};

export type ImportMapField = {
  __typename?: 'ImportMapField';
  Source: Scalars['String']['output'];
  Target: Scalars['String']['output'];
};

export type ImportMapFieldInput = {
  Source: Scalars['String']['input'];
  Target: Scalars['String']['input'];
};

/** A order to be imported */
export type ImportOrder = {
  CancelReason?: InputMaybe<Scalars['StringInput']['input']>;
  Dispatches: Array<ImportDispatch>;
  OrderItems: Array<ImportOrderItem>;
  OrderNumber: Scalars['StringInput']['input'];
};

/** A order item to be imported */
export type ImportOrderItem = {
  Quantity: Scalars['Int']['input'];
  SKU: Scalars['StringInput']['input'];
  Status?: InputMaybe<Scalars['StringInput']['input']>;
  SupplierVariantID?: InputMaybe<Scalars['StringInput']['input']>;
  VariantDescription?: InputMaybe<Scalars['StringInput']['input']>;
};

/** The result of a order import */
export type ImportOrderResult = {
  __typename?: 'ImportOrderResult';
  Error?: Maybe<Scalars['String']['output']>;
  Success: Scalars['Boolean']['output'];
};

/** A product to be imported */
export type ImportProduct = {
  Archived?: InputMaybe<Scalars['StringInput']['input']>;
  Categories?: InputMaybe<Array<InputMaybe<Scalars['StringInput']['input']>>>;
  CustomSectionLabel1?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionLabel2?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionLabel3?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionLabel4?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionLabel5?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionValue1?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionValue2?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionValue3?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionValue4?: InputMaybe<Scalars['StringInput']['input']>;
  CustomSectionValue5?: InputMaybe<Scalars['StringInput']['input']>;
  Delete?: InputMaybe<Scalars['StringInput']['input']>;
  Description?: InputMaybe<Scalars['StringInput']['input']>;
  Designer?: InputMaybe<Scalars['StringInput']['input']>;
  DimensionDiagrams?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  ExcludeAdvertising?: InputMaybe<Scalars['StringInput']['input']>;
  FileDownloads?: InputMaybe<Array<ImportDownload>>;
  InDirectory?: InputMaybe<Scalars['StringInput']['input']>;
  InternalProductID?: InputMaybe<Scalars['Int']['input']>;
  Link?: InputMaybe<Scalars['StringInput']['input']>;
  ManufacturerBrand?: InputMaybe<Scalars['StringInput']['input']>;
  Performance?: InputMaybe<Scalars['StringInput']['input']>;
  ProductID: Scalars['StringInput']['input'];
  ProductImage?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  ProductVideos?: InputMaybe<Array<ImportVideo>>;
  Publish?: InputMaybe<Scalars['StringInput']['input']>;
  Range?: InputMaybe<Scalars['StringInput']['input']>;
  SEODescription?: InputMaybe<Scalars['StringInput']['input']>;
  SEOTitle?: InputMaybe<Scalars['StringInput']['input']>;
  ScopeOfUse?: InputMaybe<Scalars['StringInput']['input']>;
  SearchTags?: InputMaybe<Array<InputMaybe<Scalars['StringInput']['input']>>>;
  SellOnline?: InputMaybe<Scalars['StringInput']['input']>;
  Specifications?: InputMaybe<Scalars['StringInput']['input']>;
  Status?: InputMaybe<DirectoryItemStatusEnum>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  Variants: Array<ImportVariant>;
  Warranty?: InputMaybe<Scalars['StringInput']['input']>;
  Year?: InputMaybe<Scalars['Int']['input']>;
};

/** The result of a product import */
export type ImportResult = {
  __typename?: 'ImportResult';
  Error?: Maybe<Scalars['String']['output']>;
  NewProduct?: Maybe<Scalars['Boolean']['output']>;
  Success: Scalars['Boolean']['output'];
  Warnings: Array<Scalars['String']['output']>;
};

/** A variant to be imported */
export type ImportVariant = {
  BackOrder?: InputMaybe<Scalars['StringInput']['input']>;
  Barcode?: InputMaybe<Scalars['StringInput']['input']>;
  Colour?: InputMaybe<Scalars['StringInput']['input']>;
  ColourHex?: InputMaybe<Scalars['StringInput']['input']>;
  CoverageArea?: InputMaybe<Scalars['StringInput']['input']>;
  Delete?: InputMaybe<Scalars['StringInput']['input']>;
  Depth?: InputMaybe<Scalars['StringInput']['input']>;
  Diameter?: InputMaybe<Scalars['StringInput']['input']>;
  Height?: InputMaybe<Scalars['StringInput']['input']>;
  Indent?: InputMaybe<Scalars['StringInput']['input']>;
  InternalVariantID?: InputMaybe<Scalars['Int']['input']>;
  LeadTime?: InputMaybe<Scalars['StringInput']['input']>;
  Length?: InputMaybe<Scalars['StringInput']['input']>;
  MadeToOrder?: InputMaybe<Scalars['StringInput']['input']>;
  Material?: InputMaybe<Scalars['StringInput']['input']>;
  OnSale?: InputMaybe<Scalars['StringInput']['input']>;
  Option1Label?: InputMaybe<Scalars['StringInput']['input']>;
  Option1Value?: InputMaybe<Scalars['StringInput']['input']>;
  Option2Label?: InputMaybe<Scalars['StringInput']['input']>;
  Option2Value?: InputMaybe<Scalars['StringInput']['input']>;
  Option3Label?: InputMaybe<Scalars['StringInput']['input']>;
  Option3Value?: InputMaybe<Scalars['StringInput']['input']>;
  PackageHeight?: InputMaybe<Scalars['StringInput']['input']>;
  PackageLength?: InputMaybe<Scalars['StringInput']['input']>;
  PackageWeight?: InputMaybe<Scalars['StringInput']['input']>;
  PackageWidth?: InputMaybe<Scalars['StringInput']['input']>;
  Price?: InputMaybe<Scalars['StringInput']['input']>;
  PriceUnit?: InputMaybe<Scalars['StringInput']['input']>;
  QuantityPerUnit?: InputMaybe<Scalars['StringInput']['input']>;
  SKU?: InputMaybe<Scalars['StringInput']['input']>;
  SalePrice?: InputMaybe<Scalars['StringInput']['input']>;
  SampleEnabled?: InputMaybe<Scalars['StringInput']['input']>;
  SamplePrice?: InputMaybe<Scalars['StringInput']['input']>;
  SampleShipping?: InputMaybe<Scalars['StringInput']['input']>;
  SampleStock?: InputMaybe<Scalars['StringInput']['input']>;
  Shipping?: InputMaybe<Scalars['StringInput']['input']>;
  Size?: InputMaybe<Scalars['StringInput']['input']>;
  Stock?: InputMaybe<Scalars['StringInput']['input']>;
  /** The original SKU provided by the supplier, used for platform integrations that auto-generate SKUs */
  SupplierSKU?: InputMaybe<Scalars['StringInput']['input']>;
  /** The suppliers variant ID used in integrations */
  SupplierVariantID?: InputMaybe<Scalars['StringInput']['input']>;
  SwatchImage?: InputMaybe<Scalars['StringInput']['input']>;
  VariantImage?: InputMaybe<Scalars['StringInput']['input']>;
  Volume?: InputMaybe<Scalars['StringInput']['input']>;
  Weight?: InputMaybe<Scalars['StringInput']['input']>;
  Width?: InputMaybe<Scalars['StringInput']['input']>;
};

/** The format of an imported video */
export type ImportVideo = {
  Thumbnail?: InputMaybe<Scalars['StringInput']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  Url: Scalars['StringInput']['input'];
};

export type ImportWarning = {
  __typename?: 'ImportWarning';
  Reference?: Maybe<Scalars['String']['output']>;
  Source: Scalars['String']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  Warnings: Array<Scalars['String']['output']>;
};

/** Deprecated stub for legacy clients. Always returns zero values. */
export type Inbox = {
  __typename?: 'Inbox';
  ID: Scalars['Int']['output'];
  UnreadConversationCount: Scalars['Int']['output'];
};

/** Information about a pagination in a cursor */
export type Info = {
  __typename?: 'Info';
  ID: Scalars['String']['output'];
  Next?: Maybe<Scalars['String']['output']>;
  Previous?: Maybe<Scalars['String']['output']>;
};

export type InformationModule = ModuleType & {
  __typename?: 'InformationModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  MainContent?: Maybe<Scalars['String']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  SubContentColumnOne?: Maybe<Scalars['String']['output']>;
  SubContentColumnTwo?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

/** Information about an available input data type for email templates */
export type InputDataTypeInfo = {
  __typename?: 'InputDataTypeInfo';
  Label: Scalars['String']['output'];
  Tokens: Array<InputDataTypeToken>;
  TypeKey: Scalars['String']['output'];
};

/** A single token available within an input data type */
export type InputDataTypeToken = {
  __typename?: 'InputDataTypeToken';
  Description: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export type InspirationGroup = BuildHubDocument & {
  __typename?: 'InspirationGroup';
  Breadcrumbs: Scalars['String']['output'];
  BuildHub: BuildHub;
  CanComment: Scalars['Boolean']['output'];
  CanCreate: Scalars['Boolean']['output'];
  CanDelete: Scalars['Boolean']['output'];
  CanEdit: Scalars['Boolean']['output'];
  Children: Array<BuildHubDocument>;
  ClonedFromID?: Maybe<Scalars['Int']['output']>;
  Collaborators: Array<BuildHubDocumentCollaborator>;
  CollaboratorsWithAccess: Array<BuildHubDocumentCollaborator>;
  Comments: Array<BuildHubComment>;
  CommentsCount: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  EffectiveAccessMode: Scalars['String']['output'];
  EffectiveAccessRole: Scalars['String']['output'];
  Followers: Array<Member>;
  FollowersCount: Scalars['Int']['output'];
  FutureTeamMemberRole: Scalars['String']['output'];
  GeneralAccessMode: Scalars['String']['output'];
  GeneralAccessRole: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  InheritPermissions: Scalars['Boolean']['output'];
  IsCollaborator: Scalars['Boolean']['output'];
  IsCustomThumbnail: Scalars['Boolean']['output'];
  IsFile: Scalars['Boolean']['output'];
  IsFolder: Scalars['Boolean']['output'];
  IsFollower: Scalars['Boolean']['output'];
  IsPersonalMoodBoard: Scalars['Boolean']['output'];
  Items: InspirationItemsConnection;
  LastActivity?: Maybe<Scalars['String']['output']>;
  LastEdited: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  NegativeReactionsCount: Scalars['Int']['output'];
  Owner: Member;
  Parent?: Maybe<BuildHubDocument>;
  PositiveReactionsCount: Scalars['Int']['output'];
  Private: Scalars['Boolean']['output'];
  Reactions: Array<BuildHubReaction>;
  SortOrder: Scalars['Int']['output'];
  Source?: Maybe<DesignBoard>;
  ThumbnailBackgroundColor?: Maybe<Scalars['String']['output']>;
  ThumbnailIsClearCut?: Maybe<Scalars['Boolean']['output']>;
  ThumbnailIsMultiplied?: Maybe<Scalars['Boolean']['output']>;
  ThumbnailType?: Maybe<Scalars['String']['output']>;
  ThumbnailURL?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  UnreadCount: Scalars['Int']['output'];
};


export type InspirationGroupItemsArgs = {
  filter?: InputMaybe<ItemsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type InspirationGroupResponse = InspirationGroup | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type InspirationGroupsConnection = {
  __typename?: 'InspirationGroupsConnection';
  ID: Scalars['String']['output'];
  edges: Array<InspirationGroupsConnectionEdge>;
  nodes: Array<InspirationGroup>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type InspirationGroupsConnectionEdge = {
  __typename?: 'InspirationGroupsConnectionEdge';
  /** The node at the end of the collections edge */
  node: InspirationGroup;
};

export type InspirationItem = BuildHubDocument & {
  __typename?: 'InspirationItem';
  Breadcrumbs: Scalars['String']['output'];
  BuildHub: BuildHub;
  CanComment: Scalars['Boolean']['output'];
  CanCreate: Scalars['Boolean']['output'];
  CanDelete: Scalars['Boolean']['output'];
  CanEdit: Scalars['Boolean']['output'];
  Children: Array<BuildHubDocument>;
  Collaborators: Array<BuildHubDocumentCollaborator>;
  Comments: Array<BuildHubComment>;
  CommentsCount: Scalars['Int']['output'];
  ContentType?: Maybe<InspirationTypeEnum>;
  Created: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  EffectiveAccessMode: Scalars['String']['output'];
  EffectiveAccessRole: Scalars['String']['output'];
  ExternalUrl?: Maybe<ExternalUrlContent>;
  FollowersCount: Scalars['Int']['output'];
  FutureTeamMemberRole: Scalars['String']['output'];
  GeneralAccessMode: Scalars['String']['output'];
  GeneralAccessRole: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  Image?: Maybe<LibraryImage>;
  InheritPermissions: Scalars['Boolean']['output'];
  IsCollaborator: Scalars['Boolean']['output'];
  IsFile: Scalars['Boolean']['output'];
  IsFolder: Scalars['Boolean']['output'];
  IsFollower: Scalars['Boolean']['output'];
  LastActivity?: Maybe<Scalars['String']['output']>;
  LastEdited: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  NegativeReactionsCount: Scalars['Int']['output'];
  Owner: Member;
  Page?: Maybe<DirectoryItem>;
  Parent?: Maybe<BuildHubDocument>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  PhotoTileBackground?: Maybe<Scalars['String']['output']>;
  PositiveReactionsCount: Scalars['Int']['output'];
  Private: Scalars['Boolean']['output'];
  Reactions: Array<BuildHubReaction>;
  /** Polymorphic class name of the surface this pin was saved from (e.g. \"Archipro\Component\PageBuilder\ORM\EventDetails\" for an HDE save). Null when the pin was saved from a generic context. */
  SavedFromClass?: Maybe<Scalars['String']['output']>;
  /** Polymorphic record ID matching SavedFromClass. Always 0 when SavedFromClass is null. */
  SavedFromID?: Maybe<Scalars['Int']['output']>;
  SortOrder: Scalars['Int']['output'];
  Source?: Maybe<DesignBoardPin>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  UnreadCount: Scalars['Int']['output'];
  Upload?: Maybe<MemberUpload>;
};

export type InspirationItemResponse = InspirationItem | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type InspirationItemsConnection = {
  __typename?: 'InspirationItemsConnection';
  ID: Scalars['String']['output'];
  edges: Array<InspirationItemsConnectionEdge>;
  nodes: Array<InspirationItem>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type InspirationItemsConnectionEdge = {
  __typename?: 'InspirationItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: InspirationItem;
};

/** The type of content associated with a InspirationItem. */
export enum InspirationTypeEnum {
  Article = 'Article',
  ExternalProduct = 'ExternalProduct',
  ExternalUrl = 'ExternalUrl',
  MemberUpload = 'MemberUpload',
  Photo = 'Photo',
  Product = 'Product',
  Professional = 'Professional',
  Project = 'Project'
}

export type InspirationsSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  LastActivity?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type InstagramMediaSocialAd = SocialAd & {
  __typename?: 'InstagramMediaSocialAd';
  BodyText: Scalars['String']['output'];
  Date: Scalars['String']['output'];
  Engagements: InstagramMediaSocialAdEngagements;
  ExternalID: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Image: Scalars['String']['output'];
  Performance: InstagramMediaSocialAdPerformance;
  Permalink: Scalars['String']['output'];
  PreviewImage: Scalars['String']['output'];
  PreviewShareableLink: Scalars['String']['output'];
  Thumbnail: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  Top10: Scalars['Boolean']['output'];
  Type: Scalars['String']['output'];
};

export type InstagramMediaSocialAdEngagements = AdEngagements & {
  __typename?: 'InstagramMediaSocialAdEngagements';
  Comments: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Likes: Scalars['Int']['output'];
  Saves: Scalars['Int']['output'];
};

export type InstagramMediaSocialAdPerformance = AdPerformance & {
  __typename?: 'InstagramMediaSocialAdPerformance';
  EngagementRate?: Maybe<Scalars['Float']['output']>;
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  Reach: Scalars['Int']['output'];
  Saved: Scalars['Int']['output'];
};

export type InstallersType = {
  __typename?: 'InstallersType';
  Categories?: Maybe<Array<Category>>;
  Professionals?: Maybe<Array<Professional>>;
};

export type IntegratedPlatform = {
  __typename?: 'IntegratedPlatform';
  Data?: Maybe<Array<IntegratedPlatformData>>;
  Enabled: Scalars['Boolean']['output'];
  OrdersEnabled?: Maybe<Scalars['Boolean']['output']>;
  Platform: Scalars['String']['output'];
};

export type IntegratedPlatformData = {
  __typename?: 'IntegratedPlatformData';
  Key: Scalars['String']['output'];
  Value?: Maybe<Scalars['String']['output']>;
};

export enum IntegratedPlatformEnum {
  Archipro = 'ARCHIPRO',
  Csv = 'CSV',
  Shopify = 'SHOPIFY',
  ShopifyCsv = 'SHOPIFY_CSV',
  Squarespace = 'SQUARESPACE',
  WooCommerce = 'WOO_COMMERCE',
  WooCommerceCsv = 'WOO_COMMERCE_CSV'
}

export type IntegrationRequest = {
  __typename?: 'IntegrationRequest';
  Created: Scalars['Int']['output'];
  Errors?: Maybe<Array<Scalars['String']['output']>>;
  ErrorsList?: Maybe<Array<ImportError>>;
  Failed?: Maybe<Scalars['Int']['output']>;
  FileName?: Maybe<Scalars['String']['output']>;
  Finished?: Maybe<Scalars['Int']['output']>;
  Format?: Maybe<Scalars['String']['output']>;
  ImportType?: Maybe<Scalars['String']['output']>;
  Inserted?: Maybe<Scalars['Int']['output']>;
  IntegrationStatus: Scalars['String']['output'];
  IntegrationType?: Maybe<Scalars['String']['output']>;
  Processed?: Maybe<Scalars['Int']['output']>;
  Professional: Scalars['String']['output'];
  ProfessionalSort: Scalars['Int']['output'];
  RequestID: Scalars['String']['output'];
  Source?: Maybe<Scalars['String']['output']>;
  Started?: Maybe<Scalars['Int']['output']>;
  Total?: Maybe<Scalars['Int']['output']>;
  User?: Maybe<Scalars['String']['output']>;
  WarningsList?: Maybe<Array<ImportWarning>>;
};

export type IntegrationRequestConnection = {
  __typename?: 'IntegrationRequestConnection';
  items?: Maybe<Array<IntegrationRequest>>;
  pageInfo: ListConnectionPageInfo;
};

export type IntegrationSettingsModelInput = {
  ContentLockFlexibilitySettings?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntegrationSettingsModelOutput = {
  __typename?: 'IntegrationSettingsModelOutput';
  ContentLockFlexibilitySettings?: Maybe<Array<Scalars['String']['output']>>;
};

export type IntegrationUnpublishProductResult = Error | NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type InterestedCategory = {
  __typename?: 'InterestedCategory';
  CategoryLabel: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  InterestPercentage: Scalars['Int']['output'];
  URLSegment?: Maybe<Scalars['String']['output']>;
};

export type IntroModule = ModuleType & {
  __typename?: 'IntroModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  BackgroundImage?: Maybe<ResponsiveVariantImage>;
  Content?: Maybe<Scalars['String']['output']>;
  ExternalVideoLink?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  PlayInModal: Scalars['Boolean']['output'];
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
  VideoCover?: Maybe<ResponsiveVariantImage>;
};

export type InviteInfo = DesignBoardInvite | EnquiryConversationInvite | NotFoundError | ServerError;

/** The result of the `inviteToGroupChat` mutation. */
export type InviteToGroupChatPayload = {
  __typename?: 'InviteToGroupChatPayload';
  /** The destination group chat. */
  Conversation: DirectConversation;
  /** The original conversation. */
  SourceConversation: DirectConversation;
  /** The system messages created as a result of the invite (in the destination group chat). */
  SystemMessages: Array<SystemMessage>;
};

export type InviteToGroupChatResponse = InviteToGroupChatPayload | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type Invoice = Invoiceable & ModuleColumn & SortableItem & {
  __typename?: 'Invoice';
  AccountDetails?: Maybe<TokenisedField>;
  BankTransferTerms?: Maybe<TokenisedField>;
  BusinessTermsVersions: Array<BusinessTermsVersion>;
  /** Whether the current member may edit the invoice summary (description/subheadline) only; full editing requires FullAccess. */
  CanEditSummary: Scalars['Boolean']['output'];
  Contact?: Maybe<Contact>;
  ContactAddress?: Maybe<Scalars['String']['output']>;
  ContactCity?: Maybe<Scalars['String']['output']>;
  ContactCompanyName?: Maybe<Scalars['String']['output']>;
  ContactEmail?: Maybe<Scalars['String']['output']>;
  ContactFirstName?: Maybe<Scalars['String']['output']>;
  ContactID: Scalars['ID']['output'];
  ContactInfo?: Maybe<TokenisedField>;
  /** When true, contact was set from the HubSpot deal during invoice creation; lock contact tile (read-only). */
  ContactOriginatedFromDeal?: Maybe<Scalars['Boolean']['output']>;
  ContactPhone?: Maybe<Scalars['String']['output']>;
  ContactPostCode?: Maybe<Scalars['String']['output']>;
  ContactSurname?: Maybe<Scalars['String']['output']>;
  Created: Scalars['Date']['output'];
  CreditCardTerms?: Maybe<TokenisedField>;
  Currency: Scalars['String']['output'];
  /** The onboarded deal owner (team member) from HubSpot. */
  DealOwner?: Maybe<TeamMember>;
  Description?: Maybe<TokenisedField>;
  Discounts: CurrencyAmount;
  /** Whether automatic charging is enabled for this invoice. When true, Stripe will attempt to charge the default payment method on due dates. */
  EnabledAutoCharge: Scalars['Boolean']['output'];
  EndDate?: Maybe<Scalars['Date']['output']>;
  ExpiryAutoSetOnSend?: Maybe<Scalars['Boolean']['output']>;
  ExpiryDate?: Maybe<Scalars['Date']['output']>;
  FooterLinks?: Maybe<Array<FooterLink>>;
  /** Whether the current member has full (delete-tier) BM access for this invoice, quote, or template. */
  FullAccess: Scalars['Boolean']['output'];
  HasProcessingPayment: Scalars['Boolean']['output'];
  HasStripePaymentMethod: Scalars['Boolean']['output'];
  Headline?: Maybe<Scalars['String']['output']>;
  /** When true, BM and proposal UIs should not show the membership term (New Business pipeline quotes). */
  HideMembershipTerm: Scalars['Boolean']['output'];
  /** HubSpot deal ID when invoice was created from a HubSpot deal via syncDeal/useDealAsQuote. */
  HubspotID?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  /** BM invoice classification — membership core billing vs add-on premium checkout (values membership, add-on). */
  InvoiceKind: Scalars['String']['output'];
  InvoiceSentDate?: Maybe<Scalars['Date']['output']>;
  InvoiceSentViaExternalEmail?: Maybe<Scalars['Boolean']['output']>;
  IsEmpty: Scalars['Boolean']['output'];
  LastEdited: Scalars['Date']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  /** Display string for membership term (Lifetime for non-manufacturer clients outside the US, or start–end dates otherwise). */
  MembershipTerm: Scalars['String']['output'];
  ModuleID: Scalars['Int']['output'];
  Notes?: Maybe<TokenisedField>;
  PONumber?: Maybe<Scalars['String']['output']>;
  PaymentTerms?: Maybe<TokenisedField>;
  Payments: Array<InvoicePayment>;
  PendingResultInvoicePaymentID?: Maybe<Scalars['Int']['output']>;
  Professional?: Maybe<Professional>;
  ProposalUrlSegment: Scalars['String']['output'];
  PublishableKey?: Maybe<Scalars['String']['output']>;
  QuoteDecisionDate?: Maybe<Scalars['Date']['output']>;
  ReadOnly: Scalars['Boolean']['output'];
  References?: Maybe<TokenisedField>;
  Scope?: Maybe<TokenisedField>;
  SelectedBusinessTermsCategories: Array<BusinessTermsCategory>;
  Services: Array<InvoiceServiceItem>;
  SignatureDataUrl?: Maybe<Scalars['String']['output']>;
  SignatureEmail?: Maybe<Scalars['String']['output']>;
  SignatureFullName?: Maybe<Scalars['String']['output']>;
  SplitPayment?: Maybe<Scalars['String']['output']>;
  StartDate?: Maybe<Scalars['Date']['output']>;
  StartedProcessingPaymentAt?: Maybe<Scalars['Date']['output']>;
  Status: InvoiceStatusEnum;
  StripeAccount?: Maybe<Scalars['String']['output']>;
  StripeHostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the most recent Stripe sync task last changed status, or null if never synced. */
  StripeSyncLastEdited?: Maybe<Scalars['Date']['output']>;
  /** Status of the most recent Stripe sync task (Queued, Running, Success, Failed, etc.), or null if never synced. */
  StripeSyncStatus?: Maybe<AsyncTaskStatus>;
  SubHeadline?: Maybe<Scalars['String']['output']>;
  SubTotal: CurrencyAmount;
  Tax: CurrencyAmount;
  TaxBehavior?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<TokenisedField>;
  Total: CurrencyAmount;
  /** Total amount paid for this invoice, including surcharges. Sums all fully paid payments (base amount + surcharge for each payment). */
  TotalPaid: Scalars['Float']['output'];
  /** Total surcharge amount paid across all fully paid payments. Useful for reporting and auditing purposes. Only includes surcharges from payments with FullyPaid status. */
  TotalSurcharge: Scalars['Float']['output'];
  UUID: Scalars['String']['output'];
  WordCount: Scalars['Int']['output'];
};

/** Captures resolved proposal email content at confirm time for email preview */
export type InvoiceEmailSnapshot = {
  __typename?: 'InvoiceEmailSnapshot';
  ID: Scalars['Int']['output'];
  QuoteContentUrlSegment: Scalars['String']['output'];
  RecipientEmail: Scalars['String']['output'];
  RecipientFirstName: Scalars['String']['output'];
  RecipientSurname: Scalars['String']['output'];
  RenderedHtml: Scalars['String']['output'];
  SnapshotData: Scalars['String']['output'];
  Subject: Scalars['String']['output'];
  UUID: Scalars['String']['output'];
};

export type InvoiceEmailSnapshotResponse = InvoiceEmailSnapshot | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Response type for invoice payment processing status query */
export type InvoiceHasProcessingPaymentResponse = {
  __typename?: 'InvoiceHasProcessingPaymentResponse';
  HasProcessingPayment: Scalars['Boolean']['output'];
  PendingResultInvoicePaymentID?: Maybe<Scalars['Int']['output']>;
  StartedProcessingPaymentAt?: Maybe<Scalars['Date']['output']>;
};

/** Activity log entry for an invoice or quote */
export type InvoiceLog = {
  __typename?: 'InvoiceLog';
  Activity: Scalars['String']['output'];
  Created: Scalars['Date']['output'];
  CreatedBy?: Maybe<Member>;
  Data?: Maybe<Scalars['String']['output']>;
  Description: Scalars['String']['output'];
  Event: Scalars['String']['output'];
  Group: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  InvoicePaymentID?: Maybe<Scalars['Int']['output']>;
  InvoicePaymentStripeAttemptID?: Maybe<Scalars['Int']['output']>;
  Level?: Maybe<Scalars['String']['output']>;
  Professional?: Maybe<Professional>;
  Source?: Maybe<Scalars['String']['output']>;
  TriggeredBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceModule = FlexibleModule & {
  __typename?: 'InvoiceModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type InvoiceModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type InvoicePayment = {
  __typename?: 'InvoicePayment';
  Amount: Scalars['Float']['output'];
  AmountOption: InvoicePaymentAmountOptionEnum;
  AmountPercentage?: Maybe<Scalars['Float']['output']>;
  /** Card brand from Stripe (e.g. \"visa\", \"mastercard\") captured at payment time. Null for non-card payments. */
  CardBrand?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of the card used for payment. Null for non-card payments. */
  CardLast4?: Maybe<Scalars['String']['output']>;
  DueDate?: Maybe<Scalars['Date']['output']>;
  DueDaysAfterInvoiceSent?: Maybe<Scalars['Int']['output']>;
  DueFixedDayOfMonth?: Maybe<Scalars['Int']['output']>;
  DueOption: InvoicePaymentDueOptionEnum;
  EndDate?: Maybe<Scalars['Date']['output']>;
  /** Installment ID for display. When invoice has HubspotID, returns \"{HubspotID}-{2-digit}\" (e.g. \"12318724-03\"). Otherwise zero-padded 2-digit (e.g. \"01\", \"03\"). */
  FormattedPaymentInstallmentNumber?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Invoice: Invoice;
  Notes?: Maybe<Scalars['String']['output']>;
  PaymentDate?: Maybe<Scalars['Date']['output']>;
  /** Immutable 1-based index per invoice for external accounting reference. Like ID but scoped; never renumbered on delete. */
  PaymentInstallmentNumber?: Maybe<Scalars['Int']['output']>;
  /** Payment method from the latest paid transaction (e.g. Credit/Debit, card). Null when unpaid. */
  PaymentMethod?: Maybe<Scalars['String']['output']>;
  /** Per-payment receipt breakdown (null when unavailable). */
  PaymentReceiptAllocation?: Maybe<PaymentReceiptAllocation>;
  PaymentTransactionID?: Maybe<Scalars['String']['output']>;
  ResolvedStripeId?: Maybe<Scalars['String']['output']>;
  SortOrder?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['Date']['output']>;
  StartedProcessingPaymentAt?: Maybe<Scalars['Date']['output']>;
  Status: Scalars['String']['output'];
  /** Persisted customer-facing Stripe hosted invoice URL. Populated when StripeInvoiceID is set for Stripe invoices. May be null for legacy rows or non-invoice IDs. */
  StripeHostedUrl?: Maybe<Scalars['String']['output']>;
  StripeIntentID?: Maybe<Scalars['String']['output']>;
  /** Customer-facing Stripe hosted invoice URL for this payment, when available. */
  StripeInvoiceUrl?: Maybe<Scalars['String']['output']>;
  StripeUrl?: Maybe<Scalars['String']['output']>;
  /** Credit card surcharge amount paid for this payment (tax-inclusive). Stored for record keeping when payment is processed. Null if no surcharge was applied. */
  SurchargeAmount?: Maybe<Scalars['Float']['output']>;
  /** Surcharge rate applied at time of payment (as decimal, e.g., 0.0265 for 2.65%, tax-inclusive). Stored for record keeping. Null if no surcharge was applied. */
  SurchargeRate?: Maybe<Scalars['Float']['output']>;
  /** Total amount charged to the customer for this payment (base amount + surcharge). Used for displaying the actual amount charged. */
  TotalWithSurcharge: Scalars['Float']['output'];
  UUID: Scalars['String']['output'];
  WasPreviouslyRefunded: Scalars['Boolean']['output'];
};

/** the option user selected for payment amount */
export enum InvoicePaymentAmountOptionEnum {
  CustomAmount = 'CustomAmount',
  EqualPayments = 'EqualPayments',
  Percentage = 'Percentage'
}

export type InvoicePaymentConfirmAfterStripeResponse = InvoicePaymentConfirmAfterStripeResult | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Outcome of synchronous proposal payment confirm after Stripe.js succeeds */
export type InvoicePaymentConfirmAfterStripeResult = {
  __typename?: 'InvoicePaymentConfirmAfterStripeResult';
  InvoicePaymentId: Scalars['Int']['output'];
  InvoiceStatus: Scalars['String']['output'];
  Outcome: Scalars['String']['output'];
};

/** determines how due date will be resolved, either setup upfront or determined after invoice is sent */
export enum InvoicePaymentDueOptionEnum {
  FixedDate = 'FixedDate',
  FixedDayOfMonth = 'FixedDayOfMonth',
  RelativeInvoiceDate = 'RelativeInvoiceDate'
}

export type InvoicePaymentResponse = InvoicePayment | NotAuthorizedError | NotFoundError | ServerError | UserError;

export enum InvoicePermissionActionEnum {
  BmInvoiceDelete = 'BM_INVOICE_DELETE',
  BmInvoiceEdit = 'BM_INVOICE_EDIT',
  BmInvoiceExport = 'BM_INVOICE_EXPORT',
  BmInvoiceMarkPaid = 'BM_INVOICE_MARK_PAID',
  BmInvoiceRefund = 'BM_INVOICE_REFUND',
  BmInvoiceSend = 'BM_INVOICE_SEND',
  BmInvoiceView = 'BM_INVOICE_VIEW',
  BmQuoteDelete = 'BM_QUOTE_DELETE',
  BmQuoteEdit = 'BM_QUOTE_EDIT',
  BmQuoteSend = 'BM_QUOTE_SEND',
  BmQuoteTemplateDelete = 'BM_QUOTE_TEMPLATE_DELETE',
  BmQuoteTemplateEdit = 'BM_QUOTE_TEMPLATE_EDIT',
  BmQuoteTemplateView = 'BM_QUOTE_TEMPLATE_VIEW',
  BmQuoteView = 'BM_QUOTE_VIEW',
  BmTermsDelete = 'BM_TERMS_DELETE',
  BmTermsEdit = 'BM_TERMS_EDIT',
  BmTermsView = 'BM_TERMS_VIEW'
}

/** A reminder setting configured by a professional */
export type InvoiceReminderSetting = {
  __typename?: 'InvoiceReminderSetting';
  Days: Scalars['Int']['output'];
  Direction: Scalars['String']['output'];
  Enabled: Scalars['Boolean']['output'];
  ID: Scalars['ID']['output'];
  IsGlobal: Scalars['Boolean']['output'];
  IsOwn: Scalars['Boolean']['output'];
  Sequence: Scalars['Int']['output'];
  Type: Scalars['String']['output'];
};

/** Result of a reminder setting mutation */
export type InvoiceReminderSettingResult = {
  __typename?: 'InvoiceReminderSettingResult';
  Message?: Maybe<Scalars['String']['output']>;
  Setting?: Maybe<InvoiceReminderSetting>;
  Success: Scalars['Boolean']['output'];
};

export type InvoiceServiceItem = {
  __typename?: 'InvoiceServiceItem';
  Description?: Maybe<Scalars['String']['output']>;
  DiscountAmount?: Maybe<Scalars['Float']['output']>;
  DiscountAmountPerUnit?: Maybe<Scalars['Float']['output']>;
  DiscountApplied: Scalars['Boolean']['output'];
  DiscountedUnitPrice: CurrencyAmount;
  ID: Scalars['ID']['output'];
  Invoice: Invoice;
  PhotoSrc?: Maybe<Scalars['String']['output']>;
  Quantity?: Maybe<Scalars['Int']['output']>;
  SKU?: Maybe<Scalars['String']['output']>;
  /** Display order within the parent quote or invoice (1-based; managed when reordering line items) */
  SortOrder?: Maybe<Scalars['Int']['output']>;
  TaxAmount?: Maybe<Scalars['Float']['output']>;
  TaxRate?: Maybe<Scalars['Float']['output']>;
  /** String */
  Thumbnail?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  Total: CurrencyAmount;
  UnitPrice: CurrencyAmount;
};

/** Invoice status */
export enum InvoiceStatusEnum {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Expired = 'Expired',
  Issued = 'Issued',
  Overdue = 'Overdue',
  Paid = 'Paid',
  PartialPaid = 'PartialPaid',
  Refunded = 'Refunded',
  Sent = 'Sent'
}

/** common fields between invoice and quote template */
export type Invoiceable = {
  AccountDetails?: Maybe<TokenisedField>;
  BankTransferTerms?: Maybe<TokenisedField>;
  BusinessTermsVersions: Array<BusinessTermsVersion>;
  /** Whether the current member may edit the invoice summary (description/subheadline) only; full editing requires FullAccess. */
  CanEditSummary: Scalars['Boolean']['output'];
  Contact?: Maybe<Contact>;
  ContactInfo?: Maybe<TokenisedField>;
  Created: Scalars['Date']['output'];
  CreditCardTerms?: Maybe<TokenisedField>;
  Currency: Scalars['String']['output'];
  Description?: Maybe<TokenisedField>;
  Discounts: CurrencyAmount;
  ExpiryAutoSetOnSend?: Maybe<Scalars['Boolean']['output']>;
  ExpiryDate?: Maybe<Scalars['Date']['output']>;
  /** Whether the current member has full (delete-tier) BM access for this invoice, quote, or template. */
  FullAccess: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  IsEmpty: Scalars['Boolean']['output'];
  LastEdited: Scalars['Date']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleID: Scalars['Int']['output'];
  Notes?: Maybe<TokenisedField>;
  PaymentTerms?: Maybe<TokenisedField>;
  Payments: Array<InvoicePayment>;
  Professional?: Maybe<Professional>;
  ReadOnly: Scalars['Boolean']['output'];
  References?: Maybe<TokenisedField>;
  Scope?: Maybe<TokenisedField>;
  SelectedBusinessTermsCategories: Array<BusinessTermsCategory>;
  Services: Array<InvoiceServiceItem>;
  SubTotal: CurrencyAmount;
  Tax: CurrencyAmount;
  TaxBehavior?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<TokenisedField>;
  Total: CurrencyAmount;
  WordCount: Scalars['Int']['output'];
};

export type InvoiceableResponse = Invoice | NotAuthorizedError | NotFoundError | QuoteTemplate | ServerError | UserError;

export type Item = Article | Product | Professional | Project;

export type ItemSortOrders = {
  ID: Scalars['Int']['input'];
  MemberSortOrder: Scalars['Int']['input'];
};

export type ItemsFilters = {
  /** Filter inspiration items by content type */
  ByContentType?: InputMaybe<InspirationTypeEnum>;
};

export type Itineraries_Connection = {
  __typename?: 'Itineraries_Connection';
  edges: Array<Itineraries_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Itineraries_ConnectionEdge = {
  __typename?: 'Itineraries_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventItinerary;
};

export type Itineraries_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** Audience for JWT tokens */
export enum JwtAudience {
  IntegrationServiceBackend = 'IntegrationServiceBackend',
  IntegrationServiceBrowser = 'IntegrationServiceBrowser',
  Mcp = 'MCP',
  MobileApp = 'MobileApp',
  SystemUser = 'SystemUser',
  WebSocketServer = 'WebSocketServer',
  Workflow = 'Workflow'
}

export type JwtTokenError = ErrorInterface & {
  __typename?: 'JWTTokenError';
  Message: Scalars['String']['output'];
  Status: JwtTokenErrorStatus;
};

/** JWT token error status */
export enum JwtTokenErrorStatus {
  Dead = 'Dead',
  Expired = 'Expired',
  Invalid = 'Invalid'
}

/** Successful JWT authentication response containing member details and optionally tokens */
export type JwtTokenMember = {
  __typename?: 'JWTTokenMember';
  /** The authenticated member */
  Member: Member;
  /** Refresh token for obtaining new access tokens (long-lived, store securely). Only returned for create/refresh operations. */
  RefreshToken: Scalars['String']['output'];
  /** JWT access token for API authorization (short-lived, use in Bearer header). Only returned for create/refresh operations. */
  Token: Scalars['String']['output'];
};

/** Successful JWT validation response containing only member details */
export type JwtTokenMemberOnly = {
  __typename?: 'JWTTokenMemberOnly';
  /** The authenticated member */
  Member: Member;
};

export type JwtTokenValidResponse = JwtTokenError | JwtTokenMember | NotAuthenticatedError | ServerError | UserError;

/** Response for JWT validation operations that only return member details without issuing new tokens */
export type JwtTokenValidationResponse = JwtTokenError | JwtTokenMemberOnly | NotAuthenticatedError | ServerError | UserError;

/** A scope name controlling which GraphQL operations a JWT can execute. */
export enum JwtScopeEnum {
  /** Allows all GraphQL operations. Avoid using this scope. */
  Everything = 'everything',
  /** Permission to generate AI description with the integration service */
  GenerateAiDescription = 'generateAiDescription',
  /** Administration of integration settings (system user only) */
  IntegrationAdmin = 'integrationAdmin',
  /** Invoice reminder callback from useWorkflow (system user only) */
  InvoiceReminderWorkflow = 'invoice_reminder_workflow',
  /** Manage supplier orders (system user only) */
  OrderManagement = 'orderManagement',
  /** Manage product imports and unpublishing (system user only) */
  ProductManagement = 'productManagement',
  /** Used by the profile-generation workflow to create and update professional profiles via GraphQL. */
  ProfileBuilder = 'profile_builder',
  /** Public scope that do not require authentication */
  Public = 'public',
  /** Permission to access Airtable ad schedule (no GraphQL access) */
  ReadAdSchedule = 'readAdSchedule',
  /** Read information about a user's BuildHub projects */
  ReadBuildHub = 'readBuildHub',
  /** Read information about chats/conversations */
  ReadChat = 'readChat',
  /** Permission to access import requests */
  ReadImportRequests = 'readImportRequests',
  /** Permission to access integration settings */
  ReadIntegrationSettings = 'readIntegrationSettings',
  /** Read information about the user */
  ReadUser = 'readUser',
  /** Trigger product CSV export for integration */
  TriggerProductExport = 'triggerProductExport',
  /** Trigger product sync in connected platform */
  TriggerProductSync = 'triggerProductSync',
  /** Update information about the user */
  UpdateUser = 'updateUser',
  /** Write information about a user's BuildHub projects */
  WriteBuildHub = 'writeBuildHub'
}

export type KeynoteSpeakers_Connection = {
  __typename?: 'KeynoteSpeakers_Connection';
  edges: Array<KeynoteSpeakers_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type KeynoteSpeakers_ConnectionEdge = {
  __typename?: 'KeynoteSpeakers_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventKeynoteSpeaker;
};

export type KeynoteSpeakers_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

/** An append-only lead activity recorded against a contact. */
export type LeadActivity = {
  __typename?: 'LeadActivity';
  /** Where the activity originated (Platform, Pixel, HDE). */
  Channel: LeadChannelEnum;
  Contact: Contact;
  Created: Scalars['String']['output'];
  /** Human-readable context about the activity. */
  Description?: Maybe<Scalars['String']['output']>;
  Enquiry?: Maybe<Enquiry>;
  /** Event the activity occurred at, when applicable (HDE scan flow). */
  EventDetailsID?: Maybe<Scalars['ID']['output']>;
  ID: Scalars['ID']['output'];
  /** Link to the inbox conversation for enquiry activities. */
  InboxLink?: Maybe<Scalars['String']['output']>;
  /** The product or project that triggered this activity. */
  LibraryItem?: Maybe<DirectoryItem>;
  /** Subject member of the activity (e.g. the scanned attendee for HDE scans). */
  Member?: Maybe<Member>;
  /** Flexible metadata as a JSON string (product title, file name, form payload, etc.). */
  Meta?: Maybe<Scalars['String']['output']>;
  Professional: Professional;
  /** Member who initiated the activity, when distinct from the subject (e.g. the booth staffer who scanned an attendee QR). */
  ScannerMember?: Maybe<Member>;
  /** Event ticket type used by the scanned member for HDE scan activities. Null for non-HDE activity and legacy scans without a captured ticket. */
  TicketType?: Maybe<Scalars['String']['output']>;
  /** How the activity was generated (Download, Enquiry, FormSubmit, HdeScan). */
  Type: LeadActivityTypeEnum;
  /** Reference page URL for the activity (e.g. page where a pixel conversion occurred). */
  URL?: Maybe<Scalars['String']['output']>;
};

/** Identifies the append-only lead activity recorded against a contact. */
export enum LeadActivityTypeEnum {
  Download = 'Download',
  Enquiry = 'Enquiry',
  FormSubmit = 'FormSubmit',
  HdeScan = 'HdeScan'
}

/** Identifies where a lead originated. */
export enum LeadChannelEnum {
  Hde = 'HDE',
  Pixel = 'Pixel',
  Platform = 'Platform'
}

export type LeadExportInput = {
  Filter?: InputMaybe<ProfessionalContactsFilters>;
  Professional: Scalars['String']['input'];
  Sort?: InputMaybe<ProfessionalContactsSortFields>;
};

export type LeadExportJob = {
  __typename?: 'LeadExportJob';
  ContactCount: Scalars['Int']['output'];
  CreatedAt: Scalars['Date']['output'];
  DownloadURL?: Maybe<Scalars['String']['output']>;
  FileName?: Maybe<Scalars['String']['output']>;
  /** The ID of the underlying TaskDetails object. */
  ID: Scalars['Int']['output'];
  /** The ID of the underlying LeadExportJob object. */
  JobID: Scalars['Int']['output'];
  LastEditedAt: Scalars['Date']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  Status: AsyncTaskStatus;
};

export type LeadFunnelFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeadFunnelStatsFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeadFunnelUserScoresFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeadFunnelUserSessionsFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeadFunnelUserStatusFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeadFunnelUserTimeFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeadFunnelUsersFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  FUNNEL_STAGE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LeadFunnelUsersSort = {
  CONVERSIONS?: InputMaybe<PrioritySort>;
  DETAILS?: InputMaybe<PrioritySort>;
  LAST_VISIT?: InputMaybe<PrioritySort>;
  LOCATION?: InputMaybe<PrioritySort>;
  NAME?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  STAGE?: InputMaybe<PrioritySort>;
  STATUS?: InputMaybe<PrioritySort>;
  TIME?: InputMaybe<PrioritySort>;
  TYPE?: InputMaybe<PrioritySort>;
  USER_ENGAGEMENT?: InputMaybe<PrioritySort>;
  USER_SCORE?: InputMaybe<PrioritySort>;
  VIEWS?: InputMaybe<PrioritySort>;
};

/** Tracks the progression of a lead through the sales funnel. */
export enum LeadStatusEnum {
  Closed = 'Closed',
  Contacted = 'Contacted',
  Converted = 'Converted',
  New = 'New',
  Qualified = 'Qualified'
}

export enum LeadTimeUnitEnum {
  Day = 'Day',
  Week = 'Week'
}

export type LegacyArticle = NotFoundError | Redirect;

export type LibraryDownload = SortableItem & {
  __typename?: 'LibraryDownload';
  ExternalLink?: Maybe<Scalars['String']['output']>;
  FileCategory?: Maybe<FileCategory>;
  FileID?: Maybe<Scalars['Int']['output']>;
  ID: Scalars['Int']['output'];
  InternalLink?: Maybe<Scalars['String']['output']>;
  LibraryItem?: Maybe<DirectoryItem>;
  MemberSortOrder: Scalars['Int']['output'];
  SortOrder?: Maybe<Scalars['Int']['output']>;
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
};

export type LibraryImage = DesignBoardPinTarget & SortableItem & {
  __typename?: 'LibraryImage';
  AltText?: Maybe<Scalars['String']['output']>;
  /** Aspect ratio of raw uploaded photo */
  AspectRatio: Scalars['Float']['output'];
  BannerSegment?: Maybe<BannerSegmentEnum>;
  /** Associated caption for this LibraryImage */
  Caption?: Maybe<Scalars['String']['output']>;
  Categories: Array<Category>;
  /** Clickable link for this photo */
  ClickableLink?: Maybe<Scalars['String']['output']>;
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  /** Crop Position in x-axis (if applicable) */
  CropPosX: Scalars['Int']['output'];
  /** Crop Position in y-axis (if applicable) */
  CropPosY: Scalars['Int']['output'];
  /** Return any of this user's Design Boards that contain this image */
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  /** Download link for this photo */
  DownloadLink?: Maybe<Scalars['String']['output']>;
  Format?: Maybe<Scalars['String']['output']>;
  FullScreen?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if LibraryImage has tags */
  HasTags: Scalars['Boolean']['output'];
  /** Height of the photo after cropping it */
  HeightAfterCrop: Scalars['Int']['output'];
  /** Height of the photo before cropping it */
  HeightBeforeCrop: Scalars['Int']['output'];
  /** When true, the image should be hidden on the frontend page (e.g., needs upscaling) */
  HideOnPage?: Maybe<Scalars['Boolean']['output']>;
  /** Does a LibraryImage need to hide resene tool */
  HideReseneTool?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier of the LibraryImage */
  ID: Scalars['Int']['output'];
  /** Is this image Landscape or Portrait? */
  ImageFormat: Scalars['String']['output'];
  /** If a LibraryImage has active tags */
  Interactive?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if LibraryImage is clearcut */
  IsClearCut: Scalars['Boolean']['output'];
  /** Returns true if LibraryImage should display as a half-width */
  IsHalfWidth: Scalars['Boolean']['output'];
  /** Returns true if LibraryImage has multiply filter */
  IsMultiplied: Scalars['Boolean']['output'];
  /** is raw image portrait, backend treats square image as portrait */
  IsPortrait: Scalars['Boolean']['output'];
  /** Returns true if LibraryImage is zoomed out */
  IsZoomedOut: Scalars['Boolean']['output'];
  /** LibraryImageFile for this LibraryImage */
  LibraryImageFile?: Maybe<LibraryImageFile>;
  /** SiteTreeID of related LibraryItem */
  LibraryImageFileID?: Maybe<Scalars['Int']['output']>;
  /** AI-generated label for this image (ordered by AdminScore DESC and ID DESC, limit 1) */
  LibraryImageLabel?: Maybe<LibraryImageLabel>;
  /** Return a list of tags on this photo */
  LibraryImageMarkers: Array<LibraryImageMarker>;
  /** DirectoryItem associated with this LibraryImage */
  LibraryItem?: Maybe<DirectoryItem>;
  /** SiteTreeID of related LibraryItem */
  LibraryItemID?: Maybe<Scalars['Int']['output']>;
  MemberSortOrder: Scalars['Int']['output'];
  MetaDescription?: Maybe<Scalars['String']['output']>;
  /** Returns true if this LibraryImage needs upscaling (marked for upscaling but not yet processed) */
  NeedsUpscale: Scalars['Boolean']['output'];
  /** Show overlay on banner image */
  Overlay?: Maybe<Scalars['Boolean']['output']>;
  PhotoBrickPortrait?: Maybe<Scalars['String']['output']>;
  /** Professional to give Photo Credit for this image */
  PhotoCredit?: Maybe<Professional>;
  /** Name of the photo credit, can be a custom credit without a Professional */
  PhotoCreditName?: Maybe<Scalars['String']['output']>;
  PhotoListing?: Maybe<Scalars['String']['output']>;
  PhotoListingPreload?: Maybe<Scalars['String']['output']>;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  /** Is the image product related */
  ProductRelated?: Maybe<Scalars['Boolean']['output']>;
  /** Professional associated with this LibraryImage */
  Professional?: Maybe<Professional>;
  ProfessionalID: Scalars['String']['output'];
  ProfessionalWebsite: Scalars['String']['output'];
  ProfessionalWebsiteShort: Scalars['String']['output'];
  /** Scroll Position in x-axis (if applicable) */
  ScrollPosX: Scalars['Int']['output'];
  /** Scroll Position in y-axis (if applicable) */
  ScrollPosY: Scalars['Int']['output'];
  SearchTags: LibraryImageSearchTagsConnection;
  SortOrder: Scalars['Int']['output'];
  Tags?: Maybe<Array<Maybe<LibraryImageMarker>>>;
  /** Title of the LibraryImage (usually internal) */
  Title: Scalars['String']['output'];
  /** Returns true if this LibraryImage has been upscaled with AI (has a LibraryImageUpscale record) */
  WasUpscaled: Scalars['Boolean']['output'];
  /** Width for this photo */
  Width?: Maybe<Scalars['Int']['output']>;
  /** Width of the photo after cropping it */
  WidthAfterCrop: Scalars['Int']['output'];
  /** Width of the photo before cropping it */
  WidthBeforeCrop: Scalars['Int']['output'];
  /** Zoom percentage of photo (default 100) */
  ZoomFactor: Scalars['Int']['output'];
};


export type LibraryImageSearchTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LibraryImageFile = {
  __typename?: 'LibraryImageFile';
  AwardThumb?: Maybe<Scalars['String']['output']>;
  Created: Scalars['String']['output'];
  Cropped48?: Maybe<Scalars['String']['output']>;
  Cropped200?: Maybe<Scalars['String']['output']>;
  DetailBannerEditMode: ResponsiveImage;
  DetailBannerStandard: ResponsiveImage;
  DetailPageEditMode: ResponsiveImage;
  DetailPageLandscape: ResponsiveImage;
  DetailPageSegmentBanner: ResponsiveImage;
  DetailPageSquare: ResponsiveImage;
  DetailPageStandard: ResponsiveImage;
  DirectoryBannerStandard: ResponsiveImage;
  DirectoryFeaturedBannerDesktop?: Maybe<Scalars['String']['output']>;
  DirectoryPageFeatured: ResponsiveImage;
  DirectoryPageLandscape: ResponsiveImage;
  DirectoryPageSquare: ResponsiveImage;
  EmailAsset?: Maybe<Scalars['String']['output']>;
  Filename?: Maybe<Scalars['String']['output']>;
  FlexibleBanner: ResponsiveImage;
  /** Frontend-only detail page image without watermarks - separate from existing watermarked fields */
  FrontendDetailPage: ResponsiveImage;
  ID: Scalars['Int']['output'];
  /** the image background */
  ImageBackgroundColor?: Maybe<Scalars['String']['output']>;
  ImageFilter?: Maybe<Scalars['String']['output']>;
  ImageHeight: Scalars['Int']['output'];
  ImageWidth: Scalars['Int']['output'];
  IsPortrait: Scalars['Boolean']['output'];
  /** the professional logo background of the image owner */
  LogoBackground?: Maybe<Scalars['String']['output']>;
  LogoSearch?: Maybe<Scalars['String']['output']>;
  ModuleImage: ResponsiveImage;
  Name?: Maybe<Scalars['String']['output']>;
  PhotoBrick?: Maybe<Scalars['String']['output']>;
  PhotoBrickLandscape?: Maybe<Scalars['String']['output']>;
  PhotoBrickPortrait?: Maybe<Scalars['String']['output']>;
  PhotoEnquiryThumb?: Maybe<Scalars['String']['output']>;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  PhotoTileDraggable?: Maybe<Scalars['String']['output']>;
  PhotoViewer: ResponsiveImage;
  PositionedImage?: Maybe<Scalars['String']['output']>;
  ProfessionalLogo?: Maybe<Scalars['String']['output']>;
  RecommendedSlider: ResponsiveImage;
  RelatedArticle: ResponsiveImage;
  SimpleFlexibleThumb: ResponsiveImage;
  SliderThumb: ResponsiveImage;
  ThumbCategory?: Maybe<Scalars['String']['output']>;
  ThumbLandscapeDesktop?: Maybe<Scalars['String']['output']>;
  ThumbLandscapeMobile?: Maybe<Scalars['String']['output']>;
  ThumbPortrait?: Maybe<Scalars['String']['output']>;
  ThumbTiny?: Maybe<Scalars['String']['output']>;
  ThumbnailBM?: Maybe<Scalars['String']['output']>;
  ThumbnailBM90?: Maybe<Scalars['String']['output']>;
  ThumbnailBM180?: Maybe<Scalars['String']['output']>;
  ThumbnailBMTable?: Maybe<Scalars['String']['output']>;
  ThumbnailDirectoryTile?: Maybe<Scalars['String']['output']>;
  VideoCover: ResponsiveImage;
  aiEdited: Scalars['Boolean']['output'];
  isBanner: Scalars['Boolean']['output'];
};


export type LibraryImageFileDetailPageEditModeArgs = {
  remix?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LibraryImageFileDetailPageSquareArgs = {
  remix?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LibraryImageFileDetailPageStandardArgs = {
  remix?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LibraryImageFileFlexibleBannerArgs = {
  desktopHeight?: InputMaybe<Scalars['Int']['input']>;
  desktopWidth?: InputMaybe<Scalars['Int']['input']>;
  mobileHeight?: InputMaybe<Scalars['Int']['input']>;
  mobileWidth?: InputMaybe<Scalars['Int']['input']>;
};


export type LibraryImageFileFrontendDetailPageArgs = {
  remix?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LibraryImageFileModuleImageArgs = {
  identifier: Scalars['String']['input'];
};


export type LibraryImageFilePhotoTileDraggableArgs = {
  remix?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LibraryImageFilePositionedImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type LibraryImageFileSimpleFlexibleThumbArgs = {
  desktopHeight?: InputMaybe<Scalars['Int']['input']>;
  desktopWidth?: InputMaybe<Scalars['Int']['input']>;
  exactCrop?: InputMaybe<Scalars['Boolean']['input']>;
  mobileHeight?: InputMaybe<Scalars['Int']['input']>;
  mobileWidth?: InputMaybe<Scalars['Int']['input']>;
};


export type LibraryImageFileThumbCategoryArgs = {
  WithWatermark?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryImageLabel = {
  __typename?: 'LibraryImageLabel';
  /** Admin score for the result (0-100) */
  AdminScore?: Maybe<Scalars['Int']['output']>;
  /** Estimated Cost per 1K images */
  AiCost1K?: Maybe<Scalars['Float']['output']>;
  /** Execution time in seconds */
  AiExecSecond?: Maybe<Scalars['Int']['output']>;
  /** URL of the image sent to AI */
  AiImageUrl?: Maybe<Scalars['String']['output']>;
  /** AI model used for the analysis */
  AiModel?: Maybe<Scalars['String']['output']>;
  /** Raw JSON response from the AI API */
  AiRawResult?: Maybe<Scalars['String']['output']>;
  /** Number of input tokens used */
  AiTokenInput?: Maybe<Scalars['Int']['output']>;
  /** Number of output tokens used */
  AiTokenOutput?: Maybe<Scalars['Int']['output']>;
  /** JSON array of architectural styles */
  ArchitecturalStyle?: Maybe<Scalars['String']['output']>;
  /** JSON object with primary_families, accent_families, tone, contrast, brightness */
  ColorPalette?: Maybe<Scalars['String']['output']>;
  /** JSON object with confidence scores per field */
  ConfidenceScores?: Maybe<Scalars['String']['output']>;
  /** Description of the image */
  Description?: Maybe<Scalars['String']['output']>;
  /** JSON array of emotional tags */
  EmotionalTags?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the LibraryImageLabel */
  ID: Scalars['Int']['output'];
  /** JSON array of interior styles */
  InteriorStyle?: Maybe<Scalars['String']['output']>;
  /** ID of the associated item */
  ItemID?: Maybe<Scalars['Int']['output']>;
  /** Type of the associated item (e.g., \"project\", \"product\", \"article\", \"professional\") */
  ItemType?: Maybe<DirectoryItemEnumType>;
  /** The library image this label is associated with */
  LibraryImage?: Maybe<LibraryImage>;
  /** Foreign key to the library image */
  LibraryImageID: Scalars['Int']['output'];
  /** JSON array of material objects with category, material, finish, colour_family, confidence */
  Materials?: Maybe<Scalars['String']['output']>;
  /** Additional notes about the label */
  Note?: Maybe<Scalars['String']['output']>;
  /** Primary room type (e.g., \"kitchen\", \"bathroom\") */
  RoomTypePrimary?: Maybe<Scalars['String']['output']>;
  /** JSON array of secondary room types */
  RoomTypeSecondary?: Maybe<Scalars['String']['output']>;
  /** JSON array of semantic tag objects with tag and confidence */
  SemanticTags?: Maybe<Scalars['String']['output']>;
  /** JSON object with room_size, ceiling_height, scale_cues, confidence */
  SizeScale?: Maybe<Scalars['String']['output']>;
  /** Visibility statuses based on LibraryImage deleted status, parent item status, and professional status */
  Visibilities?: Maybe<Array<Scalars['String']['output']>>;
};

export type LibraryImageLabelFilters = {
  /** Filter by array of IDs, compatible with ID__in filter for search index */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by LibraryImageID */
  LibraryImageID?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by LibraryItemID (directory item like Project/Product) */
  LibraryItemID?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by ProfessionalID */
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};

export type LibraryImageMarker = {
  __typename?: 'LibraryImageMarker';
  /** Has this tag been approved by an ArchiPro admin? */
  Approved: Scalars['Boolean']['output'];
  /** The unique identifier of the LibraryImage */
  ID: Scalars['Int']['output'];
  /** Indicate if this tag is created by Staff/High admin */
  IsArchiPro: Scalars['Boolean']['output'];
  /** Page that this tag is placed on */
  LibraryItem?: Maybe<DirectoryItem>;
  /** Member who created this tag */
  Member?: Maybe<Member>;
  /** Position in x-axis */
  PositionX: Scalars['Float']['output'];
  /** Position in y-axis */
  PositionY: Scalars['Float']['output'];
  /** Product tagged in this photo */
  Product?: Maybe<Product>;
  /** [Fallback] The professional has been tagged - we should find the correct product. */
  ProfessionalForUnknownProduct?: Maybe<Professional>;
  /** Product name when the product is not listed on the platform */
  TitleForUnknownProduct?: Maybe<Scalars['String']['output']>;
  /** [Fallback] The name of the professional has been given - we should add them to our platform */
  TitleForUnknownProfessional?: Maybe<Scalars['String']['output']>;
  /** External URL to the product page on the supplier's website */
  URLForUnknownProduct?: Maybe<Scalars['String']['output']>;
};

export type LibraryImageMarkerCount = {
  __typename?: 'LibraryImageMarkerCount';
  pendingProductCount: Scalars['Int']['output'];
  pendingProfessionalCount: Scalars['Int']['output'];
  totalProductCount: Scalars['Int']['output'];
  totalProfessionalCount: Scalars['Int']['output'];
  uniquePendingProductCount: Scalars['Int']['output'];
  uniqueProductCount: Scalars['Int']['output'];
};

export type LibraryImageSearchTagsConnection = {
  __typename?: 'LibraryImageSearchTagsConnection';
  edges: Array<LibraryImageSearchTagsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LibraryImageSearchTagsConnectionEdge = {
  __typename?: 'LibraryImageSearchTagsConnectionEdge';
  /** The node at the end of the collections edge */
  node: SearchTag;
};

export type LibraryImagesInput = {
  ID: Scalars['Int']['input'];
  SortOrder: Scalars['Int']['input'];
};

export type LibraryItemBanner = {
  __typename?: 'LibraryItemBanner';
  BannerImage: LibraryImage;
  BannerVideoUrl?: Maybe<Scalars['String']['output']>;
  IsVideoBanner: Scalars['Boolean']['output'];
  Overlay?: Maybe<Scalars['Boolean']['output']>;
  /** The on-page gallery image this banner was copied from (provenance), if any. */
  SourceImage?: Maybe<LibraryImage>;
};

export type LibraryItemBannersConnection = {
  __typename?: 'LibraryItemBannersConnection';
  edges: Array<LibraryItemBannersConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LibraryItemBannersConnectionEdge = {
  __typename?: 'LibraryItemBannersConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImage;
};

export type LibraryItemBannersFilters = {
  /** Filters this type when BannerSegment is eq the provided value */
  BannerSegment__eq?: InputMaybe<Scalars['Boolean']['input']>;
  BannerSegment__in?: InputMaybe<BannerSegmentEnum>;
  BannerSegment__is_nil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LibraryItemBannersSortFields = {
  ID?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  Professional__Title?: InputMaybe<SortDirection>;
};

export type LibraryItemImagesConnection = {
  __typename?: 'LibraryItemImagesConnection';
  edges: Array<LibraryItemImagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LibraryItemImagesConnectionEdge = {
  __typename?: 'LibraryItemImagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImage;
};

export type LibraryItemKpi = {
  __typename?: 'LibraryItemKPI';
  ClientType: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  ItemType: Scalars['String']['output'];
  PeriodClientProjected12MonthEnquiries?: Maybe<Scalars['Int']['output']>;
  PeriodClientProjected12MonthPageViews?: Maybe<Scalars['Int']['output']>;
  PeriodClientProjected12MonthReferrals?: Maybe<Scalars['Int']['output']>;
  PeriodClientProjected12MonthSaves?: Maybe<Scalars['Int']['output']>;
  PeriodClientTotalEnquiries?: Maybe<Scalars['Int']['output']>;
  PeriodClientTotalPageViews?: Maybe<Scalars['Int']['output']>;
  PeriodClientTotalReferrals?: Maybe<Scalars['Int']['output']>;
  PeriodClientTotalSaves?: Maybe<Scalars['Int']['output']>;
  PeriodItemEnquiries?: Maybe<Scalars['Int']['output']>;
  PeriodItemPageViews?: Maybe<Scalars['Int']['output']>;
  PeriodItemReferrals?: Maybe<Scalars['Int']['output']>;
  PeriodItemSaves?: Maybe<Scalars['Int']['output']>;
  PeriodStart?: Maybe<Scalars['String']['output']>;
  PredictedWinRate?: Maybe<Scalars['Float']['output']>;
  SubscriptionAmount?: Maybe<Scalars['Float']['output']>;
};

export type LibraryItemPublicKpi = {
  __typename?: 'LibraryItemPublicKPI';
  ID: Scalars['Int']['output'];
  ItemEnquiries?: Maybe<Scalars['Int']['output']>;
  ItemImpressions?: Maybe<Scalars['Int']['output']>;
  ItemPageViews?: Maybe<Scalars['Int']['output']>;
  ItemReferrals?: Maybe<Scalars['Int']['output']>;
  ItemSaves?: Maybe<Scalars['Int']['output']>;
  ItemTimeSpent?: Maybe<Scalars['Int']['output']>;
};

export enum LibraryItemRelationshipEnumType {
  Installers = 'Installers',
  Partner = 'Partner',
  ProductsUsed = 'ProductsUsed',
  ProductsWeRetail = 'ProductsWeRetail',
  ProfessionalsUsed = 'ProfessionalsUsed'
}

export type LibraryLocation = SortableItem & {
  __typename?: 'LibraryLocation';
  Address1?: Maybe<Scalars['String']['output']>;
  Address2?: Maybe<Scalars['String']['output']>;
  AllowsDispatch?: Maybe<Scalars['Boolean']['output']>;
  AllowsPickup: Scalars['Boolean']['output'];
  City?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  DispatchEstimate: MinMax;
  District?: Maybe<Scalars['String']['output']>;
  FormattedAddress: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  LocationHidden: Scalars['Boolean']['output'];
  MapAddress?: Maybe<Scalars['String']['output']>;
  MapCoordinates: Coordinate;
  MemberSortOrder: Scalars['Int']['output'];
  Phone?: Maybe<Scalars['String']['output']>;
  PickupEstimate: MinMax;
  PickupEstimateText: Scalars['String']['output'];
  PostCode?: Maybe<Scalars['String']['output']>;
  Region?: Maybe<Scalars['String']['output']>;
  RegionType?: Maybe<Region>;
  State?: Maybe<Scalars['String']['output']>;
  Suburb?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Type: Scalars['String']['output'];
  ZoomLevel?: Maybe<Scalars['Int']['output']>;
};

export type LibraryLocationUpdatesList = {
  Address1?: InputMaybe<Scalars['StringInput']['input']>;
  Address2?: InputMaybe<Scalars['StringInput']['input']>;
  AllowsDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  AllowsPickup?: InputMaybe<Scalars['Boolean']['input']>;
  City?: InputMaybe<Scalars['StringInput']['input']>;
  Country?: InputMaybe<Scalars['StringInput']['input']>;
  DispatchEstimate?: InputMaybe<MinMaxInput>;
  ID: Scalars['Int']['input'];
  LocationHidden?: InputMaybe<Scalars['Boolean']['input']>;
  MapAddress?: InputMaybe<Scalars['StringInput']['input']>;
  MapCoordinates?: InputMaybe<CoordinateInput>;
  MemberSortOrder?: InputMaybe<Scalars['Int']['input']>;
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  PickupEstimate?: InputMaybe<MinMaxInput>;
  PickupEstimateText?: InputMaybe<Scalars['StringInput']['input']>;
  PostCode?: InputMaybe<Scalars['StringInput']['input']>;
  Region?: InputMaybe<Scalars['StringInput']['input']>;
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Suburb?: InputMaybe<Scalars['StringInput']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  Type?: InputMaybe<Scalars['StringInput']['input']>;
  ZoomLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type LibraryPageVersion = DataObject & {
  __typename?: 'LibraryPageVersion';
  author?: Maybe<Member>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latestDraftVersion?: Maybe<Scalars['Boolean']['output']>;
  liveVersion?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  publisher?: Maybe<Member>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type LibraryPageVersionConnection = {
  __typename?: 'LibraryPageVersionConnection';
  edges: Array<LibraryPageVersionConnectionEdge>;
  nodes?: Maybe<Array<Maybe<LibraryPageVersion>>>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LibraryPageVersionConnectionEdge = {
  __typename?: 'LibraryPageVersionConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryPageVersion;
};

export type LibraryPinUpdateResultType = Article | NotAuthorizedError | Product | Professional | Project | UserError;

export type LibraryRange = {
  __typename?: 'LibraryRange';
  Categories: Array<Category>;
  HasPublicItems: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Professional?: Maybe<Professional>;
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  URLSlug: Scalars['String']['output'];
};

export type LibraryTab = {
  __typename?: 'LibraryTab';
  Content?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};

export type LibraryTabUpdate = {
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  /** ID of the library tab */
  ID: Scalars['Int']['input'];
  MemberSortOrder?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};

/**
 * Deprecated - use the `ThumbnailFile` field with the PositionedImage(width, height) resolver instead.
 * DOC: https://archipro.atlassian.net/wiki/x/B4CXag
 */
export type LibraryThumb = {
  __typename?: 'LibraryThumb';
  /** Aspect ratio of raw uploaded photo */
  AspectRatio: Scalars['Float']['output'];
  ID: Scalars['Int']['output'];
  IsClearCut: Scalars['Boolean']['output'];
  IsMultiplied: Scalars['Boolean']['output'];
  /** is raw image portrait, backend treats square image as portrait */
  IsPortrait: Scalars['Boolean']['output'];
  /**
   * Deprecated - use the `ThumbnailFile` field with the PositionedImage(width, height) resolver instead.
   * DOC: https://archipro.atlassian.net/wiki/x/B4CXag
   */
  LibraryImage?: Maybe<LibraryImage>;
  ScrollPosX: Scalars['Int']['output'];
  ScrollPosY: Scalars['Int']['output'];
  /**
   * Deprecated - use the `ThumbnailFile` field with the PositionedImage(width, height) resolver instead.
   * DOC: https://archipro.atlassian.net/wiki/x/B4CXag
   */
  ThumbImageFile?: Maybe<LibraryImageFile>;
  ZoomLevel: Scalars['Int']['output'];
};

export type LibraryVideo = SortableItem & {
  __typename?: 'LibraryVideo';
  CreatedDate?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  /** The LibraryImage to use as this video's thumbnail */
  LibraryImage?: Maybe<LibraryImage>;
  /** DirectoryItem associated with this LibraryImage */
  LibraryItem?: Maybe<DirectoryItem>;
  MemberSortOrder: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  /** The thumbnail image URL - either from an uploaded LibraryImage or pulled from YouTube */
  ThumbnailImageQuick?: Maybe<Scalars['String']['output']>;
  /** The thumbnail URL from Youtube or Vimeo, to be used as a fallback if LibraryImage isn't set. */
  ThumbnailOfficial?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  /** Is this a YouTube or Vimeo video? */
  Type: Scalars['String']['output'];
  VideoID: Scalars['String']['output'];
  /** Full video url constructed using base url depending on video type and video id. */
  VideoLink?: Maybe<Scalars['String']['output']>;
};

export type LinkAwardToEntityMutationType = Award | NotAuthorizedError | NotFoundError;

/** External URL metadata used for chat link previews. */
export type LinkPreview = {
  __typename?: 'LinkPreview';
  /** The best available page description. */
  Description?: Maybe<Scalars['String']['output']>;
  /** The page favicon URL if available. */
  FaviconUrl?: Maybe<Scalars['String']['output']>;
  /** The best available page preview image URL. */
  ImageUrl?: Maybe<Scalars['String']['output']>;
  /** The best available page title. */
  Title?: Maybe<Scalars['String']['output']>;
};

/** Describes which member linked a related item. Admin only. */
export type LinkedByMemberInfo = {
  __typename?: 'LinkedByMemberInfo';
  Email: Scalars['String']['output'];
  /** The ID of the linked entity (e.g. ProductID, ProfessionalID). */
  EntityID: Scalars['Int']['output'];
  FirstName: Scalars['String']['output'];
  LastName: Scalars['String']['output'];
};

export type ListArticlesFilter = {
  eq: Scalars['String']['input'];
  field: ListArticlesFilterFields;
};

export enum ListArticlesFilterFields {
  AuthorId = 'AuthorID',
  Category = 'Category',
  DataScoreMax = 'DataScoreMax',
  DataScoreMin = 'DataScoreMin',
  InLibraryOnly = 'InLibraryOnly',
  InProfileOnly = 'InProfileOnly',
  IsTemplate = 'IsTemplate',
  Keyword = 'Keyword',
  PendingTag = 'PendingTag',
  Professional = 'Professional',
  ProfessionalAuthorId = 'ProfessionalAuthorID',
  ProfessionalId = 'ProfessionalID',
  PublishDateMax = 'PublishDateMax',
  PublishDateMin = 'PublishDateMin',
  StaffAuthors = 'StaffAuthors',
  Status = 'Status'
}

export type ListClickEngagementEvents_Cursor = {
  __typename?: 'ListClickEngagementEvents_Cursor';
  ID: Scalars['String']['output'];
  /** Cursor information */
  Info: Info;
  /** Collection of records */
  Rows: Array<EngagementEvent>;
};

export type ListConnectionPageInfo = {
  __typename?: 'ListConnectionPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ListDesignBoardsSimpleSortFields = {
  LastEdited?: InputMaybe<SortDirection>;
};

export type ListDesignBoards_Connection = {
  __typename?: 'ListDesignBoards_Connection';
  ID: Scalars['String']['output'];
  edges: Array<ListDesignBoards_ConnectionEdge>;
  nodes: Array<DesignBoard>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListDesignBoards_ConnectionEdge = {
  __typename?: 'ListDesignBoards_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: DesignBoard;
};

export type ListDigitalPublicationRecipientClicksConnection = {
  __typename?: 'ListDigitalPublicationRecipientClicksConnection';
  ID: Scalars['String']['output'];
  edges: Array<ListDigitalPublicationRecipientClicksConnectionEdge>;
  nodes: Array<PublicationRecipientEvent>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListDigitalPublicationRecipientClicksConnectionEdge = {
  __typename?: 'ListDigitalPublicationRecipientClicksConnectionEdge';
  /** The node at the end of the collections edge */
  node: PublicationRecipientEvent;
};

export type ListDirectoryItemsByCategorySimpleSortFields = {
  Activated?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  InLibrary?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  Price?: InputMaybe<SortDirection>;
  Publish?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
  Website?: InputMaybe<SortDirection>;
};

export type ListDirectoryItemsFilter = {
  eq: Scalars['String']['input'];
  field: ListDirectoryItemsFilterFields;
};

export enum ListDirectoryItemsFilterFields {
  Archived = 'Archived',
  Brand = 'Brand',
  Category = 'Category',
  ContentLocked = 'ContentLocked',
  ContentStatus = 'ContentStatus',
  DataScore = 'DataScore',
  DataSource = 'DataSource',
  Deleted = 'Deleted',
  ECommerce = 'ECommerce',
  ExcludeAdvertising = 'ExcludeAdvertising',
  ExcludedFromSpecialtyRates = 'ExcludedFromSpecialtyRates',
  HasSupplierProductId = 'HasSupplierProductID',
  IsFeatured = 'IsFeatured',
  LastExternalUpdateMax = 'LastExternalUpdateMax',
  LastExternalUpdateMin = 'LastExternalUpdateMin',
  MissingCategory = 'MissingCategory',
  MissingPackageSize = 'MissingPackageSize',
  Pricing = 'Pricing',
  PublishDateMax = 'PublishDateMax',
  PublishDateMin = 'PublishDateMin',
  Purchasable = 'Purchasable',
  Range = 'Range',
  Sample = 'Sample',
  Status = 'Status'
}

export type ListDirectoryItemsSimpleSortFields = {
  Activated?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  InLibrary?: InputMaybe<SortDirection>;
  Price?: InputMaybe<SortDirection>;
  Publish?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
  Website?: InputMaybe<SortDirection>;
};

export type ListEngagementEvents_Cursor = {
  __typename?: 'ListEngagementEvents_Cursor';
  ID: Scalars['String']['output'];
  /** Cursor information */
  Info: Info;
  /** Collection of records */
  Rows: Array<EngagementEvent>;
};

export type ListEnquiryConversationsSimpleSortFields = {
  LastCommentedOn?: InputMaybe<SortDirection>;
};

export type ListEnquiryConversations_Connection = {
  __typename?: 'ListEnquiryConversations_Connection';
  ID: Scalars['String']['output'];
  nodes: Array<EnquiryConversation>;
  pageInfo: ApPageInfo;
};

export type ListLibraryImagesSimpleSortFields = {
  Activated?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  InLibrary?: InputMaybe<SortDirection>;
  Price?: InputMaybe<SortDirection>;
  Publish?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
  Website?: InputMaybe<SortDirection>;
};

export type ListLibraryImages_Connection = {
  __typename?: 'ListLibraryImages_Connection';
  ID: Scalars['String']['output'];
  edges: Array<ListLibraryImages_ConnectionEdge>;
  nodes: Array<LibraryImage>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListLibraryImages_ConnectionEdge = {
  __typename?: 'ListLibraryImages_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImage;
};

export type ListLibraryRangeItemsSimpleSortFields = {
  Activated?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  InLibrary?: InputMaybe<SortDirection>;
  Price?: InputMaybe<SortDirection>;
  Publish?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  URLSegment?: InputMaybe<SortDirection>;
  Website?: InputMaybe<SortDirection>;
};

export type ListLibraryRangeItems_Connection = {
  __typename?: 'ListLibraryRangeItems_Connection';
  ID: Scalars['String']['output'];
  edges: Array<ListLibraryRangeItems_ConnectionEdge>;
  nodes: Array<DirectoryItem>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListLibraryRangeItems_ConnectionEdge = {
  __typename?: 'ListLibraryRangeItems_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: DirectoryItem;
};

export type ListPinsConnection = {
  __typename?: 'ListPinsConnection';
  ID: Scalars['String']['output'];
  edges: Array<ListPinsConnectionEdge>;
  nodes: Array<Pin>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListPinsConnectionEdge = {
  __typename?: 'ListPinsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Pin;
};

export type ListProfessionalNetworkSuggestionsInputType = {
  /** Only return professionals that are in any of the given categories. */
  CategoryURLSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, will only return professionals local to the region. */
  LimitToRegion?: InputMaybe<Scalars['Boolean']['input']>;
  ShowChildCategories?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListProfessionalPartnersFilterType = {
  excludeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  professionalCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type ListProfessionalProjectsSimpleSortFields = {
  ID?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ListProfessionalProjects_Connection = {
  __typename?: 'ListProfessionalProjects_Connection';
  ID: Scalars['String']['output'];
  edges: Array<ListProfessionalProjects_ConnectionEdge>;
  nodes: Array<Project>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListProfessionalProjects_ConnectionEdge = {
  __typename?: 'ListProfessionalProjects_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: Project;
};

export type ListProjectsFilter = {
  eq: Scalars['String']['input'];
  field: ListProjectsFilterFields;
};

export enum ListProjectsFilterFields {
  Category = 'Category',
  DataScoreMax = 'DataScoreMax',
  DataScoreMin = 'DataScoreMin',
  IsFeatured = 'IsFeatured',
  IsTemplate = 'IsTemplate',
  Keyword = 'Keyword',
  PendingTag = 'PendingTag',
  Professional = 'Professional',
  ProfessionalCategory = 'ProfessionalCategory',
  PublishDateMax = 'PublishDateMax',
  PublishDateMin = 'PublishDateMin',
  Status = 'Status'
}

export type ListPublicationOpenedRecipientsConnection = {
  __typename?: 'ListPublicationOpenedRecipientsConnection';
  ID: Scalars['String']['output'];
  edges: Array<ListPublicationOpenedRecipientsConnectionEdge>;
  nodes: Array<PublicationRecipient>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListPublicationOpenedRecipientsConnectionEdge = {
  __typename?: 'ListPublicationOpenedRecipientsConnectionEdge';
  /** The node at the end of the collections edge */
  node: PublicationRecipient;
};

export type ListPublications_Cursor = {
  __typename?: 'ListPublications_Cursor';
  ID: Scalars['String']['output'];
  /** Cursor information */
  Info: Info;
  /** Collection of records */
  Rows: Array<PromotionalStat>;
};

export type ListSocialAds_Cursor = {
  __typename?: 'ListSocialAds_Cursor';
  ID: Scalars['String']['output'];
  /** Cursor information */
  Info: Info;
  /** Collection of records */
  Rows: Array<PromotionalStat>;
};

export type ListTeamMembersByUrlSegmentConnection = {
  __typename?: 'ListTeamMembersByURLSegmentConnection';
  edges: Array<ListTeamMembersByUrlSegmentConnectionEdge>;
  nodes: Array<TeamMember>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ListTeamMembersByUrlSegmentConnectionEdge = {
  __typename?: 'ListTeamMembersByURLSegmentConnectionEdge';
  /** The node at the end of the collections edge */
  node: TeamMember;
};

export type ListTeamMembersByUrlSegmentFilters = {
  Approved__eq?: InputMaybe<Scalars['Boolean']['input']>;
  IsPublic__eq?: InputMaybe<Scalars['Boolean']['input']>;
  Name__contains?: InputMaybe<Scalars['String']['input']>;
};

export type ListTeamMembersByUrlSegmentSimpleSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
};

export type ListWebsiteNotifications_Connection = {
  __typename?: 'ListWebsiteNotifications_Connection';
  ID: Scalars['String']['output'];
  edges: Array<ListWebsiteNotifications_ConnectionEdge>;
  nodes: Array<WebsiteNotificationInterface>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type ListWebsiteNotifications_ConnectionEdge = {
  __typename?: 'ListWebsiteNotifications_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: WebsiteNotificationInterface;
};

export type LocalitiesSimpleSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type Locality = {
  __typename?: 'Locality';
  GeoPostcode?: Maybe<Scalars['String']['output']>;
  GeoRegion?: Maybe<Scalars['String']['output']>;
  GeoStreetName?: Maybe<Scalars['String']['output']>;
  GeoStreetNumber?: Maybe<Scalars['String']['output']>;
  GeoSuburb?: Maybe<Scalars['String']['output']>;
  GeoTownCity?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  Latitude?: Maybe<Scalars['String']['output']>;
  Longitude?: Maybe<Scalars['String']['output']>;
  Postcode: Scalars['String']['output'];
  Region: Region;
  Title: Scalars['String']['output'];
};

export type LocalityConnection = {
  __typename?: 'LocalityConnection';
  ID: Scalars['String']['output'];
  edges: Array<LocalityConnectionEdge>;
  nodes: Array<Locality>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type LocalityConnectionEdge = {
  __typename?: 'LocalityConnectionEdge';
  /** The node at the end of the collections edge */
  node: Locality;
};

export type LocationData = {
  __typename?: 'LocationData';
  ID: Scalars['String']['output'];
  Location: Scalars['String']['output'];
  Percentage: Scalars['Float']['output'];
  Users: Scalars['String']['output'];
};

export type LocationFilterInput = {
  City?: InputMaybe<Scalars['String']['input']>;
  Country?: InputMaybe<Scalars['String']['input']>;
  District?: InputMaybe<Scalars['String']['input']>;
  Region?: InputMaybe<Scalars['String']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  State?: InputMaybe<Scalars['String']['input']>;
  Suburb?: InputMaybe<Scalars['String']['input']>;
};

export type LocationsConnection = {
  __typename?: 'LocationsConnection';
  edges: Array<LocationsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type LocationsConnectionEdge = {
  __typename?: 'LocationsConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryLocation;
};

export type LoginInput = {
  Email: Scalars['Email']['input'];
  Password: Scalars['StringInput']['input'];
  RememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  Member: Me;
  RequiresMfa: Scalars['Boolean']['output'];
  ServerToken: Scalars['String']['output'];
};

export type LogoCarouselModule = ModuleType & {
  __typename?: 'LogoCarouselModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  /** logo images */
  Logos: Logos_Connection;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SmallPrint?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};


export type LogoCarouselModuleLogosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Logos_SortFields>;
};

export type Logos_Connection = {
  __typename?: 'Logos_Connection';
  edges: Array<Logos_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Logos_ConnectionEdge = {
  __typename?: 'Logos_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ResponsiveSingleImage;
};

export type Logos_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type MgeFormInput = {
  ApplicationType: MgeFormTypeEnum;
  /** Whether to automatically create a member account (similar to enquiry form) */
  AutoCreateMember?: InputMaybe<Scalars['Boolean']['input']>;
  BringingGuest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference to existing BuildHub project */
  BuildHubID?: InputMaybe<Scalars['Int']['input']>;
  /** Company location for Professional/Exhibitor submissions */
  CompanyLocation?: InputMaybe<Scalars['String']['input']>;
  CompanyName?: InputMaybe<Scalars['String']['input']>;
  CompanyType?: InputMaybe<Scalars['String']['input']>;
  CompanyWebsite?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['String']['input']>;
  EventIDs: Array<InputMaybe<Scalars['Int']['input']>>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  GuestEmail?: InputMaybe<Scalars['String']['input']>;
  GuestFirstName?: InputMaybe<Scalars['String']['input']>;
  GuestLastName?: InputMaybe<Scalars['String']['input']>;
  GuestPhone?: InputMaybe<Scalars['String']['input']>;
  /** Active stage URL segment for new BuildHub */
  HDEBuildHubActiveStageURLSegment?: InputMaybe<Scalars['String']['input']>;
  /** Budget maximum for new BuildHub */
  HDEBuildHubBudgetMax?: InputMaybe<Scalars['Float']['input']>;
  /** Budget minimum for new BuildHub */
  HDEBuildHubBudgetMin?: InputMaybe<Scalars['Float']['input']>;
  /** JSON-encoded location data for new BuildHub (FullAddress, Suburb, City, Region, State, PostCode, Country) */
  HDEBuildHubLocationData?: InputMaybe<Scalars['String']['input']>;
  /** Project scope label for new BuildHub */
  HDEBuildHubProjectScope?: InputMaybe<Scalars['String']['input']>;
  /** Project type for new BuildHub (Residential, Commercial) */
  HDEBuildHubProjectType?: InputMaybe<Scalars['String']['input']>;
  HDEOtherPleaseSpecify?: InputMaybe<Scalars['String']['input']>;
  /** Title for new BuildHub project to be created */
  HDEProjectTitle?: InputMaybe<Scalars['String']['input']>;
  HearAboutMGE?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  Phone?: InputMaybe<Scalars['String']['input']>;
  ProjectArchitect?: InputMaybe<Scalars['String']['input']>;
  ProjectAttendanceReason?: InputMaybe<Scalars['String']['input']>;
  ProjectBudget?: InputMaybe<Scalars['String']['input']>;
  ProjectLending?: InputMaybe<Scalars['String']['input']>;
  ProjectLocation?: InputMaybe<Scalars['String']['input']>;
  ProjectLocationPostcode?: InputMaybe<Scalars['String']['input']>;
  ProjectProductInterest?: InputMaybe<Scalars['String']['input']>;
  /** Project scope (e.g. \"New Home Build\", \"Renovation\") */
  ProjectScope?: InputMaybe<Scalars['String']['input']>;
  ProjectStage?: InputMaybe<Scalars['String']['input']>;
  ProjectType?: InputMaybe<Scalars['String']['input']>;
  PropertyOwned?: InputMaybe<Scalars['Boolean']['input']>;
  PropertySize?: InputMaybe<Scalars['String']['input']>;
  TimeSlot?: InputMaybe<Scalars['String']['input']>;
};

export enum MgeFormTypeEnum {
  Exhibitor = 'Exhibitor',
  Homeowner = 'Homeowner',
  Professional = 'Professional'
}

export type MapMaker = {
  __typename?: 'MapMaker';
  City?: Maybe<Scalars['String']['output']>;
  Coordinates?: Maybe<Coordinates>;
  Country: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Region?: Maybe<Scalars['String']['output']>;
  Value: Scalars['Int']['output'];
};

/** Individual marketing guide item with step number, description, link and image */
export type MarketingGuideItem = {
  __typename?: 'MarketingGuideItem';
  /** Descriptive text for this guide */
  description: Scalars['String']['output'];
  /** URL for the guide image */
  image: Scalars['String']['output'];
  /** URL or path to the guide details */
  link: Scalars['String']['output'];
  /** Name of the guide PDF */
  pdfName?: Maybe<Scalars['String']['output']>;
  /** URL for the guide PDF */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** The step number for this guide */
  step: Scalars['Int']['output'];
};

export type Material = {
  __typename?: 'Material';
  ID: Scalars['Int']['output'];
  Label: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export type Me = User & {
  __typename?: 'Me';
  APID: Scalars['String']['output'];
  /** The BuildHub the member is currently working in. Prefers LastViewedBuildHub when valid; otherwise the most recently created non-personal owned BuildHub (so a hub auto-created during signup still resolves before the user has opened it). Null when the member has no eligible BuildHub. */
  ActiveBuildHub?: Maybe<BuildHub>;
  AgeGroup?: Maybe<Scalars['String']['output']>;
  ArchiproProfilePage: Scalars['String']['output'];
  Budget?: Maybe<Scalars['String']['output']>;
  BuildStatus?: Maybe<Scalars['String']['output']>;
  Company: Scalars['String']['output'];
  DesignBoard: DesignBoardResult;
  DesignBoards: ListDesignBoards_Connection;
  DesignBoardsPins: DesignBoardPinsConnection;
  EcommerceBookingURL: Scalars['String']['output'];
  Email: Scalars['String']['output'];
  Enrichment?: Maybe<Scalars['String']['output']>;
  FeatureFlags: Array<FeatureFlag>;
  FirstName: Scalars['String']['output'];
  /** True when the member owns or collaborates on at least one non-personal BuildHub. Drives the post-signup onboarding gate so collaborator-only members (e.g. HDE guests) skip create-project and land on their existing project. */
  HasNonPersonalBuildHubAccess: Scalars['Boolean']['output'];
  HashedEmail: Scalars['String']['output'];
  HomeownerPurpose?: Maybe<HomeownerPurpose>;
  HomeownerStage?: Maybe<HomeownerStage>;
  ID: Scalars['Int']['output'];
  Industry?: Maybe<Scalars['String']['output']>;
  Initials?: Maybe<Scalars['String']['output']>;
  IsActive: Scalars['Boolean']['output'];
  IsArchiproStaff: Scalars['Boolean']['output'];
  IsEditorialTeam: Scalars['Boolean']['output'];
  IsHighAdmin: Scalars['Boolean']['output'];
  IsLeadershipTeam: Scalars['Boolean']['output'];
  IsSalesAdmin: Scalars['Boolean']['output'];
  IsStaffAdmin: Scalars['Boolean']['output'];
  JobTitle?: Maybe<Scalars['String']['output']>;
  LastName: Scalars['String']['output'];
  LastViewedBuildHub?: Maybe<BuildHub>;
  MemberImage?: Maybe<MemberImage>;
  MemberOAuths?: Maybe<Array<MemberOAuth>>;
  MfaType?: Maybe<MfaConfigEnumType>;
  ModalAds: Array<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  OnboardingDismissed?: Maybe<Scalars['String']['output']>;
  OrderNotificationCount: Scalars['Int']['output'];
  Orders: Array<Order>;
  OwnedBuildHubs: Array<BuildHub>;
  PasswordLastChanged?: Maybe<Scalars['String']['output']>;
  /** Active account deletion request if one exists (where RestoredAt IS NULL) */
  PendingDeletionRequest?: Maybe<AccountDeletionRequest>;
  Permissions: Array<PermissionEnum>;
  Phone: Scalars['String']['output'];
  PostSignupQuestionnaireSeen: Scalars['Boolean']['output'];
  ProfessionalCategory?: Maybe<ProfessionalCategory>;
  ProfessionalCategoryUpdatedAt?: Maybe<Scalars['String']['output']>;
  ProfessionalLisitingInterest?: Maybe<Scalars['Boolean']['output']>;
  ProfessionalTargetMarket?: Maybe<ProfessionalTargetMarketType>;
  ProfessionalType: Scalars['String']['output'];
  ProfessionalTypeIsUserSelected: Scalars['Boolean']['output'];
  Professionals: Array<MemberProfessional>;
  ProfileImage: Scalars['String']['output'];
  ProfileImageComments: Scalars['String']['output'];
  ProfileImageLink?: Maybe<Scalars['String']['output']>;
  Region: Scalars['String']['output'];
  RegionCoordinates?: Maybe<Coordinate>;
  RegisteredPushDevices: Array<UserPushDevice>;
  Section?: Maybe<Scalars['Boolean']['output']>;
  ShoppingCart?: Maybe<ShoppingCart>;
  Style?: Maybe<Scalars['String']['output']>;
  Suburb?: Maybe<Scalars['String']['output']>;
  Surname?: Maybe<Scalars['String']['output']>;
  TaggedProducts: Array<Product>;
  TaggedProfessionals: Array<Professional>;
  TeamMembers: Array<TeamMember>;
  TempPassword: Scalars['Boolean']['output'];
  TrackedGuest?: Maybe<Guest>;
  UserClassification?: Maybe<UserClassificationType>;
  UserClassificationUpdatedAt?: Maybe<Scalars['String']['output']>;
  UserType: Scalars['String']['output'];
  Website: Scalars['String']['output'];
  When?: Maybe<Scalars['String']['output']>;
  Where?: Maybe<Scalars['String']['output']>;
  calendarConnection: Array<CalendarConnectionSummary>;
};


export type MeDesignBoardArgs = {
  Link: Scalars['String']['input'];
};


export type MeDesignBoardsArgs = {
  filter?: InputMaybe<DesignBoardsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DesignBoardsSimpleSortFields>;
};


export type MeDesignBoardsPinsArgs = {
  filter?: InputMaybe<DesignBoardsPinsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DesignBoardsPinsSimpleSortFields>;
};


export type MeTaggedProductsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MeTaggedProfessionalsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Member = ArticleAuthor & DataObject & PermissionInterface & {
  __typename?: 'Member';
  ArchiProEditorial: Scalars['Boolean']['output'];
  Email?: Maybe<Scalars['String']['output']>;
  FirstName: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  Initials?: Maybe<Scalars['String']['output']>;
  /** Whether this member is blocked by the current user. */
  IsBlocked: Scalars['Boolean']['output'];
  IsEditorialTeam: Scalars['Boolean']['output'];
  LastName: Scalars['String']['output'];
  MemberImage?: Maybe<MemberImage>;
  Name: Scalars['String']['output'];
  Permissions: Array<PermissionEnum>;
  Phone: Scalars['String']['output'];
  ProfessionalCategory?: Maybe<ProfessionalCategory>;
  ProfessionalTypeIsUserSelected: Scalars['Boolean']['output'];
  Professionals: Array<MemberProfessional>;
  ProfileImageLink?: Maybe<Scalars['String']['output']>;
  Region?: Maybe<Scalars['String']['output']>;
  Surname?: Maybe<Scalars['String']['output']>;
  UserType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type MemberCalendarOAuth = {
  __typename?: 'MemberCalendarOAuth';
  AccessToken?: Maybe<Scalars['String']['output']>;
  ConnectedAt?: Maybe<Scalars['String']['output']>;
  DisplayName?: Maybe<Scalars['String']['output']>;
  Email?: Maybe<Scalars['String']['output']>;
  ExpiresAt?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  IsTokenExpired?: Maybe<Scalars['Boolean']['output']>;
  IsValid?: Maybe<Scalars['Boolean']['output']>;
  LastSyncAt?: Maybe<Scalars['String']['output']>;
  MemberID?: Maybe<Scalars['Int']['output']>;
  Provider?: Maybe<Scalars['String']['output']>;
  RefreshToken?: Maybe<Scalars['String']['output']>;
};

export type MemberConnection = {
  __typename?: 'MemberConnection';
  edges: Array<MemberConnectionEdge>;
  nodes: Array<Member>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type MemberConnectionEdge = {
  __typename?: 'MemberConnectionEdge';
  /** The node at the end of the collections edge */
  node: Member;
};

export type MemberEnquiryEmail = {
  __typename?: 'MemberEnquiryEmail';
  CommentID?: Maybe<Scalars['Int']['output']>;
  EmailMsgID?: Maybe<Scalars['String']['output']>;
  EmailThreadID?: Maybe<Scalars['String']['output']>;
  EmailTime?: Maybe<Scalars['String']['output']>;
  EnquiryConversationID: Scalars['Int']['output'];
  EnquiryID: Scalars['Int']['output'];
  FromEmail?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  InReplyTo?: Maybe<Scalars['String']['output']>;
  IsFromSentBox: Scalars['Boolean']['output'];
  MemberID: Scalars['Int']['output'];
  MemberOAuthID: Scalars['Int']['output'];
  MessageID?: Maybe<Scalars['Int']['output']>;
  ProfessionalID: Scalars['Int']['output'];
  Provider?: Maybe<Scalars['String']['output']>;
  RawEmail?: Maybe<Scalars['String']['output']>;
  Subject?: Maybe<Scalars['String']['output']>;
  ToEmail?: Maybe<Scalars['String']['output']>;
  UniqueBody?: Maybe<Scalars['String']['output']>;
};

/** Message sent when a user sends an enquiry to a professional. */
export type MemberEnquiryMessage = Message & {
  __typename?: 'MemberEnquiryMessage';
  Attachments: Array<MemberUpload>;
  BuildHub?: Maybe<BuildHub>;
  BuildHubFieldSelection?: Maybe<Scalars['String']['output']>;
  Content: Scalars['String']['output'];
  ConversationID: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  CreatedBy: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  LibraryItems: Array<DirectoryItem>;
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

export type MemberImage = {
  __typename?: 'MemberImage';
  Avatar?: Maybe<Scalars['String']['output']>;
  DetailsPage?: Maybe<Scalars['String']['output']>;
  /** Uncropped, width-capped original used as the headshot reposition editor source. */
  EditorSource?: Maybe<Scalars['String']['output']>;
  FileName?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  LargeAvatar?: Maybe<Scalars['String']['output']>;
  Logo?: Maybe<Scalars['String']['output']>;
  TeamMemberDisplay?: Maybe<Scalars['String']['output']>;
};


export type MemberImageAvatarArgs = {
  Height: Scalars['Int']['input'];
  Width: Scalars['Int']['input'];
};

export type MemberOAuth = {
  __typename?: 'MemberOAuth';
  AccessToken?: Maybe<Scalars['String']['output']>;
  Disabled?: Maybe<Scalars['Boolean']['output']>;
  ExpiresAt?: Maybe<Scalars['String']['output']>;
  From?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  MemberID?: Maybe<Scalars['Int']['output']>;
  OAuthEmail?: Maybe<Scalars['String']['output']>;
  Provider?: Maybe<Scalars['String']['output']>;
  RefreshToken?: Maybe<Scalars['String']['output']>;
  Scope?: Maybe<Scalars['String']['output']>;
  SyncedAt?: Maybe<Scalars['String']['output']>;
};

export type MemberOrdersSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  OrderNumber?: InputMaybe<SortDirection>;
};

export type MemberParticipant = Participant & {
  __typename?: 'MemberParticipant';
  ID: Scalars['ID']['output'];
  Identity: Member;
  LastReadMessageDate?: Maybe<Scalars['String']['output']>;
  LastReadMessageID: Scalars['Int']['output'];
  Member: Member;
};

export type MemberProfessional = {
  __typename?: 'MemberProfessional';
  AnalyticsEnabled: Scalars['Boolean']['output'];
  AnalyticsStatus: AnalyticsStatusEnum;
  BusinessFocus: Scalars['String']['output'];
  CanEdit: Scalars['Boolean']['output'];
  CompanyLogo: Scalars['String']['output'];
  CompanyLogo48Resized?: Maybe<Scalars['String']['output']>;
  CompanyLogo96Resized?: Maybe<Scalars['String']['output']>;
  Country: Scalars['String']['output'];
  EcommerceEnabled: Scalars['Boolean']['output'];
  HasClones: Scalars['Boolean']['output'];
  HasEcommerceEmail: Scalars['Boolean']['output'];
  HasInboxAccess: Scalars['Boolean']['output'];
  HubspotCompany?: Maybe<HubspotCompany>;
  ID: Scalars['Int']['output'];
  IsCloned: Scalars['Boolean']['output'];
  IsManufacturer: Scalars['Boolean']['output'];
  LibraryLocationsCount: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  LogoBackgroundColor?: Maybe<Scalars['String']['output']>;
  MetaData: ProfessionalMetaData;
  /** The organization network owned by this professional, if any. */
  Network?: Maybe<OrganizationNetwork>;
  PrimaryDomain: Scalars['String']['output'];
  ServiceableAreasCount: Scalars['Int']['output'];
  StripeAccountEnabled: Scalars['Boolean']['output'];
  Title: Scalars['String']['output'];
  TradePricing: Array<SpecialtyRateCategories>;
  URLSegment: Scalars['String']['output'];
  Website: Scalars['String']['output'];
};

export type MemberUpload = DesignBoardPinTarget & {
  __typename?: 'MemberUpload';
  Created: Scalars['String']['output'];
  FileName?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  PhotoTile?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
};

export type MemberUploadPin = {
  __typename?: 'MemberUploadPin';
  BoardID: Scalars['Int']['output'];
  BoardURLSegment: Scalars['String']['output'];
  CanDelete: Scalars['Boolean']['output'];
  Caption?: Maybe<Scalars['String']['output']>;
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int']['output'];
  CreatedBy?: Maybe<Member>;
  Filename?: Maybe<Scalars['String']['output']>;
  HasUnreadComments: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  TypeID: Scalars['Int']['output'];
  UploadedBy?: Maybe<Member>;
};

/** Stripe card payment method for BM membership billing (live from Stripe; LastPaymentError from local BillingPaymentMethod snapshot) */
export type MembershipPaymentMethod = {
  __typename?: 'MembershipPaymentMethod';
  Brand?: Maybe<Scalars['String']['output']>;
  ExpMonth?: Maybe<Scalars['Int']['output']>;
  ExpYear?: Maybe<Scalars['Int']['output']>;
  ID: Scalars['String']['output'];
  IsDefault: Scalars['Boolean']['output'];
  Last4?: Maybe<Scalars['String']['output']>;
  LastPaymentError?: Maybe<Scalars['String']['output']>;
  PaymentAttemptCount?: Maybe<Scalars['Int']['output']>;
};

export type Message = {
  ConversationID: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  CreatedBy: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

/** An emoji reaction on a chat message. */
export type MessageReaction = {
  __typename?: 'MessageReaction';
  /** The participant who reacted. */
  Participant: Participant;
  /** The emoji character for this reaction. */
  Reaction: Scalars['String']['output'];
};

export type Meta = {
  __typename?: 'Meta';
  Canonical?: Maybe<Scalars['String']['output']>;
  ExtraMeta: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  MetaDescription: Scalars['String']['output'];
  MetaKeywords: Scalars['String']['output'];
  SearchTags: Array<SearchTag>;
  SocialDescription: Scalars['String']['output'];
  SocialPreviewImage?: Maybe<Scalars['String']['output']>;
  SocialTitle: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type MetaAdCampaignConversionsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAdCampaignEngagementsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAdCampaignProfileStatsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAdCampaignReachLocationsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAdCampaignStatsFilters = {
  EXTERNAL_FACEBOOKCAMPAIGNID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type MetaAdsCampaignTableFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MetaAdsCampaignTableSort = {
  CAMPAIGN_NAME?: InputMaybe<PrioritySort>;
  CLICK_THROUGH_RATE?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  CONVERSION_RATE?: InputMaybe<PrioritySort>;
  DURATION?: InputMaybe<PrioritySort>;
  ENGAGEMENTS?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  REACH?: InputMaybe<PrioritySort>;
  START_DATE?: InputMaybe<PrioritySort>;
};

export type MetaAdsConversionBreakdownFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MetaAdsEngagementBreakdownFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MetaAdsStatsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MetaCampaignsByUtmFilters = {
  CLEAN_CAMPAIGN_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type MetaCampaignsFilters = {
  CLEAN_CAMPAIGN_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MfaConfigEnumType {
  App = 'App',
  Disabled = 'Disabled',
  Email = 'Email',
  Pending = 'Pending',
  Sms = 'SMS'
}

export type MfaConfirmLoginInput = {
  /** Auth token. */
  AuthToken: Scalars['String']['input'];
  /** Remember the the login after session close. */
  RememberMe: Scalars['Boolean']['input'];
  /** Server token. */
  ServerToken: Scalars['String']['input'];
  /** Type of MFA being confirmed. */
  Type: MfaConfirmTypeEnum;
};

export type MfaConfirmSetupInput = {
  /** Auth token. */
  AuthToken: Scalars['String']['input'];
  /** Password to validate session. */
  Password: Scalars['String']['input'];
  /** Server token. */
  ServerToken: Scalars['String']['input'];
  /** Type of MFA being confirmed. */
  Type: MfaConfirmTypeEnum;
};

export enum MfaConfirmTypeEnum {
  App = 'App',
  Sms = 'SMS'
}

export type MfaDisableSetupInput = {
  /** Password to validate session. */
  Password: Scalars['String']['input'];
  /** Server token. */
  ServerToken: Scalars['String']['input'];
};

export type MfaPasswordReset = {
  __typename?: 'MfaPasswordReset';
  Email: Scalars['String']['output'];
};

export type MfaPasswordResetInput = {
  /** Confirmation of email to use. */
  Email: Scalars['String']['input'];
};

export type MfaRequest = {
  __typename?: 'MfaRequest';
  Email?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  QrCode?: Maybe<Scalars['String']['output']>;
  Secret?: Maybe<Scalars['String']['output']>;
  ServerToken: Scalars['String']['output'];
  Type: MfaRequestTypeEnum;
};

export type MfaRequestInput = {
  /** Server token. */
  ServerToken: Scalars['String']['input'];
  /** Type of MFA being requested. */
  Type: MfaRequestTypeEnum;
};

export enum MfaRequestTypeEnum {
  App = 'App',
  Email = 'Email',
  Sms = 'SMS'
}

export type MfaSetup = {
  __typename?: 'MfaSetup';
  ID: Scalars['Int']['output'];
  MfaType: Scalars['String']['output'];
  PasswordResetEmail?: Maybe<Scalars['String']['output']>;
  ServerToken: Scalars['String']['output'];
};

export type MfaSetupInput = {
  /** If setup is an enable or disable. */
  Enabled: Scalars['Boolean']['input'];
};

export type Milestone = {
  __typename?: 'Milestone';
  Content?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Title?: Maybe<Scalars['String']['output']>;
};

export type MilestoneModule = ModuleType & {
  __typename?: 'MilestoneModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Milestones: AboutModule_MilestonesConnection;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type MilestoneModuleMilestonesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AboutModule_MilestonesSortFields>;
};

export type MinMax = {
  __typename?: 'MinMax';
  Max: Scalars['Int']['output'];
  Min: Scalars['Int']['output'];
};

export type MinMaxInput = {
  Max: Scalars['Int']['input'];
  Min: Scalars['Int']['input'];
};

/** Union type for reports (can be ModerationContentReport or ModerationUserReport) */
export type Moderation = {
  __typename?: 'Moderation';
  /** Timestamp when the report was created */
  Created: Scalars['Date']['output'];
  ID: Scalars['ID']['output'];
  /** The selected moderation reason */
  ModerationReason: ModerationReason;
  /** Optional additional details from the reporter */
  Note?: Maybe<Scalars['String']['output']>;
  /** The member who submitted the report */
  Reporter: Member;
};

/** Minimal response when content report is created successfully */
export type ModerationContentReportCreated = {
  __typename?: 'ModerationContentReportCreated';
  /** The ID of the created content report */
  ID: Scalars['ID']['output'];
};

/** Entity types that can be flagged for moderation (DirectoryItem or User). */
export enum ModerationEntityTypeEnum {
  DirectoryItem = 'DirectoryItem',
  User = 'User'
}

/** A predefined reason for reporting content or users for moderation */
export type ModerationReason = {
  __typename?: 'ModerationReason';
  /** Child reasons if this is a parent reason */
  Children: Array<ModerationReason>;
  /** Array of entity types this reason applies to (DirectoryItem, User, or both) */
  EntityTypes: Array<ModerationEntityTypeEnum>;
  ID: Scalars['ID']['output'];
  /** Human-readable reason label */
  Label: Scalars['String']['output'];
  /** Parent reason if this is a nested reason */
  Parent?: Maybe<ModerationReason>;
  /** ID of parent reason for hierarchical structure (null for top-level) */
  ParentID?: Maybe<Scalars['Int']['output']>;
  /** Display order for sorting reasons (lower numbers appear first) */
  SortOrder?: Maybe<Scalars['Int']['output']>;
};

/** Minimal response when user report is created successfully */
export type ModerationUserReportCreated = {
  __typename?: 'ModerationUserReportCreated';
  /** The ID of the created user report */
  ID: Scalars['ID']['output'];
};

export type Module = AccordionModule | AdvertisingEnquireModule | AttendeeListModule | BannerModule | BusinessModule | BusinessSupportBlock | CallToActionModule | CampaignFormFooterModule | CampaignHeaderModule | CaptionCtaModule | ContactUsMapModule | DirectoryModule | EcomCallToActionModule | EcomTestimonialModule | EcomWelcomeModule | EventDetailsModule | EventItineraryModule | EventRegisterModule | FeatureShowcaseModule | FeaturesModule | FramedPictureCarouselModule | FramedPictureContentModule | GalleryModule | GuestHomeHeroModule | HdeGridCarouselModule | HdeInPageBannerModule | HeadingTextModule | HighlightsModule | HostedVideoModule | IframeEmbedModule | ImageBannerModule | ImageColumn | ImageTextCarouselModule | InformationModule | IntroModule | LogoCarouselModule | MilestoneModule | PhotoCollageModule | PlaceholderModule | PlainTextModule | ProductFeature | ProfessionalAttendeeModule | ProfessionalMembersModule | ProjectFeaturesModule | RecommendationModule | RichTextModule | SpeakerLineupModule | StaticGalleryModule | TestimonialModule | TextColumn | VideoColumn | VideoModule | WelcomeModule;

export type ModuleColumn = {
  ID: Scalars['Int']['output'];
  IsEmpty: Scalars['Boolean']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleID: Scalars['Int']['output'];
  ReadOnly: Scalars['Boolean']['output'];
  WordCount: Scalars['Int']['output'];
};

export enum ModuleColumnEnum {
  HtmlColumn = 'HtmlColumn',
  ImageColumn = 'ImageColumn',
  Invoice = 'Invoice',
  TextColumn = 'TextColumn',
  VideoColumn = 'VideoColumn'
}

export type ModuleColumnInput = {
  Caption?: InputMaybe<Scalars['String']['input']>;
  Content?: InputMaybe<Scalars['String']['input']>;
  File?: InputMaybe<Scalars['Upload']['input']>;
  ID?: InputMaybe<Scalars['Int']['input']>;
  /** Attach an existing library image to this column (page builder drag-move). Must belong to the same parent library item as the module. */
  LibraryImageID?: InputMaybe<Scalars['Int']['input']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** When true, the image needs upscaling. Backend will set HideOnPage=true when this is true. */
  NeedsUpscale?: InputMaybe<Scalars['Boolean']['input']>;
  ProductID?: InputMaybe<Scalars['Int']['input']>;
  ReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  TextType?: InputMaybe<TextTypeEnum>;
  UpdateDimensionID?: InputMaybe<Scalars['Int']['input']>;
  VideoLink?: InputMaybe<Scalars['String']['input']>;
};

export enum ModuleGroupEnum {
  Gallery = 'Gallery',
  Photos = 'Photos',
  Plans = 'Plans',
  Products = 'Products',
  Text = 'Text',
  Videos = 'Videos'
}

export type ModulePage = {
  __typename?: 'ModulePage';
  ID: Scalars['ID']['output'];
  MetaData: Meta;
  Modules: Array<ModuleType>;
  PageBackgroundColor?: Maybe<Scalars['String']['output']>;
  PageTheme: ModulePageThemeEnum;
};

export enum ModulePageThemeEnum {
  About = 'about',
  Ace = 'ace',
  Home = 'home',
  Mge = 'mge'
}

export type ModulePreset = FlexibleModule & SortableItem & {
  __typename?: 'ModulePreset';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup: ModuleGroupEnum;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  PreviewImage?: Maybe<ResponsiveImage>;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type ModulePresetColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type ModuleType = {
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export type Module_AccordionsConnection = {
  __typename?: 'Module_AccordionsConnection';
  edges: Array<Module_AccordionsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_AccordionsConnectionEdge = {
  __typename?: 'Module_AccordionsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Accordion;
};

export type Module_AccordionsSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Module_FeatureBlocksConnection = {
  __typename?: 'Module_FeatureBlocksConnection';
  edges: Array<Module_FeatureBlocksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_FeatureBlocksConnectionEdge = {
  __typename?: 'Module_FeatureBlocksConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProjectFeatureBlock;
};

export type Module_FeatureBlocksSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Module_GuestHeroSlidesConnection = {
  __typename?: 'Module_GuestHeroSlidesConnection';
  edges: Array<Module_GuestHeroSlidesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_GuestHeroSlidesConnectionEdge = {
  __typename?: 'Module_GuestHeroSlidesConnectionEdge';
  /** The node at the end of the collections edge */
  node: GuestHeroSlide;
};

export type Module_GuestHeroSlidesSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Module_ImageCarouselItemsConnection = {
  __typename?: 'Module_ImageCarouselItemsConnection';
  edges: Array<Module_ImageCarouselItemsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_ImageCarouselItemsConnectionEdge = {
  __typename?: 'Module_ImageCarouselItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ImageCarouselItem;
};

export type Module_ImageCarouselItemsSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type Module_TeamMembersConnection = {
  __typename?: 'Module_TeamMembersConnection';
  edges: Array<Module_TeamMembersConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_TeamMembersConnectionEdge = {
  __typename?: 'Module_TeamMembersConnectionEdge';
  /** The node at the end of the collections edge */
  node: TeamMember;
};

export type Module_TeamMembersSortFields = {
  ModuleSort?: InputMaybe<SortDirection>;
};

export type Module_TextCarouselItemsConnection = {
  __typename?: 'Module_TextCarouselItemsConnection';
  edges: Array<Module_TextCarouselItemsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Module_TextCarouselItemsConnectionEdge = {
  __typename?: 'Module_TextCarouselItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: TextCarouselItem;
};

export type Module_TextCarouselItemsSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type MonthlyUserDisplay = {
  __typename?: 'MonthlyUserDisplay';
  DataLastUpdatedInclusive: Scalars['String']['output'];
  IsCompletedMonth: Scalars['Boolean']['output'];
  UniqueUsers: Scalars['Int']['output'];
};

export type MoodBoardSavedIDs = {
  __typename?: 'MoodBoardSavedIDs';
  imageIDs: Array<Scalars['Int']['output']>;
  pageIDs: Array<Scalars['Int']['output']>;
};

export type MoveTeamMemberToRoleInput = {
  CurrentRoleID?: InputMaybe<Scalars['Int']['input']>;
  TeamMemberID: Scalars['Int']['input'];
};

export type MultiColumnModule = FlexibleModule & SortableItem & {
  __typename?: 'MultiColumnModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type MultiColumnModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ArcherCommentAction: ArcherComment;
  ArcherCommentDelete: Scalars['Int']['output'];
  ArcherCommentReply: ArcherReply;
  /** Links an Award to an Entity. */
  AwardLinkToEntity?: Maybe<LinkAwardToEntityMutationType>;
  /** UnLinks an Award from an Entity. */
  AwardUnlinkFromEntity?: Maybe<UnlinkAwardFromEntityMutationType>;
  BulkUploadAndRearrange: BulkUploadResult;
  /** Invalidates the cache of Integration Settings used for Content Lock Flexibility etc. */
  CachedIntegrationSettingsInvalidate: Scalars['Boolean']['output'];
  CancelSync: BooleanResult;
  ConsignmentPickupRequest: Consignment;
  ConsignmentSync: Consignment;
  /** Updates the content teams status for a library item */
  ContentStatusUpdate?: Maybe<ContentStatusUpdateResult>;
  DeleteQBRByID: Scalars['Boolean']['output'];
  EnrichProductWithAi?: Maybe<ProductEnrichmentResult>;
  FeaturedBrandPinToggle?: Maybe<FeaturedBrandPinToggleResultType>;
  HomePinToggle?: Maybe<HomePinToggleResultType>;
  ImageExportCreate?: Maybe<ImageExportCreateResult>;
  /** Takes an image from the import bucket and replaces the related original website image */
  ImageImport?: Maybe<ImageExportCreateResult>;
  IntegrationRequestReportResult: Scalars['Boolean']['output'];
  IntegrationSettingsUpdate: BooleanResult;
  /** Handles the unlink of an integration. It will set linked products to Not Live when an integration is unlinked. */
  IntegrationUnlink: Scalars['Boolean']['output'];
  /** Handles when products are deleted from and integration. It will set the given product to not live */
  IntegrationUnpublishProduct?: Maybe<IntegrationUnpublishProductResult>;
  /** Creates a JWT token for a valid user */
  JWTTokenCreate?: Maybe<JwtTokenValidResponse>;
  /** Refreshes a JWT using a refresh token (secure token rotation pattern) */
  JWTTokenRefresh?: Maybe<JwtTokenValidResponse>;
  LibraryPinUpdate?: Maybe<LibraryPinUpdateResultType>;
  /** Processes an order import from the integration service. */
  OrderImport: ImportOrderResult;
  /** Connects a professional profile to an ecommerce store. Only use for WooCommerce at this point. */
  PlatformConnect?: Maybe<Scalars['String']['output']>;
  PlatformDisconnect: BooleanResult;
  /** Handlings invalidating the field blacklist cache when it has been changed on the integration service. */
  ProductImportFieldBlacklistInvalidate: Scalars['Boolean']['output'];
  /** Initiates a product import task. Returns the the TaskRunner job identifier or null on failure. */
  ProductImportProcess?: Maybe<Scalars['String']['output']>;
  ProductImprovementCreateTask?: Maybe<ProductImprovementTaskStatus>;
  /** Sends an Enquiry to a Professional */
  SampleEnquiryCreate: Scalars['Boolean']['output'];
  SetDirectoryFeaturedProject?: Maybe<SetDirectoryFeaturedProjectResult>;
  SetProductInLibrary?: Maybe<SetProductInLibraryResult>;
  SetProjectInLibrary?: Maybe<SetProjectInLibraryResult>;
  /** Update an existing shipping provider */
  ShippingProviderUpdate: ShippingProvider;
  /** Creates a new shipping zone */
  ShippingZoneCreate?: Maybe<ShippingZoneCreateResult>;
  /** Deletes a professionals shipping zone */
  ShippingZoneDelete: ShippingZoneDeleteResult;
  /** Updates an existing shipping zone */
  ShippingZoneUpdate?: Maybe<ShippingZoneUpdateResult>;
  SpecialtyRatesUpdate?: Maybe<Professional>;
  /** User submission of the MGE form */
  SubmitMGEForm: Scalars['Boolean']['output'];
  /** Update a SupplierOrder by OrderNumber from an external source i.e. the Intergration Service */
  SupplierOrderExternalUpdate: Scalars['Boolean']['output'];
  SyncFilteredProducts: BooleanResult;
  SyncProducts: BooleanResult;
  ToggleAutomatedSync: BooleanResult;
  ToggleOrderSyncing: BooleanResult;
  UpdateAllowedTags: BooleanResult;
  UpdateMemberOAuth?: Maybe<Scalars['Boolean']['output']>;
  UpdateSettings: BooleanResult;
  UpsertQBR: Qbr;
  VariantImageUnlink: Variant;
  VariantOptionModify?: Maybe<AttributeOption>;
  WebsiteEventCreate?: Maybe<Scalars['Boolean']['output']>;
  WooCommerceCancelSync: BooleanResult;
  WooCommerceDisconnect: BooleanResult;
  WooCommerceToggleOrderSyncing: BooleanResult;
  WooCommerceToggleWebhooks: BooleanResult;
  WooCommerceUpdateAllowedTags: BooleanResult;
  WooCommerceUpdateSettings: BooleanResult;
  /** Accepts and invite */
  acceptDesignBoardInvite?: Maybe<AcceptDesignBoardInvite>;
  /** Accepts enquiry conversation invite */
  acceptEnquiryConversationInvite?: Maybe<AcceptEnquiryConversationInvite>;
  /** Accepts and invite to be part of Team */
  acceptTeamMemberInvite: Scalars['String']['output'];
  /** Add a billing recipient. If email is not already a team member, invites them and grants BILLING_RECIPIENT permission. */
  addBillingRecipient: BillingRecipientResponse;
  addInvoiceLogNote: InvoiceLog;
  addPermission?: Maybe<PermissionInterface>;
  /** Adds a premium feature SKU to the server-side BM membership cart (`AddOnCart` JSON list synced with checkout.) */
  addPremiumFeatureToCart: Scalars['Boolean']['output'];
  addProductFacetOption: Product;
  addSupplierOrderNote: OrderEvent;
  /** Adds a variant to the cart */
  addToShoppingCart: ShoppingCart;
  /** Apply a saved template to a page. */
  applyPageTemplate?: Maybe<DirectoryItem>;
  /** Reconciles the Stripe draft invoice when the user changes subscription pack checkout options (BM_MEMBERSHIP_EDIT); persists pack preference on AddOnCart. */
  applyPremiumCheckoutSubscriptionPack: PremiumFeatureStripeCheckout;
  /** Archive/unarchive a conversation for the current user. */
  archiveConversation: Conversation;
  /** Grant an atomic permission to a team member */
  assignTeamMemberPermission: Scalars['Boolean']['output'];
  /** Assign a team member to a role (team) */
  assignTeamMemberToRole: Scalars['Boolean']['output'];
  /** sync page with associated page in another zone */
  associatedPageSync?: Maybe<DirectoryItemSyncPageType>;
  /** Completes a Stripe SetupIntent after confirmSetup, validates and syncs default, returns updated payment methods */
  billingCompleteSetupIntent: BillingPaymentMethodsPayload;
  /** Create Stripe SetupIntent for BM membership billing (main team member; not Contact-based) */
  billingSetupIntentCreate: BillingSetupIntentResponse;
  /** Block/unblock users for the current user. */
  blockUsers: BlockUsersResponse;
  /** Issue an event ticket directly from Business Manager (no submission). Authorised through BMEventAccess::authoriseForActor + BMEventActor::assertCanIssue, so the caller must hold an event role (owner-team / staff-admin / exhibitor-team / professional-team) AND the EventDetails per-type flag must allow it AND the per-Professional cap must not be exhausted. ExhibitorProfessionalID is honoured only for staff-admin (pick-any) callers; non-staff exhibitor-team self-issue ignores it and pins the ticket to the BM-context Professional. Homeowner (Guest) tickets keep the historic \"no Professional\" stamp only when the BM-context Professional is the event owner; every other path (including a staff-admin operating from an exhibitor's BM context) stamps the BM-context Professional so the cap is counted per-Professional and the ticket appears in that Professional's BM exhibiting Guests group. */
  bmIssueEventTicket: BmIssueEventTicketResult;
  /** Issue an event ticket from an existing event submission. Authorised through BMEventAccess::authoriseForActor + BMEventActor::assertCanIssue and additionally re-checks that the submission belongs to the authorised event. ExhibitorProfessionalID is honoured only for staff-admin (pick-any) callers; non-staff exhibitor-team self-issue ignores it and pins the ticket to the BM-context Professional. */
  bmIssueEventTicketFromSubmission: BmIssueEventTicketResult;
  /** Resend the HDE invite confirmation email for an existing ticket. Restricted to event-owner BM team and ArchiPro staff-admin. Bypasses same-day SentReceipt deduplication so the email is always dispatched. */
  bmResendEventTicketEmail: Scalars['Boolean']['output'];
  /** Queue the HDE invite email with an embedded ticket QR for one ticket. Restricted to event-owner BM team and ArchiPro staff-admin. */
  bmResendEventTicketQrEmail: Scalars['Boolean']['output'];
  /** Revoke (soft-delete) a previously-issued event ticket. Authorised through BMEventAccess::authoriseForActor; ArchiPro staff-admin and the owning professional's BM team can revoke any ticket on the event, while exhibitor-team and professional-team members may revoke only tickets stamped to their BM-context Professional (the same set surfaced by bmExhibitingTicketsForEvent). */
  bmRevokeEventTicket: BmRevokeEventTicketResult;
  /** Queue ticket QR emails for tickets on the event. When TicketIDs is omitted, all tickets on the event are considered (up to the list cap). Restricted to event-owner BM team and ArchiPro staff-admin. */
  bmSendEventTicketQrEmails: BmSendEventTicketQrEmailsResult;
  /** AP staff only. Toggle whether an exhibitor's booth staff share one mobile Leads list at this event (SharedLeads on ExhibitingProfessionals). Defaults to true when unset. */
  bmSetHdeExhibitorSharedLeads: BmEventExhibitor;
  /** Update the curated subset of EventDetails fields exposed on the Business Manager Settings tab. Restricted to ArchiPro staff and the owning professional's BM team. */
  bmUpdateEventSettings: BmUpdateEventSettingsResult;
  /** Book a calendar event with a client director */
  bookCalendarEvent?: Maybe<BookCalendarEventResult>;
  /** Shares a BuildHub with user by email */
  buildHubCollaboratorAdd: BuildHubResponse;
  /** Removes a BuildHub collaborator */
  buildHubCollaboratorRemove: BuildHubCollaboratorResponse;
  /** Reorder collaborators for a BuildHub */
  buildHubCollaboratorReorder: BuildHubResponse;
  /** Update a BuildHub collaborator */
  buildHubCollaboratorUpdate: BuildHubCollaboratorResponse;
  /** Soft deletes a BuildHub */
  buildHubDelete: BuildHubResponse;
  /** Update a document's access mode and role settings */
  buildHubDocumentAccessUpdate: BuildHubDocument;
  /** Add collaborators with specific roles to a BuildHub document */
  buildHubDocumentCollaboratorAdd: BuildHubDocumentCollaboratorAddResult;
  /** Remove a collaborator from a document */
  buildHubDocumentCollaboratorRemove: BuildHubDocumentCollaborator;
  /** Update a document collaborator's role */
  buildHubDocumentCollaboratorUpdate: BuildHubDocumentCollaborator;
  /** Accept a document invite (e.g. mood board). Call after signup/login with invite hash from URL. */
  buildHubDocumentInviteAccept: BuildHubDocumentResponse;
  /** Member accepting a BuildHub invite */
  buildHubInviteAccept: BuildHubCollaboratorResponse;
  /** triggers a resend on a previously created invite */
  buildHubInviteResend: BuildHubCollaboratorResponse;
  /** leaves the BuildHub project */
  buildHubLeaveProject: BuildHubCollaboratorResponse;
  /** Update or create a BuildHub */
  buildHubUpsert: BuildHubResponse;
  /** Cancel a calendar event */
  cancelCalendarEvent?: Maybe<CancelCalendarEventResult>;
  cancelRequest?: Maybe<IntegrationRequest>;
  /** Cancels a supplier order. When the supplier is unable to processing it. */
  cancelSupplierOrder: Scalars['Boolean']['output'];
  /** Dismiss a card */
  cardDismiss?: Maybe<CardResult>;
  /** Mark a card as viewed */
  cardMarkAsViewed?: Maybe<CardResult>;
  /** Clear custom thumbnail and revert to auto (oldest pin) */
  clearInspirationGroupThumbnail: InspirationGroupResponse;
  /** Clone a professional */
  cloneProfessional: CloneTask;
  /** Mark a document's comments as read for the current user */
  commentMarkAsRead: BuildHubDocumentResponse;
  /** Mark a document's comments as unread for the current user from a specific comment onwards */
  commentMarkAsUnread: BuildHubDocumentResponse;
  commentSubmit: BuildHubCommentResponse;
  /** Completes $0 premium checkout without Stripe: attach-existing adds SubscriptionPackItem rows on the selected pack; new monthly/annual/daily creates an Active SubscriptionPack with the membership default card and hydrates items. Cart must match a validated zero-payment checkout snapshot (BM_MEMBERSHIP_EDIT). */
  completePremiumPackResubscribeWithoutPayment: Scalars['Boolean']['output'];
  /** Confirms the shopping cart is ready to be paid for a finalised. */
  confirmShoppingCartState: Scalars['Boolean']['output'];
  confirmStripeAccount: Professional;
  /** Confirms a supplier order. When the supplier commits to processing it. */
  confirmSupplierOrder: Scalars['Boolean']['output'];
  connectStripeAccount: Scalars['String']['output'];
  /** Archive a Pixel Conversion config */
  conversionConfigArchive?: Maybe<ProfessionalPixelTrackerConversionStatus>;
  /** Create a Pixel Conversion under a Professional. */
  conversionConfigCreate?: Maybe<PixelTrackerConversionConfig>;
  /** Delete a Pixel Conversion config */
  conversionConfigDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Unarchive a Pixel Conversion config */
  conversionConfigUnarchive?: Maybe<ProfessionalPixelTrackerConversionStatus>;
  /** Update a Pixel Conversion config */
  conversionConfigUpdate?: Maybe<PixelTrackerConversionConfig>;
  /** Soft deletes a conversion rule */
  conversionRuleDelete: Scalars['Boolean']['output'];
  /** Reorders conversion rule, updating SortOrder on the rule and shifting all ensuing rules */
  conversionRuleOrder: ConversionRuleResponse;
  /** Toggle enable or disable a conversion rule */
  conversionRuleToggle: ConversionRuleResponse;
  /** Update or create a conversion rule for a Professional. */
  conversionRuleUpsert: ConversionRuleResponse;
  /** Copy a Pin */
  copyPin: Array<Maybe<DesignBoard>>;
  /** Creates a checkout session for purchasing analytics */
  createAnalyticsCheckoutSession?: Maybe<AnalyticsCheckoutSession>;
  createAndUpdateFacetOption: Product;
  /** Create an article */
  createArticle?: Maybe<ArticleMutationResult>;
  createAttribute: Attribute;
  createAttributeAndOptions: Attribute;
  createAttributeOption: AttributeOption;
  /** Submits a B2B \"Apply to Join\" lead to HubSpot */
  createB2BLead?: Maybe<B2BLeadResult>;
  /** Creates a banner LibraryImage and associates it to a LibraryItem. */
  createBannerImage?: Maybe<Array<LibraryImage>>;
  /** Creates a checkout session for building guide */
  createBuildingGuideCheckoutSession?: Maybe<BuildingGuideCheckoutSession>;
  createCalendarSession: CalendarSession;
  createCompany: CompanyResponse;
  createContact: ContactResponse;
  createContentBlock?: Maybe<ContentBlock>;
  /** Create a new conversation with the given participants and send a first message. If the conversation already exists, the message is sent to it instead. */
  createConversation: DirectConversation;
  /** Create a new message in a conversation. At least one of Text or Attachments must be provided. */
  createConversationMessage: CreateConversationMessageResponse;
  /** Create a Conversion under a Professional. */
  createConversionConfig?: Maybe<PixelTrackerConversionConfig>;
  /** Creates a DesignBoard for the loggedIn Member or the current Tracked user */
  createDesignBoard?: Maybe<DesignBoard>;
  /** Creates comment for a design board */
  createDesignBoardComment?: Maybe<Comment>;
  /** Creates DiagramImages from file uploads and associates them with a  */
  createDiagramImages: Array<Maybe<DiagramImage>>;
  /** Sends an Enquiry to a Professional */
  createEnquiry?: Maybe<CreateEnquiry>;
  /** Adds a message to an enquiry conversation */
  createEnquiryConversationMessage?: Maybe<CreateConversationMessageType>;
  createFacetOption: FacetOption;
  /** Creates a banner LibraryImage and associates it to a LibraryItem. Supports both image and video banners. */
  createItemTopBanner: LibraryItemBanner;
  createLibraryDownload?: Maybe<Array<Maybe<LibraryDownload>>>;
  /** Creates LibraryImages from file uploads and associates them with a nominated LibraryItem/LibraryVideo/ContentBlock. */
  createLibraryImage: Array<Maybe<LibraryImage>>;
  /** Place a tag on a photo. */
  createLibraryImageMarker?: Maybe<LibraryImageMarker>;
  /**
   * Creates a LibraryLocation and associates it to a
   *                 LibraryItem (Currently only Professionals).
   */
  createLibraryLocation?: Maybe<LibraryLocation>;
  createLibraryRange: LibraryRange;
  createLibraryTab?: Maybe<Array<LibraryTab>>;
  createLibraryVideo?: Maybe<LibraryVideo>;
  /** Creates a Member Upload Pin for given designboard. */
  createMemberUploadPin?: Maybe<Pin>;
  /** Create network participants and add them to the network */
  createNetworkParticipant: Array<OrganizationNetworkParticipant>;
  createOrUpdateMasterVariant: Variant;
  createOrderReturn: SupplierOrder;
  /** Initializes a new organization network */
  createOrganizationNetwork: OrganizationNetwork;
  /** Create an template from a page to be reused later. */
  createPageTemplate?: Maybe<DirectoryItem>;
  /** Creates a Pin */
  createPin?: Maybe<Pin>;
  /** Creates comment for a Pin */
  createPinComment?: Maybe<Comment>;
  createPins: Array<Maybe<Pin>>;
  /** Create a product */
  createProduct?: Maybe<ProductMutationResult>;
  createProductSize: ProductSize;
  /** Create one or more product swatches */
  createProductSwatches?: Maybe<Array<ProductSwatch>>;
  createProductVariants: Product;
  /** Create a professional */
  createProfessional: DirectoryItem;
  /** Creates a ProfessionalAward for a given professional */
  createProfessionalAward?: Maybe<ProfessionalAwardMutationCreateResultType>;
  /** Creates a ProfessionalServiceArea and associates it to a professional. */
  createProfessionalServiceArea?: Maybe<ProfessionalServiceArea>;
  /** Create a project */
  createProject?: Maybe<ProjectMutationResult>;
  createQuoteTemplate: SavedQuoteResponse;
  /** Create a new reminder setting for a professional */
  createReminderSetting: InvoiceReminderSettingResult;
  createReviewAction?: Maybe<ReviewAction>;
  createSavedModule: SavedModule;
  createSearchTag: SearchTag;
  createServiceOffering: ServiceOfferingResponse;
  /** Creates a new shipping method */
  createShippingMethod: ShippingMethod;
  /** Creates a new shipping profile */
  createShippingProfile?: Maybe<ShippingProfile>;
  /** Creates a new address on the shopping cart */
  createShoppingCartAddress: ShoppingCart;
  /** Creates an order from a shopping cart */
  createShoppingCartOrder: CreateShoppingCartOrderResult;
  /** create a new team member */
  createTeamMember: TeamMember;
  /** Create a new team role with feature permissions */
  createTeamRole: TeamMemberRole;
  /** Creates a testimonial and associates it to given ID */
  createTestimonial?: Maybe<Testimonial>;
  createVariant: Variant;
  createVariantImage: LibraryImage;
  /** Delete an article */
  deleteArticle?: Maybe<ArticleMutationResult>;
  deleteAttributeOption: Scalars['Boolean']['output'];
  deleteBusinessTermsByID: Scalars['Boolean']['output'];
  deleteBusinessTermsCategory: Scalars['Boolean']['output'];
  deleteCalendarSession: Scalars['Boolean']['output'];
  /** Deletes a comment */
  deleteComment: Scalars['Int']['output'];
  deleteCompany: CompanyResponse;
  deleteContact: ContactResponse;
  deleteContentBlock: Scalars['Int']['output'];
  deleteConversionConfig?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a DesignBoard */
  deleteDesignBoard: Scalars['Int']['output'];
  /** Delete a Directory Item */
  deleteDirectoryItem?: Maybe<DirectoryItemMutationResult>;
  deleteEmailTemplateByID: Scalars['Boolean']['output'];
  deleteEmailTemplateInputConfig: Scalars['Boolean']['output'];
  deleteInvoiceLogNote: Scalars['Boolean']['output'];
  deleteLibraryDownload: Scalars['Boolean']['output'];
  deleteLibraryImage?: Maybe<Scalars['Boolean']['output']>;
  deleteLibraryImageMarker?: Maybe<Scalars['Boolean']['output']>;
  deleteLibraryImages: Array<ImageDeletionResult>;
  deleteLibraryLocation?: Maybe<Scalars['Boolean']['output']>;
  deleteLibraryRange?: Maybe<Scalars['Boolean']['output']>;
  deleteLibraryTab: Scalars['Boolean']['output'];
  deleteLibraryVideo: Scalars['Boolean']['output'];
  deleteLibraryVideoThumbnail?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a message from a conversation. Users can only delete messages they sent. */
  deleteMessage: DeleteMessageResponse;
  deleteModule: Scalars['Boolean']['output'];
  deleteModuleColumn: FlexibleModule;
  /** Deletes a Pin */
  deletePin?: Maybe<DesignBoard>;
  /** Deletes a Pin */
  deletePinsByPage?: Maybe<DesignBoard>;
  deleteProductSwatch: Scalars['Boolean']['output'];
  /** Delete a ProfessionalAward with the given IDs */
  deleteProfessionalAward?: Maybe<ProfessionalAwardMutationDeleteResultType>;
  /** Delete Badge image with the given award ID */
  deleteProfessionalAwardBadge?: Maybe<ProfessionalAwardBadgeDeleteResultType>;
  deleteProfessionalCompanyField: CustomFieldResponse;
  deleteProfessionalContactField: CustomFieldResponse;
  /** Deletes a ProfessionalServiceArea by ID. */
  deleteProfessionalServiceArea?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a project */
  deleteProject?: Maybe<ProjectMutationResult>;
  deleteQuoteContentByID: Scalars['Boolean']['output'];
  deleteQuotePayment: InvoiceableResponse;
  deleteQuoteServiceItem: InvoiceableResponse;
  /** Permanently delete a reminder setting */
  deleteReminderSetting: ReminderResult;
  deleteReviewAction?: Maybe<Scalars['Boolean']['output']>;
  deleteSavedModule: Scalars['Boolean']['output'];
  deleteSearchTag: Scalars['Boolean']['output'];
  deleteServiceOffering: ServiceOfferingResponse;
  /** Deletes a shipping method */
  deleteShippingMethod?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a shipping profile */
  deleteShippingProfile?: Maybe<Scalars['Int']['output']>;
  /** Removes the shipping rate */
  deleteShippingRate?: Maybe<Scalars['Boolean']['output']>;
  deleteSupplierOrderNote: Scalars['Boolean']['output'];
  /** Deletes TeamMember with given ID */
  deleteTeamMember: Scalars['Boolean']['output'];
  /** Delete a team role (removes role but not team members) */
  deleteTeamRole: Scalars['Boolean']['output'];
  deleteTestimonial?: Maybe<Scalars['Boolean']['output']>;
  deleteUnusedOptions: Array<Scalars['Int']['output']>;
  deleteVariant?: Maybe<DeleteVariantResult>;
  deleteVariantImage: Scalars['Boolean']['output'];
  deleteVariants: Array<DeleteVariantResult>;
  /** Detach a Stripe payment method from the membership billing customer and return the updated list */
  detachBillingPaymentMethod: BillingPaymentMethodsPayload;
  /** Bulk update visibility of directory items */
  directoryItemBulkUpdateVisibility: Scalars['Boolean']['output'];
  /** Disconnect calendar OAuth integration */
  disconnectCalendar: Scalars['Boolean']['output'];
  /** Dispatches order items or marks them ready for pickup */
  dispatchSupplierOrder: SupplierOrder;
  emailAssetRename: EmailAssetResponse;
  emailAssetUpload: EmailAssetListResponse;
  emailDataBindingUpdate: EmailTemplateResponse;
  /** Updates a collaborator permission */
  followDesignBoard?: Maybe<DesignBoard>;
  followInspirationGroup: InspirationGroupResponse;
  /** Accept the AI Image and replace the original LibraryImage */
  imageAccept: EditableImage;
  /** Center the image with AI Service */
  imageCenter?: Maybe<ImageCenterResultType>;
  /** Remove the image background with AI Service */
  imageRemoveBackground?: Maybe<ImageRemoveBackgroundResultType>;
  /** Revert the AI Image and replace the original LibraryImage */
  imageRevert: EditableImage;
  /** Upscale the image with AI Service */
  imageUpscale?: Maybe<ImageUpscaleResultType>;
  /** Purchases a single product through the ApplePay/GPay button */
  instantPurchase: CreateShoppingCartOrderResult;
  /** Invites one or more Collaborators */
  inviteCollaborators?: Maybe<DesignBoard>;
  /** Send an invite to be part of Team */
  inviteTeamMember: TeamMember;
  /** bulk invite team members to the professional */
  inviteTeamMembers: Scalars['Boolean']['output'];
  /** Invite participants from a 1-on-1 chat to a group chat. Finds an existing group chat with the desired participants or creates a new one. Messages from the original chat can be copied to the group chat. The original 1-on-1 chat remains unchanged. */
  inviteToGroupChat: InviteToGroupChatResponse;
  /** Sync settlement after Stripe.js confirms SetupIntent or PaymentIntent on the public proposal page */
  invoicePaymentConfirmAfterStripe: InvoicePaymentConfirmAfterStripeResponse;
  /** Marks the active proposal PaymentIntent attempt as failed after Stripe.js reports a card decline */
  invoicePaymentFailProposalStripeAttempt: InvoicePaymentResponse;
  /** Creates a pending Stripe attempt before the customer confirms a PaymentIntent on the proposal page */
  invoicePaymentPendingProposalStripeAttempt: InvoicePaymentResponse;
  invoicePaymentSetProcessingPayment: InvoicePaymentResponse;
  invoicePaymentUpdateStatus: InvoiceableResponse;
  leadExportCreate: LeadExportJob;
  /** Updates a collaborator permission */
  leaveDesignBoard?: Maybe<DesignBoard>;
  /** Create a relationship of some kind between two pages */
  linkLibraryItem: DirectoryItem;
  /** Log JavaScript error */
  logError?: Maybe<Scalars['Boolean']['output']>;
  logProposalView: Scalars['Boolean']['output'];
  /** Attempts to login a user. */
  login: LoginResult;
  /** Logs out the current user */
  logout?: Maybe<Scalars['Boolean']['output']>;
  /** Mark all messages in a Conversation as read for the current user. */
  markConversationRead: Conversation;
  /** Mark a Conversation as unread for the current user. */
  markConversationUnread: Conversation;
  /** Marks one notification as read */
  markWebsiteNotificationsAsRead: Array<WebsiteNotificationInterface>;
  /** Marks a member read record */
  memberReadRecordSet: Scalars['Boolean']['output'];
  mergeInvoicePayments: InvoiceableResponse;
  mfaConfirmLogin: Me;
  mfaConfirmSetup: Me;
  mfaDisableSetup: Me;
  mfaPasswordReset: MfaPasswordReset;
  mfaRequest: MfaRequest;
  mfaSetup: MfaSetup;
  moduleSwitch: Scalars['Boolean']['output'];
  moodBoardPinUpload: InspirationItemResponse;
  moodBoardPinsAdd: InspirationGroupResponse;
  moodBoardPinsCopy: InspirationGroupResponse;
  moodBoardPinsMove: InspirationGroupResponse;
  moodBoardPinsRemove: InspirationGroupResponse;
  /** remove mood board pins by page ids */
  moodBoardPinsRemoveByPage: InspirationGroupResponse;
  /** Moves a Pin */
  movePin: Array<Maybe<DesignBoard>>;
  /** Move a team member from one role to another atomically. Supports both single member (via TeamMemberID) and bulk operations (via Members array). If TargetRoleID is null, the member will be removed from their current role and placed in \"Ungrouped\". */
  moveTeamMemberToRole: Scalars['Boolean']['output'];
  /** Mute/unmute a conversation for the current user. */
  muteConversation: Conversation;
  /** bulk clone page to target zone */
  pageBulkClone: PageBulkCloneJob;
  pageClone: DirectoryItemClonePageType;
  pageURLSegmentUpdate?: Maybe<DirectoryItemUpdateUrlResultType>;
  /** Finalises and pays the premium add-on Stripe invoice. PaymentMethodID is optional when the invoice is attached to an existing subscription pack — the pack’s saved Stripe payment method is used. */
  payPremiumFeatureStripeInvoice: Scalars['Boolean']['output'];
  /** Charges a payable Upcoming or Overdue linked instalment for a subscription pack using the pack saved payment method (BM_MEMBERSHIP_EDIT) */
  paySubscriptionPackLinkedInvoice: Scalars['Boolean']['output'];
  paymentIntentCreate: PaymentIntentResponse;
  processOrderDecline: SupplierOrder;
  processOrderReturn: SupplierOrder;
  /** Process the PaymentResponse data from the Stripe Payment Request Button */
  processPaymentResponse: Scalars['Boolean']['output'];
  /** Processes a product import from the integration service. (deprecated) */
  processProductImport: ImportResult;
  processReminder: ReminderResult;
  /** Apply the side effects of an HDE QR scan. LEAD mode creates a Lead and pins the exhibitor's professional onto the attendee's design board. DOOR mode is staff-only and only stamps ScanInTime. */
  processScan: ScanResult;
  /** Restore a soft deleted product */
  productRestore: Array<Product>;
  /** Clone an existing InspirationGroup and its items into a target BuildHub */
  projectInspirationGroupClone: InspirationGroupResponse;
  /** soft deletes a existing inspiration group */
  projectInspirationGroupRemove: InspirationGroupResponse;
  /** soft deletes a existing inspiration group by its migrated source */
  projectInspirationGroupRemoveBySource: InspirationGroupResponse;
  /** create a new inspiration group */
  projectInspirationGroupUpsert: InspirationGroupResponse;
  /** creates a new inspiration group by migrating from an IdeaBook and its items */
  projectInspirationIdeaBookMigrate: InspirationGroupResponse;
  /** Import an external URL as an inspiration item */
  projectInspirationItemImportUrl: InspirationItemResponse;
  /** Update title and/or description of an inspiration item */
  projectInspirationItemUpdate: InspirationItemResponse;
  /** Link a team member to a project */
  projectTeamMemberCreate: ProjectTeamMember;
  /** Unlink a team member from a project */
  projectTeamMemberDelete: ProjectTeamMember;
  publishBusinessTerms: BusinessTermsResponse;
  quoteAcceptOrDecline: InvoiceableResponse;
  /** Move a selection of item to a starting position and arrange consecutively */
  rearrangeSortOrders: Array<SortableItem>;
  /** Persist the current member's last viewed non-personal BuildHub. */
  recordBuildHubView: BuildHubResponse;
  /** Queue stale external URL refresh jobs for a mood board. */
  refreshStaleExternalUrlPins: RefreshStaleExternalUrlPinsResult;
  registerExpoPushDevice: UserPushDevicesResponse;
  /** register an email address to the newsletter */
  registerForNewsLetter?: Maybe<Scalars['Boolean']['output']>;
  /** Claim a Scenario 2 guest ticket (registrant used own email for guest). Corrects the submission guest fields, issues a new ticket to the valid email, and syncs HubSpot. */
  registrantClaimGuestTicket: BmIssueEventTicketResult;
  /** Issue a guest ticket from the My Tickets page. Scoped to the logged-in member who must own the submission. Enforces per-event guest cap (MaxGuestInvitesPerRegistrant) and email uniqueness. Guest 1 updates the submission fields and syncs HubSpot; guests 2+ are ticket-only. */
  registrantIssueGuestTicket: BmIssueEventTicketResult;
  /** Revoke (soft-delete) a guest ticket from the My Tickets page. Scoped to the logged-in member who must own the submission. If the revoked ticket is the submission-linked guest, clears the submission guest fields and syncs HubSpot. */
  registrantRevokeGuestTicket: BmRevokeEventTicketResult;
  /** Remove a billing recipient by revoking their BILLING_RECIPIENT permission. */
  removeBillingRecipient: BillingRecipientResponse;
  /** Removes an existing collaborator */
  removeCollaborator?: Maybe<DesignBoard>;
  removeFollower: InspirationGroupResponse;
  /** Removes the participant from the organization network */
  removeNetworkParticipant: Scalars['Boolean']['output'];
  removePermission?: Maybe<PermissionInterface>;
  /** Removes a premium feature from the server-side cart */
  removePremiumFeatureFromCart: Scalars['Boolean']['output'];
  removeProductFacetOption: Product;
  /** Removes a reaction for the current user on a document. */
  removeReaction: BuildHubReactionResponse;
  /** Remove a team member from a role (team) */
  removeTeamMemberFromRole: Scalars['Boolean']['output'];
  renameSavedModule: SavedModule;
  reorderQuoteServiceItem: InvoiceableResponse;
  /** Update the sort order of a team role for drag-and-drop reordering */
  reorderTeamRole: TeamMemberRole;
  /** Reports a DirectoryItem (Product, Project, Professional, Article) for moderation review */
  reportDirectoryItem: ReportDirectoryItemResponse;
  /** Reports a User/Member for moderation review */
  reportUser: ReportUserResponse;
  /** Request account deletion. Creates a deletion request and begins a 30-day grace period. Account remains active during this time. A scheduled task will disable the account after 30 days if not restored. */
  requestAccountDeletion: AccountDeletionRequestResponse;
  requestDownloadAccess: ContactResponse;
  /** Resend an invite to a collaborator */
  resendCollaboratorInvite: DesignBoard;
  /** Resend an invitation to the teammate */
  resendTeamMemberInvitation: Scalars['Boolean']['output'];
  resetModuleColumn: FlexibleModule;
  /** Resets SupplierOrder.NotifyCustomer. */
  resetOrderNotification: SupplierOrder;
  /** Cancel a pending account deletion request. Cancels the deletion and the account remains active. */
  restoreAccount: AccountDeletionRequestResponse;
  reuseVariantImage: LibraryImage;
  /** Adds a message to an enquiry conversation */
  revealContactDetails: EnquiryConversation;
  reviewPage?: Maybe<PageReviewType>;
  /** Revoke an atomic permission from a team member */
  revokeTeamMemberPermission: Scalars['Boolean']['output'];
  /** Saves a team member and send invitation if the email has changed or is a new record */
  saveAndInviteTeamMember: TeamMember;
  saveImportMap?: Maybe<Scalars['Boolean']['output']>;
  /** User reacts to a document in BuildHub */
  saveReaction: BuildHubReactionResponse;
  /** Send badge install code to developer email */
  sendBadgeCode?: Maybe<Scalars['Boolean']['output']>;
  sendEmailTemplate: EmailMessageResponse;
  /** AP staff only. Email the uploaded HDE exhibitor brochure PDF to a target email address. */
  sendHDEExhibitorBrochureEmail: Scalars['Boolean']['output'];
  sendHubspotMarketingPreferencesEmail: SendHubspotMarketingPreferencesEmailResultType;
  /** Send pixel code to developer email */
  sendPixelCode?: Maybe<Scalars['Boolean']['output']>;
  sendPushNotification: Scalars['Boolean']['output'];
  sendQuote: SavedQuoteResponse;
  sendQuoteExternally: SavedQuoteResponse;
  /** Set the default Stripe payment method for membership billing; returns the same payload as billingPaymentMethods */
  setBillingDefaultPaymentMethod: BillingPaymentMethodsPayload;
  /** Marks comments for board as read */
  setBoardCommentsAsRead?: Maybe<DesignBoard>;
  /** Set a specific pin's image as the board thumbnail */
  setInspirationGroupThumbnail: InspirationGroupResponse;
  setInvoiceAutoBill: InvoiceableResponse;
  /** Sets a LibraryItem's top banner to one of its existing on-page images, by reference (no file upload or copy). The banner shares the gallery image's ID, so project tiles can detect which slide is the current banner. */
  setItemBannerFromImage: LibraryItemBanner;
  setLibraryItemCategories?: Maybe<DirectoryItem>;
  setLibraryRange: LibraryRange;
  /** Set a LibraryThumb */
  setLibraryThumb?: Maybe<LibraryThumb>;
  /** Marks comments for pin as read */
  setPinCommentsAsRead?: Maybe<DesignBoard>;
  /** Sets the absolute cart quantity for a premium SKU (use 0 to remove). BM_MEMBERSHIP_EDIT; honours catalogue min/max for `per_unit`. */
  setPremiumFeatureCartQty: Scalars['Boolean']['output'];
  /** Set the professional disciplines (roles) recorded for a project. CategoryIDs must be a subset of the owning professional's categories. */
  setProjectRoles?: Maybe<ProjectMutationResult>;
  /** Set the custom team member order for a project */
  setProjectTeamOrder: Project;
  setQuoteContact: InvoiceableResponse;
  /** Sets the charges for one or more shipping rates */
  setShippingRates?: Maybe<Array<Maybe<ShippingRate>>>;
  /** Configures an address type on the shopping cart */
  setShoppingCartAddress: ShoppingCart;
  setupIntentCreate: SetupIntentResponse;
  setupSplitPayments: SavedQuoteResponse;
  /** Share en enquiry conversation to other invitees */
  shareEnquiryConversation?: Maybe<ShareEnquiryConversationResult>;
  /** Share an item. */
  shareItem?: Maybe<Scalars['Boolean']['output']>;
  /** Attempts to login a user via social login (Google, Facebook, LinkedIn). */
  socialLogin: LoginResult;
  /** Soft-deletes a pending-checkout subscription pack after voiding or deleting unpaid Stripe draft/open invoices (BM_MEMBERSHIP_EDIT) */
  softDeleteSubscriptionPack: Scalars['Boolean']['output'];
  sortContentBlocks?: Maybe<Array<Maybe<ContentBlock>>>;
  splitInvoicePayment: InvoiceableResponse;
  /** User submission of the ACE form */
  submitACEForm: Scalars['Boolean']['output'];
  /** User submission of the Advertising form */
  submitAdvertisingForm: Scalars['Boolean']['output'];
  /** Creates premium-feature PurchasedAddOn when needed (GraphQL enrolment dates). Stripe SubscriptionPack checkout is separate for recurring billing */
  subscribePremiumFeaturePurchase: Scalars['Boolean']['output'];
  /** Atomically swap library images between two image columns (cross-module page builder DnD). */
  swapModuleLibraryImages: Scalars['Boolean']['output'];
  /** Updates site subscription using payment provider data */
  syncAnalyticsSubscription?: Maybe<AnalyticsSubscription>;
  syncSavedModule: FlexibleModule;
  /** Enable or disable an existing reminder setting */
  toggleReminderSetting: InvoiceReminderSettingResult;
  unfollowInspirationGroup: InspirationGroupResponse;
  /** Remove a relationship of some kind between two pages */
  unlinkLibraryItem?: Maybe<DirectoryItem>;
  unregisterExpoPushDevice: UserPushDevicesResponse;
  unsetLibraryRange: Product;
  unsetVariantOptions: Array<Scalars['Int']['output']>;
  unsetVariantSize: Scalars['Boolean']['output'];
  /** Removes the SKU from live SubscriptionPack billing (stops Stripe rebilling); entitlement windows on PurchasedAddOn are unchanged until they expire naturally */
  unsubscribePremiumFeaturePurchase: Scalars['Boolean']['output'];
  /** Updates an analytics subscription */
  updateAnalyticsSubscription?: Maybe<Scalars['Boolean']['output']>;
  /** Update/edit an article */
  updateArticle?: Maybe<ArticleMutationResult>;
  updateAttributeOption: AttributeOption;
  updateAttributeOptionSortOrders: Array<ProductAttributeOption>;
  /** Update the notification category tag for a billing recipient. */
  updateBillingRecipientTag: BillingRecipientResponse;
  /** Update timeline view settings for a BuildHub */
  updateBuildHubTimelineSettings: BuildHubTimelineSettings;
  updateBusinessTermsDataBinding: BusinessTermsResponse;
  updateCalendarSession: CalendarSession;
  /** Updates a collaborator permission */
  updateCollaboratorPermission: DesignBoard;
  updateCompany: CompanyResponse;
  updateContact: ContactResponse;
  updateContactInternalNote: ContactResponse;
  updateContactLeadStatus: ContactResponse;
  updateContactPhoto: ContactResponse;
  updateContentBlock?: Maybe<ContentBlock>;
  /** Update one or more settings of a (direct) conversation. Fields that are `nullish` are ignored and won't be updated. */
  updateConversation: UpdateConversationPayload;
  /** Update the participants of a (direct) conversation. At least 1 original participant must remain and at least 2 participants must remain after the update. */
  updateConversationParticipants: UpdateConversationPayload;
  /** Update the conversation settings for the current user. Fields that are `null` are ignored and won't be updated. */
  updateConversationSettings: ConversationSettings;
  /** Update the thumbnail of a (direct) conversation. */
  updateConversationThumbnail: UpdateConversationPayload;
  /** Update a Conversion of the Professional. */
  updateConversionConfig?: Maybe<PixelTrackerConversionConfig>;
  /** Creates a DesignBoard for the loggedIn Member or the current Tracked user */
  updateDesignBoard?: Maybe<DesignBoard>;
  /** Updates a user's DesignBoardSetting */
  updateDesignBoardSetting?: Maybe<DesignBoardSetting>;
  updateFeatureBooking?: Maybe<FeatureBooking>;
  /** Update or Create a flexible module based on preset name */
  updateFlexibleModule: FlexibleModule;
  updateInvoiceLogNote: InvoiceLog;
  /** Items status change is used by admin button on item tiles. It allows us to change the publish/approval/inLibrary status of product/project. Staff admin and company admin users are allowed to use this mutation. */
  updateItemStatusByAdmin?: Maybe<DirectoryItem>;
  updateLibraryDownload?: Maybe<Array<Maybe<LibraryDownload>>>;
  updateLibraryImage?: Maybe<LibraryImage>;
  /** Update a tag */
  updateLibraryImageMarker?: Maybe<LibraryImageMarker>;
  updateLibraryImages: Array<LibraryImage>;
  updateLibraryImagesSortOrder?: Maybe<Array<LibraryImage>>;
  updateLibraryLocations: Array<LibraryLocation>;
  updateLibraryRange: LibraryRange;
  updateLibraryTabs?: Maybe<Array<LibraryTab>>;
  /** Update a LibraryThumb */
  updateLibraryThumb?: Maybe<LibraryThumb>;
  updateLibraryVideo?: Maybe<LibraryVideo>;
  updateMe?: Maybe<Me>;
  /** Add or remove an emoji reaction on a chat message. Only available for text and file attachment messages. */
  updateMessageReaction: UpdateMessageReactionResponse;
  updateMeta: Meta;
  /** Updates the participants meta */
  updateOrganizationNetworkParticipant: OrganizationNetworkParticipant;
  /** Toggles the status of a participant (Unread, archived, important) */
  updateParticipantStatus?: Maybe<UpdateEnquiryParticipantStatusResult>;
  updatePassword?: Maybe<Me>;
  /** Update/edit a product */
  updateProduct?: Maybe<ProductMutationResult>;
  updateProductFacetOptions: Product;
  updateProductPricing: ProductPricing;
  updateProductSize: ProductSize;
  updateProductSizeSortOrders: Array<ProductSize>;
  /** Updates one or more product swatches */
  updateProductSwatches: Array<ProductSwatch>;
  /** Update/edit a professional */
  updateProfessional?: Maybe<Professional>;
  /** Update a ProfessionalAward with the given ID */
  updateProfessionalAward?: Maybe<ProfessionalAwardMutationUpdateResultType>;
  /** Updates ProfessionalServiceAreas of a professional. */
  updateProfessionalServiceArea?: Maybe<Array<ProfessionalServiceArea>>;
  /** Update/edit a project */
  updateProject?: Maybe<ProjectMutationResult>;
  updateQuoteDataBinding: InvoiceableResponse;
  updateQuoteMetaData: InvoiceableResponse;
  updateReviewAction?: Maybe<ReviewAction>;
  updateSavedModule: SavedModule;
  updateSearchTags: Array<SearchTag>;
  updateServiceOffering: ServiceOfferingResponse;
  /** Updates a shipping method */
  updateShippingMethod?: Maybe<ShippingMethod>;
  /** Update an existing shipping profile */
  updateShippingProfile?: Maybe<ShippingProfile>;
  /** Updates data on the shopping cart */
  updateShoppingCart: ShoppingCart;
  /** Updates an address on the shopping cart */
  updateShoppingCartAddress: ShoppingCart;
  /** Updates or removes an item on the cart */
  updateShoppingCartItem: ShoppingCart;
  /** Updates data on the CartSupplier on the shopping cart */
  updateShoppingCartSupplier: ShoppingCart;
  /** Update the sort orders of a list of directoryItems of a certain type */
  updateSortOrders: Array<SortableItem>;
  /** Updates SubscriptionPack saved Stripe payment method and aligns open draft Stripe invoice default_payment_method when set (BM_MEMBERSHIP_EDIT) */
  updateSubscriptionPackPaymentMethod: Scalars['Boolean']['output'];
  updateSupplierOrderNote: OrderEvent;
  updateSupplierOrderShipping: SupplierOrder;
  /** Updates a team member */
  updateTeamMember: Array<TeamMember>;
  /** Update a team role (name or permissions) */
  updateTeamRole: TeamMemberRole;
  /** Batch updates testimonials */
  updateTestimonials?: Maybe<Array<Maybe<Testimonial>>>;
  updateVariant: Variant;
  updateVariantOption: AttributeOption;
  updateVariantSize: ProductSize;
  updateVariants: Array<Maybe<Variant>>;
  /** Creates a Member UploadDesignBoardPin for given design board. */
  uploadDesignBoardPin?: Maybe<DesignBoardPin>;
  /** Uploads a LibraryImage and updates the Professional logo */
  uploadLogoImage?: Maybe<LibraryImageFile>;
  upscaleImageColumn: UpscaleImageColumnResult;
  upsertBusinessTerms: BusinessTermsResponse;
  upsertBusinessTermsCategory: BusinessTermsCategory;
  upsertEmailTemplate: EmailTemplateResponse;
  upsertEmailTemplateInputConfig: EmailTemplateInputConfigResponse;
  /** AP staff only. Upsert or remove the canonical HDE exhibitor featured profile for a professional. */
  upsertHDEExhibitorProfile?: Maybe<Professional>;
  upsertProfessionalCompanyField: CustomFieldResponse;
  upsertProfessionalContactField: CustomFieldResponse;
  upsertQuoteContact: InvoiceableResponse;
  upsertQuoteContent: SavedQuoteResponse;
  upsertQuotePayment: InvoiceableResponse;
  upsertQuoteServiceItem: InvoiceableResponse;
  useQuoteTemplate: SavedQuoteResponse;
};


export type MutationArcherCommentActionArgs = {
  Action: Scalars['Boolean']['input'];
  CommentID: Scalars['Int']['input'];
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  Level?: InputMaybe<ArcherCommentLevelEnum>;
  ProductID?: InputMaybe<Scalars['Int']['input']>;
  Section?: InputMaybe<ArcherHighlightSectionEnum>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationArcherCommentDeleteArgs = {
  CommentID?: InputMaybe<Scalars['Int']['input']>;
  ReplyID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationArcherCommentReplyArgs = {
  CommentID: Scalars['Int']['input'];
  Content: Scalars['StringInput']['input'];
  ReplyID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAwardLinkToEntityArgs = {
  AwardID: Scalars['Int']['input'];
  AwardedEntityLink?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationAwardUnlinkFromEntityArgs = {
  AwardID: Scalars['Int']['input'];
  AwardedEntityLink?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationBulkUploadAndRearrangeArgs = {
  Images: Array<Scalars['Upload']['input']>;
  ParentClass: Scalars['String']['input'];
  ParentID: Scalars['Int']['input'];
};


export type MutationCachedIntegrationSettingsInvalidateArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationCancelSyncArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationConsignmentPickupRequestArgs = {
  Consignment: Scalars['Int']['input'];
  Packages: Array<ConsignmentPackageInput>;
};


export type MutationConsignmentSyncArgs = {
  Consignment: Scalars['Int']['input'];
};


export type MutationContentStatusUpdateArgs = {
  Comment?: InputMaybe<Scalars['StringInput']['input']>;
  LibraryItemID: Scalars['Int']['input'];
  RejectionReasons?: InputMaybe<Array<InputMaybe<ContentRejectReasonEnum>>>;
  Status?: InputMaybe<ContentStatusEnum>;
};


export type MutationDeleteQbrByIdArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationEnrichProductWithAiArgs = {
  AiModel?: InputMaybe<Scalars['String']['input']>;
  ClearExisting?: InputMaybe<Scalars['Boolean']['input']>;
  ProductID: Scalars['Int']['input'];
  PromptVersion?: InputMaybe<Scalars['Int']['input']>;
  Temperature?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationFeaturedBrandPinToggleArgs = {
  ItemID: Scalars['Int']['input'];
  Pin: Scalars['Boolean']['input'];
};


export type MutationHomePinToggleArgs = {
  ItemID: Scalars['Int']['input'];
  Pin: Scalars['Boolean']['input'];
};


export type MutationImageExportCreateArgs = {
  input?: InputMaybe<ImageExportCreateInputType>;
};


export type MutationImageImportArgs = {
  ImageKey: Scalars['StringInput']['input'];
};


export type MutationIntegrationRequestReportResultArgs = {
  Error?: InputMaybe<Scalars['String']['input']>;
  NewProduct?: InputMaybe<Scalars['Boolean']['input']>;
  ProductData?: InputMaybe<ProductResultData>;
  Professional: Scalars['String']['input'];
  Reference?: InputMaybe<Scalars['String']['input']>;
  RequestID: Scalars['String']['input'];
  Success: Scalars['Boolean']['input'];
  Warnings?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationIntegrationSettingsUpdateArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
  Settings: IntegrationSettingsModelInput;
};


export type MutationIntegrationUnlinkArgs = {
  DataSource: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationIntegrationUnpublishProductArgs = {
  Professional: Scalars['String']['input'];
  SupplierProductID: Scalars['String']['input'];
};


export type MutationJwtTokenCreateArgs = {
  audience: JwtAudience;
  deviceName: Scalars['String']['input'];
  professional?: InputMaybe<Scalars['String']['input']>;
  scopes: Array<JwtScopeEnum>;
  ttl?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationJwtTokenRefreshArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationLibraryPinUpdateArgs = {
  CategoryID: Scalars['Int']['input'];
  ItemID: Scalars['Int']['input'];
  Pin: Scalars['Boolean']['input'];
};


export type MutationOrderImportArgs = {
  DataSource: IntegratedPlatformEnum;
  Order: ImportOrder;
  Professional: Scalars['String']['input'];
};


export type MutationPlatformConnectArgs = {
  ConnectHash: Scalars['StringInput']['input'];
  CountryCode: Scalars['String']['input'];
  Link: Scalars['StringInput']['input'];
  Platform: IntegratedPlatformEnum;
  Shop: Scalars['StringInput']['input'];
};


export type MutationPlatformDisconnectArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationProductImportFieldBlacklistInvalidateArgs = {
  Professional: Scalars['String']['input'];
};


export type MutationProductImportProcessArgs = {
  DataSource?: InputMaybe<IntegratedPlatformEnum>;
  Overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  Product: ImportProduct;
  Professional: Scalars['String']['input'];
  RequestID: Scalars['String']['input'];
  Synchronous?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreMe?: InputMaybe<ContentLockFlexibilityFieldEnum>;
};


export type MutationProductImprovementCreateTaskArgs = {
  CommentID?: InputMaybe<Scalars['Int']['input']>;
  IsUndo?: InputMaybe<Scalars['Boolean']['input']>;
  ProductID: Scalars['Int']['input'];
};


export type MutationSampleEnquiryCreateArgs = {
  FormData: SampleEnquiryInput;
  ProductID: Scalars['Int']['input'];
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationSetDirectoryFeaturedProjectArgs = {
  Feature: Scalars['Boolean']['input'];
  ProjectID: Scalars['Int']['input'];
};


export type MutationSetProductInLibraryArgs = {
  InLibrary: Scalars['Boolean']['input'];
  ProductID: Scalars['Int']['input'];
};


export type MutationSetProjectInLibraryArgs = {
  InLibrary: Scalars['Boolean']['input'];
  ProjectID: Scalars['Int']['input'];
};


export type MutationShippingProviderUpdateArgs = {
  AccountID?: InputMaybe<Scalars['StringInput']['input']>;
  AccountSecret?: InputMaybe<Scalars['StringInput']['input']>;
  Enabled?: InputMaybe<Scalars['Boolean']['input']>;
  FreeThresholdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  Locations?: InputMaybe<Array<ShippingProviderLocationInput>>;
  ProfessionalID: Scalars['Int']['input'];
  ShippingProvider: ShippingProviderEnum;
};


export type MutationShippingZoneCreateArgs = {
  ProfessionalID: Scalars['Int']['input'];
  ShippingZone: ShippingZoneInput;
};


export type MutationShippingZoneDeleteArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationShippingZoneUpdateArgs = {
  ID: Scalars['Int']['input'];
  ShippingZone: ShippingZoneInput;
};


export type MutationSpecialtyRatesUpdateArgs = {
  Categories: Array<SpecialtyRateCategoriesInput>;
  ProfessionalID: Scalars['Int']['input'];
  SpecialtyRatesOnSalePrices?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSubmitMgeFormArgs = {
  Input: MgeFormInput;
};


export type MutationSupplierOrderExternalUpdateArgs = {
  ExternalOrderReference: Scalars['StringInput']['input'];
  OrderNumber: Scalars['Int']['input'];
};


export type MutationSyncFilteredProductsArgs = {
  Filters: Array<ListDirectoryItemsFilter>;
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
  Title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncProductsArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationToggleAutomatedSyncArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationToggleOrderSyncingArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationUpdateAllowedTagsArgs = {
  AllowedTags: Array<Scalars['String']['input']>;
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationUpdateMemberOAuthArgs = {
  Action: Scalars['String']['input'];
  OAuthID: Scalars['Int']['input'];
};


export type MutationUpdateSettingsArgs = {
  DisabledSettings?: InputMaybe<Array<Scalars['String']['input']>>;
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type MutationUpsertQbrArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalID: Scalars['Int']['input'];
  Title: Scalars['StringInput']['input'];
};


export type MutationVariantImageUnlinkArgs = {
  VariantID: Scalars['Int']['input'];
};


export type MutationVariantOptionModifyArgs = {
  AttributeID: Scalars['Int']['input'];
  Code?: InputMaybe<Scalars['StringInput']['input']>;
  Label?: InputMaybe<Scalars['StringInput']['input']>;
  ProfessionalID: Scalars['Int']['input'];
  VariantID: Scalars['Int']['input'];
};


export type MutationWebsiteEventCreateArgs = {
  Event: WebsiteEvent;
  Professional: Scalars['String']['input'];
};


export type MutationWooCommerceCancelSyncArgs = {
  Professional: Scalars['String']['input'];
};


export type MutationWooCommerceDisconnectArgs = {
  Professional: Scalars['String']['input'];
};


export type MutationWooCommerceToggleOrderSyncingArgs = {
  Professional: Scalars['String']['input'];
};


export type MutationWooCommerceToggleWebhooksArgs = {
  Professional: Scalars['String']['input'];
};


export type MutationWooCommerceUpdateAllowedTagsArgs = {
  Professional: Scalars['String']['input'];
  Tags: Array<Scalars['Int']['input']>;
};


export type MutationWooCommerceUpdateSettingsArgs = {
  DisabledSettings?: InputMaybe<Array<Scalars['String']['input']>>;
  Professional: Scalars['String']['input'];
};


export type MutationAcceptDesignBoardInviteArgs = {
  InviteHash: Scalars['StringInput']['input'];
};


export type MutationAcceptEnquiryConversationInviteArgs = {
  InviteHash: Scalars['String']['input'];
};


export type MutationAcceptTeamMemberInviteArgs = {
  InviteHash: Scalars['StringInput']['input'];
};


export type MutationAddBillingRecipientArgs = {
  Email: Scalars['Email']['input'];
  Name: Scalars['StringInput']['input'];
  ProfessionalID: Scalars['Int']['input'];
  Tag?: InputMaybe<BillingRecipientTag>;
};


export type MutationAddInvoiceLogNoteArgs = {
  InvoiceID: Scalars['Int']['input'];
  Note: Scalars['StringInput']['input'];
};


export type MutationAddPermissionArgs = {
  Permission: PermissionGroupEnum;
  Resource: PermissionResource;
};


export type MutationAddPremiumFeatureToCartArgs = {
  PremiumFeatureCartQty?: InputMaybe<Scalars['Int']['input']>;
  PremiumFeatureSKU: Scalars['String']['input'];
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type MutationAddProductFacetOptionArgs = {
  Input?: InputMaybe<AddFacetOptionInput>;
};


export type MutationAddSupplierOrderNoteArgs = {
  Note: Scalars['StringInput']['input'];
  SupplierOrder: Scalars['Int']['input'];
};


export type MutationAddToShoppingCartArgs = {
  PickupLocation?: InputMaybe<Scalars['Int']['input']>;
  Quantity?: InputMaybe<Scalars['Int']['input']>;
  Region?: InputMaybe<Scalars['Int']['input']>;
  Sample?: InputMaybe<Scalars['Boolean']['input']>;
  ShippingMethod?: InputMaybe<Scalars['Int']['input']>;
  ShippingProvider?: InputMaybe<ShippingProviderEnum>;
  Variant: Scalars['Int']['input'];
};


export type MutationApplyPageTemplateArgs = {
  DirectoryType: DirectoryItemEnumType;
  ID: Scalars['Int']['input'];
  TemplateID: Scalars['Int']['input'];
};


export type MutationApplyPremiumCheckoutSubscriptionPackArgs = {
  ExistingSubscriptionPackID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalURLSegment: Scalars['String']['input'];
  SubscriptionPackCheckoutMode: SubscriptionPackCheckoutMode;
};


export type MutationArchiveConversationArgs = {
  ConversationID: Scalars['Int']['input'];
  IsArchived: Scalars['Boolean']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAssignTeamMemberPermissionArgs = {
  Action: InvoicePermissionActionEnum;
  ProfessionalID: Scalars['Int']['input'];
  TeamMemberID: Scalars['Int']['input'];
};


export type MutationAssignTeamMemberToRoleArgs = {
  ProfessionalID: Scalars['Int']['input'];
  RoleID: Scalars['Int']['input'];
  TeamMemberID: Scalars['Int']['input'];
};


export type MutationAssociatedPageSyncArgs = {
  AssociatedPageID: Scalars['Int']['input'];
  ID: Scalars['Int']['input'];
  PageType: Scalars['String']['input'];
};


export type MutationBillingCompleteSetupIntentArgs = {
  ProfessionalID: Scalars['Int']['input'];
  SetupIntentID: Scalars['String']['input'];
};


export type MutationBillingSetupIntentCreateArgs = {
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationBlockUsersArgs = {
  AddMemberIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  RemoveMemberIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationBmIssueEventTicketArgs = {
  Email: Scalars['String']['input'];
  EventID: Scalars['ID']['input'];
  ExhibitorProfessionalID?: InputMaybe<Scalars['ID']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Type: Scalars['String']['input'];
};


export type MutationBmIssueEventTicketFromSubmissionArgs = {
  EventSubmissionID: Scalars['ID']['input'];
  ExhibitorProfessionalID?: InputMaybe<Scalars['ID']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Type: Scalars['String']['input'];
};


export type MutationBmResendEventTicketEmailArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  TicketID: Scalars['ID']['input'];
};


export type MutationBmResendEventTicketQrEmailArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  TicketID: Scalars['ID']['input'];
};


export type MutationBmRevokeEventTicketArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  TicketID: Scalars['ID']['input'];
};


export type MutationBmSendEventTicketQrEmailsArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  TicketIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationBmSetHdeExhibitorSharedLeadsArgs = {
  EventID: Scalars['ID']['input'];
  ExhibitorProfessionalID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  SharedLeads: Scalars['Boolean']['input'];
};


export type MutationBmUpdateEventSettingsArgs = {
  EventID: Scalars['ID']['input'];
  Input: BmEventSettingsInput;
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationBookCalendarEventArgs = {
  input: BookCalendarEventInput;
};


export type MutationBuildHubCollaboratorAddArgs = {
  BuildHubID: Scalars['ID']['input'];
  Emails: Array<Scalars['Email']['input']>;
  Message?: InputMaybe<Scalars['StringInput']['input']>;
  Role?: InputMaybe<Scalars['StringInput']['input']>;
  TeamMemberID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationBuildHubCollaboratorRemoveArgs = {
  BuildHubID: Scalars['ID']['input'];
  CollaboratorID: Scalars['ID']['input'];
};


export type MutationBuildHubCollaboratorReorderArgs = {
  BuildHubID: Scalars['ID']['input'];
  CollaboratorIDs: Array<Scalars['ID']['input']>;
};


export type MutationBuildHubCollaboratorUpdateArgs = {
  BuildHubID: Scalars['ID']['input'];
  Caption?: InputMaybe<Scalars['StringInput']['input']>;
  CollaboratorID: Scalars['ID']['input'];
  CustomCompanyName?: InputMaybe<Scalars['StringInput']['input']>;
  Role: Scalars['StringInput']['input'];
};


export type MutationBuildHubDeleteArgs = {
  BuildHubID: Scalars['ID']['input'];
};


export type MutationBuildHubDocumentAccessUpdateArgs = {
  AccessSettings: BuildHubDocumentAccessInput;
  BuildHubDocumentID: Scalars['ID']['input'];
};


export type MutationBuildHubDocumentCollaboratorAddArgs = {
  BuildHubDocumentID: Scalars['ID']['input'];
  Collaborators: Array<BuildHubDocumentCollaboratorInput>;
};


export type MutationBuildHubDocumentCollaboratorRemoveArgs = {
  CollaboratorID: Scalars['ID']['input'];
};


export type MutationBuildHubDocumentCollaboratorUpdateArgs = {
  CollaboratorID: Scalars['ID']['input'];
  Role: Scalars['String']['input'];
};


export type MutationBuildHubDocumentInviteAcceptArgs = {
  InviteHash: Scalars['String']['input'];
};


export type MutationBuildHubInviteAcceptArgs = {
  InviteHash: Scalars['String']['input'];
};


export type MutationBuildHubInviteResendArgs = {
  CollaboratorID: Scalars['ID']['input'];
};


export type MutationBuildHubLeaveProjectArgs = {
  BuildHubID: Scalars['ID']['input'];
};


export type MutationBuildHubUpsertArgs = {
  ActiveStageURLSegment?: InputMaybe<Scalars['StringInput']['input']>;
  BudgetMax?: InputMaybe<Scalars['Float']['input']>;
  BudgetMin?: InputMaybe<Scalars['Float']['input']>;
  BuildHubID?: InputMaybe<Scalars['ID']['input']>;
  EndDate?: InputMaybe<Scalars['StringInput']['input']>;
  Location?: InputMaybe<Scalars['StringInput']['input']>;
  LocationData?: InputMaybe<PlaceDetailTypeInput>;
  MainDescription?: InputMaybe<Scalars['StringInput']['input']>;
  OwnerCustomCompanyName?: InputMaybe<Scalars['StringInput']['input']>;
  OwnerTeamMemberID?: InputMaybe<Scalars['Int']['input']>;
  ProjectScope?: InputMaybe<Scalars['StringInput']['input']>;
  ProjectType?: InputMaybe<BuildHubTypeEnum>;
  RemoveThumbnail?: InputMaybe<Scalars['Boolean']['input']>;
  Stages?: InputMaybe<Array<InputMaybe<BuildHubStageInput>>>;
  StartDate?: InputMaybe<Scalars['StringInput']['input']>;
  ThumbnailFile?: InputMaybe<Scalars['Upload']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationCancelCalendarEventArgs = {
  input: CancelCalendarEventInput;
};


export type MutationCancelRequestArgs = {
  RequestID: Scalars['String']['input'];
};


export type MutationCancelSupplierOrderArgs = {
  ID: Scalars['Int']['input'];
  Message?: InputMaybe<Scalars['StringInput']['input']>;
  Reason: Scalars['StringInput']['input'];
};


export type MutationCardDismissArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationCardMarkAsViewedArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationClearInspirationGroupThumbnailArgs = {
  InspirationGroupID: Scalars['ID']['input'];
};


export type MutationCloneProfessionalArgs = {
  Options?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCommentMarkAsReadArgs = {
  DocumentID: Scalars['ID']['input'];
};


export type MutationCommentMarkAsUnreadArgs = {
  CommentID?: InputMaybe<Scalars['ID']['input']>;
  DocumentID: Scalars['ID']['input'];
};


export type MutationCommentSubmitArgs = {
  CommentTargetID: Scalars['ID']['input'];
  Files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Mentions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  Message: Scalars['StringInput']['input'];
};


export type MutationCompletePremiumPackResubscribeWithoutPaymentArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type MutationConfirmStripeAccountArgs = {
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationConfirmSupplierOrderArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationConnectStripeAccountArgs = {
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationConversionConfigArchiveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationConversionConfigCreateArgs = {
  categoryID: Scalars['StringInput']['input'];
  eventType: PixelTrackerConversionConfigEventType;
  extraInfo: Scalars['StringInput']['input'];
  funnelID: Scalars['StringInput']['input'];
  professionalID: Scalars['Int']['input'];
  title: Scalars['StringInput']['input'];
};


export type MutationConversionConfigDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationConversionConfigUnarchiveArgs = {
  id: Scalars['Int']['input'];
};


export type MutationConversionConfigUpdateArgs = {
  conversionCategoryID: Scalars['Int']['input'];
  funnelID: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  title: Scalars['StringInput']['input'];
};


export type MutationConversionRuleDeleteArgs = {
  ID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationConversionRuleOrderArgs = {
  ID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  SortOrder: Scalars['Int']['input'];
};


export type MutationConversionRuleToggleArgs = {
  Enabled: Scalars['Boolean']['input'];
  ID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationConversionRuleUpsertArgs = {
  Action: ConversionActionEnum;
  Conversion: ConversionTypeEnum;
  CustomClassification?: InputMaybe<Scalars['StringInput']['input']>;
  ID?: InputMaybe<Scalars['ID']['input']>;
  Pattern: ConversionPatternEnum;
  ProfessionalID: Scalars['ID']['input'];
  Rule: Scalars['StringInput']['input'];
};


export type MutationCopyPinArgs = {
  DestinationBoardID: Scalars['Int']['input'];
  IDs: Array<Scalars['Int']['input']>;
  SourceBoardID: Scalars['Int']['input'];
};


export type MutationCreateAnalyticsCheckoutSessionArgs = {
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateAndUpdateFacetOptionArgs = {
  Input?: InputMaybe<CreateFacetOptionInput>;
};


export type MutationCreateArticleArgs = {
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateAttributeArgs = {
  Name: Scalars['StringInput']['input'];
  ProfessionalURLSegment: Scalars['StringInput']['input'];
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationCreateAttributeAndOptionsArgs = {
  Name: Scalars['StringInput']['input'];
  Options: Array<Scalars['StringInput']['input']>;
  ProfessionalURLSegment: Scalars['StringInput']['input'];
  ReplaceAttributeID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateAttributeOptionArgs = {
  AttributeID: Scalars['Int']['input'];
  Code?: InputMaybe<Scalars['StringInput']['input']>;
  Label: Scalars['StringInput']['input'];
  ProfessionalURLSegment: Scalars['StringInput']['input'];
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateB2BLeadArgs = {
  HubspotContext?: InputMaybe<HubspotContextInput>;
  Input: B2BLeadInput;
};


export type MutationCreateBannerImageArgs = {
  BannerSegment?: InputMaybe<BannerSegmentEnum>;
  File: Scalars['Upload']['input'];
  LibraryItemID: Scalars['Int']['input'];
  NeedsUpscale?: InputMaybe<Scalars['Boolean']['input']>;
  Overlay?: InputMaybe<Scalars['Boolean']['input']>;
  ReplaceExistingBanner?: InputMaybe<Scalars['Boolean']['input']>;
  UnfilteredImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateBuildingGuideCheckoutSessionArgs = {
  Name: Scalars['StringInput']['input'];
};


export type MutationCreateCalendarSessionArgs = {
  input: CreateCalendarSessionInput;
};


export type MutationCreateCompanyArgs = {
  CustomFields?: InputMaybe<Array<CustomFieldInput>>;
  Name: Scalars['StringInput']['input'];
  ProfessionalID: Scalars['ID']['input'];
  Website?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationCreateContactArgs = {
  CustomFields?: InputMaybe<Array<CustomFieldInput>>;
  Email: Scalars['Email']['input'];
  FirstName?: InputMaybe<Scalars['StringInput']['input']>;
  JobTitle?: InputMaybe<Scalars['StringInput']['input']>;
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  Photo?: InputMaybe<Scalars['Upload']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Surname?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationCreateContentBlockArgs = {
  BlogPostID: Scalars['Int']['input'];
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  File?: InputMaybe<Scalars['Upload']['input']>;
  Header?: InputMaybe<Scalars['StringInput']['input']>;
  LibraryImageFileID?: InputMaybe<Scalars['Int']['input']>;
  Type?: InputMaybe<Scalars['StringInput']['input']>;
  VideoURL?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationCreateConversationArgs = {
  Attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  MemberIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  ProfessionalIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  ReplyToID?: InputMaybe<Scalars['Int']['input']>;
  Text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateConversationMessageArgs = {
  Attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  ConversationID: Scalars['Int']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  ReplyToID?: InputMaybe<Scalars['Int']['input']>;
  Text?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateConversionConfigArgs = {
  EventType: PixelTrackerConversionConfigEventType;
  ExtraInfo: Scalars['StringInput']['input'];
  Title: Scalars['StringInput']['input'];
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateDesignBoardArgs = {
  Content: Scalars['StringInput']['input'];
  Public?: InputMaybe<Scalars['Boolean']['input']>;
  Title: Scalars['StringInput']['input'];
};


export type MutationCreateDesignBoardCommentArgs = {
  Content: Scalars['StringInput']['input'];
  DesignBoardID: Scalars['Int']['input'];
};


export type MutationCreateDiagramImagesArgs = {
  Files: Array<InputMaybe<Scalars['Upload']['input']>>;
  LibraryItemID: Scalars['Int']['input'];
};


export type MutationCreateEnquiryArgs = {
  HubspotContext?: InputMaybe<HubspotContextInput>;
  Input: EnquiryInput;
};


export type MutationCreateEnquiryConversationMessageArgs = {
  Input: AddEnquiryConversationMessageInput;
};


export type MutationCreateFacetOptionArgs = {
  FacetID: Scalars['Int']['input'];
  Name: Scalars['StringInput']['input'];
  ProfessionalURLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateItemTopBannerArgs = {
  BannerSegment?: InputMaybe<BannerSegmentEnum>;
  BannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  CoverImageFile?: InputMaybe<Scalars['Upload']['input']>;
  LibraryItemID: Scalars['Int']['input'];
  NeedsUpscale?: InputMaybe<Scalars['Boolean']['input']>;
  Overlay?: InputMaybe<Scalars['Boolean']['input']>;
  ReplaceExistingBanner?: InputMaybe<Scalars['Boolean']['input']>;
  UnfilteredImage?: InputMaybe<Scalars['Boolean']['input']>;
  VideoFile?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationCreateLibraryDownloadArgs = {
  ExternalLink?: InputMaybe<Scalars['StringInput']['input']>;
  FileCategoryID?: InputMaybe<Scalars['Int']['input']>;
  Files?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  Titles?: InputMaybe<Array<InputMaybe<Scalars['StringInput']['input']>>>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateLibraryImageArgs = {
  ContentBlockID?: InputMaybe<Scalars['Int']['input']>;
  Files: Array<InputMaybe<Scalars['Upload']['input']>>;
  IsBanner?: InputMaybe<Scalars['Int']['input']>;
  LibraryItemID: Scalars['Int']['input'];
  LibraryVideoID?: InputMaybe<Scalars['Int']['input']>;
  NeedsUpscale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateLibraryImageMarkerArgs = {
  LibraryImageID: Scalars['Int']['input'];
  PositionX: Scalars['Float']['input'];
  PositionY: Scalars['Float']['input'];
  ProfessionalName?: InputMaybe<Scalars['StringInput']['input']>;
  TargetID?: InputMaybe<Scalars['Int']['input']>;
  TitleForUnknownProduct?: InputMaybe<Scalars['StringInput']['input']>;
  URLForUnknownProduct?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationCreateLibraryLocationArgs = {
  Address1: Scalars['StringInput']['input'];
  Address2?: InputMaybe<Scalars['StringInput']['input']>;
  AllowsDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  AllowsPickup?: InputMaybe<Scalars['Boolean']['input']>;
  City?: InputMaybe<Scalars['StringInput']['input']>;
  Country?: InputMaybe<Scalars['StringInput']['input']>;
  DispatchEstimate?: InputMaybe<MinMaxInput>;
  LocationHidden?: InputMaybe<Scalars['Boolean']['input']>;
  MapCoordinates?: InputMaybe<CoordinateInput>;
  Phone: Scalars['StringInput']['input'];
  PickupEstimate?: InputMaybe<MinMaxInput>;
  PostCode?: InputMaybe<Scalars['StringInput']['input']>;
  Region?: InputMaybe<Scalars['StringInput']['input']>;
  Suburb?: InputMaybe<Scalars['StringInput']['input']>;
  Title: Scalars['StringInput']['input'];
  Type: Scalars['StringInput']['input'];
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateLibraryRangeArgs = {
  Title: Scalars['StringInput']['input'];
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateLibraryTabArgs = {
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  Title: Scalars['StringInput']['input'];
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateLibraryVideoArgs = {
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  URLSegment: Scalars['StringInput']['input'];
  Url: Scalars['StringInput']['input'];
};


export type MutationCreateMemberUploadPinArgs = {
  DesignBoardID: Scalars['Int']['input'];
  File?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationCreateNetworkParticipantArgs = {
  input: CreateNetworkParticipantCreateData;
};


export type MutationCreateOrUpdateMasterVariantArgs = {
  Input?: InputMaybe<VariantInput>;
  ProductID: Scalars['Int']['input'];
};


export type MutationCreateOrderReturnArgs = {
  ReturnItems: Array<OrderReturnItemInput>;
  SupplierOrder: Scalars['Int']['input'];
};


export type MutationCreateOrganizationNetworkArgs = {
  input?: InputMaybe<OrganizationCreateData>;
};


export type MutationCreatePageTemplateArgs = {
  DirectoryType: DirectoryItemEnumType;
  ID?: InputMaybe<Scalars['Int']['input']>;
  Title: Scalars['StringInput']['input'];
};


export type MutationCreatePinArgs = {
  Input: PinInput;
};


export type MutationCreatePinCommentArgs = {
  Content: Scalars['StringInput']['input'];
  PinID: Scalars['Int']['input'];
};


export type MutationCreatePinsArgs = {
  Input: Array<InputMaybe<PinInput>>;
};


export type MutationCreateProductArgs = {
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  PricingType?: InputMaybe<ProductPricingTypeEnum>;
  RangeID?: InputMaybe<Scalars['Int']['input']>;
  RangeText?: InputMaybe<Scalars['StringInput']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateProductSizeArgs = {
  Input: ProductSizeInput;
  ProductID: Scalars['Int']['input'];
};


export type MutationCreateProductSwatchesArgs = {
  Files: Array<InputMaybe<Scalars['Upload']['input']>>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateProductVariantsArgs = {
  ColourImages?: InputMaybe<Array<Scalars['Int']['input']>>;
  Excludes?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  ProductURLSegment: Scalars['StringInput']['input'];
  Sizes?: InputMaybe<Array<Scalars['Int']['input']>>;
  VariantOptions: Array<VariantOptionGroupInput>;
};


export type MutationCreateProfessionalArgs = {
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Title: Scalars['StringInput']['input'];
};


export type MutationCreateProfessionalAwardArgs = {
  AwardDetails: CreateProfessionalAwardInput;
  AwardedEntityLinkList?: InputMaybe<Array<InputMaybe<Scalars['StringInput']['input']>>>;
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationCreateProfessionalServiceAreaArgs = {
  Place: ServiceAreaInput;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateProjectArgs = {
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ProjectHeroTitle?: InputMaybe<Scalars['StringInput']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateQuoteTemplateArgs = {
  ApplicableCountryIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  Description?: InputMaybe<Scalars['StringInput']['input']>;
  ID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalID: Scalars['Int']['input'];
  Thumb?: InputMaybe<Scalars['Upload']['input']>;
  Title: Scalars['StringInput']['input'];
};


export type MutationCreateReminderSettingArgs = {
  Days: Scalars['Int']['input'];
  ProfessionalID: Scalars['Int']['input'];
  Type: Scalars['String']['input'];
};


export type MutationCreateReviewActionArgs = {
  LibraryItemID: Scalars['Int']['input'];
  Task: Scalars['StringInput']['input'];
};


export type MutationCreateSavedModuleArgs = {
  ContentBuilderType?: InputMaybe<ContentBuilderTypeEnum>;
  ModuleID: Scalars['Int']['input'];
  Name: Scalars['String']['input'];
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationCreateSearchTagArgs = {
  LibraryItemID: Scalars['Int']['input'];
  Text: Scalars['StringInput']['input'];
};


export type MutationCreateServiceOfferingArgs = {
  Description?: InputMaybe<Scalars['StringInput']['input']>;
  Photo?: InputMaybe<Scalars['Upload']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Quantity?: InputMaybe<Scalars['Int']['input']>;
  SKU: Scalars['StringInput']['input'];
  Title: Scalars['StringInput']['input'];
  Unit?: InputMaybe<Scalars['StringInput']['input']>;
  UnitPriceAmount?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateShippingMethodArgs = {
  DeliveryEstimate?: InputMaybe<MinMaxInput>;
  Professional: Scalars['StringInput']['input'];
  Title: Scalars['StringInput']['input'];
};


export type MutationCreateShippingProfileArgs = {
  Professional: Scalars['StringInput']['input'];
  Title: Scalars['StringInput']['input'];
};


export type MutationCreateShoppingCartAddressArgs = {
  Address: AddressInput;
  AddressType: AddressTypeEnum;
};


export type MutationCreateShoppingCartOrderArgs = {
  PaymentMethod?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationCreateTeamMemberArgs = {
  Input: TeamMemberInput;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationCreateTeamRoleArgs = {
  Input: CreateTeamRoleInput;
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationCreateTestimonialArgs = {
  Content: Scalars['StringInput']['input'];
  ID?: InputMaybe<Scalars['Int']['input']>;
  Location?: InputMaybe<Scalars['StringInput']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Source?: InputMaybe<Scalars['StringInput']['input']>;
  URLSegment?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationCreateVariantArgs = {
  AttributeOptionIDs: Array<Scalars['Int']['input']>;
  Barcode?: InputMaybe<Scalars['StringInput']['input']>;
  IsOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  Name?: InputMaybe<Scalars['StringInput']['input']>;
  Price?: InputMaybe<Scalars['Int']['input']>;
  ProductURLSegment: Scalars['StringInput']['input'];
  SKU?: InputMaybe<Scalars['StringInput']['input']>;
  SaleFinish?: InputMaybe<Scalars['StringInput']['input']>;
  SalePrice?: InputMaybe<Scalars['Int']['input']>;
  SaleStart?: InputMaybe<Scalars['StringInput']['input']>;
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  TradePrice?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateVariantImageArgs = {
  Files: Array<InputMaybe<Scalars['Upload']['input']>>;
  VariantID: Scalars['Int']['input'];
};


export type MutationDeleteArticleArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteAttributeOptionArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteBusinessTermsByIdArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteBusinessTermsCategoryArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeleteCalendarSessionArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteCommentArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteCompanyArgs = {
  CompanyID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationDeleteContactArgs = {
  Email: Scalars['Email']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationDeleteContentBlockArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteConversionConfigArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeleteDesignBoardArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteDirectoryItemArgs = {
  DirectoryItemID: Scalars['Int']['input'];
};


export type MutationDeleteEmailTemplateByIdArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteEmailTemplateInputConfigArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeleteInvoiceLogNoteArgs = {
  InvoiceLogID: Scalars['Int']['input'];
};


export type MutationDeleteLibraryDownloadArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteLibraryImageArgs = {
  LibraryImageID: Scalars['Int']['input'];
};


export type MutationDeleteLibraryImageMarkerArgs = {
  LibraryImageMarkerID: Scalars['Int']['input'];
};


export type MutationDeleteLibraryImagesArgs = {
  ImageIds: Array<Scalars['Int']['input']>;
};


export type MutationDeleteLibraryLocationArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteLibraryRangeArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteLibraryTabArgs = {
  ID: Scalars['Int']['input'];
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationDeleteLibraryVideoArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteLibraryVideoThumbnailArgs = {
  LibraryVideoID: Scalars['Int']['input'];
};


export type MutationDeleteMessageArgs = {
  MessageID: Scalars['Int']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteModuleArgs = {
  ID: Scalars['Int']['input'];
  ParentClass: Scalars['String']['input'];
  ParentID: Scalars['Int']['input'];
};


export type MutationDeleteModuleColumnArgs = {
  ColumnID: Scalars['Int']['input'];
  ModuleID: Scalars['Int']['input'];
  ParentClass: Scalars['String']['input'];
  ParentID: Scalars['Int']['input'];
};


export type MutationDeletePinArgs = {
  IDs: Array<Scalars['Int']['input']>;
};


export type MutationDeletePinsByPageArgs = {
  BoardID?: InputMaybe<Scalars['Int']['input']>;
  LibraryItemIDs: Array<Scalars['Int']['input']>;
};


export type MutationDeleteProductSwatchArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteProfessionalAwardArgs = {
  AwardID: Scalars['Int']['input'];
};


export type MutationDeleteProfessionalAwardBadgeArgs = {
  AwardID: Scalars['Int']['input'];
  BadgeID: Scalars['Int']['input'];
};


export type MutationDeleteProfessionalCompanyFieldArgs = {
  FieldID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationDeleteProfessionalContactFieldArgs = {
  FieldID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationDeleteProfessionalServiceAreaArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteProjectArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteQuoteContentByIdArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteQuotePaymentArgs = {
  IsTemplate: Scalars['Boolean']['input'];
  PaymentID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
};


export type MutationDeleteQuoteServiceItemArgs = {
  IsTemplate: Scalars['Boolean']['input'];
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
  ServiceID: Scalars['ID']['input'];
};


export type MutationDeleteReminderSettingArgs = {
  ProfessionalID: Scalars['Int']['input'];
  ReminderSettingID: Scalars['Int']['input'];
};


export type MutationDeleteReviewActionArgs = {
  ReviewActionID: Scalars['Int']['input'];
};


export type MutationDeleteSavedModuleArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteSearchTagArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteServiceOfferingArgs = {
  ProfessionalID: Scalars['ID']['input'];
  SKU: Scalars['StringInput']['input'];
};


export type MutationDeleteShippingMethodArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteShippingProfileArgs = {
  ShippingProfileID: Scalars['Int']['input'];
};


export type MutationDeleteShippingRateArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteSupplierOrderNoteArgs = {
  OrderEventID: Scalars['Int']['input'];
};


export type MutationDeleteTeamMemberArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteTeamRoleArgs = {
  RoleID: Scalars['Int']['input'];
};


export type MutationDeleteTestimonialArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteUnusedOptionsArgs = {
  AttributeID: Scalars['Int']['input'];
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type MutationDeleteVariantArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationDeleteVariantImageArgs = {
  VariantImageID: Scalars['Int']['input'];
};


export type MutationDeleteVariantsArgs = {
  IDs: Array<Scalars['Int']['input']>;
};


export type MutationDetachBillingPaymentMethodArgs = {
  PaymentMethodID: Scalars['String']['input'];
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationDirectoryItemBulkUpdateVisibilityArgs = {
  inLibrary: Scalars['Boolean']['input'];
  pageIds: Array<Scalars['Int']['input']>;
  professionalId: Scalars['Int']['input'];
  type: DirectoryItemEnumType;
};


export type MutationDisconnectCalendarArgs = {
  provider: Scalars['String']['input'];
};


export type MutationDispatchSupplierOrderArgs = {
  Courier?: InputMaybe<Scalars['Int']['input']>;
  OrderItems: Array<Scalars['Int']['input']>;
  ShippingProvider?: InputMaybe<Scalars['StringInput']['input']>;
  SupplierOrder: Scalars['Int']['input'];
  TrackingCode?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationEmailAssetRenameArgs = {
  LibraryImageID: Scalars['ID']['input'];
  Title: Scalars['StringInput']['input'];
};


export type MutationEmailAssetUploadArgs = {
  ProfessionalID: Scalars['ID']['input'];
  Uploads: Array<Scalars['Upload']['input']>;
};


export type MutationEmailDataBindingUpdateArgs = {
  EmailTemplateID: Scalars['ID']['input'];
  SourceClass: Scalars['String']['input'];
  SourceID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationFollowDesignBoardArgs = {
  DesignBoardID: Scalars['ID']['input'];
};


export type MutationFollowInspirationGroupArgs = {
  InspirationGroupID: Scalars['ID']['input'];
};


export type MutationImageAcceptArgs = {
  fileKey: Scalars['String']['input'];
  keepReposition?: InputMaybe<Scalars['Boolean']['input']>;
  libraryImageID: Scalars['Int']['input'];
};


export type MutationImageCenterArgs = {
  libraryImageID: Scalars['Int']['input'];
};


export type MutationImageRemoveBackgroundArgs = {
  libraryImageID: Scalars['Int']['input'];
};


export type MutationImageRevertArgs = {
  libraryImageID: Scalars['Int']['input'];
  originalImageUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImageUpscaleArgs = {
  libraryImageID: Scalars['Int']['input'];
};


export type MutationInstantPurchaseArgs = {
  Data: Scalars['StringInput']['input'];
  PickupLocation?: InputMaybe<Scalars['Int']['input']>;
  Quantity: Scalars['Int']['input'];
  ShippingMethod?: InputMaybe<Scalars['Int']['input']>;
  TotalCheck: Scalars['Int']['input'];
  Variant: Scalars['Int']['input'];
};


export type MutationInviteCollaboratorsArgs = {
  CanEdit: Scalars['Boolean']['input'];
  DesignBoardID: Scalars['ID']['input'];
  Emails: Scalars['StringInput']['input'];
  Message?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationInviteTeamMemberArgs = {
  BypassEmail?: InputMaybe<Scalars['Boolean']['input']>;
  Email: Scalars['Email']['input'];
  Message?: InputMaybe<Scalars['StringInput']['input']>;
  Name: Scalars['StringInput']['input'];
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  Position?: InputMaybe<Scalars['StringInput']['input']>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationInviteTeamMembersArgs = {
  EmailAndNames: Array<TeamMemberInput>;
  Message?: InputMaybe<Scalars['StringInput']['input']>;
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationInviteToGroupChatArgs = {
  AddMemberIDs: Array<Scalars['Int']['input']>;
  MigrateMessagesFrom?: InputMaybe<Scalars['Int']['input']>;
  SourceConversationID: Scalars['Int']['input'];
};


export type MutationInvoicePaymentConfirmAfterStripeArgs = {
  IntentType: Scalars['String']['input'];
  InvoicePaymentId: Scalars['Int']['input'];
  ProposalUrlSegment: Scalars['String']['input'];
  StripeIntentId: Scalars['String']['input'];
};


export type MutationInvoicePaymentFailProposalStripeAttemptArgs = {
  FailureReason?: InputMaybe<Scalars['String']['input']>;
  InvoicePaymentId: Scalars['Int']['input'];
  StripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInvoicePaymentPendingProposalStripeAttemptArgs = {
  InvoicePaymentId: Scalars['Int']['input'];
  StripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInvoicePaymentSetProcessingPaymentArgs = {
  InvoicePaymentId: Scalars['Int']['input'];
};


export type MutationInvoicePaymentUpdateStatusArgs = {
  Amount?: InputMaybe<Scalars['Float']['input']>;
  IsTemplate: Scalars['Boolean']['input'];
  Notes?: InputMaybe<Scalars['String']['input']>;
  PaymentID: Scalars['ID']['input'];
  PaymentMethod?: InputMaybe<Scalars['String']['input']>;
  PaymentTransactionID: Scalars['String']['input'];
  ProfessionalID: Scalars['ID']['input'];
  Status: Scalars['String']['input'];
};


export type MutationLeadExportCreateArgs = {
  input: LeadExportInput;
};


export type MutationLeaveDesignBoardArgs = {
  DesignBoardID: Scalars['ID']['input'];
};


export type MutationLinkLibraryItemArgs = {
  ChildID: Scalars['Int']['input'];
  ParentID: Scalars['Int']['input'];
  Relationship: LibraryItemRelationshipEnumType;
};


export type MutationLogErrorArgs = {
  Error: Scalars['StringInput']['input'];
  JsUrl?: InputMaybe<Scalars['StringInput']['input']>;
  PageUrl?: InputMaybe<Scalars['StringInput']['input']>;
  StackTrace: Scalars['StringInput']['input'];
  UserAgent?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationLogProposalViewArgs = {
  InvoiceID: Scalars['Int']['input'];
};


export type MutationLoginArgs = {
  Input: LoginInput;
};


export type MutationMarkConversationReadArgs = {
  ConversationID: Scalars['Int']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMarkConversationUnreadArgs = {
  ConversationID: Scalars['Int']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMarkWebsiteNotificationsAsReadArgs = {
  IDS?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationMemberReadRecordSetArgs = {
  Group: Scalars['String']['input'];
  Name: Scalars['String']['input'];
  hasRead: Scalars['Boolean']['input'];
};


export type MutationMergeInvoicePaymentsArgs = {
  IsTemplate: Scalars['Boolean']['input'];
  PaymentIDs: Array<Scalars['ID']['input']>;
  PrimaryPaymentID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
};


export type MutationMfaConfirmLoginArgs = {
  Input?: InputMaybe<MfaConfirmLoginInput>;
};


export type MutationMfaConfirmSetupArgs = {
  Input?: InputMaybe<MfaConfirmSetupInput>;
};


export type MutationMfaDisableSetupArgs = {
  Input?: InputMaybe<MfaDisableSetupInput>;
};


export type MutationMfaPasswordResetArgs = {
  Input?: InputMaybe<MfaPasswordResetInput>;
};


export type MutationMfaRequestArgs = {
  Input?: InputMaybe<MfaRequestInput>;
};


export type MutationMfaSetupArgs = {
  Input?: InputMaybe<MfaSetupInput>;
};


export type MutationModuleSwitchArgs = {
  ModuleID: Scalars['Int']['input'];
  ParentClass: Scalars['String']['input'];
  ParentID: Scalars['Int']['input'];
  PresetID: Scalars['Int']['input'];
};


export type MutationMoodBoardPinUploadArgs = {
  BoardID: Scalars['ID']['input'];
  BuildHubID: Scalars['ID']['input'];
  File: Scalars['Upload']['input'];
};


export type MutationMoodBoardPinsAddArgs = {
  BoardID: Scalars['ID']['input'];
  Pins: Array<InputMaybe<PinInput>>;
};


export type MutationMoodBoardPinsCopyArgs = {
  BuildHubUrl: Scalars['String']['input'];
  FromBoardID: Scalars['Int']['input'];
  Pins: Array<Scalars['String']['input']>;
  ToBoardID: Scalars['Int']['input'];
};


export type MutationMoodBoardPinsMoveArgs = {
  BuildHubUrl: Scalars['String']['input'];
  FromBoardID: Scalars['Int']['input'];
  Pins: Array<Scalars['String']['input']>;
  ToBoardID: Scalars['Int']['input'];
};


export type MutationMoodBoardPinsRemoveArgs = {
  BoardID: Scalars['ID']['input'];
  Pins: Array<Scalars['ID']['input']>;
};


export type MutationMoodBoardPinsRemoveByPageArgs = {
  BoardID: Scalars['ID']['input'];
  LibraryItemIDs: Array<Scalars['ID']['input']>;
};


export type MutationMovePinArgs = {
  DestinationBoardID: Scalars['Int']['input'];
  IDs: Array<Scalars['Int']['input']>;
  SourceBoardID: Scalars['Int']['input'];
};


export type MutationMoveTeamMemberToRoleArgs = {
  CurrentRoleID?: InputMaybe<Scalars['Int']['input']>;
  Members?: InputMaybe<Array<MoveTeamMemberToRoleInput>>;
  ProfessionalID: Scalars['Int']['input'];
  TargetRoleID?: InputMaybe<Scalars['Int']['input']>;
  TeamMemberID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMuteConversationArgs = {
  ConversationID: Scalars['Int']['input'];
  IsMuted: Scalars['Boolean']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationPageBulkCloneArgs = {
  CountryCode: SupportedCountry;
  PageIDs: Array<Scalars['Int']['input']>;
  PageType: Scalars['String']['input'];
};


export type MutationPageCloneArgs = {
  ID: Scalars['Int']['input'];
  PageType: Scalars['String']['input'];
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationPageUrlSegmentUpdateArgs = {
  PageID: Scalars['Int']['input'];
  PageType: Scalars['String']['input'];
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationPayPremiumFeatureStripeInvoiceArgs = {
  PaymentMethodID?: InputMaybe<Scalars['String']['input']>;
  ProfessionalURLSegment: Scalars['String']['input'];
  StripeInvoiceID: Scalars['String']['input'];
};


export type MutationPaySubscriptionPackLinkedInvoiceArgs = {
  InvoicePaymentID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalURLSegment: Scalars['String']['input'];
  SubscriptionPackID: Scalars['Int']['input'];
};


export type MutationPaymentIntentCreateArgs = {
  InvoicePaymentID: Scalars['ID']['input'];
};


export type MutationProcessOrderDeclineArgs = {
  DeclineItems: Array<OrderDeclineItemInput>;
  DeclineReason?: InputMaybe<Scalars['StringInput']['input']>;
  SupplierOrder: Scalars['Int']['input'];
};


export type MutationProcessOrderReturnArgs = {
  ReturnItems: Array<OrderReturnItemInput>;
  ReturnReason?: InputMaybe<Scalars['StringInput']['input']>;
  ShippingRefund: Scalars['Int']['input'];
  SupplierOrder: Scalars['Int']['input'];
};


export type MutationProcessPaymentResponseArgs = {
  Data: Scalars['StringInput']['input'];
};


export type MutationProcessProductImportArgs = {
  DataSource?: InputMaybe<IntegratedPlatformEnum>;
  Overwrite?: InputMaybe<Scalars['Boolean']['input']>;
  Product: ImportProduct;
  Professional: Scalars['String']['input'];
};


export type MutationProcessReminderArgs = {
  EntityID: Scalars['Int']['input'];
  Hash: Scalars['String']['input'];
  Sequence: Scalars['Int']['input'];
  Type: Scalars['String']['input'];
};


export type MutationProcessScanArgs = {
  ScannerContext: ScannerContextInput;
  Token: Scalars['String']['input'];
};


export type MutationProductRestoreArgs = {
  products?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationProjectInspirationGroupCloneArgs = {
  BuildHubID: Scalars['ID']['input'];
  InspirationGroupID: Scalars['ID']['input'];
  ParentID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectInspirationGroupRemoveArgs = {
  BuildHubID: Scalars['ID']['input'];
  InspirationGroupID: Scalars['ID']['input'];
};


export type MutationProjectInspirationGroupRemoveBySourceArgs = {
  BuildHubID: Scalars['ID']['input'];
  IdeaBookID: Scalars['ID']['input'];
};


export type MutationProjectInspirationGroupUpsertArgs = {
  BuildHubID: Scalars['ID']['input'];
  Description?: InputMaybe<Scalars['StringInput']['input']>;
  GeneralAccessMode?: InputMaybe<Scalars['String']['input']>;
  GeneralAccessRole?: InputMaybe<Scalars['String']['input']>;
  InheritPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  InspirationGroupID?: InputMaybe<Scalars['ID']['input']>;
  ParentID?: InputMaybe<Scalars['Int']['input']>;
  Private?: InputMaybe<Scalars['Boolean']['input']>;
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationProjectInspirationIdeaBookMigrateArgs = {
  BuildHubID: Scalars['ID']['input'];
  IdeaBookID: Scalars['ID']['input'];
  ParentID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectInspirationItemImportUrlArgs = {
  BuildHubID: Scalars['ID']['input'];
  InspirationGroupID: Scalars['ID']['input'];
  URL: Scalars['String']['input'];
};


export type MutationProjectInspirationItemUpdateArgs = {
  Description?: InputMaybe<Scalars['StringInput']['input']>;
  InspirationItemID: Scalars['ID']['input'];
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationProjectTeamMemberCreateArgs = {
  Category: Scalars['String']['input'];
  ProjectID: Scalars['ID']['input'];
  TeamMemberID: Scalars['ID']['input'];
};


export type MutationProjectTeamMemberDeleteArgs = {
  Category: Scalars['String']['input'];
  ProjectID: Scalars['ID']['input'];
  TeamMemberID: Scalars['ID']['input'];
};


export type MutationPublishBusinessTermsArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationQuoteAcceptOrDeclineArgs = {
  Decision: QuoteDecisionEnum;
  Email?: InputMaybe<Scalars['Email']['input']>;
  FullName?: InputMaybe<Scalars['StringInput']['input']>;
  SignatureDataUrl?: InputMaybe<Scalars['StringInput']['input']>;
  UrlSegment: Scalars['StringInput']['input'];
};


export type MutationRearrangeSortOrdersArgs = {
  ItemType: SortableItemEnum;
  Items?: InputMaybe<Array<RearrangeItems>>;
  PageNumber: Scalars['Int']['input'];
  PageSize: Scalars['Int']['input'];
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationRecordBuildHubViewArgs = {
  BuildHubID: Scalars['ID']['input'];
};


export type MutationRefreshStaleExternalUrlPinsArgs = {
  BoardID: Scalars['ID']['input'];
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRegisterExpoPushDeviceArgs = {
  Devices: Array<PushDeviceInfo>;
};


export type MutationRegisterForNewsLetterArgs = {
  Email: Scalars['Email']['input'];
};


export type MutationRegistrantClaimGuestTicketArgs = {
  Email: Scalars['String']['input'];
  FirstName?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  SubmissionID: Scalars['ID']['input'];
};


export type MutationRegistrantIssueGuestTicketArgs = {
  Email: Scalars['String']['input'];
  FirstName?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  SubmissionID: Scalars['ID']['input'];
};


export type MutationRegistrantRevokeGuestTicketArgs = {
  SubmissionID: Scalars['ID']['input'];
  TicketID: Scalars['ID']['input'];
};


export type MutationRemoveBillingRecipientArgs = {
  ProfessionalID: Scalars['Int']['input'];
  TeamMemberID: Scalars['Int']['input'];
};


export type MutationRemoveCollaboratorArgs = {
  DesignBoardID: Scalars['ID']['input'];
  Email: Scalars['Email']['input'];
  HasAccepted: Scalars['Boolean']['input'];
};


export type MutationRemoveFollowerArgs = {
  InspirationGroupID: Scalars['ID']['input'];
  MemberID: Scalars['ID']['input'];
};


export type MutationRemoveNetworkParticipantArgs = {
  input: RemoveNetworkParticipantCreateData;
};


export type MutationRemovePermissionArgs = {
  Permission: PermissionGroupEnum;
  Resource: PermissionResource;
};


export type MutationRemovePremiumFeatureFromCartArgs = {
  PremiumFeatureSKU: Scalars['String']['input'];
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type MutationRemoveProductFacetOptionArgs = {
  Input?: InputMaybe<RemoveFacetOptionInput>;
};


export type MutationRemoveReactionArgs = {
  DocumentID: Scalars['ID']['input'];
  Reaction: ReactionTypeEnum;
};


export type MutationRemoveTeamMemberFromRoleArgs = {
  ProfessionalID: Scalars['Int']['input'];
  RoleID: Scalars['Int']['input'];
  TeamMemberID: Scalars['Int']['input'];
};


export type MutationRenameSavedModuleArgs = {
  ID: Scalars['Int']['input'];
  Name: Scalars['String']['input'];
};


export type MutationReorderQuoteServiceItemArgs = {
  IsTemplate: Scalars['Boolean']['input'];
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
  ServiceID: Scalars['ID']['input'];
  SortOrder: Scalars['Int']['input'];
};


export type MutationReorderTeamRoleArgs = {
  RoleID: Scalars['Int']['input'];
  SortOrder: Scalars['Int']['input'];
};


export type MutationReportDirectoryItemArgs = {
  Link: Scalars['String']['input'];
  ModerationReasonID: Scalars['Int']['input'];
  Note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReportUserArgs = {
  Metadata?: InputMaybe<Scalars['String']['input']>;
  ModerationReasonID: Scalars['Int']['input'];
  Note?: InputMaybe<Scalars['String']['input']>;
  UserID: Scalars['Int']['input'];
};


export type MutationRequestAccountDeletionArgs = {
  ReasonID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRequestDownloadAccessArgs = {
  LibraryItemID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationResendCollaboratorInviteArgs = {
  DesignBoardID: Scalars['ID']['input'];
  Email: Scalars['Email']['input'];
};


export type MutationResendTeamMemberInvitationArgs = {
  ID: Scalars['Int']['input'];
  NotificationField?: InputMaybe<Scalars['String']['input']>;
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationResetModuleColumnArgs = {
  ColumnID: Scalars['Int']['input'];
  ModuleID: Scalars['Int']['input'];
};


export type MutationResetOrderNotificationArgs = {
  OrderNumber: Scalars['String']['input'];
};


export type MutationReuseVariantImageArgs = {
  VariantID: Scalars['Int']['input'];
  VariantImageID: Scalars['Int']['input'];
};


export type MutationRevealContactDetailsArgs = {
  ParticipantID: Scalars['Int']['input'];
};


export type MutationReviewPageArgs = {
  Approved: Scalars['Boolean']['input'];
  LibraryItemID: Scalars['Int']['input'];
};


export type MutationRevokeTeamMemberPermissionArgs = {
  Action: InvoicePermissionActionEnum;
  ProfessionalID: Scalars['Int']['input'];
  TeamMemberID: Scalars['Int']['input'];
};


export type MutationSaveAndInviteTeamMemberArgs = {
  Email?: InputMaybe<Scalars['Email']['input']>;
  ID?: InputMaybe<Scalars['Int']['input']>;
  Image?: InputMaybe<Scalars['Upload']['input']>;
  JobTitle?: InputMaybe<Scalars['StringInput']['input']>;
  LinkedInLink?: InputMaybe<Scalars['StringInput']['input']>;
  Name: Scalars['StringInput']['input'];
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationSaveImportMapArgs = {
  Fields?: InputMaybe<Array<InputMaybe<ImportMapFieldInput>>>;
  Professional: Scalars['String']['input'];
};


export type MutationSaveReactionArgs = {
  DocumentID: Scalars['ID']['input'];
  Reaction: ReactionTypeEnum;
  UniqueReaction?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendBadgeCodeArgs = {
  Email: Scalars['Email']['input'];
  Message: Scalars['StringInput']['input'];
  ProfessionalID: Scalars['Int']['input'];
  ReceiverName?: InputMaybe<Scalars['StringInput']['input']>;
  SenderName?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationSendEmailTemplateArgs = {
  BCC?: InputMaybe<Scalars['StringInput']['input']>;
  EmailTemplateID: Scalars['ID']['input'];
  ReplyTo?: InputMaybe<Scalars['Email']['input']>;
  To: Scalars['Email']['input'];
  ToFirstName: Scalars['StringInput']['input'];
  ToSurname: Scalars['StringInput']['input'];
};


export type MutationSendHdeExhibitorBrochureEmailArgs = {
  EventID: Scalars['Int']['input'];
  ProfessionalID: Scalars['Int']['input'];
  TargetEmail: Scalars['Email']['input'];
};


export type MutationSendHubspotMarketingPreferencesEmailArgs = {
  input: SendHubspotMarketingPreferencesEmailInputType;
};


export type MutationSendPixelCodeArgs = {
  Email: Scalars['Email']['input'];
  Message: Scalars['StringInput']['input'];
  ProfessionalID: Scalars['Int']['input'];
  ReceiverName?: InputMaybe<Scalars['StringInput']['input']>;
  RecordStartedAt?: InputMaybe<Scalars['StringInput']['input']>;
  RecordStoppedAt?: InputMaybe<Scalars['StringInput']['input']>;
  SenderName?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationSendPushNotificationArgs = {
  Message: Scalars['StringInput']['input'];
  Recipients: Array<PushNotificationRecipient>;
  Title: Scalars['StringInput']['input'];
};


export type MutationSendQuoteArgs = {
  ProfessionalID: Scalars['ID']['input'];
  QuoteContentID: Scalars['ID']['input'];
  To?: InputMaybe<Scalars['Email']['input']>;
  ToFirstName?: InputMaybe<Scalars['StringInput']['input']>;
  ToSurname?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationSendQuoteExternallyArgs = {
  ProfessionalID: Scalars['ID']['input'];
  QuoteContentID: Scalars['ID']['input'];
};


export type MutationSetBillingDefaultPaymentMethodArgs = {
  PaymentMethodID: Scalars['String']['input'];
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationSetBoardCommentsAsReadArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationSetInspirationGroupThumbnailArgs = {
  InspirationGroupID: Scalars['ID']['input'];
  InspirationItemID: Scalars['ID']['input'];
};


export type MutationSetInvoiceAutoBillArgs = {
  Enable: Scalars['Boolean']['input'];
  QuoteID: Scalars['ID']['input'];
};


export type MutationSetItemBannerFromImageArgs = {
  LibraryImageID: Scalars['Int']['input'];
  LibraryItemID: Scalars['Int']['input'];
};


export type MutationSetLibraryItemCategoriesArgs = {
  CategoryIDs: Array<InputMaybe<Scalars['Int']['input']>>;
  DirectoryItemType?: InputMaybe<DirectoryItemEnumType>;
  LibraryItemID: Scalars['Int']['input'];
};


export type MutationSetLibraryRangeArgs = {
  ID: Scalars['Int']['input'];
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationSetLibraryThumbArgs = {
  LibraryImageFileID: Scalars['Int']['input'];
  LibraryItemID: Scalars['Int']['input'];
};


export type MutationSetPinCommentsAsReadArgs = {
  ID: Scalars['Int']['input'];
};


export type MutationSetPremiumFeatureCartQtyArgs = {
  PremiumFeatureSKU: Scalars['String']['input'];
  ProfessionalURLSegment: Scalars['String']['input'];
  Qty: Scalars['Int']['input'];
};


export type MutationSetProjectRolesArgs = {
  CategoryIDs: Array<InputMaybe<Scalars['Int']['input']>>;
  DirectoryItemID: Scalars['Int']['input'];
};


export type MutationSetProjectTeamOrderArgs = {
  ProjectID: Scalars['Int']['input'];
  TeamMemberIDs: Array<Scalars['Int']['input']>;
};


export type MutationSetQuoteContactArgs = {
  ContactID: Scalars['ID']['input'];
  IsTemplate: Scalars['Boolean']['input'];
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
};


export type MutationSetShippingRatesArgs = {
  ShippingProfileID: Scalars['Int']['input'];
  ShippingRates: Array<ShippingRateInput>;
};


export type MutationSetShoppingCartAddressArgs = {
  AddressID: Scalars['Int']['input'];
  AddressType: AddressTypeEnum;
};


export type MutationSetupIntentCreateArgs = {
  ContactID: Scalars['ID']['input'];
  InvoicePaymentID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetupSplitPaymentsArgs = {
  DueDayOfMonth: Scalars['Int']['input'];
  NumberOfPayments: Scalars['Int']['input'];
  ProfessionalID: Scalars['ID']['input'];
  QuoteContentID: Scalars['ID']['input'];
};


export type MutationShareEnquiryConversationArgs = {
  Input?: InputMaybe<ShareEnquiryConversationInput>;
};


export type MutationShareItemArgs = {
  ItemID: Scalars['Int']['input'];
  ItemType: ShareItemType;
  Message?: InputMaybe<Scalars['StringInput']['input']>;
  ShareType: ShareType;
  To?: InputMaybe<Array<Scalars['StringInput']['input']>>;
};


export type MutationSocialLoginArgs = {
  Input: SocialLoginInput;
};


export type MutationSoftDeleteSubscriptionPackArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
  SubscriptionPackID: Scalars['Int']['input'];
};


export type MutationSortContentBlocksArgs = {
  BlogPostID: Scalars['Int']['input'];
  ContentBlockIDs: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MutationSplitInvoicePaymentArgs = {
  IsTemplate: Scalars['Boolean']['input'];
  PaymentID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
  SplitAmount: Scalars['Float']['input'];
};


export type MutationSubmitAceFormArgs = {
  Input: AceFormInput;
};


export type MutationSubmitAdvertisingFormArgs = {
  Input: AdvertisingFormInput;
};


export type MutationSubscribePremiumFeaturePurchaseArgs = {
  PremiumFeatureSKU: Scalars['String']['input'];
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type MutationSwapModuleLibraryImagesArgs = {
  ParentClass: Scalars['String']['input'];
  ParentID: Scalars['Int']['input'];
  SourceColumnID: Scalars['Int']['input'];
  SourceModuleID: Scalars['Int']['input'];
  TargetColumnID: Scalars['Int']['input'];
  TargetModuleID: Scalars['Int']['input'];
};


export type MutationSyncAnalyticsSubscriptionArgs = {
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationSyncSavedModuleArgs = {
  ModuleID: Scalars['Int']['input'];
};


export type MutationToggleReminderSettingArgs = {
  Enabled: Scalars['Boolean']['input'];
  ProfessionalID: Scalars['Int']['input'];
  ReminderSettingID: Scalars['Int']['input'];
};


export type MutationUnfollowInspirationGroupArgs = {
  InspirationGroupID: Scalars['ID']['input'];
};


export type MutationUnlinkLibraryItemArgs = {
  ChildID: Scalars['Int']['input'];
  ParentID: Scalars['Int']['input'];
  Relationship: LibraryItemRelationshipEnumType;
};


export type MutationUnregisterExpoPushDeviceArgs = {
  DeviceID: Scalars['String']['input'];
};


export type MutationUnsetLibraryRangeArgs = {
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationUnsetVariantOptionsArgs = {
  Options: Array<Scalars['Int']['input']>;
  VariantID: Scalars['Int']['input'];
};


export type MutationUnsetVariantSizeArgs = {
  VariantID: Scalars['Int']['input'];
};


export type MutationUnsubscribePremiumFeaturePurchaseArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
  PurchasedAddOnID: Scalars['Int']['input'];
};


export type MutationUpdateAnalyticsSubscriptionArgs = {
  Cancel: Scalars['Boolean']['input'];
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationUpdateArticleArgs = {
  Activated?: InputMaybe<Scalars['Boolean']['input']>;
  AuthorID?: InputMaybe<Scalars['Int']['input']>;
  BulkPhotoCreditID?: InputMaybe<Scalars['Int']['input']>;
  ByArchipro?: InputMaybe<Scalars['Boolean']['input']>;
  CategoryIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  DirectoryItemID: Scalars['Int']['input'];
  InLibrary?: InputMaybe<Scalars['Boolean']['input']>;
  IntroText?: InputMaybe<Scalars['StringInput']['input']>;
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  Publish?: InputMaybe<Scalars['Boolean']['input']>;
  PublishDate?: InputMaybe<Scalars['StringInput']['input']>;
  SelfPublished?: InputMaybe<Scalars['Boolean']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateAttributeOptionArgs = {
  Code?: InputMaybe<Scalars['StringInput']['input']>;
  ID: Scalars['Int']['input'];
  Label?: InputMaybe<Scalars['StringInput']['input']>;
  Name?: InputMaybe<Scalars['StringInput']['input']>;
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateAttributeOptionSortOrdersArgs = {
  Input: Array<SortOrderInput>;
  ProductID: Scalars['Int']['input'];
};


export type MutationUpdateBillingRecipientTagArgs = {
  ProfessionalID: Scalars['Int']['input'];
  Tag: BillingRecipientTag;
  TeamMemberID: Scalars['Int']['input'];
};


export type MutationUpdateBuildHubTimelineSettingsArgs = {
  BuildHubID: Scalars['ID']['input'];
  HighlightNonWorkingDays?: InputMaybe<Scalars['Boolean']['input']>;
  ShowGridLines?: InputMaybe<Scalars['Boolean']['input']>;
  ShowMinorGridLines?: InputMaybe<Scalars['Boolean']['input']>;
  ShowNonWorkingDays?: InputMaybe<Scalars['Boolean']['input']>;
  ViewMode?: InputMaybe<Scalars['StringInput']['input']>;
  WorkingDays?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBusinessTermsDataBindingArgs = {
  BusinessTermsID: Scalars['ID']['input'];
  SourceClass: Scalars['String']['input'];
  SourceID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateCalendarSessionArgs = {
  ID: Scalars['Int']['input'];
  input: UpdateCalendarSessionInput;
};


export type MutationUpdateCollaboratorPermissionArgs = {
  CanEdit: Scalars['Boolean']['input'];
  DesignBoardID: Scalars['ID']['input'];
  Email: Scalars['Email']['input'];
  HasAccepted: Scalars['Boolean']['input'];
};


export type MutationUpdateCompanyArgs = {
  CompanyID: Scalars['ID']['input'];
  CustomFields?: InputMaybe<Array<CustomFieldInput>>;
  Name?: InputMaybe<Scalars['StringInput']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Website?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateContactArgs = {
  CustomFields?: InputMaybe<Array<CustomFieldInput>>;
  Email: Scalars['Email']['input'];
  FirstName?: InputMaybe<Scalars['StringInput']['input']>;
  JobTitle?: InputMaybe<Scalars['StringInput']['input']>;
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  Photo?: InputMaybe<Scalars['Upload']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Surname?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateContactInternalNoteArgs = {
  ContactID: Scalars['ID']['input'];
  InternalNote?: InputMaybe<Scalars['StringInput']['input']>;
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationUpdateContactLeadStatusArgs = {
  ContactID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  Status: LeadStatusEnum;
};


export type MutationUpdateContactPhotoArgs = {
  ContactID: Scalars['ID']['input'];
  Photo?: InputMaybe<Scalars['Upload']['input']>;
  ProfessionalID: Scalars['ID']['input'];
};


export type MutationUpdateContentBlockArgs = {
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  Header?: InputMaybe<Scalars['StringInput']['input']>;
  ID: Scalars['Int']['input'];
  Type?: InputMaybe<Scalars['StringInput']['input']>;
  VideoURL?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateConversationArgs = {
  BuildHubID?: InputMaybe<Scalars['Int']['input']>;
  ConversationID: Scalars['Int']['input'];
  Name?: InputMaybe<Scalars['String']['input']>;
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateConversationParticipantsArgs = {
  AddMemberIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  ConversationID: Scalars['Int']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  RemoveMemberIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  RemoveParticipantIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationUpdateConversationSettingsArgs = {
  AllowMessageRequests?: InputMaybe<Scalars['Boolean']['input']>;
  NotificationSoundEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateConversationThumbnailArgs = {
  ConversationID: Scalars['Int']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  Thumbnail?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationUpdateConversionConfigArgs = {
  ID: Scalars['ID']['input'];
  Title: Scalars['StringInput']['input'];
};


export type MutationUpdateDesignBoardArgs = {
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  DesignBoardID: Scalars['Int']['input'];
  Public?: InputMaybe<Scalars['Boolean']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateDesignBoardSettingArgs = {
  EnquiryReminderEmailEnabled: Scalars['Boolean']['input'];
  NotifyAllEnabled: Scalars['Boolean']['input'];
  WeeklyEmailEnabled: Scalars['Boolean']['input'];
};


export type MutationUpdateFeatureBookingArgs = {
  ID: Scalars['Int']['input'];
  ScrollPosY: Scalars['Int']['input'];
};


export type MutationUpdateFlexibleModuleArgs = {
  Columns?: InputMaybe<Array<ModuleColumnInput>>;
  ID?: InputMaybe<Scalars['Int']['input']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']['input']>;
  ParentClass: Scalars['String']['input'];
  ParentID: Scalars['Int']['input'];
  PresetID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateInvoiceLogNoteArgs = {
  InvoiceLogID: Scalars['Int']['input'];
  Note: Scalars['StringInput']['input'];
};


export type MutationUpdateItemStatusByAdminArgs = {
  Field: DirectoryItemsStatusActions;
  ID: Scalars['Int']['input'];
  Value: Scalars['Boolean']['input'];
};


export type MutationUpdateLibraryDownloadArgs = {
  FileCategoryID?: InputMaybe<Scalars['Int']['input']>;
  ID: Scalars['Int']['input'];
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateLibraryImageArgs = {
  AltText?: InputMaybe<Scalars['StringInput']['input']>;
  Caption?: InputMaybe<Scalars['StringInput']['input']>;
  ClickableLink?: InputMaybe<Scalars['StringInput']['input']>;
  FileName?: InputMaybe<Scalars['StringInput']['input']>;
  FullScreen?: InputMaybe<Scalars['Boolean']['input']>;
  ImageFilter?: InputMaybe<Scalars['StringInput']['input']>;
  IsHalfWidth?: InputMaybe<Scalars['Boolean']['input']>;
  IsMultiplied?: InputMaybe<Scalars['Boolean']['input']>;
  LibraryImageID: Scalars['Int']['input'];
  MetaDescription?: InputMaybe<Scalars['StringInput']['input']>;
  Overlay?: InputMaybe<Scalars['Boolean']['input']>;
  PhotoCreditID?: InputMaybe<Scalars['Int']['input']>;
  PhotoCreditName?: InputMaybe<Scalars['StringInput']['input']>;
  Regenerate?: InputMaybe<Scalars['Boolean']['input']>;
  ScrollPosX?: InputMaybe<Scalars['Float']['input']>;
  ScrollPosY?: InputMaybe<Scalars['Float']['input']>;
  SearchTags?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  ZoomFactor?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateLibraryImageMarkerArgs = {
  Approved?: InputMaybe<Scalars['Boolean']['input']>;
  LibraryImageMarkerID: Scalars['Int']['input'];
  ProfessionalName?: InputMaybe<Scalars['StringInput']['input']>;
  TargetID?: InputMaybe<Scalars['Int']['input']>;
  TitleForUnknownProduct?: InputMaybe<Scalars['StringInput']['input']>;
  URLForUnknownProduct?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateLibraryImagesArgs = {
  Input: Array<UpdateLibraryImageInput>;
};


export type MutationUpdateLibraryImagesSortOrderArgs = {
  LibraryImages?: InputMaybe<Array<LibraryImagesInput>>;
};


export type MutationUpdateLibraryLocationsArgs = {
  LibraryLocations: Array<InputMaybe<LibraryLocationUpdatesList>>;
};


export type MutationUpdateLibraryRangeArgs = {
  ID: Scalars['Int']['input'];
  Title: Scalars['StringInput']['input'];
};


export type MutationUpdateLibraryTabsArgs = {
  LibraryTabs: Array<LibraryTabUpdate>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationUpdateLibraryThumbArgs = {
  LibraryImageID?: InputMaybe<Scalars['Int']['input']>;
  LibraryItemID?: InputMaybe<Scalars['Int']['input']>;
  ScrollPosX?: InputMaybe<Scalars['Float']['input']>;
  ScrollPosY?: InputMaybe<Scalars['Float']['input']>;
  ZoomLevel?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateLibraryVideoArgs = {
  ID: Scalars['Int']['input'];
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  Url?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateMeArgs = {
  Input: UpdateMeInput;
};


export type MutationUpdateMessageReactionArgs = {
  IsRemove?: InputMaybe<Scalars['Boolean']['input']>;
  MessageID: Scalars['Int']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  Reaction: Scalars['String']['input'];
};


export type MutationUpdateMetaArgs = {
  Input: UpdateMetaInput;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationUpdateOrganizationNetworkParticipantArgs = {
  input: UpdateOrganizationNetworkParticipantData;
};


export type MutationUpdateParticipantStatusArgs = {
  Input: SetParticipantStatusInput;
};


export type MutationUpdatePasswordArgs = {
  Input: UpdatePasswordInput;
};


export type MutationUpdateProductArgs = {
  Activated?: InputMaybe<Scalars['Boolean']['input']>;
  AllowFastQuote?: InputMaybe<Scalars['Boolean']['input']>;
  Brand?: InputMaybe<Scalars['StringInput']['input']>;
  BulkPhotoCreditID?: InputMaybe<Scalars['Int']['input']>;
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  ContentLocked?: InputMaybe<Scalars['Boolean']['input']>;
  Designer?: InputMaybe<Scalars['StringInput']['input']>;
  DirectoryItemID: Scalars['Int']['input'];
  ExcludeAdvertising?: InputMaybe<Scalars['Boolean']['input']>;
  ExcludedFromSpecialtyRates?: InputMaybe<Scalars['Boolean']['input']>;
  InLibrary?: InputMaybe<Scalars['Boolean']['input']>;
  IsBasePrice?: InputMaybe<Scalars['Boolean']['input']>;
  IsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  LeadTime?: InputMaybe<Scalars['StringInput']['input']>;
  PerformanceDescription?: InputMaybe<Scalars['StringInput']['input']>;
  Price?: InputMaybe<Scalars['Float']['input']>;
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  Publish?: InputMaybe<Scalars['Boolean']['input']>;
  PublishDate?: InputMaybe<Scalars['StringInput']['input']>;
  ScopeOfUseDescription?: InputMaybe<Scalars['StringInput']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  WarrantyDuration?: InputMaybe<Scalars['StringInput']['input']>;
  Website?: InputMaybe<Scalars['StringInput']['input']>;
  Year?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateProductFacetOptionsArgs = {
  FacetOptionIDs: Array<Scalars['Int']['input']>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationUpdateProductPricingArgs = {
  Input: UpdateProductPricingInput;
};


export type MutationUpdateProductSizeArgs = {
  ID: Scalars['Int']['input'];
  Input: ProductSizeInput;
};


export type MutationUpdateProductSizeSortOrdersArgs = {
  Input: Array<SortOrderInput>;
  ProductID: Scalars['Int']['input'];
};


export type MutationUpdateProductSwatchesArgs = {
  ProductSwatches: Array<ProductSwatchUpdate>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationUpdateProfessionalArgs = {
  APConnect?: InputMaybe<Scalars['Boolean']['input']>;
  Activated?: InputMaybe<Scalars['Boolean']['input']>;
  AllowBooking?: InputMaybe<Scalars['Boolean']['input']>;
  AllowCRMIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  AllowEmailBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  AllowInvoicing?: InputMaybe<Scalars['Boolean']['input']>;
  AnalyticsStatus?: InputMaybe<AnalyticsStatusEnum>;
  AutoConfirmOrders?: InputMaybe<Scalars['Boolean']['input']>;
  AvailableForWork?: InputMaybe<Scalars['Boolean']['input']>;
  Awards?: InputMaybe<Scalars['StringInput']['input']>;
  BannerOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  BlockSummary?: InputMaybe<Scalars['StringInput']['input']>;
  BulkPhotoCreditID?: InputMaybe<Scalars['Int']['input']>;
  BusinessFocus?: InputMaybe<BusinessFocusEnum>;
  BusinessTypes?: InputMaybe<Array<BusinessTypeEnum>>;
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  CollectWebsiteFormData?: InputMaybe<Scalars['Boolean']['input']>;
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  ContentNotificationEmailAddresses?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  CustomEnquiryMessage?: InputMaybe<Scalars['StringInput']['input']>;
  DirectoryItemID: Scalars['Int']['input'];
  Disable?: InputMaybe<Scalars['Boolean']['input']>;
  EcommerceEmailAddresses?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  Email?: InputMaybe<Scalars['Email']['input']>;
  EngagementNotificationEmailAddresses?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  EnquiryAudience?: InputMaybe<EnquiryAudienceEnum>;
  EnquiryEmailAddresses?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  EnquiryProjectType?: InputMaybe<EnquiryProjectTypeEnum>;
  FreeShippingThreshold?: InputMaybe<Scalars['Int']['input']>;
  FreeShippingThresholdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  HDEExhibitingEventIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  HubspotID?: InputMaybe<Scalars['String']['input']>;
  InLibrary?: InputMaybe<Scalars['Boolean']['input']>;
  Mobile?: InputMaybe<Scalars['StringInput']['input']>;
  NoticePeriod?: InputMaybe<Scalars['Int']['input']>;
  NoticePeriodUnit?: InputMaybe<ProfessionalNoticePeriodUnitEnum>;
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  Phone2?: InputMaybe<Scalars['StringInput']['input']>;
  PhoneTracking?: InputMaybe<Scalars['StringInput']['input']>;
  PhoneTrackingPlayMessage?: InputMaybe<Scalars['StringInput']['input']>;
  PixelNotGated?: InputMaybe<Scalars['Boolean']['input']>;
  PriceRanges?: InputMaybe<Array<Scalars['Int']['input']>>;
  PrimaryCTA?: InputMaybe<PrimaryCtaEnum>;
  ProductCTA?: InputMaybe<ProductCtaEnum>;
  PublicFacebookLink?: InputMaybe<Scalars['StringInput']['input']>;
  PublicInstagramLink?: InputMaybe<Scalars['StringInput']['input']>;
  PublicLinkedinLink?: InputMaybe<Scalars['StringInput']['input']>;
  PublicPinterestLink?: InputMaybe<Scalars['StringInput']['input']>;
  PublicTikTokLink?: InputMaybe<Scalars['StringInput']['input']>;
  PublicTwitterLink?: InputMaybe<Scalars['StringInput']['input']>;
  PublicYoutubeLink?: InputMaybe<Scalars['StringInput']['input']>;
  Publish?: InputMaybe<Scalars['Boolean']['input']>;
  PublishDate?: InputMaybe<Scalars['StringInput']['input']>;
  Services?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  StatsReportEmailAddresses?: InputMaybe<Array<Scalars['StringInput']['input']>>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  Website?: InputMaybe<Scalars['StringInput']['input']>;
  YearFounded?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateProfessionalAwardArgs = {
  AwardDetails: UpdateProfessionalAwardInput;
  AwardID: Scalars['Int']['input'];
  AwardedEntityLinkList?: InputMaybe<Array<InputMaybe<Scalars['StringInput']['input']>>>;
};


export type MutationUpdateProfessionalServiceAreaArgs = {
  Places: Array<InputMaybe<ServiceAreaInput>>;
  URLSegment: Scalars['StringInput']['input'];
};


export type MutationUpdateProjectArgs = {
  Activated?: InputMaybe<Scalars['Boolean']['input']>;
  BuildingStyle?: InputMaybe<Scalars['StringInput']['input']>;
  BulkPhotoCreditID?: InputMaybe<Scalars['Int']['input']>;
  CategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Client?: InputMaybe<Scalars['StringInput']['input']>;
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  DirectoryItemID: Scalars['Int']['input'];
  InLibrary?: InputMaybe<Scalars['Boolean']['input']>;
  IsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  IsFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  PriceRangeID?: InputMaybe<Scalars['Int']['input']>;
  ProjectHeroTitle?: InputMaybe<Scalars['StringInput']['input']>;
  Publish?: InputMaybe<Scalars['Boolean']['input']>;
  PublishDate?: InputMaybe<Scalars['StringInput']['input']>;
  SelfPublished?: InputMaybe<Scalars['Boolean']['input']>;
  Subheading?: InputMaybe<Scalars['StringInput']['input']>;
  TeamMemberOrder?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  YearOfCompletion?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateQuoteDataBindingArgs = {
  IsTemplate: Scalars['Boolean']['input'];
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
  SourceClass: Scalars['String']['input'];
  SourceID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateQuoteMetaDataArgs = {
  AccountDetails?: InputMaybe<Scalars['StringInput']['input']>;
  BankTransferTerms?: InputMaybe<Scalars['StringInput']['input']>;
  ContactInfo?: InputMaybe<Scalars['StringInput']['input']>;
  CreditCardTerms?: InputMaybe<Scalars['StringInput']['input']>;
  Description?: InputMaybe<Scalars['StringInput']['input']>;
  ExpiryDate?: InputMaybe<Scalars['StringInput']['input']>;
  IsTemplate: Scalars['Boolean']['input'];
  Notes?: InputMaybe<Scalars['StringInput']['input']>;
  PaymentTerms?: InputMaybe<Scalars['StringInput']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
  References?: InputMaybe<Scalars['StringInput']['input']>;
  Scope?: InputMaybe<Scalars['StringInput']['input']>;
  SelectedBusinessTermsCategoryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  TaxBehavior?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateReviewActionArgs = {
  IsDone?: InputMaybe<Scalars['Boolean']['input']>;
  ReviewActionID: Scalars['Int']['input'];
  Task?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateSavedModuleArgs = {
  ID: Scalars['Int']['input'];
  ModuleID: Scalars['Int']['input'];
  Name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSearchTagsArgs = {
  LibraryItemID: Scalars['Int']['input'];
  SearchTags: Array<Scalars['StringInput']['input']>;
};


export type MutationUpdateServiceOfferingArgs = {
  Description?: InputMaybe<Scalars['StringInput']['input']>;
  Photo?: InputMaybe<Scalars['Upload']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Quantity?: InputMaybe<Scalars['Int']['input']>;
  SKU: Scalars['StringInput']['input'];
  Title: Scalars['StringInput']['input'];
  Unit?: InputMaybe<Scalars['StringInput']['input']>;
  UnitPriceAmount?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateShippingMethodArgs = {
  DeliveryEstimate?: InputMaybe<MinMaxInput>;
  ID: Scalars['Int']['input'];
  Title: Scalars['StringInput']['input'];
};


export type MutationUpdateShippingProfileArgs = {
  ApplyRatePerItem?: InputMaybe<Scalars['Boolean']['input']>;
  Default?: InputMaybe<Scalars['Boolean']['input']>;
  ExcludePromotions?: InputMaybe<Scalars['Boolean']['input']>;
  ID: Scalars['Int']['input'];
  ShippingMethods?: InputMaybe<Array<ShippingMethodInput>>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateShoppingCartArgs = {
  Email?: InputMaybe<Scalars['Email']['input']>;
  Locality?: InputMaybe<Scalars['Int']['input']>;
  Region?: InputMaybe<Scalars['Int']['input']>;
  ResetModified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateShoppingCartAddressArgs = {
  Address: AddressInput;
  AddressType: AddressTypeEnum;
};


export type MutationUpdateShoppingCartItemArgs = {
  CartItemID: Scalars['Int']['input'];
  ClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  PickupLocation?: InputMaybe<Scalars['Int']['input']>;
  Quantity?: InputMaybe<Scalars['Int']['input']>;
  Region?: InputMaybe<Scalars['Int']['input']>;
  Selected?: InputMaybe<Scalars['Boolean']['input']>;
  ShippingMethod?: InputMaybe<Scalars['Int']['input']>;
  ShippingProvider?: InputMaybe<ShippingProviderEnum>;
};


export type MutationUpdateShoppingCartSupplierArgs = {
  Comment?: InputMaybe<Scalars['StringInput']['input']>;
  PickupLocation?: InputMaybe<Scalars['Int']['input']>;
  Selected?: InputMaybe<Scalars['Boolean']['input']>;
  SupplierID: Scalars['Int']['input'];
};


export type MutationUpdateSortOrdersArgs = {
  ItemType: SortableItemEnum;
  SortOrders?: InputMaybe<Array<ItemSortOrders>>;
};


export type MutationUpdateSubscriptionPackPaymentMethodArgs = {
  PaymentMethodID: Scalars['String']['input'];
  ProfessionalURLSegment: Scalars['String']['input'];
  SubscriptionPackID: Scalars['Int']['input'];
};


export type MutationUpdateSupplierOrderNoteArgs = {
  Note: Scalars['StringInput']['input'];
  OrderEventID: Scalars['Int']['input'];
};


export type MutationUpdateSupplierOrderShippingArgs = {
  DeliveryAddressID?: InputMaybe<Scalars['Int']['input']>;
  ID: Scalars['Int']['input'];
  PickupLocationID?: InputMaybe<Scalars['Int']['input']>;
  ShippingMethodID?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateTeamMemberArgs = {
  Approved?: InputMaybe<Scalars['Int']['input']>;
  ClearMeetingImage?: InputMaybe<Scalars['Boolean']['input']>;
  Email?: InputMaybe<Scalars['Email']['input']>;
  HasInboxAccess?: InputMaybe<Scalars['Boolean']['input']>;
  HideEmail?: InputMaybe<Scalars['Boolean']['input']>;
  HideJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  HideLinkedInLink?: InputMaybe<Scalars['Boolean']['input']>;
  HidePhone?: InputMaybe<Scalars['Boolean']['input']>;
  ID: Scalars['Int']['input'];
  Image?: InputMaybe<Scalars['Upload']['input']>;
  ImageScrollPosX?: InputMaybe<Scalars['Int']['input']>;
  ImageScrollPosY?: InputMaybe<Scalars['Int']['input']>;
  ImageZoomFactor?: InputMaybe<Scalars['Int']['input']>;
  IsOwner?: InputMaybe<Scalars['Int']['input']>;
  IsPublic?: InputMaybe<Scalars['Int']['input']>;
  JobTitle?: InputMaybe<Scalars['StringInput']['input']>;
  LicenseNumber?: InputMaybe<Scalars['StringInput']['input']>;
  LinkedInLink?: InputMaybe<Scalars['StringInput']['input']>;
  MeetingImage?: InputMaybe<Scalars['Upload']['input']>;
  MemberImage?: InputMaybe<Scalars['Upload']['input']>;
  Message?: InputMaybe<Scalars['StringInput']['input']>;
  Name?: InputMaybe<Scalars['StringInput']['input']>;
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Summary?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateTeamRoleArgs = {
  FeaturePermissions?: InputMaybe<Array<FeaturePermissionInput>>;
  RoleID: Scalars['Int']['input'];
  Title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTestimonialsArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
  Testimonials: Array<InputMaybe<TestimonialsList>>;
  URLSegment?: InputMaybe<Scalars['StringInput']['input']>;
};


export type MutationUpdateVariantArgs = {
  Input: VariantInput;
};


export type MutationUpdateVariantOptionArgs = {
  OptionID: Scalars['Int']['input'];
  SwatchID?: InputMaybe<Scalars['Int']['input']>;
  VariantID: Scalars['Int']['input'];
};


export type MutationUpdateVariantSizeArgs = {
  ProductSizeID: Scalars['Int']['input'];
  VariantID: Scalars['Int']['input'];
};


export type MutationUpdateVariantsArgs = {
  Input: Array<VariantInput>;
};


export type MutationUploadDesignBoardPinArgs = {
  DesignBoardID: Scalars['Int']['input'];
  File?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationUploadLogoImageArgs = {
  File?: InputMaybe<Scalars['Upload']['input']>;
  LibraryItemID: Scalars['Int']['input'];
};


export type MutationUpscaleImageColumnArgs = {
  ColumnID?: InputMaybe<Scalars['Int']['input']>;
  ExpectedHeight: Scalars['Int']['input'];
  ExpectedWidth: Scalars['Int']['input'];
  ForceUpscale?: InputMaybe<Scalars['Boolean']['input']>;
  ImageAssistantServiceName?: InputMaybe<Scalars['String']['input']>;
  LibraryImageID: Scalars['Int']['input'];
  ModuleID?: InputMaybe<Scalars['Int']['input']>;
  RevertUpscale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpsertBusinessTermsArgs = {
  CategoryID?: InputMaybe<Scalars['Int']['input']>;
  CountryIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  ID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalID: Scalars['Int']['input'];
  Terms?: InputMaybe<Scalars['String']['input']>;
  TermsLexical?: InputMaybe<Scalars['String']['input']>;
  Title: Scalars['String']['input'];
};


export type MutationUpsertBusinessTermsCategoryArgs = {
  ProfessionalID: Scalars['Int']['input'];
  Title: Scalars['String']['input'];
};


export type MutationUpsertEmailTemplateArgs = {
  BackgroundColor?: InputMaybe<Scalars['String']['input']>;
  BorderRadius?: InputMaybe<Scalars['Int']['input']>;
  ContainerPadding?: InputMaybe<Scalars['Int']['input']>;
  ContainerWidth?: InputMaybe<Scalars['String']['input']>;
  ContainerWidthValue?: InputMaybe<Scalars['Int']['input']>;
  CustomFontFamily?: InputMaybe<Scalars['String']['input']>;
  FontFamily?: InputMaybe<Scalars['String']['input']>;
  FontSize?: InputMaybe<Scalars['Int']['input']>;
  ID?: InputMaybe<Scalars['Int']['input']>;
  InnerBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  ProfessionalID: Scalars['Int']['input'];
  Subject: Scalars['StringInput']['input'];
  TextColor?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertEmailTemplateInputConfigArgs = {
  Alias: Scalars['StringInput']['input'];
  EmailTemplateID: Scalars['ID']['input'];
  ID?: InputMaybe<Scalars['ID']['input']>;
  InputTypeKey: Scalars['String']['input'];
};


export type MutationUpsertHdeExhibitorProfileArgs = {
  Brochure?: InputMaybe<Scalars['Upload']['input']>;
  Enabled: Scalars['Boolean']['input'];
  EventID?: InputMaybe<Scalars['Int']['input']>;
  FeaturedBanner?: InputMaybe<Scalars['Upload']['input']>;
  ProfessionalID: Scalars['Int']['input'];
};


export type MutationUpsertProfessionalCompanyFieldArgs = {
  FieldID?: InputMaybe<Scalars['ID']['input']>;
  Label: Scalars['StringInput']['input'];
  ProfessionalID: Scalars['ID']['input'];
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Type?: InputMaybe<Scalars['StringInput']['input']>;
  Visible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpsertProfessionalContactFieldArgs = {
  FieldID?: InputMaybe<Scalars['ID']['input']>;
  Label: Scalars['StringInput']['input'];
  ProfessionalID: Scalars['ID']['input'];
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Type?: InputMaybe<Scalars['StringInput']['input']>;
  Visible?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpsertQuoteContactArgs = {
  Address?: InputMaybe<Scalars['StringInput']['input']>;
  AddressLineTwo?: InputMaybe<Scalars['StringInput']['input']>;
  City?: InputMaybe<Scalars['StringInput']['input']>;
  Country?: InputMaybe<Scalars['StringInput']['input']>;
  Email: Scalars['Email']['input'];
  FirstName: Scalars['StringInput']['input'];
  IsTemplate: Scalars['Boolean']['input'];
  JobTitle?: InputMaybe<Scalars['StringInput']['input']>;
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  Photo?: InputMaybe<Scalars['Upload']['input']>;
  PostCode?: InputMaybe<Scalars['StringInput']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
  Region?: InputMaybe<Scalars['StringInput']['input']>;
  Suburb?: InputMaybe<Scalars['StringInput']['input']>;
  Surname: Scalars['StringInput']['input'];
};


export type MutationUpsertQuoteContentArgs = {
  CountryID?: InputMaybe<Scalars['Int']['input']>;
  CreateInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  ID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalID: Scalars['Int']['input'];
  Title: Scalars['StringInput']['input'];
};


export type MutationUpsertQuotePaymentArgs = {
  Amount?: InputMaybe<Scalars['Float']['input']>;
  AmountOption: InvoicePaymentAmountOptionEnum;
  AmountPercentage?: InputMaybe<Scalars['Float']['input']>;
  DueDate?: InputMaybe<Scalars['StringInput']['input']>;
  DueDaysAfterInvoiceSent?: InputMaybe<Scalars['Int']['input']>;
  DueFixedDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  DueOption: InvoicePaymentDueOptionEnum;
  IsTemplate: Scalars['Boolean']['input'];
  PaymentID?: InputMaybe<Scalars['ID']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  QuoteID: Scalars['ID']['input'];
};


export type MutationUpsertQuoteServiceItemArgs = {
  Description?: InputMaybe<Scalars['StringInput']['input']>;
  DiscountApplied?: InputMaybe<Scalars['Boolean']['input']>;
  DiscountedUnitPriceAmount?: InputMaybe<Scalars['Float']['input']>;
  IsTemplate: Scalars['Boolean']['input'];
  Photo?: InputMaybe<Scalars['Upload']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Quantity?: InputMaybe<Scalars['Int']['input']>;
  QuoteID: Scalars['ID']['input'];
  ServiceID?: InputMaybe<Scalars['ID']['input']>;
  TaxBehavior?: InputMaybe<Scalars['String']['input']>;
  Title: Scalars['StringInput']['input'];
  UnitPriceAmount: Scalars['Float']['input'];
};


export type MutationUseQuoteTemplateArgs = {
  ProfessionalID: Scalars['ID']['input'];
  QuoteContentID: Scalars['ID']['input'];
};

/** list of all registered devices on the current user. */
export type MyPushDevices = {
  __typename?: 'MyPushDevices';
  RegisteredDevices: Array<UserPushDevice>;
};

/** Per-event group of guests for the logged-in registrant, combining submission-linked and UI-issued guests. */
export type MyRegistrantEventGroup = {
  __typename?: 'MyRegistrantEventGroup';
  EventDateTimeDescription?: Maybe<Scalars['String']['output']>;
  EventID: Scalars['ID']['output'];
  /** Registration status of the event (draft, active, closed, finished). Used by the frontend for active/past tab filtering. */
  EventRegistrationStatus?: Maybe<Scalars['String']['output']>;
  EventTitle?: Maybe<Scalars['String']['output']>;
  /** All guests for this event (submission-linked + UI-issued), merged. */
  Guests: Array<MyRegistrantGuest>;
  /** Cap on guest tickets this registrant can invite for this event. 0 means unlimited. */
  MaxGuestInvitesPerRegistrant: Scalars['Int']['output'];
  /** The registrant's primary submission for this event. */
  SubmissionID: Scalars['ID']['output'];
};

/** A single guest entry within a registrant's event group. */
export type MyRegistrantGuest = {
  __typename?: 'MyRegistrantGuest';
  /** Empty for Scenario 2 rows where the registrant used their own email. */
  GuestEmail?: Maybe<Scalars['String']['output']>;
  GuestFirstName?: Maybe<Scalars['String']['output']>;
  GuestLastName?: Maybe<Scalars['String']['output']>;
  /** True for the form guest (tracked on MGEEventSubmission), false for UI-issued ticket-only guests. */
  IsSubmissionGuest: Scalars['Boolean']['output'];
  /** True when this guest needs a claim-ticket retrofix (Scenario 2). */
  NeedsClaim: Scalars['Boolean']['output'];
  /** The guest's event ticket. Null when no ticket has been issued yet (Scenario 2). */
  Ticket?: Maybe<EventTicket>;
};

export type NativeDriverAdPerformanceFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type NativeDriverCampaignsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NativeDriverDeviceFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type NativeDriverOverviewStatFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NativeDriverRegionFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type Newsletter = {
  __typename?: 'Newsletter';
  BannerPhoto: Scalars['String']['output'];
  BannerPhotoLarge: Scalars['String']['output'];
  Created: Scalars['String']['output'];
  FormattedDate: Scalars['String']['output'];
  FrameStyle: NewsletterTileFrameEnum;
  ID: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  Month: Scalars['Int']['output'];
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Type: Scalars['String']['output'];
  URL: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  Year: Scalars['Int']['output'];
};

export enum NewsletterTileFrameEnum {
  Framed = 'Framed',
  Frameless = 'Frameless'
}

export enum NewsletterTypeEnum {
  ArchiPros = 'ArchiPros',
  Build = 'Build',
  CommercialEdit = 'CommercialEdit',
  CuratedCollection = 'CuratedCollection',
  DedicatedEdm = 'DedicatedEDM',
  Misc = 'Misc',
  ProjectFeature = 'ProjectFeature',
  ProjectPortfolio = 'ProjectPortfolio'
}

export type NotAuthenticatedError = ErrorInterface & {
  __typename?: 'NotAuthenticatedError';
  Message: Scalars['String']['output'];
};

export type NotAuthorizedError = ErrorInterface & {
  __typename?: 'NotAuthorizedError';
  Message: Scalars['String']['output'];
};

export type NotFoundError = ErrorInterface & {
  __typename?: 'NotFoundError';
  Message: Scalars['String']['output'];
};

export type NotificationLink = {
  __typename?: 'NotificationLink';
  Link: Scalars['String']['output'];
  Target: Scalars['String']['output'];
};

export type OctaImageModule = FlexibleModule & {
  __typename?: 'OctaImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type OctaImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type OldConversionTableDataFilters = {
  CONTENT_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  CONVERSION__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  EVENT_LOCATION_DATA__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  TITLE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  USER_CLASS_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OldConversionTableDataSort = {
  CONTENT?: InputMaybe<PrioritySort>;
  CONVERSION?: InputMaybe<PrioritySort>;
  DESCRIPTION?: InputMaybe<PrioritySort>;
  INDUSTRY?: InputMaybe<PrioritySort>;
  LOCATION?: InputMaybe<PrioritySort>;
  PAGE?: InputMaybe<PrioritySort>;
  TIME?: InputMaybe<PrioritySort>;
  USER?: InputMaybe<PrioritySort>;
};

export type OldProfileTopPagesFilters = {
  CONVERSION_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  LIBRARY_ITEM_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  TITLE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OldProfileTopPagesSort = {
  AVG_TIME_ON_PAGE?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  CONVERSION_RATE?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  TYPE?: InputMaybe<PrioritySort>;
};

export type OnboardingProfessionalCategory = {
  __typename?: 'OnboardingProfessionalCategory';
  ID: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};

export type OnboardingProfessionalCategoryConnection = {
  __typename?: 'OnboardingProfessionalCategoryConnection';
  edges: Array<OnboardingProfessionalCategoryConnectionEdge>;
  nodes: Array<OnboardingProfessionalCategory>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OnboardingProfessionalCategoryConnectionEdge = {
  __typename?: 'OnboardingProfessionalCategoryConnectionEdge';
  /** The node at the end of the collections edge */
  node: OnboardingProfessionalCategory;
};

export type OnsitePlacementBreakdownFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OnsitePlacementLocationTypeFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OnsitePlacementOverviewFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OnsitePlacementTableFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OnsitePlacementUserDevicesFilters = {
  DATE_CREATED__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OpenClickRates = {
  __typename?: 'OpenClickRates';
  Delivered: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  TotalAllClicks: Scalars['Int']['output'];
  TotalClicks: Scalars['Int']['output'];
  TotalOpens: Scalars['Int']['output'];
  UniqueClicks: Scalars['Int']['output'];
  UniqueOpens: Scalars['Int']['output'];
};

export type Option = {
  __typename?: 'Option';
  ID: Scalars['String']['output'];
  Label: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  Company: Scalars['String']['output'];
  Created: Scalars['String']['output'];
  Email: Scalars['String']['output'];
  FirstName: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  ItemTotal?: Maybe<CurrencyAmount>;
  Member: Member;
  OrderTotal?: Maybe<CurrencyAmount>;
  Phone: Scalars['String']['output'];
  ShippingTotal?: Maybe<CurrencyAmount>;
  Status: Scalars['String']['output'];
  SupplierOrders: Array<SupplierOrder>;
  Surname: Scalars['String']['output'];
  TaxSystem: Scalars['String']['output'];
  TaxTotal?: Maybe<CurrencyAmount>;
};


export type OrderSupplierOrdersArgs = {
  SupplierID?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderDeclineItemInput = {
  OrderReturnItem: Scalars['Int']['input'];
  Quantity: Scalars['Int']['input'];
};

export type OrderEvent = {
  __typename?: 'OrderEvent';
  ByMember?: Maybe<Member>;
  Created: Scalars['String']['output'];
  Event?: Maybe<Scalars['String']['output']>;
  EventSource: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  UpdateType?: Maybe<OrderEventUpdateTypeEnum>;
};

export enum OrderEventUpdateTypeEnum {
  Note = 'Note'
}

export type OrderItem = {
  __typename?: 'OrderItem';
  BusinessFullShippingMethodLabel: Scalars['String']['output'];
  ClickAndCollect: Scalars['Boolean']['output'];
  Consignment?: Maybe<Consignment>;
  DeliveryEstimate?: Maybe<Scalars['String']['output']>;
  Dispatch?: Maybe<Dispatch>;
  ID: Scalars['Int']['output'];
  Image?: Maybe<ResponsiveImage>;
  LastEdited: Scalars['String']['output'];
  LeadTime: Scalars['Int']['output'];
  LeadTimeUnit?: Maybe<LeadTimeUnitEnum>;
  Price: CurrencyAmount;
  Product: Scalars['String']['output'];
  Quantity: Scalars['Int']['output'];
  RetailPrice: CurrencyAmount;
  RetailSubTotal?: Maybe<CurrencyAmount>;
  ReturnReason?: Maybe<Scalars['String']['output']>;
  Returns: Array<OrderReturnItem>;
  SKU: Scalars['String']['output'];
  Sample: Scalars['Boolean']['output'];
  ShippingCost: CurrencyAmount;
  ShippingMethod?: Maybe<ShippingMethod>;
  ShippingMethodLabel: Scalars['String']['output'];
  Status: OrderStatusEnum;
  SubTotal: CurrencyAmount;
  SupplierSKU?: Maybe<Scalars['String']['output']>;
  TaxPerItem: CurrencyAmount;
  TaxTotal: CurrencyAmount;
  Variant: Variant;
  VariantDescription: Scalars['String']['output'];
};

export type OrderItemsConnection = {
  __typename?: 'OrderItemsConnection';
  edges: Array<OrderItemsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OrderItemsConnectionEdge = {
  __typename?: 'OrderItemsConnectionEdge';
  /** The node at the end of the collections edge */
  node: OrderItem;
};

export type OrderReturnItem = {
  __typename?: 'OrderReturnItem';
  Archived: Scalars['Boolean']['output'];
  Created: Scalars['String']['output'];
  DeclineReason?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  Photo?: Maybe<Scalars['String']['output']>;
  Quantity: Scalars['Int']['output'];
  Reason: Scalars['String']['output'];
  ReasonGroup: Scalars['String']['output'];
  Status: OrderReturnItemStatusEnum;
  SubTotal: CurrencyAmount;
};

export type OrderReturnItemInput = {
  OrderItem: Scalars['Int']['input'];
  OrderReturnItemID?: InputMaybe<Scalars['Int']['input']>;
  Photo?: InputMaybe<Scalars['Upload']['input']>;
  Quantity: Scalars['Int']['input'];
  Reason?: InputMaybe<Scalars['StringInput']['input']>;
  ReasonGroup?: InputMaybe<Scalars['StringInput']['input']>;
};

export enum OrderReturnItemStatusEnum {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum OrderStatusEnum {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Dispatched = 'DISPATCHED',
  Fulfilled = 'FULFILLED',
  Pending = 'PENDING',
  Returned = 'RETURNED'
}

export type OrganizationCreateData = {
  /** URLSegment of the professional that is creating this network */
  owner: Scalars['String']['input'];
};

export type OrganizationNetwork = {
  __typename?: 'OrganizationNetwork';
  id: Scalars['ID']['output'];
  owner: OrganizationNetworkParticipant;
  participants: OrganizationNetworkParticipantConnection;
};


export type OrganizationNetworkParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OrganizationNetworkParticipantsSortFields>;
};

export type OrganizationNetworkConnection = {
  __typename?: 'OrganizationNetworkConnection';
  edges: Array<OrganizationNetworkConnectionEdge>;
  nodes: Array<OrganizationNetwork>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OrganizationNetworkConnectionEdge = {
  __typename?: 'OrganizationNetworkConnectionEdge';
  /** The node at the end of the collections edge */
  node: OrganizationNetwork;
};

export type OrganizationNetworkOwner = {
  __typename?: 'OrganizationNetworkOwner';
  ID: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};

export type OrganizationNetworkParticipant = {
  __typename?: 'OrganizationNetworkParticipant';
  directEnquiry: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identity: Professional;
  network: OrganizationNetwork;
  productSharing: Scalars['Boolean']['output'];
};

export type OrganizationNetworkParticipantConnection = {
  __typename?: 'OrganizationNetworkParticipantConnection';
  edges: Array<OrganizationNetworkParticipantConnectionEdge>;
  nodes: Array<OrganizationNetworkParticipant>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OrganizationNetworkParticipantConnectionEdge = {
  __typename?: 'OrganizationNetworkParticipantConnectionEdge';
  /** The node at the end of the collections edge */
  node: OrganizationNetworkParticipant;
};

export type OrganizationNetworkParticipantUpdateData = {
  /** Enables direct enquiry for this participant */
  directEnquiry?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enables product sharing for this participant */
  productSharing?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationNetworkParticipantsSortFields = {
  ID?: InputMaybe<SortDirection>;
  Professional__Title?: InputMaybe<SortDirection>;
};

export type OtherRangeProductsConnection = {
  __typename?: 'OtherRangeProductsConnection';
  edges: Array<OtherRangeProductsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type OtherRangeProductsConnectionEdge = {
  __typename?: 'OtherRangeProductsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Product;
};

export type OverviewAudience = {
  __typename?: 'OverviewAudience';
  AgeGroups: Array<GraphSegment>;
  DeviceBreakdown: Array<Maybe<DeviceData>>;
  ID: Scalars['String']['output'];
  LocationBreakdown: Array<Maybe<LocationData>>;
};

export type OverviewImpressionFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewInteractionsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewNewsletterStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewPackageCampaignsDetailsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewPackageCampaignsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewPackageFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewPackageOtherCampaignsDetailsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewPackageOtherCampaignsFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewPageViewFilters = {
  START_DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewProfilePageStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewSocialAdStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverviewSummaryNumbers = {
  __typename?: 'OverviewSummaryNumbers';
  Clicks: Scalars['Int']['output'];
  Conversions: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  NewsletterSummary: EngagementSummary;
  ProfileSummary: EngagementSummary;
  SocialSummary: EngagementSummary;
  TotalTimeSpent: Scalars['String']['output'];
};

export type OverviewTotalConversionFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type PotmData = {
  __typename?: 'POTMData';
  AutoPlay?: Maybe<Scalars['Boolean']['output']>;
  DesktopCover?: Maybe<Scalars['String']['output']>;
  DirectoryGridAutoPlay?: Maybe<Scalars['Boolean']['output']>;
  DirectoryGridDesktopCover?: Maybe<Scalars['String']['output']>;
  DirectoryGridMobileCover?: Maybe<Scalars['String']['output']>;
  DirectoryGridVideoMp4Url?: Maybe<Scalars['String']['output']>;
  DirectoryGridVideoWebMUrl?: Maybe<Scalars['String']['output']>;
  DirectoryHeroAutoPlay?: Maybe<Scalars['Boolean']['output']>;
  DirectoryHeroDesktopCover?: Maybe<Scalars['String']['output']>;
  DirectoryHeroFullVideo?: Maybe<Scalars['String']['output']>;
  DirectoryHeroMobileCover?: Maybe<Scalars['String']['output']>;
  DirectoryHeroPrimaryCTAText: Scalars['String']['output'];
  DirectoryHeroVideoID?: Maybe<Scalars['String']['output']>;
  DirectoryHeroVideoMp4MobileUrl?: Maybe<Scalars['String']['output']>;
  DirectoryHeroVideoMp4Url?: Maybe<Scalars['String']['output']>;
  DirectoryHeroVideoPlatform?: Maybe<Scalars['String']['output']>;
  DirectoryHeroVideoWebMMobileUrl?: Maybe<Scalars['String']['output']>;
  DirectoryHeroVideoWebMUrl?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  MobileCover?: Maybe<Scalars['String']['output']>;
  OverrideURL?: Maybe<Scalars['String']['output']>;
  PrimaryCTAText: Scalars['String']['output'];
  Project?: Maybe<Project>;
  ProjectArticle?: Maybe<Article>;
  ShortDescription?: Maybe<Scalars['String']['output']>;
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  VideoMp4Url?: Maybe<Scalars['String']['output']>;
  VideoWebMUrl?: Maybe<Scalars['String']['output']>;
};

export enum PotmPlacement {
  DirectoryGrid = 'DirectoryGrid',
  DirectoryHero = 'DirectoryHero',
  Homepage = 'Homepage'
}

export type PackagesConnection = {
  __typename?: 'PackagesConnection';
  edges: Array<PackagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PackagesConnectionEdge = {
  __typename?: 'PackagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ConsignmentPackage;
};

export type PageBuilderImagesConnection = {
  __typename?: 'PageBuilderImagesConnection';
  edges: Array<PageBuilderImagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PageBuilderImagesConnectionEdge = {
  __typename?: 'PageBuilderImagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImage;
};

export type PageBuilderModulesConnection = {
  __typename?: 'PageBuilderModulesConnection';
  edges: Array<PageBuilderModulesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PageBuilderModulesConnectionEdge = {
  __typename?: 'PageBuilderModulesConnectionEdge';
  /** The node at the end of the collections edge */
  node: FlexibleModule;
};

export type PageBuilderModulesSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
};

export type PageBulkCloneJob = {
  __typename?: 'PageBulkCloneJob';
  ClonedCount: Scalars['Int']['output'];
  CreatedAt: Scalars['Date']['output'];
  /** The ID of the underlying TaskDetails object */
  ID: Scalars['Int']['output'];
  /** The ID of the underlying PageBulkCloneJob object */
  JobID: Scalars['Int']['output'];
  LastEditedAt: Scalars['Date']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  SourceCount: Scalars['Int']['output'];
  Status: AsyncTaskStatus;
};

export type PageContent = {
  __typename?: 'PageContent';
  Content: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
};

export type PageEmbedding = {
  __typename?: 'PageEmbedding';
  EmbeddedData?: Maybe<Scalars['String']['output']>;
  Embeddings?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PagePin = {
  __typename?: 'PagePin';
  ID: Scalars['Int']['output'];
  PageType?: Maybe<Scalars['String']['output']>;
  PageTypeID?: Maybe<Scalars['Int']['output']>;
};

export type PageReview = {
  __typename?: 'PageReview';
  Approved?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  ReviewDateTime?: Maybe<Scalars['String']['output']>;
  Reviewer?: Maybe<Member>;
};

export type PageReviewType = NotAuthorizedError | NotFoundError | PageReview | UserError;

export type PageSeoSchema = {
  __typename?: 'PageSEOSchema';
  FAQSchemas?: Maybe<Array<Maybe<FaqSchema>>>;
  ID: Scalars['Int']['output'];
};

export type PaginatedProductSwatches_Connection = {
  __typename?: 'PaginatedProductSwatches_Connection';
  ID: Scalars['String']['output'];
  edges: Array<PaginatedProductSwatches_ConnectionEdge>;
  nodes: Array<ProductSwatch>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type PaginatedProductSwatches_ConnectionEdge = {
  __typename?: 'PaginatedProductSwatches_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductSwatch;
};

export type PaintColour = {
  __typename?: 'PaintColour';
  B: Scalars['Int']['output'];
  Code: Scalars['String']['output'];
  G: Scalars['Int']['output'];
  Hex: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  Product?: Maybe<Product>;
  ProductID: Scalars['Int']['output'];
  Professional?: Maybe<Professional>;
  R: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};

export type PaintColoursConnection = {
  __typename?: 'PaintColoursConnection';
  edges: Array<PaintColoursConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PaintColoursConnectionEdge = {
  __typename?: 'PaintColoursConnectionEdge';
  /** The node at the end of the collections edge */
  node: PaintColour;
};

export type PaintPartner = {
  __typename?: 'PaintPartner';
  PaintColours: PaintColoursConnection;
};


export type PaintPartnerPaintColoursArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Participant = {
  ID: Scalars['ID']['output'];
  Identity: ParticipantIdentity;
  /** When this participant last read up to LastReadMessageID. */
  LastReadMessageDate?: Maybe<Scalars['String']['output']>;
  /** The ID of the last message this participant has read. A value of -1 means manually marked unread. */
  LastReadMessageID: Scalars['Int']['output'];
};

export type ParticipantIdentity = Member | Professional;

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  Amount?: Maybe<Scalars['Int']['output']>;
  ClientSecret: Scalars['String']['output'];
  Currency?: Maybe<Scalars['String']['output']>;
  Customer?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
};

export type PaymentIntentResponse = NotAuthenticatedError | NotAuthorizedError | NotFoundError | PaymentIntent | ServerError | UserError;

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  ID: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type PaymentOptions = {
  __typename?: 'PaymentOptions';
  Intent: Scalars['String']['output'];
  Methods: Array<PaymentMethod>;
};

export enum PaymentProviderEnum {
  Stripe = 'STRIPE'
}

/** Per-payment receipt amounts aligned with Stripe split-invoice prep. */
export type PaymentReceiptAllocation = {
  __typename?: 'PaymentReceiptAllocation';
  GoodsSubtotalExTax: Scalars['Float']['output'];
  GoodsTaxBuckets: Array<PaymentReceiptTaxBucket>;
  GoodsTaxTotal: Scalars['Float']['output'];
  Lines: Array<PaymentReceiptLine>;
  ShortPaymentLabel: Scalars['String']['output'];
  SurchargeAmountTaxInclusive?: Maybe<Scalars['Float']['output']>;
  SurchargeExTax: Scalars['Float']['output'];
  SurchargeGst: Scalars['Float']['output'];
};

/** One service line on a payment receipt (allocation for this charge). */
export type PaymentReceiptLine = {
  __typename?: 'PaymentReceiptLine';
  LineTaxAmount: Scalars['Float']['output'];
  LineTotalExTax: Scalars['Float']['output'];
  LineTotalIncTax: Scalars['Float']['output'];
  PeriodDisplay?: Maybe<Scalars['String']['output']>;
  Quantity: Scalars['Int']['output'];
  ServiceItemID: Scalars['ID']['output'];
  TaxRate?: Maybe<Scalars['Float']['output']>;
  Title: Scalars['String']['output'];
  UnitPriceExTax: Scalars['Float']['output'];
};

/** Goods GST grouped by tax rate for receipt summary. */
export type PaymentReceiptTaxBucket = {
  __typename?: 'PaymentReceiptTaxBucket';
  BaseExTax: Scalars['Float']['output'];
  TaxAmount: Scalars['Float']['output'];
  TaxRate: Scalars['Float']['output'];
};

export type PeopleContact = {
  __typename?: 'PeopleContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
};

export type PeopleContactList = {
  __typename?: 'PeopleContactList';
  contacts: Array<PeopleContact>;
  provider: PeopleContactProviderEnum;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum PeopleContactProviderEnum {
  Google = 'google',
  Outlook = 'outlook'
}

export type PeriodComparison = {
  __typename?: 'PeriodComparison';
  CurrentEnquiries: Scalars['Int']['output'];
  CurrentQDD: Scalars['Int']['output'];
  CurrentReferrals: Scalars['Int']['output'];
  EnquiriesPercentChange?: Maybe<Scalars['Float']['output']>;
  ID: Scalars['String']['output'];
  PreviousEnquiries: Scalars['Int']['output'];
  PreviousQDD: Scalars['Int']['output'];
  PreviousReferrals: Scalars['Int']['output'];
  QDDPercentChange?: Maybe<Scalars['Float']['output']>;
  ReferralsPercentChange?: Maybe<Scalars['Float']['output']>;
};

export enum PermissionEnum {
  ApBmAccess = 'AP_BM_ACCESS',
  ApMarketplaceSettingsAccess = 'AP_MARKETPLACE_SETTINGS_ACCESS',
  ApProductEdit = 'AP_PRODUCT_EDIT',
  ApProductView = 'AP_PRODUCT_VIEW',
  ApProfessionalAdmin = 'AP_PROFESSIONAL_ADMIN',
  BmAdminDelete = 'BM_ADMIN_DELETE',
  BmAdminEdit = 'BM_ADMIN_EDIT',
  BmAdminView = 'BM_ADMIN_VIEW',
  BmAdvertAdminEdit = 'BM_ADVERT_ADMIN_EDIT',
  BmAnalyticsDelete = 'BM_ANALYTICS_DELETE',
  BmAnalyticsEdit = 'BM_ANALYTICS_EDIT',
  BmAnalyticsView = 'BM_ANALYTICS_VIEW',
  BmArticleDelete = 'BM_ARTICLE_DELETE',
  BmArticleEdit = 'BM_ARTICLE_EDIT',
  BmArticleView = 'BM_ARTICLE_VIEW',
  BmCategoryPlacementView = 'BM_CATEGORY_PLACEMENT_VIEW',
  BmContentApprove = 'BM_CONTENT_APPROVE',
  BmContentDelete = 'BM_CONTENT_DELETE',
  BmContentEdit = 'BM_CONTENT_EDIT',
  BmContentView = 'BM_CONTENT_VIEW',
  BmDirectEnquiryView = 'BM_DIRECT_ENQUIRY_VIEW',
  BmEnhancedConversionsView = 'BM_ENHANCED_CONVERSIONS_VIEW',
  BmImageExport = 'BM_IMAGE_EXPORT',
  BmImageImport = 'BM_IMAGE_IMPORT',
  BmInboxDelete = 'BM_INBOX_DELETE',
  BmInboxEdit = 'BM_INBOX_EDIT',
  BmInboxReply = 'BM_INBOX_REPLY',
  BmInboxRevealContact = 'BM_INBOX_REVEAL_CONTACT',
  BmInboxShare = 'BM_INBOX_SHARE',
  BmInboxUpdateStatus = 'BM_INBOX_UPDATE_STATUS',
  BmInboxView = 'BM_INBOX_VIEW',
  BmIntegrationsSettings = 'BM_INTEGRATIONS_SETTINGS',
  BmInvoiceDelete = 'BM_INVOICE_DELETE',
  BmInvoiceEdit = 'BM_INVOICE_EDIT',
  BmInvoiceExport = 'BM_INVOICE_EXPORT',
  BmInvoiceMarkPaid = 'BM_INVOICE_MARK_PAID',
  BmInvoiceRefund = 'BM_INVOICE_REFUND',
  BmInvoiceSend = 'BM_INVOICE_SEND',
  BmInvoiceView = 'BM_INVOICE_VIEW',
  BmLeadsScopeAll = 'BM_LEADS_SCOPE_ALL',
  BmLeadsScopeSelf = 'BM_LEADS_SCOPE_SELF',
  BmMarketingView = 'BM_MARKETING_VIEW',
  BmMembershipDelete = 'BM_MEMBERSHIP_DELETE',
  BmMembershipEdit = 'BM_MEMBERSHIP_EDIT',
  BmMembershipView = 'BM_MEMBERSHIP_VIEW',
  BmOrdersView = 'BM_ORDERS_VIEW',
  BmPageTemplateApply = 'BM_PAGE_TEMPLATE_APPLY',
  BmPageTemplateCreate = 'BM_PAGE_TEMPLATE_CREATE',
  BmPlatformSync = 'BM_PLATFORM_SYNC',
  BmProductsDelete = 'BM_PRODUCTS_DELETE',
  BmProductsEdit = 'BM_PRODUCTS_EDIT',
  BmProductsView = 'BM_PRODUCTS_VIEW',
  BmProductTaggingApprove = 'BM_PRODUCT_TAGGING_APPROVE',
  BmProductTaggingCreate = 'BM_PRODUCT_TAGGING_CREATE',
  BmProductTaggingDelete = 'BM_PRODUCT_TAGGING_DELETE',
  BmProfessionalCreate = 'BM_PROFESSIONAL_CREATE',
  BmProfileDelete = 'BM_PROFILE_DELETE',
  BmProfileEdit = 'BM_PROFILE_EDIT',
  BmProfileView = 'BM_PROFILE_VIEW',
  BmProjectDelete = 'BM_PROJECT_DELETE',
  BmProjectEdit = 'BM_PROJECT_EDIT',
  BmProjectView = 'BM_PROJECT_VIEW',
  BmQuoteDelete = 'BM_QUOTE_DELETE',
  BmQuoteEdit = 'BM_QUOTE_EDIT',
  BmQuoteSend = 'BM_QUOTE_SEND',
  BmQuoteTemplateDelete = 'BM_QUOTE_TEMPLATE_DELETE',
  BmQuoteTemplateEdit = 'BM_QUOTE_TEMPLATE_EDIT',
  BmQuoteTemplateView = 'BM_QUOTE_TEMPLATE_VIEW',
  BmQuoteView = 'BM_QUOTE_VIEW',
  BmSettingUpdate = 'BM_SETTING_UPDATE',
  BmStaffView = 'BM_STAFF_VIEW',
  BmSupportView = 'BM_SUPPORT_VIEW',
  BmTermsDelete = 'BM_TERMS_DELETE',
  BmTermsEdit = 'BM_TERMS_EDIT',
  BmTermsView = 'BM_TERMS_VIEW',
  DevCommand = 'DEV_COMMAND',
  DevUnattended = 'DEV_UNATTENDED',
  FcPinEdit = 'FC_PIN_EDIT'
}

export enum PermissionGroupEnum {
  BusinessManagerAccess = 'BusinessManagerAccess',
  MarketplaceSettingsAccess = 'MarketplaceSettingsAccess',
  ProductManagement = 'ProductManagement',
  ProfessionalAdmin = 'ProfessionalAdmin'
}

export type PermissionGroupFeature = {
  __typename?: 'PermissionGroupFeature';
  FeatureKey: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  PermissionLevel: PermissionLevelEnum;
  Title: Scalars['String']['output'];
};

export type PermissionInterface = {
  ID: Scalars['Int']['output'];
  Permissions: Array<PermissionEnum>;
};

/** Permission level enum for team member permissions (NoAccess, View, Edit, FullAccess). */
export enum PermissionLevelEnum {
  Edit = 'Edit',
  FullAccess = 'FullAccess',
  NoAccess = 'NoAccess',
  View = 'View'
}

export type PermissionResource = {
  /** ID of the Resource */
  ID: Scalars['Int']['input'];
  /** Type of the Resource */
  Type: ResourceType;
};

export type PersonalMoodBoardsSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type PhotoCollageModule = ModuleType & {
  __typename?: 'PhotoCollageModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  /** Images */
  Images: Images_Connection;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type PhotoCollageModuleImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Images_SortFields>;
};

export type PhotoPin = {
  __typename?: 'PhotoPin';
  BoardID: Scalars['Int']['output'];
  BoardURLSegment: Scalars['String']['output'];
  CanDelete: Scalars['Boolean']['output'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int']['output'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryImageID?: Maybe<Scalars['Int']['output']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']['output']>;
  PageType?: Maybe<Scalars['String']['output']>;
  PageTypeID?: Maybe<Scalars['Int']['output']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  ProfessionalID?: Maybe<Scalars['Int']['output']>;
  ProfessionalLink?: Maybe<Scalars['String']['output']>;
  ProfessionalTitle?: Maybe<Scalars['String']['output']>;
  ProfessionalWebsite?: Maybe<Scalars['String']['output']>;
  SubTitle: Scalars['String']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

/** Deprecated. Use DesignBoardPin type instead. */
export type Pin = ArticlePin | MemberUploadPin | PhotoPin | ProductPin | ProfessionalPin | ProjectPin;

export type PinInput = {
  DesignBoardID?: InputMaybe<Scalars['Int']['input']>;
  /** Optional polymorphic class name recording the surface this pin was saved from (e.g. \"Archipro\Component\PageBuilder\ORM\EventDetails\" for an HDE save). Used downstream by EventTicket.SavedItems. */
  SavedFromClass?: InputMaybe<Scalars['String']['input']>;
  /** Optional polymorphic record ID matching SavedFromClass. Ignored unless SavedFromClass is also supplied. */
  SavedFromID?: InputMaybe<Scalars['Int']['input']>;
  Type: Scalars['String']['input'];
  TypeID: Scalars['Int']['input'];
  URLSearchParams?: InputMaybe<Scalars['String']['input']>;
};

export type PinMembershipResult = {
  __typename?: 'PinMembershipResult';
  /** IDs of boards that contain this pin */
  boardIds: Array<Scalars['ID']['output']>;
  /** Total number of boards containing this pin */
  totalCount: Scalars['Int']['output'];
};

export type PinPermission = {
  __typename?: 'PinPermission';
  CanAddComments: Scalars['Boolean']['output'];
  CanDelete: Scalars['Boolean']['output'];
  CanViewComments: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
};

/** The type of pin being checked for membership. */
export enum PinTypeEnum {
  /** Pin is a LibraryImage (photo pin) */
  Image = 'IMAGE',
  /** Pin is a LibraryPage (product, project, professional, article) */
  Page = 'PAGE'
}

export type Pin_CommentsConnection = {
  __typename?: 'Pin_CommentsConnection';
  edges: Array<Pin_CommentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Pin_CommentsConnectionEdge = {
  __typename?: 'Pin_CommentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Comment;
};

export type PinterestBreakdownFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type PinterestCampaignsFilters = {
  CAMPAIGN_START_TIME__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PinterestSummaryFilters = {
  CAMPAIGN_ID__EQUAL?: InputMaybe<Scalars['String']['input']>;
  CAMPAIGN_START_TIME__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelActivityByOrderFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  USER_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type PixelActivityBySessionFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  SESSION_ORDER__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  USER_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type PixelActivityByUserFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Pixel Conversion Setting collection. */
export type PixelConversionSettings = {
  __typename?: 'PixelConversionSettings';
  categories: Array<ConversionCategory>;
  conversionTypes: Array<ConversionType>;
  funnels: Array<FunnelStage>;
};


/** Pixel Conversion Setting collection. */
export type PixelConversionSettingsConversionTypesArgs = {
  professionalID: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type PixelConversionsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelConversionsNonDistinctFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelIndustryBreakdownFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelRegionBreakdownFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelReturningUserBreakdownFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelRuleConversionsFilters = {
  CONVERSION__EQUAL?: InputMaybe<Scalars['String']['input']>;
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  PIXEL_CONVERSION_RULE__EQUAL?: InputMaybe<Scalars['String']['input']>;
  TRIGGER_TYPE__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type PixelSmokeTestFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelStatsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelTopLandingPagesFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelTopReferralsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PixelTracker = {
  __typename?: 'PixelTracker';
  BucketID: Scalars['String']['output'];
  ConversionList: Array<PixelTrackerConversion>;
  CreatedAt: Scalars['Int']['output'];
  CustomConversionList: Array<PixelTrackerConversionConfig>;
  EventTrackingStatus?: Maybe<PixelTrackerSnowflakeData>;
  HomeownerBreakdown: PixelTrackerHomeownerBreakdown;
  ID: Scalars['ID']['output'];
  MetaData?: Maybe<PixelTrackerMetaData>;
  MetricItemList: Array<PixelTrackerMetricItem>;
  ProfessionalBreakdown: PixelTrackerProfessionalBreakdown;
  ProfessionalID: Scalars['Int']['output'];
  RealtimeSessionList?: Maybe<PixelTrackerRealtimeSessions_Connection>;
  RealtimeUserList?: Maybe<PixelTrackerRealtimeUsers_Connection>;
  Status?: Maybe<Scalars['String']['output']>;
  TopEventList?: Maybe<PixelTrackerTopEventList_Connection>;
  TopPageList: Array<PixelTrackerTopPage>;
  TotalUV: Scalars['Int']['output'];
  UpdatedAt?: Maybe<Scalars['Float']['output']>;
  conversionConfigList?: Maybe<ProfessionalPixelTrackerConversionStatus_Connection>;
};


export type PixelTrackerCustomConversionListArgs = {
  EventType?: InputMaybe<PixelTrackerConversionConfigEventType>;
};


export type PixelTrackerRealtimeSessionListArgs = {
  PID: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PixelTrackerRealtimeUserListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PixelTrackerTopEventListArgs = {
  EventType: PixelTrackerTopEventEnum;
  SearchText?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PixelTrackerConversionConfigListArgs = {
  conversionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  eventCountSortDirection?: InputMaybe<SortDirectionEnum>;
  groupBy?: InputMaybe<ConversionGroupByEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Conversion aggregated data by Athena. */
export type PixelTrackerConversion = {
  __typename?: 'PixelTrackerConversion';
  BucketID: Scalars['String']['output'];
  EventType: Scalars['String']['output'];
  ExtraInfo: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  IsArchipro: Scalars['Boolean']['output'];
  IsPending: Scalars['Boolean']['output'];
  ProfessionalID: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  URL?: Maybe<Scalars['String']['output']>;
  Value: Scalars['Int']['output'];
};

/** Professional customized conversions stored in mysql */
export type PixelTrackerConversionConfig = {
  __typename?: 'PixelTrackerConversionConfig';
  AppearURL?: Maybe<Scalars['String']['output']>;
  Archived: Scalars['Boolean']['output'];
  ConversionCategory?: Maybe<ConversionCategory>;
  ConversionType?: Maybe<ConversionType>;
  Created: Scalars['String']['output'];
  CreatedBy?: Maybe<Member>;
  CreatedByName?: Maybe<Scalars['String']['output']>;
  EventType: PixelTrackerConversionConfigEventType;
  ExtraInfo: Scalars['String']['output'];
  FunnelStage?: Maybe<FunnelStage>;
  ID: Scalars['ID']['output'];
  Professional?: Maybe<Professional>;
  ProfessionalID: Scalars['Int']['output'];
  ProfessionalURLSegment: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

/** Conversion config eventType enum */
export enum PixelTrackerConversionConfigEventType {
  Custom = 'CUSTOM',
  Formsubmit = 'FORMSUBMIT',
  Pageview = 'PAGEVIEW'
}

export type PixelTrackerHomeownerBreakdown = {
  __typename?: 'PixelTrackerHomeownerBreakdown';
  ID: Scalars['ID']['output'];
  Regions: Array<PixelTrackerPieChart>;
  Users: Array<PixelTrackerPieChart>;
};

export enum PixelTrackerIsTrackingEnumType {
  NotTracking = 'NotTracking',
  Tracking = 'Tracking',
  TrackingError = 'TrackingError',
  Description = 'description'
}

/** ArchiPro Pixel, meta data of each professional. */
export type PixelTrackerMetaData = {
  __typename?: 'PixelTrackerMetaData';
  Aggregation?: Maybe<PixelTrackerMetaDataAggregation>;
  BucketID: Scalars['String']['output'];
  HasRealtimeData: Scalars['Boolean']['output'];
  ID: Scalars['String']['output'];
  IsTracking: PixelTrackerIsTrackingEnumType;
  LastPixelTrackerEventTimestamp?: Maybe<Scalars['Float']['output']>;
  LastPixelTrackerPingEventTimestamp?: Maybe<Scalars['Float']['output']>;
  LastPixelTrackerRealEventTimestamp?: Maybe<Scalars['Float']['output']>;
  ProfessionalID: Scalars['String']['output'];
  QualifiedTimestamp?: Maybe<Scalars['Float']['output']>;
};

/** The aggregation sub-field of ArchiPro Pixel metadata for each professional. */
export type PixelTrackerMetaDataAggregation = {
  __typename?: 'PixelTrackerMetaDataAggregation';
  CreatedAt?: Maybe<Scalars['Float']['output']>;
  ID: Scalars['ID']['output'];
  Status?: Maybe<Scalars['String']['output']>;
  UpdatedAt?: Maybe<Scalars['Float']['output']>;
};

/** overview statistic data of ArchiPro Pixel, contains events like \"total time spent\", \"page views\", \"website referrals\", etc. */
export type PixelTrackerMetricItem = {
  __typename?: 'PixelTrackerMetricItem';
  BucketID: Scalars['String']['output'];
  Description: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  IsArchipro: Scalars['Boolean']['output'];
  ProfessionalID: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  Type: Scalars['String']['output'];
  Value: Scalars['Int']['output'];
};

export type PixelTrackerPieChart = {
  __typename?: 'PixelTrackerPieChart';
  Data: Scalars['Int']['output'];
  ID: Scalars['ID']['output'];
  Range: Scalars['String']['output'];
};

export type PixelTrackerProfessionalBreakdown = {
  __typename?: 'PixelTrackerProfessionalBreakdown';
  Categories: Array<PixelTrackerPieChart>;
  ID: Scalars['ID']['output'];
  Regions: Array<PixelTrackerPieChart>;
  Users: Array<PixelTrackerPieChart>;
};

export type PixelTrackerRealTimeEvent = {
  __typename?: 'PixelTrackerRealTimeEvent';
  Event: Scalars['String']['output'];
  EventConversion?: Maybe<Scalars['String']['output']>;
  EventData: Scalars['String']['output'];
  EventDescription: Scalars['String']['output'];
  EventIsArchipro: Scalars['Boolean']['output'];
  EventSource: Scalars['String']['output'];
  EventTimeSpent?: Maybe<Scalars['Float']['output']>;
  ID: Scalars['ID']['output'];
  RawURL: Scalars['String']['output'];
  RecordID: Scalars['String']['output'];
  TargetTitle: Scalars['String']['output'];
  Timestamp: Scalars['Float']['output'];
  WebsiteEventFromOtherPage?: Maybe<Scalars['Boolean']['output']>;
};

export type PixelTrackerRealTimeSession = {
  __typename?: 'PixelTrackerRealTimeSession';
  BucketID: Scalars['String']['output'];
  Events: Array<PixelTrackerRealTimeEvent>;
  ID: Scalars['ID']['output'];
  PrefixID: Scalars['String']['output'];
  ProfessionalID: Scalars['String']['output'];
  SessionEndTime: Scalars['Float']['output'];
  SessionOrder: Scalars['Int']['output'];
  SessionStartTime: Scalars['Float']['output'];
  SessionTotalTimeSpent?: Maybe<Scalars['Float']['output']>;
  Timestamp: Scalars['Float']['output'];
  TotalEvents: Scalars['Int']['output'];
};

export type PixelTrackerRealTimeUser = {
  __typename?: 'PixelTrackerRealTimeUser';
  BucketID: Scalars['String']['output'];
  FirstSessionStart: Scalars['Float']['output'];
  ID: Scalars['ID']['output'];
  IsNewUser: Scalars['Boolean']['output'];
  IsOnline: Scalars['Boolean']['output'];
  LastSessionEnd: Scalars['Float']['output'];
  LastSessionStart: Scalars['Float']['output'];
  PrefixID: Scalars['String']['output'];
  ProfessionalID: Scalars['String']['output'];
  Source: Scalars['String']['output'];
  Timestamp: Scalars['Float']['output'];
  TotalConversions: Scalars['Int']['output'];
  TotalPageViews: Scalars['Int']['output'];
  TotalSessions: Scalars['Int']['output'];
  TotalTimeSpent?: Maybe<Scalars['Float']['output']>;
  UserCategory?: Maybe<Scalars['String']['output']>;
  UserLocation?: Maybe<Scalars['String']['output']>;
};

export type PixelTrackerRealtimeSessions_Connection = {
  __typename?: 'PixelTrackerRealtimeSessions_Connection';
  ID: Scalars['ID']['output'];
  nodes: Array<PixelTrackerRealTimeSession>;
  pageInfo: ApPageInfo;
};

export type PixelTrackerRealtimeUsers_Connection = {
  __typename?: 'PixelTrackerRealtimeUsers_Connection';
  ID: Scalars['ID']['output'];
  nodes: Array<PixelTrackerRealTimeUser>;
  pageInfo: ApPageInfo;
};

/** Snowflake data for pixel tracker, first and last event dates */
export type PixelTrackerSnowflakeData = {
  __typename?: 'PixelTrackerSnowflakeData';
  CreatedAt?: Maybe<Scalars['Int']['output']>;
  Status: Scalars['String']['output'];
  UpdatedAt?: Maybe<Scalars['Int']['output']>;
};

export type PixelTrackerTopEvent = {
  __typename?: 'PixelTrackerTopEvent';
  AppearPages?: Maybe<Scalars['Int']['output']>;
  AppearURL?: Maybe<Scalars['String']['output']>;
  BucketID: Scalars['String']['output'];
  EventName: Scalars['String']['output'];
  EventSource: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  InDB: Scalars['Boolean']['output'];
  PageViews: Scalars['Int']['output'];
  ProfessionalID: Scalars['Int']['output'];
};

/** ArchiPro Pixel top events, currently support pageview and formsubmit */
export enum PixelTrackerTopEventEnum {
  FormSubmit = 'FormSubmit',
  PageView = 'PageView'
}

export type PixelTrackerTopEventList_Connection = {
  __typename?: 'PixelTrackerTopEventList_Connection';
  ID: Scalars['ID']['output'];
  nodes: Array<PixelTrackerTopEvent>;
  pageInfo: ApPageInfo;
};

/** Top referral pages on ArchiPro and top 5 visited pages on professional website */
export type PixelTrackerTopPage = {
  __typename?: 'PixelTrackerTopPage';
  BucketID: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  IsArchipro: Scalars['Boolean']['output'];
  Link: Scalars['String']['output'];
  Order: Scalars['Int']['output'];
  ProfessionalID: Scalars['Int']['output'];
  Thumbnail?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Value: Scalars['Int']['output'];
};

export type PlaceDetailType = {
  __typename?: 'PlaceDetailType';
  Address1?: Maybe<Scalars['String']['output']>;
  Address2?: Maybe<Scalars['String']['output']>;
  AddressID?: Maybe<Scalars['String']['output']>;
  ChildCount?: Maybe<Scalars['Int']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  Depth?: Maybe<Scalars['Int']['output']>;
  District?: Maybe<Scalars['String']['output']>;
  Division?: Maybe<Scalars['String']['output']>;
  FullAddress: Scalars['String']['output'];
  Latitude?: Maybe<Scalars['Float']['output']>;
  Longitude?: Maybe<Scalars['Float']['output']>;
  ParentID?: Maybe<Scalars['Int']['output']>;
  PlaceName?: Maybe<Scalars['String']['output']>;
  PlaceType?: Maybe<FindPlaceTypeEnum>;
  PostCode?: Maybe<Scalars['String']['output']>;
  Region?: Maybe<Scalars['String']['output']>;
  ServiceableAreaID?: Maybe<Scalars['Int']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Suburb?: Maybe<Scalars['String']['output']>;
};

export type PlaceDetailTypeInput = {
  Address1?: InputMaybe<Scalars['String']['input']>;
  Address2?: InputMaybe<Scalars['String']['input']>;
  AddressID?: InputMaybe<Scalars['String']['input']>;
  City?: InputMaybe<Scalars['String']['input']>;
  Country?: InputMaybe<Scalars['String']['input']>;
  Depth?: InputMaybe<Scalars['Int']['input']>;
  District?: InputMaybe<Scalars['String']['input']>;
  Division?: InputMaybe<Scalars['String']['input']>;
  FullAddress: Scalars['String']['input'];
  Latitude?: InputMaybe<Scalars['Float']['input']>;
  Longitude?: InputMaybe<Scalars['Float']['input']>;
  ParentID?: InputMaybe<Scalars['Int']['input']>;
  PlaceName?: InputMaybe<Scalars['String']['input']>;
  PlaceType?: InputMaybe<FindPlaceTypeEnum>;
  PostCode?: InputMaybe<Scalars['String']['input']>;
  Region?: InputMaybe<Scalars['String']['input']>;
  ServiceableAreaID?: InputMaybe<Scalars['Int']['input']>;
  Slug?: InputMaybe<Scalars['String']['input']>;
  State?: InputMaybe<Scalars['String']['input']>;
  Suburb?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceholderModule = ModuleType & {
  __typename?: 'PlaceholderModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export type PlacementFeaturedItemsSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type PlacementFeaturedItems_Connection = {
  __typename?: 'PlacementFeaturedItems_Connection';
  ID: Scalars['String']['output'];
  edges: Array<PlacementFeaturedItems_ConnectionEdge>;
  nodes: Array<FeaturedItemData>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type PlacementFeaturedItems_ConnectionEdge = {
  __typename?: 'PlacementFeaturedItems_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: FeaturedItemData;
};

export type PlacementPotMsSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type PlacementPotMs_Connection = {
  __typename?: 'PlacementPOTMs_Connection';
  ID: Scalars['String']['output'];
  edges: Array<PlacementPotMs_ConnectionEdge>;
  nodes: Array<PotmData>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type PlacementPotMs_ConnectionEdge = {
  __typename?: 'PlacementPOTMs_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: PotmData;
};

export type PlainTextModule = ModuleType & {
  __typename?: 'PlainTextModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
};

export type PlatformConnection = {
  __typename?: 'PlatformConnection';
  ConnectHash?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  DataMap?: Maybe<Scalars['String']['output']>;
  DisabledSettings?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
  InitiatedOn?: Maybe<Scalars['Int']['output']>;
  OrdersEnabled?: Maybe<Scalars['Boolean']['output']>;
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['output'];
  Shop: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  WebhooksDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type Postcode = {
  __typename?: 'Postcode';
  Country: Country;
  ID: Scalars['Int']['output'];
  Postcode: Scalars['String']['output'];
  PostcodeGroups: PostcodeGroupsConnection;
};


export type PostcodePostcodeGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PostcodeGroup = {
  __typename?: 'PostcodeGroup';
  Children: PostcodeGroupsConnection;
  Country: Country;
  ID: Scalars['Int']['output'];
  Postcodes: PostcodesConnection;
  Title: Scalars['String']['output'];
};


export type PostcodeGroupChildrenArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type PostcodeGroupPostcodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PostcodeGroupsConnection = {
  __typename?: 'PostcodeGroupsConnection';
  edges: Array<PostcodeGroupsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PostcodeGroupsConnectionEdge = {
  __typename?: 'PostcodeGroupsConnectionEdge';
  /** The node at the end of the collections edge */
  node: PostcodeGroup;
};

export type PostcodeGroups_Connection = {
  __typename?: 'PostcodeGroups_Connection';
  ID: Scalars['String']['output'];
  edges: Array<PostcodeGroups_ConnectionEdge>;
  nodes: Array<PostcodeGroup>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type PostcodeGroups_ConnectionEdge = {
  __typename?: 'PostcodeGroups_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: PostcodeGroup;
};

export type PostcodesConnection = {
  __typename?: 'PostcodesConnection';
  edges: Array<PostcodesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PostcodesConnectionEdge = {
  __typename?: 'PostcodesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Postcode;
};

export type PremiumFeatureCheckoutPoll = {
  __typename?: 'PremiumFeatureCheckoutPoll';
  HasProcessingPayment: Scalars['Boolean']['output'];
  InvoicePaymentStatus: Scalars['String']['output'];
  InvoiceStatus: Scalars['String']['output'];
};

export type PremiumFeatureStripeCheckout = {
  __typename?: 'PremiumFeatureStripeCheckout';
  /** Stripe Invoice subtotal (major currency units) */
  AmountSubtotal?: Maybe<Scalars['Float']['output']>;
  /** Card surcharge line total from the Stripe invoice (major currency units) when a premium-feature checkout surcharge applies; otherwise null */
  AmountSurcharge?: Maybe<Scalars['Float']['output']>;
  /** Stripe Invoice tax (major currency units) */
  AmountTax?: Maybe<Scalars['Float']['output']>;
  /** Stripe Invoice total (major currency units) */
  AmountTotal?: Maybe<Scalars['Float']['output']>;
  /** ISO 4217 uppercase code from the Stripe invoice (e.g. NZD, AUD) for checkout display rules */
  Currency: Scalars['String']['output'];
  /** Pipe-separated checkout context fingerprint after the last successful prepare (professional id, sorted cart SKUs, pack checkout mode, attach pack id when applicable, proration date); empty when not yet persisted for this prepare. */
  EnsureContextFingerprint: Scalars['String']['output'];
  PublishableKey?: Maybe<Scalars['String']['output']>;
  /** False when the first segment total is zero: attach to an existing pack (re-subscribe without charging) or new monthly/annual/daily (create subscription pack without Stripe). Complete via completePremiumPackResubscribeWithoutPayment instead of payPremiumFeatureStripeInvoice. */
  RequiresPayment: Scalars['Boolean']['output'];
  StripeAccount?: Maybe<Scalars['String']['output']>;
  /** Stripe Invoice id for payable checkout; null when RequiresPayment is false ($0 first segment: attach re-subscribe or new monthly/annual/daily subscribe without invoice). */
  StripeInvoiceID?: Maybe<Scalars['String']['output']>;
  /** SubscriptionPack id when attaching to an existing pack; 0 when the pack row is created only after payment (pay path) or only after completePremiumPackResubscribeWithoutPayment ($0 new monthly/annual/daily). */
  SubscriptionPackID: Scalars['Int']['output'];
  /** Human-readable card surcharge rate for display (e.g. \"2.7%\") when a surcharge line applies; otherwise null */
  SurchargeRateLabel?: Maybe<Scalars['String']['output']>;
  /** When every non-surcharge line item uses the same single positive tax rate (e.g. 15%), a short label for display; otherwise null */
  UnifiedTaxRateLabel?: Maybe<Scalars['String']['output']>;
};

export type PremiumFeatureStripeCheckoutPoll = {
  __typename?: 'PremiumFeatureStripeCheckoutPoll';
  ArchiproFulfillmentReady: Scalars['Boolean']['output'];
  HasProcessingPayment: Scalars['Boolean']['output'];
  InvoicePaymentStatus: Scalars['String']['output'];
  InvoiceStatus: Scalars['String']['output'];
  StripeInvoiceStatus: Scalars['String']['output'];
};

export enum PriceUnitEnum {
  Box = 'Box',
  CubicMetre = 'CubicMetre',
  LinearMetre = 'LinearMetre',
  SquareMetre = 'SquareMetre',
  Unit = 'Unit'
}

export type PricingDisplay = {
  __typename?: 'PricingDisplay';
  Amount: Scalars['Int']['output'];
  Currency?: Maybe<Scalars['String']['output']>;
  HighestAmount: Scalars['Int']['output'];
  LowestAmount: Scalars['Int']['output'];
  Prefix?: Maybe<Scalars['String']['output']>;
  ReferenceVariant?: Maybe<Variant>;
  ReplacedAmount?: Maybe<Scalars['Int']['output']>;
  ReplacedText?: Maybe<Scalars['String']['output']>;
  Text: Scalars['String']['output'];
};

/** The primary CTA for a professional. */
export enum PrimaryCtaEnum {
  AskAQuestion = 'AskAQuestion',
  AutoOptimise = 'AutoOptimise',
  BookConsultation = 'BookConsultation',
  GetInTouch = 'GetInTouch',
  MessageSeller = 'MessageSeller',
  RequestBrochure = 'RequestBrochure',
  RequestMeeting = 'RequestMeeting',
  RequestPrice = 'RequestPrice',
  RequestQuote = 'RequestQuote'
}

export type PrimaryCategory_ParentsConnection = {
  __typename?: 'PrimaryCategory_ParentsConnection';
  edges: Array<PrimaryCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type PrimaryCategory_ParentsConnectionEdge = {
  __typename?: 'PrimaryCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: CategoryPage;
};

export type PrioritySort = {
  Direction?: InputMaybe<SortDirection>;
  Priority?: InputMaybe<Scalars['Int']['input']>;
};

export type Product = DesignBoardPinTarget & DirectoryItem & IApprovable & ICreatable & IFileCategory & IHasProfessional & IHomePinable & IPublishable & IRecentlyViewedTile & SortableItem & TagTarget & {
  __typename?: 'Product';
  ARFileData?: Maybe<ArFileData>;
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']['output']>;
  AlsoFromProducts: AlsoFromProductsConnection;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
  ArcherCommentCount: Scalars['Int']['output'];
  ArcherCommentError: Scalars['Int']['output'];
  ArcherComments: ArcherCommentsConnection;
  AssociatedPages: Product_AssociatedPagesConnection;
  AttributeOptions: AttributeOptionsConnection;
  AvailabilityZones: Array<Zone>;
  Awards: ProductAwardsConnection;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  Brand: Scalars['String']['output'];
  CanPurchase: Scalars['Boolean']['output'];
  Categories: Array<Category>;
  Clones?: Maybe<Array<DirectoryItem>>;
  Colors: Array<AttributeOption>;
  ColorsCount: Scalars['Int']['output'];
  Content?: Maybe<Scalars['String']['output']>;
  ContentComment?: Maybe<Scalars['String']['output']>;
  ContentLocked: Scalars['Boolean']['output'];
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']['output']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  CreatedTimestamp: Scalars['Int']['output'];
  DataQualityRating: Scalars['Float']['output'];
  /** The data source of the product. */
  DataSource?: Maybe<IntegratedPlatformEnum>;
  DataSourceLabel: Scalars['String']['output'];
  DefaultImage?: Maybe<LibraryImage>;
  Deleted: Scalars['Boolean']['output'];
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  Designer: Scalars['String']['output'];
  DiagramImages: Array<DiagramImage>;
  DirectoryLiveDateTimestamp?: Maybe<Scalars['Int']['output']>;
  Disable: Scalars['Boolean']['output'];
  EcommerceObstructions: Array<Scalars['String']['output']>;
  EcommerceReady: Scalars['Boolean']['output'];
  EmbeddedData?: Maybe<Scalars['String']['output']>;
  Embeddings?: Maybe<Scalars['String']['output']>;
  ExcludeAdvertising: Scalars['Boolean']['output'];
  ExcludedFromSpecialtyRates: Scalars['Boolean']['output'];
  FacebookPreviewImage?: Maybe<Scalars['String']['output']>;
  FacetOptions: Array<FacetOption>;
  FeaturedProjects: ProjectsUsingProductConnection;
  FileCategories: FileCategoriesConnection;
  FirstPublishedDate?: Maybe<Scalars['String']['output']>;
  HasClones: Scalars['Boolean']['output'];
  HasDownloads: Scalars['Boolean']['output'];
  HasInstallers: Scalars['Boolean']['output'];
  HasPhotos: Scalars['Boolean']['output'];
  HasProducts: Scalars['Boolean']['output'];
  HasProductsInRange: Scalars['Boolean']['output'];
  HasProjects: Scalars['Boolean']['output'];
  HasSwatches: Scalars['Boolean']['output'];
  HasTags: Scalars['Boolean']['output'];
  HasVideos: Scalars['Boolean']['output'];
  HighestPriceVariant?: Maybe<Variant>;
  HighestTradePriceVariant?: Maybe<Variant>;
  /** Get the highest Purchasable variant price */
  HighestVariantPrice?: Maybe<CurrencyAmount>;
  HomePinned: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']['output']>;
  /** Which member linked each installer. Admin only. */
  InstallerLinkedByMemberInfo: Array<LinkedByMemberInfo>;
  Installers?: Maybe<InstallersType>;
  InvalidWebsite: Scalars['Boolean']['output'];
  IsCloned: Scalars['Boolean']['output'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean']['output'];
  IsFeature: Scalars['Boolean']['output'];
  IsFeatured: Scalars['Boolean']['output'];
  IsInServiceableArea: Scalars['Boolean']['output'];
  /** True if published and activated */
  IsLive: Scalars['Boolean']['output'];
  IsManufacturer: Scalars['Boolean']['output'];
  IsOnSale: Scalars['Boolean']['output'];
  IsTemplate: Scalars['Boolean']['output'];
  KPI?: Maybe<LibraryItemKpi>;
  LastEditedDate?: Maybe<Scalars['String']['output']>;
  LastEditedTimestamp: Scalars['Int']['output'];
  LastExternalUpdate?: Maybe<Scalars['String']['output']>;
  LastExternalUpdateTimestamp: Scalars['Int']['output'];
  LeadTime: Scalars['String']['output'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String']['output'];
  LiveDateTimestamp?: Maybe<Scalars['Int']['output']>;
  LowestPriceVariant?: Maybe<Variant>;
  LowestTradePriceVariant?: Maybe<Variant>;
  /** Get the lowest Purchasable variant price */
  LowestVariantPrice?: Maybe<CurrencyAmount>;
  MasterVariant?: Maybe<Variant>;
  Materials: AttributeOptions_MaterialsConnection;
  MemberPricing?: Maybe<PricingDisplay>;
  MemberSortOrder: Scalars['Int']['output'];
  Meta?: Maybe<Meta>;
  MostRelevantCategory?: Maybe<ProductCategory>;
  OtherRangeProducts: OtherRangeProductsConnection;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String']['output'];
  ParentID: Scalars['Int']['output'];
  PerformanceDescription: Scalars['String']['output'];
  PriceRange: Scalars['String']['output'];
  Pricing: ProductPricing;
  PricingDisplay?: Maybe<PricingDisplay>;
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  ProductCategories?: Maybe<Array<ProductCategory>>;
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  PublicKPI?: Maybe<LibraryItemPublicKpi>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean']['output'];
  PublishDate?: Maybe<Scalars['String']['output']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']['output']>;
  RecentlyViewedImage?: Maybe<RecentlyViewedImage>;
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']['output']>;
  SampleMessagePlaceholder?: Maybe<Scalars['String']['output']>;
  SampleSubmitText?: Maybe<Scalars['String']['output']>;
  SampleText?: Maybe<Scalars['String']['output']>;
  SampleTitle?: Maybe<Scalars['String']['output']>;
  SamplesAddressRequired: Scalars['Boolean']['output'];
  SamplesAvailable: Scalars['Boolean']['output'];
  ScopeOfUseDescription: Scalars['String']['output'];
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  ShowsInElasticSearch: Scalars['Boolean']['output'];
  Sizes: Array<ProductSize>;
  SortOrder: Scalars['Int']['output'];
  SpecialtyBannerText?: Maybe<Scalars['String']['output']>;
  SpecialtyCustomerPriceText?: Maybe<Scalars['String']['output']>;
  SpecialtyTradePriceText?: Maybe<Scalars['String']['output']>;
  StockInfo?: Maybe<StockInfo>;
  SupplierProductID?: Maybe<Scalars['String']['output']>;
  Swatches: Array<ProductSwatch>;
  Teaser?: Maybe<Scalars['String']['output']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String']['output'];
  TopBanner?: Maybe<LibraryItemBanner>;
  TradePricing?: Maybe<PricingDisplay>;
  URLSegment: Scalars['String']['output'];
  VariantSummary: Scalars['String']['output'];
  Variants: Array<Variant>;
  ViewsCount: Scalars['Int']['output'];
  Visibilities?: Maybe<Array<ProductVisibility>>;
  WarrantyDuration: Scalars['String']['output'];
  Website?: Maybe<Scalars['String']['output']>;
  WebsiteShort?: Maybe<Scalars['String']['output']>;
  WebsiteUntracked: Scalars['String']['output'];
  Year: Scalars['String']['output'];
  deprecated_Awards?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ProductAlsoFromProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductArcherCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductAttributeOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductAwardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type ProductColorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductFeaturedProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductFileCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FileCategoriesSortFields>;
};


export type ProductFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductLibraryImagesArgs = {
  IncludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductMaterialsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductOtherRangeProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductPublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProductViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};

export type ProductAttributeOption = {
  __typename?: 'ProductAttributeOption';
  AttributeOption: AttributeOption;
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
};

export type ProductAwardsConnection = {
  __typename?: 'ProductAwardsConnection';
  edges: Array<ProductAwardsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductAwardsConnectionEdge = {
  __typename?: 'ProductAwardsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Award;
};

/** The product CTA for a professional. */
export enum ProductCtaEnum {
  AskAQuestion = 'AskAQuestion',
  AutoOptimise = 'AutoOptimise',
  BookConsultation = 'BookConsultation',
  GetInTouch = 'GetInTouch',
  MessageSeller = 'MessageSeller',
  RequestBrochure = 'RequestBrochure',
  RequestMeeting = 'RequestMeeting',
  RequestPrice = 'RequestPrice',
  RequestQuote = 'RequestQuote'
}

export type ProductCategory = ICategory & IHasItems & {
  __typename?: 'ProductCategory';
  Categories: ProductCategory_CategoriesConnection;
  /** Category grouping for filtering (Interior, Building, None) */
  CategoryGroup?: Maybe<Scalars['String']['output']>;
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']['output']>;
  ItemsCount: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  MenuTitle: Scalars['String']['output'];
  Parent?: Maybe<ProductCategory>;
  Parents: ProductCategory_ParentsConnection;
  PrettyTitle: Scalars['String']['output'];
  Products: ProductCategory_ProductsConnection;
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
  URLSegment?: Maybe<Scalars['String']['output']>;
};


export type ProductCategoryCategoriesArgs = {
  filter?: InputMaybe<ProductCategory_CategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductCategory_CategoriesSortFields>;
};


export type ProductCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductCategoryItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};


export type ProductCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductCategoryProductsArgs = {
  filter?: InputMaybe<ProductCategory_ProductsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductCategory_ProductsSortFields>;
};


export type ProductCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategory_CategoriesConnection = {
  __typename?: 'ProductCategory_CategoriesConnection';
  edges: Array<ProductCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductCategory_CategoriesConnectionEdge = {
  __typename?: 'ProductCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductCategory;
};

export type ProductCategory_CategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCategory_CategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type ProductCategory_ParentsConnection = {
  __typename?: 'ProductCategory_ParentsConnection';
  edges: Array<ProductCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductCategory_ParentsConnectionEdge = {
  __typename?: 'ProductCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductCategory;
};

export type ProductCategory_ProductsConnection = {
  __typename?: 'ProductCategory_ProductsConnection';
  edges: Array<ProductCategory_ProductsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductCategory_ProductsConnectionEdge = {
  __typename?: 'ProductCategory_ProductsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Product;
};

export type ProductCategory_ProductsFilters = {
  /** Filters this type when CountryCode is in the provided value */
  CountryCode__in?: InputMaybe<Array<SupportedCountry>>;
  /** Filters this type when EcommerceEnabled is eq the provided value */
  EcommerceEnabled__eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by ID */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when Visibility is find_in the provided value */
  Visibility__find_in?: InputMaybe<Scalars['String']['input']>;
};

export type ProductCategory_ProductsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Popularity?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type ProductColor = {
  __typename?: 'ProductColor';
  Hex: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
  Synonyms: SynonymsConnection;
};


export type ProductColorSynonymsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductColorSynonym = {
  __typename?: 'ProductColorSynonym';
  ID: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
};

export type ProductEnrichmentResult = {
  __typename?: 'ProductEnrichmentResult';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  executionSeconds?: Maybe<Scalars['Float']['output']>;
  facetsProcessed: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  mostRelevantCategoryId?: Maybe<Scalars['Int']['output']>;
  optionsAdded: Scalars['Int']['output'];
  optionsFound: Scalars['Int']['output'];
  optionsRemoved: Scalars['Int']['output'];
  optionsUnchanged: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProductFeature = ModuleType & {
  __typename?: 'ProductFeature';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type ProductImprovementTaskStatus = {
  __typename?: 'ProductImprovementTaskStatus';
  ArcherCommentID: Scalars['Int']['output'];
  InProgress: Scalars['Boolean']['output'];
  Message?: Maybe<Scalars['String']['output']>;
  Success?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductMutationResult = NotAuthorizedError | NotFoundError | Product | ServerError | UserError;

export type ProductPin = {
  __typename?: 'ProductPin';
  ARFileData?: Maybe<ArFileData>;
  BoardID: Scalars['Int']['output'];
  BoardURLSegment: Scalars['String']['output'];
  CanDelete: Scalars['Boolean']['output'];
  CanPurchase: Scalars['Boolean']['output'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int']['output'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryImageID?: Maybe<Scalars['Int']['output']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']['output']>;
  PageType?: Maybe<Scalars['String']['output']>;
  PageTypeID?: Maybe<Scalars['Int']['output']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  ProfessionalID?: Maybe<Scalars['Int']['output']>;
  ProfessionalLink?: Maybe<Scalars['String']['output']>;
  ProfessionalTitle?: Maybe<Scalars['String']['output']>;
  ProfessionalWebsite?: Maybe<Scalars['String']['output']>;
  SubTitle: Scalars['String']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type ProductPricing = {
  __typename?: 'ProductPricing';
  ID: Scalars['Int']['output'];
  Maximum: CurrencyAmount;
  Minimum: CurrencyAmount;
  PricingType: ProductPricingTypeEnum;
  Product: Product;
  Retail: CurrencyAmount;
  Sale: CurrencyAmount;
  Sample: CurrencyAmount;
  SampleEnabled: Scalars['Boolean']['output'];
  SampleShipping?: Maybe<ShippingProfile>;
  Trade: CurrencyAmount;
  Unit?: Maybe<PriceUnitEnum>;
};

export enum ProductPricingTypeEnum {
  EcommercePricing = 'ecommercePricing',
  OnRequest = 'onRequest'
}

export type ProductResultData = {
  ProductID: Scalars['Int']['input'];
  SupplierProductID?: InputMaybe<Scalars['String']['input']>;
  Title: Scalars['String']['input'];
};

export type ProductSize = {
  __typename?: 'ProductSize';
  Depth: Scalars['Int']['output'];
  Diameter: Scalars['Int']['output'];
  /** Formatted without name: D00 x L00 x W00 x H00 - 0kg/0L */
  Formatted: Scalars['String']['output'];
  /** Full version: Name - D00 x L00 x W00 x H00 - 0kg/0L */
  FullTitle: Scalars['String']['output'];
  Height: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  Length: Scalars['Int']['output'];
  MeasurementUnit: Scalars['String']['output'];
  MeasurementUnitShort: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  PackageHeight: Scalars['Int']['output'];
  PackageLength: Scalars['Int']['output'];
  PackageWeight: Scalars['Int']['output'];
  PackageWidth: Scalars['Int']['output'];
  Product: Product;
  SortOrder: Scalars['Int']['output'];
  /** Sort version: size name or the formatted label if name is empty */
  Title: Scalars['String']['output'];
  Volume: Scalars['Int']['output'];
  Weight: Scalars['Int']['output'];
  Width: Scalars['Int']['output'];
};

export type ProductSizeInput = {
  Depth: Scalars['Int']['input'];
  Diameter: Scalars['Int']['input'];
  Height: Scalars['Int']['input'];
  Length: Scalars['Int']['input'];
  MeasurementUnit: Scalars['StringInput']['input'];
  Name: Scalars['StringInput']['input'];
  PackageHeight: Scalars['Int']['input'];
  PackageLength: Scalars['Int']['input'];
  PackageWeight: Scalars['Int']['input'];
  PackageWidth: Scalars['Int']['input'];
  Volume: Scalars['Int']['input'];
  Weight: Scalars['Int']['input'];
  Width: Scalars['Int']['input'];
};

/** The result of a product import */
export type ProductSummaryInputType = {
  InternalProductID?: InputMaybe<Scalars['Int']['input']>;
  Link?: InputMaybe<Scalars['String']['input']>;
  ProductID?: InputMaybe<Scalars['String']['input']>;
  SKUs?: InputMaybe<Array<Scalars['String']['input']>>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSwatch = {
  __typename?: 'ProductSwatch';
  AttributeOptions: Array<AttributeOption>;
  ColourImageFileID: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  Image: ResponsiveImage;
  MemberSortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  /** Deprecated. Can use a proper ResponsiveImage type. See `Image`. */
  URL: Scalars['String']['output'];
};

export type ProductSwatchUpdate = {
  ID: Scalars['Int']['input'];
  MemberSortOrder?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};

export type ProductTagStatsFilters = {
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type ProductTagTemporalStatsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductVisibility {
  Disabled = 'Disabled',
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly'
}

export type Product_AssociatedPagesConnection = {
  __typename?: 'Product_AssociatedPagesConnection';
  edges: Array<Product_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Product_AssociatedPagesConnectionEdge = {
  __typename?: 'Product_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type ProductsUsedInProjectConnection = {
  __typename?: 'ProductsUsedInProjectConnection';
  edges: Array<ProductsUsedInProjectConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProductsUsedInProjectConnectionEdge = {
  __typename?: 'ProductsUsedInProjectConnectionEdge';
  /** The node at the end of the collections edge */
  node: Product;
};

export type Professional = DesignBoardPinTarget & DirectoryItem & IApprovable & ICreatable & IFeaturedBrandPinable & IHomePinable & IPublishable & IRecentlyViewedTile & PermissionInterface & SortableItem & TagTarget & {
  __typename?: 'Professional';
  /** AI-generated summary for the professional */
  AIServiceSummary?: Maybe<Scalars['String']['output']>;
  APConnect: Scalars['Boolean']['output'];
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']['output']>;
  AggregatedPublicKPI?: Maybe<ProfessionalAggregatedKpi>;
  AllContacts: Array<Contact>;
  AllowBooking: Scalars['Boolean']['output'];
  AllowCRMIntegration: Scalars['Boolean']['output'];
  AllowEmailBuilder: Scalars['Boolean']['output'];
  AllowInLibraryForRelatedItems: Scalars['Boolean']['output'];
  AllowInvoicing: Scalars['Boolean']['output'];
  AllowsEnquiries: Scalars['Boolean']['output'];
  AnalyticsStatus: AnalyticsStatusEnum;
  AnalyticsSubscription?: Maybe<AnalyticsSubscription>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
  ArchiproEditorialAccount: Scalars['Boolean']['output'];
  ArticleAuthors: ArticleAuthorsConnection;
  Articles: Array<Article>;
  AssociatedPages: Professional_AssociatedPagesConnection;
  Associations: AssociationsConnection;
  AutoConfirmOrders: Scalars['Boolean']['output'];
  AvailabilityZones: Array<Zone>;
  AvailableForWork: Scalars['Boolean']['output'];
  Awards: ProfessionalAwardsConnection;
  /** Professional business number field */
  BN?: Maybe<Scalars['String']['output']>;
  BannerImages: Array<LibraryImage>;
  BannerOverlay: Scalars['Boolean']['output'];
  Banners: LibraryItemBannersConnection;
  BlockSummary?: Maybe<Scalars['String']['output']>;
  /** The business focus of a professional. */
  BusinessFocus: BusinessFocusEnum;
  /** fetches professional's business terms */
  BusinessTerms: ProfessionalBusinessTermsConnection;
  BusinessTermsCategories: Array<BusinessTermsCategory>;
  BusinessTypes: BusinessTypesConnection;
  CalendarSessions: CalendarSessionsConnection;
  /** Whether membership billing/invoices in Business Manager are available for this professional (data gate). True when LatestMembership has a linked PurchasedMembership, or when this professional has at least one client invoice in the invoice phase (not a quote). BM permissions and feature flags are applied in the UI. */
  CanViewMembershipInvoiceInBM: Scalars['Boolean']['output'];
  Categories: Array<Category>;
  City?: Maybe<Scalars['String']['output']>;
  CloneTasks: Array<CloneTask>;
  Clones?: Maybe<Array<DirectoryItem>>;
  CloningOptions: Array<Option>;
  CollectAllUserData: Scalars['Boolean']['output'];
  CollectWebsiteFormData: Scalars['Boolean']['output'];
  Companies: ProfessionalCompaniesConnection;
  CompanyCustomFields: Array<CustomField>;
  CompanyLogo?: Maybe<Scalars['String']['output']>;
  CompanyLogo48Cropped?: Maybe<Scalars['String']['output']>;
  CompanyLogo48Resized?: Maybe<Scalars['String']['output']>;
  CompanyLogo96Resized?: Maybe<Scalars['String']['output']>;
  CompanyLogo200Cropped?: Maybe<Scalars['String']['output']>;
  CompanyLogoAdsThumb?: Maybe<Scalars['String']['output']>;
  CompanyLogoPadded?: Maybe<Scalars['String']['output']>;
  CompanyLogoThumbMini?: Maybe<Scalars['String']['output']>;
  CompanyLogoThumbTiny?: Maybe<Scalars['String']['output']>;
  ContactCustomFields: Array<CustomField>;
  Contacts: ProfessionalContactsConnection;
  Content?: Maybe<Scalars['String']['output']>;
  ContentComment?: Maybe<Scalars['String']['output']>;
  ContentNotificationEmailAddresses: Array<Scalars['String']['output']>;
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']['output']>;
  Country: Scalars['String']['output'];
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  CreatedTimestamp: Scalars['Int']['output'];
  CustomEnquiryMessage?: Maybe<Scalars['String']['output']>;
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  /** Best \"{category} in {place}\" directory page for this professional, validated against the materialised view so it only ever links to a page that exists. Null when no category × serviced-area page exists. Used as the geographic crumb in the profile breadcrumb trail. */
  DirectoryLocationCrumb?: Maybe<ProfessionalLocationCrumb>;
  Disable: Scalars['Boolean']['output'];
  EcommerceEmailAddresses: Array<Scalars['String']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  EligibleShippingProducts: EligibleShippingProducts;
  Email?: Maybe<Scalars['String']['output']>;
  EmailAssets: Array<LibraryImage>;
  /** fetches professional's email templates */
  EmailTemplates: ProfessionalEmailTemplatesConnection;
  EmbeddedData?: Maybe<Scalars['String']['output']>;
  EmbeddedReport?: Maybe<EmbeddedReport>;
  EmbeddedReportsList?: Maybe<Array<Maybe<EmbeddedReport>>>;
  Embeddings?: Maybe<Scalars['String']['output']>;
  EngagementNotificationEmailAddresses: Array<Scalars['String']['output']>;
  /** Who can send enquiries to this professional. */
  EnquiryAudience: EnquiryAudienceEnum;
  EnquiryAvgResponseHours: Scalars['Int']['output'];
  EnquiryEmailAddresses: Array<Scalars['String']['output']>;
  /** What project types to receive enquiries for. */
  EnquiryProjectType: EnquiryProjectTypeEnum;
  EnquiryResponseRate: Scalars['Int']['output'];
  FacebookPreviewImage?: Maybe<Scalars['String']['output']>;
  FeaturedBrandPinned: Scalars['Boolean']['output'];
  FeaturedProductThumbs?: Maybe<Array<Maybe<LibraryThumb>>>;
  FeaturedProjectThumbs?: Maybe<Array<Maybe<LibraryThumb>>>;
  FirstPublishedDate?: Maybe<Scalars['String']['output']>;
  FreeShippingThreshold: CurrencyAmount;
  FreeShippingThresholdEnabled: Scalars['Boolean']['output'];
  FullAddress?: Maybe<Scalars['String']['output']>;
  GoogleAnalytics: GoogleAnalytics;
  /** Home Design Evening events this professional is exhibiting at. */
  HDEExhibitingEvents?: Maybe<Array<EventDetails>>;
  /** Staff-managed HDE exhibitor featured cards for this professional (typically one per event) */
  HDEExhibitorProfiles: Array<HdeExhibitorProfile>;
  HasArticles: Scalars['Boolean']['output'];
  HasClones: Scalars['Boolean']['output'];
  HasDownloads: Scalars['Boolean']['output'];
  HasImageLabels: Scalars['Boolean']['output'];
  HasNativeDriver: Scalars['Boolean']['output'];
  HasOnSitePlacement: Scalars['Boolean']['output'];
  HasPackages: Scalars['Boolean']['output'];
  HasPartners: Scalars['Boolean']['output'];
  HasPhotos: Scalars['Boolean']['output'];
  HasProducts: Scalars['Boolean']['output'];
  HasProjects: Scalars['Boolean']['output'];
  HasProjectsUsingThisProfessional: Scalars['Boolean']['output'];
  HasRunningAds: Scalars['Boolean']['output'];
  HasTags: Scalars['Boolean']['output'];
  HasTeamMembers: Scalars['Boolean']['output'];
  HasVideos: Scalars['Boolean']['output'];
  HomePinned: Scalars['Boolean']['output'];
  HubspotCompany?: Maybe<HubspotCompany>;
  ID: Scalars['Int']['output'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']['output']>;
  InvalidWebsite: Scalars['Boolean']['output'];
  IsCloned: Scalars['Boolean']['output'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean']['output'];
  IsEmailIntegrationEnabled: Scalars['Boolean']['output'];
  IsFeature: Scalars['Boolean']['output'];
  /** True if published and activated */
  IsLive: Scalars['Boolean']['output'];
  IsManufacturer: Scalars['Boolean']['output'];
  IsTemplate: Scalars['Boolean']['output'];
  KPI?: Maybe<LibraryItemKpi>;
  LastEditedDate?: Maybe<Scalars['String']['output']>;
  LastEditedTimestamp: Scalars['Int']['output'];
  Leads: ProfessionalContactsConnection;
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String']['output'];
  LiveDateTimestamp?: Maybe<Scalars['Int']['output']>;
  LogoBackgroundColor?: Maybe<Scalars['String']['output']>;
  LogoNavbar?: Maybe<Scalars['String']['output']>;
  MemberSortOrder: Scalars['Int']['output'];
  /** Current membership term end (Y-m-d) from latest membership add-on, if any. */
  MembershipEndDate?: Maybe<Scalars['String']['output']>;
  /** From LatestMembership ProfessionalMembership.IsUpfront when present; otherwise true (upfront default). False means instalment (non-upfront) membership; BM premium add-on rebills still use SubscriptionPack, not split-instalment invoice facades. */
  MembershipIsUpfront: Scalars['Boolean']['output'];
  /** From LatestMembership ProfessionalMembership.PaymentDay (1–31); default 20 when LatestMembership is missing. Core membership instalment scheduling; BM premium first-segment proration uses a calendar monthly pack cycle instead. */
  MembershipPaymentDay: Scalars['Int']['output'];
  /** Exclusive end date (Y-m-d) of the first premium checkout segment from MembershipHelper::premiumFeatureExclusiveEndYmdFromProfessional: next membership renewal when upfront; for instalment membership, the first monthly SubscriptionPackPriceCalculatorService cycle end from proration today (not PaymentDay). Null when the membership chain cannot be resolved (e.g. upfront path missing end). */
  MembershipPremiumFeatureExclusiveEndYmd?: Maybe<Scalars['String']['output']>;
  /** Calendar date (Y-m-d) the server uses as \"today\" for premium-feature proration (PHP default timezone). Clients should use this instead of the browser local date so estimated subtotals match Stripe checkout. */
  MembershipPremiumFeatureProrationToday: Scalars['String']['output'];
  /** Current membership term start (Y-m-d) from latest membership add-on, if any. */
  MembershipStartDate?: Maybe<Scalars['String']['output']>;
  Meta?: Maybe<Meta>;
  MetaData?: Maybe<ProfessionalMetaData>;
  Networks: OrganizationNetworkConnection;
  NoticePeriod: Scalars['Int']['output'];
  NoticePeriodUnit: ProfessionalNoticePeriodUnitEnum;
  OrganizationNetworkOwner?: Maybe<OrganizationNetworkOwner>;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String']['output'];
  /** fetches professional's team members with pagination and filtering */
  PaginatedTeamMembers: ProfessionalTeamMembersConnection;
  ParentID: Scalars['Int']['output'];
  Parents: Array<Professional>;
  PartnerCategories?: Maybe<Array<Category>>;
  Partners: Array<Professional>;
  Permissions: Array<PermissionEnum>;
  Phone: Scalars['String']['output'];
  Phone2?: Maybe<Scalars['String']['output']>;
  PhoneTracking?: Maybe<Scalars['String']['output']>;
  PhoneTrackingPlayMessage?: Maybe<Scalars['Boolean']['output']>;
  PickupLocations: Array<LibraryLocation>;
  PixelNotGated: Scalars['Boolean']['output'];
  PixelTracker?: Maybe<PixelTracker>;
  /** Professional postcode field */
  PostCode?: Maybe<Scalars['String']['output']>;
  PriceRanges: Array<ProfessionalPriceRange>;
  PricingDisabled: Scalars['Boolean']['output'];
  PrimaryAddress?: Maybe<Scalars['String']['output']>;
  /** The primary CTA for a professional. */
  PrimaryCTA: PrimaryCtaEnum;
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  /** The product CTA for a professional. */
  ProductCTA: ProductCtaEnum;
  ProductCount: Scalars['Int']['output'];
  Products: Array<Product>;
  ProductsAllowed: Scalars['Boolean']['output'];
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  ProfessionalServices: ProfessionalServicesConnection;
  ProfileLiveDate?: Maybe<Scalars['String']['output']>;
  ProjectCount: Scalars['Int']['output'];
  Projects: Array<Project>;
  PublicFacebookLink?: Maybe<Scalars['String']['output']>;
  PublicInstagramLink?: Maybe<Scalars['String']['output']>;
  PublicKPI?: Maybe<LibraryItemPublicKpi>;
  PublicLinkedinLink?: Maybe<Scalars['String']['output']>;
  PublicPinterestLink?: Maybe<Scalars['String']['output']>;
  PublicTikTokLink?: Maybe<Scalars['String']['output']>;
  PublicTwitterLink?: Maybe<Scalars['String']['output']>;
  PublicYoutubeLink?: Maybe<Scalars['String']['output']>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean']['output'];
  PublishDate?: Maybe<Scalars['String']['output']>;
  PublishedByMember?: Maybe<Member>;
  /** fetches professional's quarterly business reviews */
  QBRs: ProfessionalQbRsConnection;
  RawTileImage?: Maybe<Scalars['String']['output']>;
  RecentlyViewedImage?: Maybe<RecentlyViewedImage>;
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  Regions?: Maybe<Array<Region>>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']['output']>;
  SampleEstimatedWeight: Scalars['Int']['output'];
  SampleMessagePlaceholder?: Maybe<Scalars['String']['output']>;
  SampleSubmitText?: Maybe<Scalars['String']['output']>;
  SampleText?: Maybe<Scalars['String']['output']>;
  SampleTitle?: Maybe<Scalars['String']['output']>;
  SamplesAddressRequired: Scalars['Boolean']['output'];
  SamplesAvailable: Scalars['Boolean']['output'];
  /** Deal owners with at least one saved quote matching the listing scope */
  SavedQuoteDealOwners: Array<TeamMember>;
  /** fetches professional's saved quotes */
  SavedQuotes: ProfessionalSavedQuotesConnection;
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  ServiceAreas?: Maybe<Array<ProfessionalServiceArea>>;
  ServiceOfferings: Array<ServiceOffering>;
  /** Deprecated. Use ProfessionalServices instead. */
  Services?: Maybe<Array<Scalars['String']['output']>>;
  /** Audit trail of changes to this professional's tracked settings (the pixel lead-collection opt-ins), newest first. Optionally filter to a single setting via SettingName. Requires edit access to the professional. */
  SettingChanges: Array<ProfessionalSettingChange>;
  ShippingProfiles: Array<ShippingProfile>;
  ShippingPromotions: Array<ShippingPromotion>;
  ShippingProviders: Array<ShippingProvider>;
  ShippingZones: ShippingZonesConnection;
  ShowCaseStudies: Scalars['Boolean']['output'];
  ShowOwnProjectsOnly: Scalars['Boolean']['output'];
  ShowsInElasticSearch: Scalars['Boolean']['output'];
  SortOrder: Scalars['Int']['output'];
  SpecialityRatesOnSalePrices: Scalars['Boolean']['output'];
  SpecialtyRates?: Maybe<Array<SpecialtyRateCategories>>;
  SpecialtyRatesOnSalePrices: Scalars['Boolean']['output'];
  /** Professional state field */
  State?: Maybe<Scalars['String']['output']>;
  StatsReportEmailAddresses: Array<Scalars['String']['output']>;
  StripeAccount: Scalars['String']['output'];
  StripeAccountEnabled: Scalars['Boolean']['output'];
  /** Professional subtitle field */
  SubTitle?: Maybe<Scalars['String']['output']>;
  SuburbCity?: Maybe<Scalars['String']['output']>;
  /** Deprecated. Use PaginatedTeamMembers instead for pagination and filtering support. */
  TeamMembers: TeamMembersConnection;
  Teaser?: Maybe<Scalars['String']['output']>;
  Testimonials?: Maybe<Array<Testimonial>>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String']['output'];
  TopBanner?: Maybe<LibraryItemBanner>;
  URLSegment: Scalars['String']['output'];
  UseLegacyPixelReport?: Maybe<Scalars['Boolean']['output']>;
  Videos: VideosConnection;
  ViewsCount: Scalars['Int']['output'];
  Visibilities?: Maybe<Array<ProfessionalVisibility>>;
  Website?: Maybe<Scalars['String']['output']>;
  WebsiteLink?: Maybe<Scalars['String']['output']>;
  WebsiteShort?: Maybe<Scalars['String']['output']>;
  WebsiteUntracked: Scalars['String']['output'];
  /** The year the company was founded. */
  YearFounded: Scalars['String']['output'];
  deprecated_Awards?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ProfessionalApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalArticleAuthorsArgs = {
  filter?: InputMaybe<ArticleAuthorsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalArticlesArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalAssociationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalAwardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalAwardsSortFields>;
};


export type ProfessionalBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type ProfessionalBusinessTermsArgs = {
  filter?: InputMaybe<ProfessionalBusinessTermsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalBusinessTermsSortFields>;
};


export type ProfessionalBusinessTypesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BusinessTypesSortFields>;
};


export type ProfessionalCalendarSessionsArgs = {
  filter?: InputMaybe<CalendarSessionsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CalendarSessionsSortFields>;
};


export type ProfessionalCloneTasksArgs = {
  Status?: InputMaybe<AsyncTaskStatus>;
  TaskID?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalCompaniesArgs = {
  filter?: InputMaybe<ProfessionalCompaniesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalCompaniesSortFields>;
};


export type ProfessionalContactsArgs = {
  filter?: InputMaybe<ProfessionalContactsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalContactsSortFields>;
};


export type ProfessionalContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalEmailTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalEmbeddedReportArgs = {
  reportCategory: ReportCategory;
};


export type ProfessionalFeaturedProductThumbsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalFeaturedProjectThumbsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalGoogleAnalyticsArgs = {
  DateRange: BmDateRange;
};


export type ProfessionalImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalLeadsArgs = {
  filter?: InputMaybe<ProfessionalContactsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalContactsSortFields>;
};


export type ProfessionalLibraryImagesArgs = {
  IncludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfessionalNetworksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalPaginatedTeamMembersArgs = {
  filter?: InputMaybe<ProfessionalTeamMembersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalTeamMembersSortFields>;
};


export type ProfessionalPixelTrackerArgs = {
  DateRange?: InputMaybe<BmDateRange>;
};


export type ProfessionalProductsArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalProfessionalServicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalServicesSortFields>;
};


export type ProfessionalProjectsArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalPublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProfessionalQbRsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalSavedQuoteDealOwnersArgs = {
  IsTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  QuoteAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  Statuses?: InputMaybe<Array<InvoiceStatusEnum>>;
};


export type ProfessionalSavedQuotesArgs = {
  filter?: InputMaybe<ProfessionalSavedQuotesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalSavedQuotesSortFields>;
};


export type ProfessionalSettingChangesArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  SettingName?: InputMaybe<Scalars['String']['input']>;
};


export type ProfessionalShippingZonesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalTeamMembersArgs = {
  filter?: InputMaybe<TeamMembersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TeamMembersSortFields>;
};


export type ProfessionalVideosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VideosSortFields>;
};


export type ProfessionalViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};

export type ProfessionalAggregatedKpi = {
  __typename?: 'ProfessionalAggregatedKPI';
  ID: Scalars['Int']['output'];
  LibraryItemsCount: Scalars['Int']['output'];
  ProfessionalID: Scalars['Int']['output'];
  TotalEnquiries: Scalars['Int']['output'];
  TotalImpressions: Scalars['Int']['output'];
  TotalPageViews: Scalars['Int']['output'];
  TotalReferrals: Scalars['Int']['output'];
  TotalSaves: Scalars['Int']['output'];
  TotalTimeSpent: Scalars['Int']['output'];
};

export type ProfessionalAttendee = {
  __typename?: 'ProfessionalAttendee';
  ID: Scalars['ID']['output'];
  Link?: Maybe<Scalars['String']['output']>;
  Logo?: Maybe<LibraryImageFile>;
  Professional?: Maybe<Professional>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type ProfessionalAttendeeModule = ModuleType & {
  __typename?: 'ProfessionalAttendeeModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  /** List of professional attendees */
  Attendees: Attendees_Connection;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  HideSponsorText: Scalars['Boolean']['output'];
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  SponsorImage?: Maybe<LibraryImageFile>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type ProfessionalAttendeeModuleAttendeesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Attendees_SortFields>;
};

export type ProfessionalAwardBadgeDeleteResultType = Award | NotAuthorizedError | NotFoundError;

export type ProfessionalAwardMutationCreateResultType = Award | NotAuthorizedError | NotFoundError;

export type ProfessionalAwardMutationDeleteResultType = Award | NotAuthorizedError | NotFoundError;

export type ProfessionalAwardMutationUpdateResultType = Award | NotAuthorizedError | NotFoundError;

export type ProfessionalAwardsConnection = {
  __typename?: 'ProfessionalAwardsConnection';
  edges: Array<ProfessionalAwardsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalAwardsConnectionEdge = {
  __typename?: 'ProfessionalAwardsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Award;
};

export type ProfessionalAwardsSortFields = {
  Created?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
  YearAwarded?: InputMaybe<SortDirection>;
};

export type ProfessionalBacklink = {
  __typename?: 'ProfessionalBacklink';
  Created?: Maybe<Scalars['String']['output']>;
  ID?: Maybe<Scalars['Int']['output']>;
  LastEdited?: Maybe<Scalars['String']['output']>;
  Links: Array<ProfessionalBacklinks>;
};

export type ProfessionalBacklinks = {
  __typename?: 'ProfessionalBacklinks';
  backlinks_num: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  country: Scalars['String']['output'];
  domain: Scalars['String']['output'];
  domain_ascore: Scalars['Int']['output'];
  first_seen: Scalars['Int']['output'];
  ip: Scalars['String']['output'];
  is_follow: Scalars['Boolean']['output'];
  last_seen: Scalars['Int']['output'];
  lost: Scalars['Boolean']['output'];
  new: Scalars['Boolean']['output'];
};

export type ProfessionalBusinessTermsConnection = {
  __typename?: 'ProfessionalBusinessTermsConnection';
  edges: Array<ProfessionalBusinessTermsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalBusinessTermsConnectionEdge = {
  __typename?: 'ProfessionalBusinessTermsConnectionEdge';
  /** The node at the end of the collections edge */
  node: BusinessTerms;
};

export type ProfessionalBusinessTermsFilters = {
  /** filter by category ID */
  CategoryID__eq?: InputMaybe<Scalars['Int']['input']>;
  /** filter by country code(s) */
  CountriesCode__in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by business terms title */
  Title__partial_match?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalBusinessTermsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ProfessionalCategory = ICategory & IHasItems & {
  __typename?: 'ProfessionalCategory';
  Categories: ProfessionalCategory_CategoriesConnection;
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  /** Clear cut Image */
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']['output']>;
  /** Items count for the given zone */
  ItemsCount: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  Locations: Array<ProfessionalLocation>;
  MenuTitle: Scalars['String']['output'];
  Parent?: Maybe<ProfessionalCategory>;
  Parents: ProfessionalCategory_ParentsConnection;
  PrettyTitle: Scalars['String']['output'];
  Professionals: ProfessionalCategory_ProfessionalsConnection;
  /** Clear cut Image */
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
  URLSegment?: Maybe<Scalars['String']['output']>;
};


export type ProfessionalCategoryCategoriesArgs = {
  filter?: InputMaybe<ProfessionalCategory_CategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalCategory_CategoriesSortFields>;
};


export type ProfessionalCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalCategoryItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};


export type ProfessionalCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfessionalCategoryProfessionalsArgs = {
  filter?: InputMaybe<ProfessionalCategory_ProfessionalsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalCategory_ProfessionalsSortFields>;
};


export type ProfessionalCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};

export type ProfessionalCategoryInLocation = {
  __typename?: 'ProfessionalCategoryInLocation';
  ItemsCount: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type ProfessionalCategory_CategoriesConnection = {
  __typename?: 'ProfessionalCategory_CategoriesConnection';
  edges: Array<ProfessionalCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalCategory_CategoriesConnectionEdge = {
  __typename?: 'ProfessionalCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalCategory;
};

export type ProfessionalCategory_CategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalCategory_CategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type ProfessionalCategory_ParentsConnection = {
  __typename?: 'ProfessionalCategory_ParentsConnection';
  edges: Array<ProfessionalCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalCategory_ParentsConnectionEdge = {
  __typename?: 'ProfessionalCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalCategory;
};

export type ProfessionalCategory_ProfessionalsConnection = {
  __typename?: 'ProfessionalCategory_ProfessionalsConnection';
  edges: Array<ProfessionalCategory_ProfessionalsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalCategory_ProfessionalsConnectionEdge = {
  __typename?: 'ProfessionalCategory_ProfessionalsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Professional;
};

export type ProfessionalCategory_ProfessionalsFilters = {
  /** Filters this type when CountryCode is in the provided value */
  CountryCode__in?: InputMaybe<Array<SupportedCountry>>;
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by ID */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when Visibility is find_in the provided value */
  Visibility__find_in?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalCategory_ProfessionalsSortFields = {
  Created?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Popularity?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type ProfessionalCompaniesConnection = {
  __typename?: 'ProfessionalCompaniesConnection';
  edges: Array<ProfessionalCompaniesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalCompaniesConnectionEdge = {
  __typename?: 'ProfessionalCompaniesConnectionEdge';
  /** The node at the end of the collections edge */
  node: Company;
};

export type ProfessionalCompaniesFilters = {
  /** Filters this type when Contacts is is_empty the provided value */
  Contacts__is_empty?: InputMaybe<Scalars['Boolean']['input']>;
  NameStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Filters this type when Name is not_eq the provided value */
  Name__not_eq?: InputMaybe<Scalars['String']['input']>;
  WebsiteContains?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalCompaniesSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
};

export type ProfessionalContactsConnection = {
  __typename?: 'ProfessionalContactsConnection';
  edges: Array<ProfessionalContactsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalContactsConnectionEdge = {
  __typename?: 'ProfessionalContactsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Contact;
};

export type ProfessionalContactsFilters = {
  EmailContains?: InputMaybe<Scalars['String']['input']>;
  /** Filters this type when ID is eq the provided value */
  ID__eq?: InputMaybe<Scalars['Int']['input']>;
  /** Filters this type when LastLeadActivityChannel is eq the provided value */
  LastLeadActivityChannel__eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters this type when LastLeadActivityType is eq the provided value */
  LastLeadActivityType__eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters this type when LeadActivities is is_empty the provided value */
  LeadActivities__is_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters this type when LeadStatus is eq the provided value */
  LeadStatus__eq?: InputMaybe<Scalars['String']['input']>;
  NameStartsWith?: InputMaybe<Scalars['String']['input']>;
  SearchContains?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalContactsSortFields = {
  Created?: InputMaybe<SortDirection>;
  FirstName?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastLeadActivityAt?: InputMaybe<SortDirection>;
  LeadActivityCount?: InputMaybe<SortDirection>;
  LeadStatus?: InputMaybe<SortDirection>;
  Surname?: InputMaybe<SortDirection>;
};

export type ProfessionalEmailAssets = {
  __typename?: 'ProfessionalEmailAssets';
  Items: Array<LibraryImage>;
};

export type ProfessionalEmailTemplatesConnection = {
  __typename?: 'ProfessionalEmailTemplatesConnection';
  edges: Array<ProfessionalEmailTemplatesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalEmailTemplatesConnectionEdge = {
  __typename?: 'ProfessionalEmailTemplatesConnectionEdge';
  /** The node at the end of the collections edge */
  node: EmailTemplate;
};

export type ProfessionalLocation = {
  __typename?: 'ProfessionalLocation';
  ID?: Maybe<Scalars['ID']['output']>;
  Link?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type ProfessionalLocationCrumb = {
  __typename?: 'ProfessionalLocationCrumb';
  Link: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type ProfessionalMembersModule = ModuleType & {
  __typename?: 'ProfessionalMembersModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  Orientation: Scalars['String']['output'];
  SlimImageColumn: Scalars['Boolean']['output'];
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  TeamMembers: Module_TeamMembersConnection;
  TextContent?: Maybe<TextCarouselItem>;
  ThemeColour: ThemedElementColourType;
};


export type ProfessionalMembersModuleTeamMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Module_TeamMembersSortFields>;
};

export type ProfessionalMetaData = {
  __typename?: 'ProfessionalMetaData';
  AverageArticleScore: Scalars['Float']['output'];
  AverageProjectScore: Scalars['Float']['output'];
  AverageScore: Scalars['Float']['output'];
  Draft: Scalars['Int']['output'];
  GetFirstItem?: Maybe<DirectoryItem>;
  GetItemsCount: Scalars['Int']['output'];
  Live: Scalars['Int']['output'];
  Pending: Scalars['Int']['output'];
  RequireAttention: Scalars['Int']['output'];
};


export type ProfessionalMetaDataGetFirstItemArgs = {
  isLowScore?: InputMaybe<Scalars['Boolean']['input']>;
  itemType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
};


export type ProfessionalMetaDataGetItemsCountArgs = {
  isLowScore?: InputMaybe<Scalars['Boolean']['input']>;
  itemType: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  withDisableItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProfessionalNoticePeriodUnitEnum {
  Days = 'Days',
  Months = 'Months',
  Weeks = 'Weeks',
  Years = 'Years'
}

export type ProfessionalParticipant = Participant & {
  __typename?: 'ProfessionalParticipant';
  ID: Scalars['ID']['output'];
  Identity: Professional;
  LastReadMessageDate?: Maybe<Scalars['String']['output']>;
  LastReadMessageID: Scalars['Int']['output'];
  Professional: Professional;
};

export type ProfessionalPin = {
  __typename?: 'ProfessionalPin';
  BoardID: Scalars['Int']['output'];
  BoardURLSegment: Scalars['String']['output'];
  CanDelete: Scalars['Boolean']['output'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int']['output'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryImageID?: Maybe<Scalars['Int']['output']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']['output']>;
  LogoBackgroundColor?: Maybe<Scalars['String']['output']>;
  PageType?: Maybe<Scalars['String']['output']>;
  PageTypeID?: Maybe<Scalars['Int']['output']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  ProfessionalID?: Maybe<Scalars['Int']['output']>;
  ProfessionalLink?: Maybe<Scalars['String']['output']>;
  ProfessionalTitle?: Maybe<Scalars['String']['output']>;
  ProfessionalWebsite?: Maybe<Scalars['String']['output']>;
  Services?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  SubTitle: Scalars['String']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

/** Status of a professional's pixel tracker conversion */
export type ProfessionalPixelTrackerConversionStatus = {
  __typename?: 'ProfessionalPixelTrackerConversionStatus';
  Archived: Scalars['Boolean']['output'];
  Created: Scalars['String']['output'];
  Deleted: Scalars['Boolean']['output'];
  EventCount: Scalars['Int']['output'];
  ID: Scalars['ID']['output'];
  PixelTrackerConversionConfig: PixelTrackerConversionConfig;
  Professional: Professional;
};

export type ProfessionalPixelTrackerConversionStatus_Connection = {
  __typename?: 'ProfessionalPixelTrackerConversionStatus_Connection';
  ID: Scalars['ID']['output'];
  nodes: Array<ProfessionalPixelTrackerConversionStatus>;
  pageInfo: ApPageInfo;
};

export type ProfessionalPriceRange = {
  __typename?: 'ProfessionalPriceRange';
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};

export enum ProfessionalProjectsTypeEnum {
  All = 'ALL',
  OurProjects = 'OUR_PROJECTS',
  TaggedIn = 'TAGGED_IN'
}

export type ProfessionalQbRsConnection = {
  __typename?: 'ProfessionalQBRsConnection';
  edges: Array<ProfessionalQbRsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalQbRsConnectionEdge = {
  __typename?: 'ProfessionalQBRsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Qbr;
};

export type ProfessionalSavedQuotesConnection = {
  __typename?: 'ProfessionalSavedQuotesConnection';
  edges: Array<ProfessionalSavedQuotesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalSavedQuotesConnectionEdge = {
  __typename?: 'ProfessionalSavedQuotesConnectionEdge';
  /** The node at the end of the collections edge */
  node: QuoteContent;
};

export type ProfessionalSavedQuotesFilters = {
  /** Filter saved quotes by deal owner team member ID */
  DealOwnerID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** quote content is a template */
  IsTemplate__eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** acceped quotes */
  QuoteAccepted__eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by invoice statuses */
  Status__in?: InputMaybe<Array<InvoiceStatusEnum>>;
  /** filter by quote content title */
  Title__partial_match?: InputMaybe<Scalars['String']['input']>;
};

export type ProfessionalSavedQuotesSortFields = {
  ID?: InputMaybe<SortDirection>;
  IsTemplate?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
};

export type ProfessionalService = SortableItem & {
  __typename?: 'ProfessionalService';
  CategoryPageID: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ProfessionalID: Scalars['Int']['output'];
  ServiceName: Scalars['String']['output'];
};

export type ProfessionalServiceArea = SortableItem & {
  __typename?: 'ProfessionalServiceArea';
  AddressID?: Maybe<Scalars['String']['output']>;
  City?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  District?: Maybe<Scalars['String']['output']>;
  Division?: Maybe<Scalars['String']['output']>;
  FullAddress?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  Latitude: Scalars['Float']['output'];
  Longitude: Scalars['Float']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  PlaceName?: Maybe<Scalars['String']['output']>;
  PlaceType: FindPlaceTypeEnum;
  PostCode?: Maybe<Scalars['String']['output']>;
  Region?: Maybe<Scalars['String']['output']>;
  RegionType: Region;
  ServiceableAreaID?: Maybe<Scalars['Int']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Suburb?: Maybe<Scalars['String']['output']>;
  ZoomLevel?: Maybe<Scalars['Int']['output']>;
};

export type ProfessionalServicesConnection = {
  __typename?: 'ProfessionalServicesConnection';
  edges: Array<ProfessionalServicesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalServicesConnectionEdge = {
  __typename?: 'ProfessionalServicesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProfessionalService;
};

export type ProfessionalServicesSortFields = {
  ID?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

/** A single audit-trail entry for a change to a professional's tracked setting. */
export type ProfessionalSettingChange = {
  __typename?: 'ProfessionalSettingChange';
  /** When the change was recorded (UTC). */
  Created: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  /** ID of the member who made the change; 0 for system/CLI/direct-DB changes. */
  MemberID: Scalars['Int']['output'];
  /** Display name of the member who made the change, or \"System\". */
  MemberName: Scalars['String']['output'];
  /** New stored value as a string (\"1\"/\"0\" for booleans). */
  NewValue: Scalars['String']['output'];
  /** Human label for the new value (\"On\"/\"Off\"). */
  NewValueLabel: Scalars['String']['output'];
  /** Previous stored value as a string (\"1\"/\"0\" for booleans); null when unknown. */
  OldValue?: Maybe<Scalars['String']['output']>;
  /** Human label for the previous value (\"On\"/\"Off\"). */
  OldValueLabel?: Maybe<Scalars['String']['output']>;
  /** Human-readable label for the changed setting. */
  SettingLabel: Scalars['String']['output'];
  /** Raw field name that changed, e.g. \"CollectWebsiteFormData\". */
  SettingName: Scalars['String']['output'];
};

export enum ProfessionalTargetMarketType {
  Both = 'Both',
  Commercial = 'Commercial',
  Residential = 'Residential'
}

export type ProfessionalTeamMembersConnection = {
  __typename?: 'ProfessionalTeamMembersConnection';
  edges: Array<ProfessionalTeamMembersConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProfessionalTeamMembersConnectionEdge = {
  __typename?: 'ProfessionalTeamMembersConnectionEdge';
  /** The node at the end of the collections edge */
  node: TeamMember;
};

export type ProfessionalTeamMembersFilters = {
  /** Filter team members that are approved */
  Approved__in?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter team members that are publicy visible */
  Ispublic__in?: InputMaybe<Scalars['Boolean']['input']>;
  NameOrEmailContains?: InputMaybe<Scalars['String']['input']>;
  /** Filter team members by whether they have roles assigned (true = no roles/ungrouped, false = has roles) */
  TeamMemberRoles__is_empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfessionalTeamMembersSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
};

export enum ProfessionalVisibility {
  Disabled = 'Disabled',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  ProfileOnly = 'ProfileOnly'
}

export type Professional_AssociatedPagesConnection = {
  __typename?: 'Professional_AssociatedPagesConnection';
  edges: Array<Professional_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Professional_AssociatedPagesConnectionEdge = {
  __typename?: 'Professional_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type ProfessionalsByKeywordOrTeamMemberNameSimpleSortFields = {
  ID?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ProfessionalsLocation = {
  __typename?: 'ProfessionalsLocation';
  City?: Maybe<Scalars['String']['output']>;
  Country?: Maybe<Scalars['String']['output']>;
  District?: Maybe<Scalars['String']['output']>;
  FullAddress?: Maybe<Scalars['String']['output']>;
  ID?: Maybe<Scalars['ID']['output']>;
  Latitude?: Maybe<Scalars['String']['output']>;
  Longitude?: Maybe<Scalars['String']['output']>;
  PlaceName?: Maybe<Scalars['String']['output']>;
  PlaceShortName?: Maybe<Scalars['String']['output']>;
  PlaceType?: Maybe<Scalars['String']['output']>;
  PostCode?: Maybe<Scalars['String']['output']>;
  Region?: Maybe<Scalars['String']['output']>;
  Slug?: Maybe<Scalars['String']['output']>;
  State?: Maybe<Scalars['String']['output']>;
  Suburb?: Maybe<Scalars['String']['output']>;
};

export type ProfileCampaignsOverTimeFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfileConversionBreakdownFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileConversionTypesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfileImpressionSourcesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileIndustriesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfilePageNamesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfilePageTypeBreakdownFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type ProfilePageTypesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfilePagesSummary = {
  __typename?: 'ProfilePagesSummary';
  ClickThroughRate: Scalars['Float']['output'];
  Clicks: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  TotalEngagements: Scalars['Int']['output'];
  TotalTimeSpent: Scalars['String']['output'];
};

export type ProfileStatsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfileStatsOverTimeFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfileTopPagesFilters = {
  CONVERSION_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INDUSTRY_CATEGORY__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  LIBRARY_ITEM_TYPE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
  TITLE__IN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProfileTopPagesSort = {
  AVG_TIME_ON_PAGE?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  CONVERSION_RATE?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  PAGE?: InputMaybe<PrioritySort>;
  PAGE_VIEWS?: InputMaybe<PrioritySort>;
  TYPE?: InputMaybe<PrioritySort>;
};

export type ProfileTrafficSourcesFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INDUSTRY_CATEGORY__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type Project = ContentBuilder & DesignBoardPinTarget & DirectoryItem & HasPaintPartner & IApprovable & ICreatable & IFileCategory & IHasProfessional & IHomePinable & IPublishable & IRecentlyViewedTile & SortableItem & {
  __typename?: 'Project';
  /** Has this page been reviewed and approved by the ArchiPro Content Team? */
  Activated?: Maybe<Scalars['Boolean']['output']>;
  ApprovedByMember?: Maybe<Member>;
  ApprovedDate?: Maybe<Scalars['String']['output']>;
  AssociatedPages: Project_AssociatedPagesConnection;
  AvailabilityZones: Array<Zone>;
  Awards: ProjectAwardsConnection;
  BannerImages: Array<LibraryImage>;
  Banners: LibraryItemBannersConnection;
  /** Project quality indicators for the BM Projects table (support review). */
  BmProjectQuality: BmProjectQuality;
  BuildingStyle?: Maybe<ProjectBuildingStyleEnum>;
  Categories: Array<Category>;
  ClassName: Scalars['String']['output'];
  Client?: Maybe<Scalars['String']['output']>;
  Clones?: Maybe<Array<DirectoryItem>>;
  Content?: Maybe<Scalars['String']['output']>;
  ContentArea: ContentArea;
  ContentBuilderType: ContentBuilderTypeEnum;
  ContentComment?: Maybe<Scalars['String']['output']>;
  ContentRejectReasons: Array<ContentRejectReasonEnum>;
  ContentStatus?: Maybe<ContentStatusEnum>;
  ContentStatusBy?: Maybe<Member>;
  ContentStatusDate?: Maybe<Scalars['String']['output']>;
  CreatedByMember?: Maybe<Member>;
  CreatedDate?: Maybe<Scalars['String']['output']>;
  CreatedTimestamp: Scalars['Int']['output'];
  DataQualityRating: Scalars['Float']['output'];
  DesignBoardsForCurrentUser?: Maybe<Array<Maybe<DesignBoard>>>;
  DirectoryLiveDateTimestamp?: Maybe<Scalars['Int']['output']>;
  Disable: Scalars['Boolean']['output'];
  EmbeddedData?: Maybe<Scalars['String']['output']>;
  Embeddings?: Maybe<Scalars['String']['output']>;
  FacebookPreviewImage?: Maybe<Scalars['String']['output']>;
  FeaturedProducts: ProductsUsedInProjectConnection;
  FeaturedProfessionals: FeaturedProfessionalsConnection;
  FeaturedProjects: FeaturedProjectsConnection;
  FileCategories: FileCategoriesConnection;
  FirstPublishedDate?: Maybe<Scalars['String']['output']>;
  HasClones: Scalars['Boolean']['output'];
  HasDownloads: Scalars['Boolean']['output'];
  HasPhotos: Scalars['Boolean']['output'];
  HasProducts: Scalars['Boolean']['output'];
  HasProjects: Scalars['Boolean']['output'];
  HasRelatedProjects: Scalars['Boolean']['output'];
  HasTags: Scalars['Boolean']['output'];
  HasVideos: Scalars['Boolean']['output'];
  HomePinned: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Images: LibraryItemImagesConnection;
  InLibrary?: Maybe<Scalars['Boolean']['output']>;
  IsCloned: Scalars['Boolean']['output'];
  /** Has this page been reviewed and approved by the client? */
  IsDraft: Scalars['Boolean']['output'];
  IsFeature: Scalars['Boolean']['output'];
  IsFeatured: Scalars['Boolean']['output'];
  /** True if published and activated */
  IsLive: Scalars['Boolean']['output'];
  IsManufacturer: Scalars['Boolean']['output'];
  IsProjectOfTheMonth: Scalars['Boolean']['output'];
  IsTemplate: Scalars['Boolean']['output'];
  KPI?: Maybe<LibraryItemKpi>;
  LastEdited?: Maybe<Scalars['String']['output']>;
  LastEditedDate?: Maybe<Scalars['String']['output']>;
  LastEditedTimestamp: Scalars['Int']['output'];
  LibraryDownloads: Array<LibraryDownload>;
  LibraryImages: Array<LibraryImage>;
  LibraryLocations: Array<LibraryLocation>;
  LibraryRange?: Maybe<LibraryRange>;
  LibraryTabs: Array<LibraryTab>;
  LibraryThumb?: Maybe<LibraryThumb>;
  LibraryVideos: Array<LibraryVideo>;
  Link: Scalars['String']['output'];
  LiveDateTimestamp?: Maybe<Scalars['Int']['output']>;
  Location?: Maybe<LibraryLocation>;
  MemberSortOrder: Scalars['Int']['output'];
  Meta?: Maybe<Meta>;
  PageMeta?: Maybe<DirectoryPageMeta>;
  PageType: Scalars['String']['output'];
  PaintPartner?: Maybe<PaintPartner>;
  ParentID: Scalars['Int']['output'];
  Photographers?: Maybe<Array<Professional>>;
  /** Same as Categories but with a different return type PrimaryCategory */
  PrimaryCategories: Array<CategoryPage>;
  PrimaryCategory?: Maybe<CategoryPage>;
  /** Which member linked each product. Admin only. */
  ProductLinkedByMemberInfo: Array<LinkedByMemberInfo>;
  ProductsUsed: Array<Product>;
  Professional?: Maybe<Professional>;
  /** Which member linked each professional. Admin only. */
  ProfessionalLinkedByMemberInfo: Array<LinkedByMemberInfo>;
  ProfessionalsUsed?: Maybe<Array<Professional>>;
  ProjectHeroTitle?: Maybe<Scalars['String']['output']>;
  ProjectPriceRange?: Maybe<ProjectPriceRange>;
  /** The professional disciplines (roles) recorded for this project, drawn from the owning professional's categories. */
  ProjectRoles: Array<ProfessionalCategory>;
  PublicKPI?: Maybe<LibraryItemPublicKpi>;
  /** Has this page been reviewed and approved by the client? */
  Publish: Scalars['Boolean']['output'];
  PublishDate?: Maybe<Scalars['String']['output']>;
  PublishedByMember?: Maybe<Member>;
  RawTileImage?: Maybe<Scalars['String']['output']>;
  RecentlyViewedImage?: Maybe<RecentlyViewedImage>;
  Recommendations?: Maybe<Array<Maybe<DirectoryItem>>>;
  Region?: Maybe<Region>;
  Review?: Maybe<PageReview>;
  /** Actions that need addressing before this page can be approved */
  ReviewActions?: Maybe<Array<Maybe<ReviewAction>>>;
  SampleAddressPlaceholder?: Maybe<Scalars['String']['output']>;
  SampleMessagePlaceholder?: Maybe<Scalars['String']['output']>;
  SampleSubmitText?: Maybe<Scalars['String']['output']>;
  SampleText?: Maybe<Scalars['String']['output']>;
  SampleTitle?: Maybe<Scalars['String']['output']>;
  SamplesAddressRequired: Scalars['Boolean']['output'];
  SamplesAvailable: Scalars['Boolean']['output'];
  SearchTags?: Maybe<Array<Maybe<SearchTag>>>;
  SelfPublished: Scalars['Boolean']['output'];
  ShowsInElasticSearch: Scalars['Boolean']['output'];
  SortOrder: Scalars['Int']['output'];
  Subheading?: Maybe<Scalars['String']['output']>;
  /** JSON array of team member IDs in custom order */
  TeamMemberOrder?: Maybe<Scalars['String']['output']>;
  Teaser?: Maybe<Scalars['String']['output']>;
  ThumbnailFile?: Maybe<LibraryImageFile>;
  Title: Scalars['String']['output'];
  TopBanner?: Maybe<LibraryItemBanner>;
  TotalSavedCount: Scalars['Int']['output'];
  TotalViewedCount: Scalars['Int']['output'];
  URLSegment: Scalars['String']['output'];
  ViewsCount: Scalars['Int']['output'];
  Visibilities?: Maybe<Array<ProjectVisibility>>;
  Website?: Maybe<Scalars['String']['output']>;
  WebsiteShort?: Maybe<Scalars['String']['output']>;
  WebsiteUntracked: Scalars['String']['output'];
  YearOfCompletion?: Maybe<Scalars['Int']['output']>;
  deprecated_Awards?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  libraryImageMarkerCount: LibraryImageMarkerCount;
};


export type ProjectApprovedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectAssociatedPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectAwardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectBannersArgs = {
  filter?: InputMaybe<LibraryItemBannersFilters>;
  filters?: InputMaybe<LibraryItemBannersFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LibraryItemBannersSortFields>;
};


export type ProjectContentStatusDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectCreatedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectFeaturedProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectFeaturedProfessionalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectFeaturedProjectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectFileCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FileCategoriesSortFields>;
};


export type ProjectFirstPublishedDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectLibraryImagesArgs = {
  IncludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectLibraryLocationsArgs = {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectProductsUsedArgs = {
  ProfileProduct?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectPublishDateArgs = {
  format?: InputMaybe<DateFormatEnum>;
};


export type ProjectViewsCountArgs = {
  Range: DirectoryItemViewsCountRange;
};

export type ProjectAward = {
  InstitutionTitle: Scalars['String']['input'];
  Title: Scalars['String']['input'];
  YearAwarded: Scalars['String']['input'];
};

export type ProjectAwardsConnection = {
  __typename?: 'ProjectAwardsConnection';
  edges: Array<ProjectAwardsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectAwardsConnectionEdge = {
  __typename?: 'ProjectAwardsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Award;
};

export enum ProjectBuildingStyleEnum {
  ArtDeco = 'Art_Deco',
  Bauhaus = 'Bauhaus',
  Cabin = 'Cabin',
  Classic = 'Classic',
  Colonial = 'Colonial',
  Contemporary = 'Contemporary',
  Cottage = 'Cottage',
  Deconstructive = 'Deconstructive',
  Farmhouse = 'Farmhouse',
  Industrial = 'Industrial',
  Mediterranean = 'Mediterranean',
  Modern = 'Modern',
  Passive = 'Passive',
  Ranch = 'Ranch',
  SmallHome = 'Small_home',
  Terrace = 'Terrace'
}

export type ProjectCategory = ICategory & IHasItems & {
  __typename?: 'ProjectCategory';
  Categories: ProjectCategory_CategoriesConnection;
  CustomSeoOnFilters?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  Image?: Maybe<ResponsiveImage>;
  IsPublished?: Maybe<Scalars['Boolean']['output']>;
  ItemsCount: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  MenuTitle: Scalars['String']['output'];
  Parent?: Maybe<ProjectCategory>;
  Parents: ProjectCategory_ParentsConnection;
  PrettyTitle: Scalars['String']['output'];
  Projects: ProjectCategory_ProjectsConnection;
  Thumbnail?: Maybe<ResponsiveImage>;
  Title: Scalars['String']['output'];
  URLSegment?: Maybe<Scalars['String']['output']>;
};


export type ProjectCategoryCategoriesArgs = {
  filter?: InputMaybe<ProjectCategory_CategoriesFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProjectCategory_CategoriesSortFields>;
};


export type ProjectCategoryImageArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectCategoryItemsCountArgs = {
  Zone?: InputMaybe<SupportedCountry>;
};


export type ProjectCategoryParentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectCategoryProjectsArgs = {
  filter?: InputMaybe<ProjectCategory_ProjectsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProjectCategory_ProjectsSortFields>;
};


export type ProjectCategoryThumbnailArgs = {
  Height?: InputMaybe<Scalars['Int']['input']>;
  Width?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectCategory_CategoriesConnection = {
  __typename?: 'ProjectCategory_CategoriesConnection';
  edges: Array<ProjectCategory_CategoriesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectCategory_CategoriesConnectionEdge = {
  __typename?: 'ProjectCategory_CategoriesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProjectCategory;
};

export type ProjectCategory_CategoriesFilters = {
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectCategory_CategoriesSortFields = {
  Title?: InputMaybe<SortDirection>;
};

export type ProjectCategory_ParentsConnection = {
  __typename?: 'ProjectCategory_ParentsConnection';
  edges: Array<ProjectCategory_ParentsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectCategory_ParentsConnectionEdge = {
  __typename?: 'ProjectCategory_ParentsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProjectCategory;
};

export type ProjectCategory_ProjectsConnection = {
  __typename?: 'ProjectCategory_ProjectsConnection';
  edges: Array<ProjectCategory_ProjectsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectCategory_ProjectsConnectionEdge = {
  __typename?: 'ProjectCategory_ProjectsConnectionEdge';
  /** The node at the end of the collections edge */
  node: Project;
};

export type ProjectCategory_ProjectsFilters = {
  /** Filters this type when CountryCode is in the provided value */
  CountryCode__in?: InputMaybe<Array<SupportedCountry>>;
  /** Filter categories that have or don`t have items */
  HasItems?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by ID */
  ID__in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filters this type when Visibility is find_in the provided value */
  Visibility__find_in?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCategory_ProjectsSortFields = {
  Created?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Popularity?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
};

export type ProjectFeatureBlock = {
  __typename?: 'ProjectFeatureBlock';
  CTA?: Maybe<SiteTreeLink>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  Summary?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type ProjectFeaturesModule = ModuleType & {
  __typename?: 'ProjectFeaturesModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  FeatureBlocks: Module_FeatureBlocksConnection;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type ProjectFeaturesModuleFeatureBlocksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Module_FeatureBlocksSortFields>;
};

export type ProjectGroup = {
  __typename?: 'ProjectGroup';
  Category: Scalars['String']['output'];
  TeamMembers: Array<TeamMember>;
};

export type ProjectMutationResult = NotAuthorizedError | NotFoundError | Project | ServerError | UserError;

export type ProjectPin = {
  __typename?: 'ProjectPin';
  BoardID: Scalars['Int']['output'];
  BoardURLSegment: Scalars['String']['output'];
  CanDelete: Scalars['Boolean']['output'];
  Comments?: Maybe<Array<Maybe<Comment>>>;
  CommentsCount: Scalars['Int']['output'];
  CreatedBy?: Maybe<Member>;
  HasUnreadComments: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryImageID?: Maybe<Scalars['Int']['output']>;
  LibraryThumb?: Maybe<LibraryThumb>;
  Link?: Maybe<Scalars['String']['output']>;
  PageType?: Maybe<Scalars['String']['output']>;
  PageTypeID?: Maybe<Scalars['Int']['output']>;
  Permission: PinPermission;
  PhotoModal?: Maybe<Scalars['String']['output']>;
  PhotoTile?: Maybe<Scalars['String']['output']>;
  ProfessionalID?: Maybe<Scalars['Int']['output']>;
  ProfessionalLink?: Maybe<Scalars['String']['output']>;
  ProfessionalTitle?: Maybe<Scalars['String']['output']>;
  ProfessionalWebsite?: Maybe<Scalars['String']['output']>;
  SubTitle: Scalars['String']['output'];
  Title?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
};

export type ProjectPriceRange = {
  __typename?: 'ProjectPriceRange';
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};

export type ProjectTeamMember = {
  __typename?: 'ProjectTeamMember';
  Category: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  Project: Project;
  ProjectID: Scalars['ID']['output'];
  TeamMember: TeamMember;
  TeamMemberID: Scalars['ID']['output'];
};

export enum ProjectVisibility {
  Disabled = 'Disabled',
  Draft = 'Draft',
  InLibrary = 'InLibrary',
  InSearch = 'InSearch',
  NotLive = 'NotLive',
  PendingApproval = 'PendingApproval',
  ProfileOnly = 'ProfileOnly'
}

export type Project_AssociatedPagesConnection = {
  __typename?: 'Project_AssociatedPagesConnection';
  edges: Array<Project_AssociatedPagesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Project_AssociatedPagesConnectionEdge = {
  __typename?: 'Project_AssociatedPagesConnectionEdge';
  /** The node at the end of the collections edge */
  node: AssociatedPage;
};

export type ProjectsSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  DataQualityRating?: InputMaybe<SortDirection>;
  ID?: InputMaybe<SortDirection>;
  IsFeatured?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

export type ProjectsUsingProductConnection = {
  __typename?: 'ProjectsUsingProductConnection';
  edges: Array<ProjectsUsingProductConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ProjectsUsingProductConnectionEdge = {
  __typename?: 'ProjectsUsingProductConnectionEdge';
  /** The node at the end of the collections edge */
  node: Project;
};

export type PromotionConversionSummary = AdConversions & {
  __typename?: 'PromotionConversionSummary';
  Downloads: Scalars['Int']['output'];
  EmailReveals: Scalars['Int']['output'];
  Enquiries: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  LocationReveals: Scalars['Int']['output'];
  PhoneReveals: Scalars['Int']['output'];
  Referrals: Scalars['Int']['output'];
  Saves: Scalars['Int']['output'];
  Shares: Scalars['Int']['output'];
  TotalPageViews: Scalars['Int']['output'];
  TotalTime: Scalars['Int']['output'];
  VideoPlays: Scalars['Int']['output'];
};

export type PromotionalSpikeDetails = {
  __typename?: 'PromotionalSpikeDetails';
  Clicks: Scalars['Int']['output'];
  DirectoryItem: DirectoryItem;
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
};

export type PromotionalStat = {
  __typename?: 'PromotionalStat';
  AdStartTime?: Maybe<Scalars['String']['output']>;
  AttentionShare?: Maybe<Scalars['Float']['output']>;
  CampaignUTMTitle?: Maybe<Scalars['String']['output']>;
  Clicks?: Maybe<Scalars['String']['output']>;
  Date: Scalars['String']['output'];
  DirectoryItem: DirectoryItem;
  ExternalCampaignID?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  Picture?: Maybe<Scalars['String']['output']>;
  PromotionID?: Maybe<Scalars['String']['output']>;
  PromotionLink?: Maybe<Scalars['String']['output']>;
  Reach?: Maybe<Scalars['Int']['output']>;
  Thumb?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Top10?: Maybe<Scalars['String']['output']>;
  Type: Scalars['String']['output'];
  VideoPicture?: Maybe<Scalars['String']['output']>;
};

export type PromotionalStats = {
  __typename?: 'PromotionalStats';
  ID: Scalars['String']['output'];
  NewsLetter: Array<PromotionalStat>;
  SocialMedia: Array<PromotionalStat>;
};

export type Proof = {
  __typename?: 'Proof';
  FullSizeURL: Scalars['String']['output'];
  ThumbnailURL: Scalars['String']['output'];
};

/** Rendered HTML for proposal email preview (no persistence) */
export type ProposalEmailPreview = {
  __typename?: 'ProposalEmailPreview';
  RenderedHtml: Scalars['String']['output'];
};

export type ProposalEmailPreviewResponse = NotAuthorizedError | NotFoundError | ProposalEmailPreview | ServerError | UserError;

export type PublicMember = {
  __typename?: 'PublicMember';
  FirstName: Scalars['String']['output'];
  LastName: Scalars['String']['output'];
  LoginOptions: Array<Maybe<Scalars['String']['output']>>;
  ProfileImageLink?: Maybe<Scalars['String']['output']>;
};

export type PublicUser = NotFoundError | PublicMember | UserError;

export type PublicationDetails = {
  __typename?: 'PublicationDetails';
  ConversionSummary: PromotionConversionSummary;
  DeviceTypes?: Maybe<Array<DeviceData>>;
  EmailClients?: Maybe<Array<EmailClient>>;
  HomeownerRegions: Array<GraphSegment>;
  HomeownerUsers: Array<GraphSegment>;
  HomeownerUsersCount: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  OpenClickRates?: Maybe<OpenClickRates>;
  PerformanceOverview: PublicationPerformanceOverview;
  ProfessionalCategories: Array<GraphSegment>;
  ProfessionalRegions: Array<GraphSegment>;
  ProfessionalUsers: Array<GraphSegment>;
  ProfessionalUsersCount: Scalars['Int']['output'];
  PublicationSummary: PublicationSummary;
  ReaderProfessionalCategories: Array<GraphSegment>;
  ReaderRegions: Array<GraphSegment>;
  RecipientOverview: RecipientOverview;
  TimeSpent?: Maybe<TimeSpent>;
};

export type PublicationPerformanceOverview = {
  __typename?: 'PublicationPerformanceOverview';
  AttentionShare: Scalars['Float']['output'];
  Clicks: Scalars['Int']['output'];
  Conversions: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  Reach: Scalars['Int']['output'];
};

export type PublicationRecipient = {
  __typename?: 'PublicationRecipient';
  EDMCategory?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
  Opened: Scalars['Boolean']['output'];
  Recipient: Scalars['String']['output'];
};

export type PublicationRecipientEvent = {
  __typename?: 'PublicationRecipientEvent';
  Count: Scalars['Int']['output'];
  EDMCategory?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
  Recipient: Scalars['String']['output'];
};

export type PublicationSummary = {
  __typename?: 'PublicationSummary';
  Date: Scalars['String']['output'];
  DirectoryItem: DirectoryItem;
  ID: Scalars['String']['output'];
  PromotionLink: Scalars['String']['output'];
  Title: Scalars['String']['output'];
  Top10: Scalars['Boolean']['output'];
};

export type PublicationsSummary = {
  __typename?: 'PublicationsSummary';
  AttentionShare: Scalars['Float']['output'];
  AttentionShareAvg: Scalars['Float']['output'];
  Clicks: Scalars['Int']['output'];
  ClicksAvg: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  ImpressionsAvg: Scalars['Int']['output'];
  Reach: Scalars['Int']['output'];
  ReachAvg: Scalars['Int']['output'];
};

export type PushDeviceInfo = {
  AppVersion?: InputMaybe<Scalars['String']['input']>;
  DeviceID: Scalars['String']['input'];
  ExpoToken: Scalars['String']['input'];
  Platform: PushDeviceType;
};

/** Device type capable of sending us an Expo push token. */
export enum PushDeviceType {
  Android = 'Android',
  Ios = 'IOS',
  Web = 'Web'
}

export type PushNotificationRecipient = {
  Email: Scalars['Email']['input'];
};

export type Qbr = ContentBuilder & {
  __typename?: 'QBR';
  ClassName: Scalars['String']['output'];
  ContentArea: ContentArea;
  ContentBuilderType: ContentBuilderTypeEnum;
  ID: Scalars['Int']['output'];
  Member?: Maybe<Member>;
  Professional?: Maybe<Professional>;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};

export type QuadImageModule = FlexibleModule & {
  __typename?: 'QuadImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type QuadImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type Query = {
  __typename?: 'Query';
  AiCompanyDescriptionGenerate?: Maybe<Scalars['String']['output']>;
  AiDescriptionGenerate?: Maybe<Scalars['String']['output']>;
  AiProductDescriptionGenerate?: Maybe<Scalars['String']['output']>;
  AiProjectDescriptionGenerate?: Maybe<Scalars['String']['output']>;
  AirtableAdSchedule: AirtableAdScheduleModel;
  ArcherComments: Array<ArcherComment>;
  Articles: ArticlesConnection;
  Attribute: Attribute;
  Attributes: Array<Attribute>;
  BAReportDashboard?: Maybe<BaReports>;
  Countries: Countries_Connection;
  Couriers: Array<Courier>;
  /** This query is just a hack to generate types that aren't directly used in any queries */
  DO_NOT_USE_QUERY?: Maybe<Do_Not_Use_Hack>;
  DigitalPublicationFilters: YearAndMonthsTypeConnection;
  /** Container for DirectoryItems an Categories */
  Directory: Directory;
  EditorialAuthors: EditorialAuthors_Connection;
  ExistingProductCount: Scalars['Int']['output'];
  Facet: Facet;
  Facets: Array<Facet>;
  FeaturedDirectoryItem?: Maybe<FeaturedDirectoryItem>;
  /** Retrieves the content for the homepage marketing guides section */
  HomeContentCampaign?: Maybe<HomeContentCampaign>;
  IntegratedPlatforms: Array<IntegratedPlatform>;
  IntegrationRequestFile: Scalars['String']['output'];
  IntegrationSettings: IntegrationSettingsModelOutput;
  /** Validates a given token from the Bearer header */
  JWTTokenValidate?: Maybe<JwtTokenValidationResponse>;
  LastUpdated?: Maybe<Scalars['String']['output']>;
  ListCombinedUnreadNotifications: CombinedUnreadNotifications;
  ListPinIdsYouOwn: Array<PagePin>;
  ListProfessionalProjects: ListProfessionalProjects_Connection;
  Localities: LocalityConnection;
  Materials: Array<Material>;
  MemberOrders: SupplierOrdersConnection;
  ModulePresets: Array<ModulePreset>;
  MonthlyTotalUsers: Scalars['Int']['output'];
  Order: Order;
  /** Retrieves the payment intent options for the current user */
  PaymentOptions: PaymentOptions;
  PeopleContacts: Array<PeopleContactList>;
  PlaceByCoordinate: Array<PlaceDetailType>;
  PlatformConnection?: Maybe<PlatformConnection>;
  Postcode: Postcode;
  PostcodeGroups: PostcodeGroups_Connection;
  ProductAttributeOptions: Array<ProductAttributeOption>;
  ProductImprovementLatestTask?: Maybe<ProductImprovementTaskStatus>;
  ProfessionalPriceRanges: Array<ProfessionalPriceRange>;
  ProjectBuildingStyles: Array<ProjectBuildingStyleEnum>;
  ProjectPriceRanges: Array<ProjectPriceRange>;
  Projects: ListProfessionalProjects_Connection;
  PublicUser: PublicUser;
  QBRByLink?: Maybe<Qbr>;
  Regions: Array<Region>;
  SalesReportDashboard?: Maybe<SalesReports>;
  SavedModuleVersion?: Maybe<SavedModule>;
  SavedModuleVersions: Array<SavedModuleVersion>;
  SavedModules: Array<SavedModule>;
  /** Retrieves a single shipping profile */
  ShippingProfile: ShippingProfile;
  /** Retrieves a single shipping zone */
  ShippingZone: ShippingZoneResult;
  ShoppingCart: ShoppingCart;
  StrategyDashboard?: Maybe<StrategyDashboard>;
  SupplierOrder: SupplierOrder;
  SupplierOrders: SupplierOrdersConnection;
  SyncEnquiryOAuthEmail?: Maybe<SyncEnquiryOAuthEmailType>;
  SyncStatus?: Maybe<SyncStatus>;
  TopTrendingCategories: Array<Category>;
  TrendingCategories: TrendingCategories_Connection;
  Variant: Variant;
  VariantShipping: VariantShippingsConnection;
  VerifyEmail: Scalars['Boolean']['output'];
  VerifyURLAccessToken?: Maybe<Scalars['Boolean']['output']>;
  WhoAmI: AuthDebugResult;
  WooCommerceLastUpdated?: Maybe<Scalars['String']['output']>;
  WooCommerceSyncCounts?: Maybe<WooCommerceSyncCounts>;
  WooCommerceTags: Array<WooCommerceTag>;
  /** Get all available account deletion request reasons, sorted by SortOrder */
  accountDeletionRequestReasons: Array<AccountDeletionRequestReason>;
  /** Persisted subscription pack checkout option for the BM cart (BM_MEMBERSHIP_VIEW); survives refresh */
  addOnCartPackCheckoutPreference: AddOnCartPackCheckoutPreference;
  /** Stripe calc-only draft invoice id on the professional's add-on cart (BM_MEMBERSHIP_VIEW), if any */
  addOnCartStripeCalcInvoiceId?: Maybe<Scalars['String']['output']>;
  allAvailableConversionSettings: PixelConversionSettings;
  availableInputTypes: Array<InputDataTypeInfo>;
  /** List Stripe payment methods for the professional main team member (membership billing); no local PM storage */
  billingPaymentMethods: BillingPaymentMethodsPayload;
  /** List all billing recipients for a professional (tag resolved from TeamMember.BillingRecipientTag) */
  billingRecipients: Array<TeamMember>;
  /** Explicit Exhibiting Professionals for an event, sorted by Title with their live ticket count. Soft-deleted Professionals are omitted. Restricted to ArchiPro staff and the professional's BM team. */
  bmEventExhibitorsForProfessional: Array<BmEventExhibitor>;
  /** Single owned event for the Business Manager manage-event page. Returns null when the event is not owned by the professional or the viewer cannot manage it. */
  bmEventForProfessional?: Maybe<EventDetails>;
  /** Single event submission for an event owned by the professional. Returns null when the submission does not belong to the event or the viewer cannot manage it. Used by the BM manage-event submission details drawer. */
  bmEventSubmissionForProfessional?: Maybe<EventSubmission>;
  /** Paginated event submissions for an event owned by the professional. Restricted to ArchiPro staff and the professional's BM team. */
  bmEventSubmissionsForProfessional: BmEventSubmissionsResult;
  /** Distinct members who have issued tickets for an event owned by the professional, sorted by display name. Used to populate the BM tickets \"Issued by\" filter. */
  bmEventTicketIssuersForProfessional: Array<BmEventIssuer>;
  /** Union of an event's Exhibiting Professionals and every Professional already holding at least one live ticket on the event, sorted by Title. Used to populate the BM tickets \"Professional\" filter dropdown. Restricted to ArchiPro staff and the professional's BM team. */
  bmEventTicketProfessionalsForProfessional: Array<BmEventExhibitor>;
  /** Paginated live event tickets for an event owned by the professional. Restricted to ArchiPro staff and the professional's BM team. */
  bmEventTicketsForProfessional: BmEventTicketsResult;
  /** Events where the BM-context Professional is in EventDetails.ExhibitingProfessionals (newest first). Drives the per-event exhibitor tabs on the Business Manager Events page. Distinct from bmOwnedEventsForProfessional (which filters by EventDetails.ProfessionalID, the owning BM Professional) and bmUpcomingEventsForProfessional (market-wide active events). Restricted to the professional's BM team and ArchiPro staff. */
  bmExhibitingEventsForProfessional: Array<EventDetails>;
  /** Live (non-soft-deleted) event tickets stamped to the BM-context Professional for a specific event, newest first. Drives the Team Members and Guests groups on the Business Manager Events page. Cross-tenant safe -- two exhibitors at the same event each see only their own stamped tickets, even when both are authorised by BMEventAccess::authoriseForActor. */
  bmExhibitingTicketsForEvent: Array<EventTicket>;
  /** Printable supplier QR card payload for a library item owned by the BM-context professional. Restricted to ArchiPro staff and the professional's BM team. */
  bmHdePrintLibraryItem: HdePrintCard;
  /** Printable card payload for one event ticket. Restricted to ArchiPro staff and the professional's BM team. */
  bmHdePrintTicket: HdePrintCard;
  /** Printable card payloads for all live tickets on an event, or an optional TicketIDs subset. Restricted to ArchiPro staff and the professional's BM team. */
  bmHdePrintTickets: Array<HdePrintCard>;
  /** Event tickets issued to the given professional, newest first. Used by Business Manager Events page. */
  bmIssuedTicketsForProfessional: Array<EventTicket>;
  /** All events owned by the professional (newest first), used by the Business Manager Events list. Includes draft and finished events. Restricted to ArchiPro staff and the professional's BM team. */
  bmOwnedEventsForProfessional: Array<EventDetails>;
  /** Searchable list of non-soft-deleted Professionals used by Business Manager pickers (e.g. exhibitor selection in the issue-ticket modal). Restricted to ArchiPro staff. */
  bmSearchProfessionals: Array<BmProfessionalLookup>;
  /** Upcoming events (RegistrationStatus=active) filtered to the professional's country. Used by Business Manager Events page. */
  bmUpcomingEventsForProfessional: Array<EventDetails>;
  buildHubByLink: BuildHubResponse;
  /** gets comments targeted at a particular buildhub file. */
  buildHubFileComments: Array<BuildHubComment>;
  /** Get the stage configuration for all project types and scopes */
  buildHubStageConfig: BuildHubStageConfiguration;
  /** Get a list of BuildHub projects that the current user has access to. */
  buildHubs: BuildHubConnection;
  /** List of cards for a given professional */
  cards: ErrorHandlingCardConnection;
  /** Check which moodboards contain a specific pin */
  checkPinMembership: PinMembershipResult;
  conversionRules: Array<ConversionRule>;
  directoryFeaturedProjects: Array<DirectoryFeaturedProject>;
  editableImage: EditableImage;
  emailTemplateByLink: EmailTemplateResponse;
  findAddress: Array<AddressResult>;
  findPlace: Array<PlaceDetailType>;
  /** Retrieves the footer video content for FooterV2 */
  footerContent?: Maybe<FooterContent>;
  /** Given an external url and a professional, make url always resolvable to that professional */
  generateExternalLink: GeneratedExternalLink;
  getAddress: AddressDetailResult;
  getAnalyticsDemoBookingURL: Scalars['String']['output'];
  /** Get the list of members that the current user has blocked. */
  getBlockList: MemberConnection;
  /** Get booking details by event ID for reschedule/cancel operations */
  getBookingByEventId?: Maybe<BookingByEventId>;
  getBrandImpressionTopPerformers: Array<BrandImpressionTopPerformer>;
  getBuildingGuide: BuildingGuide;
  getBuildingGuideSection: BuildingGuideSection;
  getBuildingGuideSections: Array<BuildingGuideSection>;
  getBuildingGuideSubscriptions: Array<BuildingGuideSubscription>;
  getBusinessTermsByID: BusinessTermsResponse;
  getBusinessTermsByURLSegment: BusinessTermsResponse;
  getBusinessTermsVersionForEditor: BusinessTermsVersion;
  getCalendarAvailability: CalendarAvailabilityResult;
  /** Get calendar OAuth connection for a member */
  getCalendarConnection?: Maybe<MemberCalendarOAuth>;
  /** Fetch calendar events and data from connected calendar */
  getCalendarData?: Maybe<CalendarDataType>;
  getCalendarSession?: Maybe<CalendarSession>;
  getCalendarSessionByURLSegment?: Maybe<CalendarSession>;
  getCampaignMetaAds: Array<Maybe<SocialAd>>;
  getCategory: Category;
  getClientDocuments?: Maybe<Array<DownloadableFile>>;
  /** Get the contacts for the current user. */
  getContactsList: MemberConnection;
  /** Get a conversation by its ID. */
  getConversation?: Maybe<Conversation>;
  /** Get a (direct) conversation by its participants, including the current user. */
  getConversationByParticipants?: Maybe<DirectConversation>;
  /** Get the available filters to filter conversations by. */
  getConversationFilters: ConversationFilters;
  /** Get a conversation message by its ID. */
  getConversationMessage: Message;
  /** Get the conversation settings for the current user. */
  getConversationSettings: ConversationSettings;
  /** Get a list of conversations that belongs to the current user. */
  getConversations: ConversationConnection;
  getCookiePolicyContent: PageContent;
  getDashboardAudience: DashboardAudienceResult;
  getDashboardOverview: DashboardOverviewResult;
  getDashboardProfilePages: DashboardProfilePagesResult;
  getDashboardPublications: DashboardPublicationsResult;
  getDashboardSocialAds: DashboardSocialAdsResult;
  getDesignBoard?: Maybe<DesignBoard>;
  getDesignBoardSetting: DesignBoardSetting;
  getDigitalPublicationDetails: PublicationDetails;
  /** Returns the list of Professionals available within the provided category Url */
  getDirectoryCompanies?: Maybe<Array<TitleWithUrlSegment>>;
  getDirectoryItems: Array<DirectoryItem>;
  getDirectoryPageMeta?: Maybe<DirectoryPageMeta>;
  getDirectoryProfessions?: Maybe<Array<Category>>;
  getDirectoryRegions?: Maybe<Array<Category>>;
  getEngagementEventsCount: EngagementEventsCount;
  getEngagementEventsSummary: EngagementEventSummary;
  getEngagementTopPerformers: Array<EngagementTopPerformer>;
  getEngagementsOverTime: EngagementsOverTime;
  getEnquiryConversation?: Maybe<EnquiryConversation>;
  getHomePageContent: RecentlyViewedContent;
  getHubspotCompany?: Maybe<HubspotCompany>;
  getImportMap?: Maybe<ImportMap>;
  /** Deprecated stub for legacy clients. Always returns zero values. */
  getInboxState: Inbox;
  getIntegrationRequest?: Maybe<IntegrationRequest>;
  getInviteInfo?: Maybe<InviteInfo>;
  /** Get items to amplify for a given URL segment and item types */
  getItemToAmplify: Array<Professional>;
  getLeadExportJob?: Maybe<LeadExportJob>;
  getLibraryImages?: Maybe<Array<LibraryImage>>;
  /** Resolve external URL metadata for a chat link preview. */
  getLinkPreview?: Maybe<LinkPreview>;
  getMember: User;
  getMembershipTerm?: Maybe<Scalars['String']['output']>;
  getModulePage?: Maybe<UnionModulePage>;
  /** Get the combined monthly user count for display, with freeze-period logic applied server-side */
  getMonthlyUserCount: MonthlyUserDisplay;
  getOverwriteBlacklist?: Maybe<BlacklistedFields>;
  getPageBulkCloneJob?: Maybe<PageBulkCloneJob>;
  getPageSEOSchema?: Maybe<PageSeoSchema>;
  getPrivacyPolicyContent: PageContent;
  getProduct: Product;
  getProductInstallers: GetProductInstallers_Connection;
  getProductSwatches: Array<ProductSwatch>;
  getProductsCSV: Scalars['String']['output'];
  getProfessional?: Maybe<Professional>;
  getProfessionalByURLSegment: Professional;
  getProfessionalCategories: Array<ProfessionalCategory>;
  getProfessionalForTeamMembers?: Maybe<Professional>;
  getProfessionalLeadsCSV: Scalars['String']['output'];
  getProfessionalServices?: Maybe<Array<ProfessionalService>>;
  getPromotionalStats: PromotionalStats;
  getPublicationDetails: PublicationDetails;
  getRecentlyViewedContent: RecentlyViewedContent;
  getRecentlyViewedDirectoryItem?: Maybe<Array<DirectoryItem>>;
  getSecuritySetting: SecuritySettings;
  getShareLink?: Maybe<Scalars['String']['output']>;
  getSidePromo?: Maybe<SidePromo>;
  getSignupData: SignupData;
  getSiteConfig: SiteConfig;
  getSocialAdDetails: SocialAd;
  getTermsContent: PageContent;
  getTopLibraryItems: TopLibraryItems;
  /** Get upscale configuration for AI image processing */
  getUpscaleConfig: UpscaleConfig;
  /** Returns the original (pre-upscale) image URL and ID for a LibraryImage that was upscaled with AI */
  getUpscaleOriginalImageUrl?: Maybe<UpscaleOriginalImageResult>;
  /** Get the active status(es) for a list of users. */
  getUserActiveStatuses: Array<UserActiveStatus>;
  getUsersOnPage?: Maybe<Scalars['Int']['output']>;
  /** Aggregate HDE scan counts at the event for the viewer's exhibitor Professional. Counts distinct contacts so re-scanning does not inflate the tiles. TotalScans is the team-wide count (not affected by SharedLeads). ScansByMe is the subset the viewer personally scanned at least once. Same auth as hdeEventLeads. */
  hdeEventLeadStats: HdeEventLeadStats;
  /** HDE-scan leads (Contacts) for the viewer's exhibitor Professional at the given event. When SharedLeads is enabled on the ExhibitingProfessionals join (default), all booth staff scans are included; when disabled, only contacts the current viewer scanned are returned. Restricted to members holding an exhibitor ticket for the event AND a current BM team membership of that Professional. */
  hdeEventLeads: Array<Contact>;
  /** Retrieves the content for the homepage hero section */
  homeHero?: Maybe<HomeHeroData>;
  /** Retrieves the content for the homepage introduction section */
  homeIntro?: Maybe<HomeIntroData>;
  /** Retrieves the content for the homepage media section */
  homeMedia?: Maybe<HomeMediaData>;
  /** Get the unread conversation count for the user's personal inbox, or a company inbox when ProfessionalID is provided. */
  inboxUnreadCount: Scalars['Int']['output'];
  inspirationByLink: InspirationGroupResponse;
  invoiceByPaymentUuid: ReceiptResponse;
  invoiceByUuid: InvoiceableResponse;
  invoiceEmailSnapshotByUuid: InvoiceEmailSnapshotResponse;
  invoiceHasProcessingPayment: InvoiceHasProcessingPaymentResponse;
  invoiceLogList: Array<InvoiceLog>;
  /** Build the canonical signed universal-link QR URL for a (Professional, LibraryItem) pair. Used by the Business Manager supplier-QR generator and by the mobile app for in-app supplier-QR display. */
  libraryItemQrUrl: Scalars['String']['output'];
  listAllDirectoryCategories?: Maybe<Array<Category>>;
  listClickEngagementEvents: ListClickEngagementEvents_Cursor;
  listDesignBoardCollaborators?: Maybe<Array<Maybe<Collaborator>>>;
  listDesignBoardComments?: Maybe<Array<Comment>>;
  listDesignBoards: ListDesignBoards_Connection;
  listDigitalPublicationRecipientClicks: ListDigitalPublicationRecipientClicksConnection;
  listDirectoryCategories: Array<Category>;
  listDirectoryItems: ListLibraryRangeItems_Connection;
  listDirectoryItemsByCategory: ListLibraryRangeItems_Connection;
  listEngagementEvents: ListEngagementEvents_Cursor;
  listEnquiryConversations?: Maybe<ListEnquiryConversations_Connection>;
  /** List all feature categories with their feature definitions (not disabled) */
  listFeatureCategories: Array<FeatureCategory>;
  listIntegrationRequests?: Maybe<IntegrationRequestConnection>;
  listLibraryDownloads?: Maybe<Array<Maybe<LibraryDownload>>>;
  listLibraryImages: ListLibraryImages_Connection;
  listLibraryRangeItems: ListLibraryRangeItems_Connection;
  listLibraryRanges: Array<LibraryRange>;
  listLibraryTabs?: Maybe<Array<LibraryTab>>;
  /** Returns moderation requests submitted by the current authenticated user */
  listModerations: Array<Moderation>;
  /** List comments on a pin */
  listPinComments?: Maybe<Array<Comment>>;
  listPins: ListPinsConnection;
  listProductBrands: Array<Scalars['String']['output']>;
  listProductSwatches: PaginatedProductSwatches_Connection;
  /** Fetch a Connection of Professionals who are suggested network partners. */
  listProfessionalNetworkSuggestions: GetProductInstallers_Connection;
  /** Fetch a paginated connection of a professionals network partners */
  listProfessionalPartners: GetProductInstallers_Connection;
  listProjectGroups: Array<ProjectGroup>;
  listPublicationClickedRecipients: ListPublicationOpenedRecipientsConnection;
  listPublicationOpenedRecipients: ListPublicationOpenedRecipientsConnection;
  listPublicationRecipientClicks: ListDigitalPublicationRecipientClicksConnection;
  listPublicationRecipientOpens: ListDigitalPublicationRecipientClicksConnection;
  listPublications: ListPublications_Cursor;
  listRecommendedCategories?: Maybe<Array<Category>>;
  listRegionOptions: Array<RegionOption>;
  listSocialAds: ListSocialAds_Cursor;
  /** [Paginated] Gets the team members of the professional with the given url segment (deprecated, please see TeamMembers on ProfessionalType) */
  listTeamMembersByURLSegment: ListTeamMembersByUrlSegmentConnection;
  /** List all team roles (TeamMemberRole) for a professional with permission summaries */
  listTeamRolesWithPermissions: Array<TeamMemberRole>;
  listTopLevelCategories: Array<Category>;
  listUploadedFiles?: Maybe<Array<Maybe<LibraryImageFile>>>;
  listWebsiteNotifications: ListWebsiteNotifications_Connection;
  /** Checks if a member has read a specific record */
  memberReadRecordGet: Scalars['Boolean']['output'];
  /** True when the given email already holds a live ticket on the event. Used by the HDE guest form to reject duplicate guest invites. Pass ExcludeSubmissionID when updating an existing submission so the current guest email is not treated as a collision. */
  mgeGuestEmailRegisteredOnEvent: Scalars['Boolean']['output'];
  /** Returns moderation reasons available for the specified entity types */
  moderationReasons: Array<ModerationReason>;
  modules: Array<Module>;
  /** Event tickets issued to the currently logged-in member, newest first. Used by the My Tickets page. */
  myEventTickets: Array<EventTicket>;
  /** True when the current member holds a live ticket on the event but does not own the primary submission for it (an invited guest who cannot register as primary). Requires authentication; the account email is derived server-side. */
  myMGEIsEventGuest: Scalars['Boolean']['output'];
  /** The current member's existing MGE submission for the given event, or null. Requires authentication; the account email is derived server-side (no email argument). */
  myMGESubmissionForEvent?: Maybe<EventSubmission>;
  /** Per-event guest groups for the logged-in registrant. Combines submission-linked guests (Source A) and UI-issued ticket-only guests (Source B). Used by the Your Guests section on the My Tickets page. */
  myRegistrantGuests: Array<MyRegistrantEventGroup>;
  /** Whether the current logged-in member is subscribed to the newsletter (HubSpot newsletter_footer). False when logged out. */
  newsletterSubscriptionStatus: Scalars['Boolean']['output'];
  pageEmbedding?: Maybe<PageEmbedding>;
  personalMoodBoards: InspirationGroupsConnection;
  /** Get the current user's personal workspace BuildHub. */
  personalWorkspace: BuildHubResponse;
  placementFeaturedItems: PlacementFeaturedItems_Connection;
  placementPOTMs: PlacementPotMs_Connection;
  /** Premium add-ons the client can still browse or add on the premium-features page (catalogue list1 minus installed SKUs except per_unit, which stays available for additional unit purchases); sorted by catalogue Order. */
  premiumFeatureAvailable: Array<AddOnItemDto>;
  /** Premium add-on items currently in the MembershipCart-driven server-side cart; same AddOnItemDTO shape as premiumFeatureSlides (PurchasedAddOnID and installation dates null). */
  premiumFeatureCart: Array<AddOnItemDto>;
  /** Stripe payment methods for premium add-on checkout (BM_MEMBERSHIP_VIEW; CanManage reflects BM_MEMBERSHIP_EDIT) */
  premiumFeatureCheckoutPaymentMethods: BillingPaymentMethodsPayload;
  /** Polls premium feature checkout invoice/payment state after Stripe confirmation */
  premiumFeatureCheckoutPoll?: Maybe<PremiumFeatureCheckoutPoll>;
  /** BM premium Stripe checkout payload from AddOnCart (BM_MEMBERSHIP_EDIT). Uses a validated ensure snapshot when the cart and pack context are unchanged; otherwise runs the same Stripe prepare as applyPremiumCheckoutSubscriptionPack. Null when the cart is empty or checkout cannot be prepared. */
  premiumFeatureCheckoutState?: Maybe<PremiumFeatureStripeCheckout>;
  /** Premium add-on items installed for the professional; same AddOnItemDTO GraphQL type as premiumFeatureSlides with PurchasedAddOnID and StartDate/EndDate populated. */
  premiumFeatureInstallations: Array<AddOnItemDto>;
  /** IsHighLight overview carousel for the membership page (not the full catalogue); includes purchasable and installed highlight rows; non-installed rows appear before installed rows; at most 10 highlight slides server-side. */
  premiumFeatureSlides: Array<AddOnItemDto>;
  /** Polls Stripe invoice status and ArchiPro fulfilment after premium add-on invoice pay */
  premiumFeatureStripeCheckoutPoll?: Maybe<PremiumFeatureStripeCheckoutPoll>;
  previewConversionRule: ConversionRuleResponse;
  professionalBacklinks?: Maybe<ProfessionalBacklink>;
  professionalCategoriesInLocation: Array<ProfessionalCategoryInLocation>;
  professionalsByKeywordOrTeamMemberName: GetProductInstallers_Connection;
  professionalsLocation?: Maybe<ProfessionalsLocation>;
  proposalEmailPreview: ProposalEmailPreviewResponse;
  /** Whether the client professional has an entitled PurchasedAddOn row for the catalogue SKU (active status; fixed_date rows also require today within [StartDate, EndDate)). Pass clientProfessionalId or urlSegment (professional URL segment); returns false when neither resolves to a professional. */
  purchasedAddOnEntitledForSku: Scalars['Boolean']['output'];
  readFeatureBookings?: Maybe<Array<Maybe<FeatureBooking>>>;
  readOneEventDetails?: Maybe<EventDetails>;
  readOneFeatureBookingByPlacement?: Maybe<FeatureBooking>;
  receiptByPaymentUuid: ReceiptResponse;
  receivedInvoices: Array<Invoice>;
  /** List all reminder settings for a professional (includes disabled) */
  reminderSettings: Array<InvoiceReminderSetting>;
  savedQuoteByLink: SavedQuoteResponse;
  /** Side-effect-free decode of an HDE QR token; returns the resolved entity or an Invalid kind with a reason. */
  scanResolution: ScanResolution;
  /** Classify a search query to generate filters for the search. */
  searchClassify: SearchClassification;
  searchEmbedding?: Maybe<SearchEmbedding>;
  /** Live subscription packs for BM membership premium billing (BM_MEMBERSHIP_VIEW); excludes soft-deleted rows */
  subscriptionPacks: Array<SubscriptionPackSummary>;
  templateTokenBindings: Array<TemplateTokenBinding>;
  templateTokens: Array<TemplateToken>;
  /** Upcoming events (RegistrationStatus=active) filtered to the country of the current request domain. Used by the My Tickets page. */
  upcomingEventsByCountry: Array<EventDetails>;
  userFollowedMoodBoards: InspirationGroupsConnection;
  userMoodBoardItems: InspirationItemsConnection;
  /** An object containing separate arrays of page IDs and image IDs saved in moodboards, useful for determining if a page or image can be saved */
  userMoodBoardSavedPageIDs: MoodBoardSavedIDs;
  userMoodBoards: InspirationGroupsConnection;
  /** Returns lightweight booleans to drive mood board filter visibility. */
  userMoodBoardsMeta: UserMoodBoardsMeta;
};


export type QueryAiCompanyDescriptionGenerateArgs = {
  Awards: Array<ProjectAward>;
  Category: Scalars['String']['input'];
  OriginalDescription: Scalars['String']['input'];
  Professional: Scalars['String']['input'];
  ProfessionalTitle: Scalars['String']['input'];
  Prompt: Scalars['String']['input'];
  Services: Array<Scalars['String']['input']>;
  Tone?: InputMaybe<AiTone>;
  YearFounded: Scalars['String']['input'];
};


export type QueryAiDescriptionGenerateArgs = {
  Categories: Array<Scalars['String']['input']>;
  OriginalDescription: Scalars['String']['input'];
  ProductTitle: Scalars['String']['input'];
  Professional: Scalars['String']['input'];
  Prompt: Scalars['String']['input'];
  Tone: Scalars['String']['input'];
};


export type QueryAiProductDescriptionGenerateArgs = {
  Categories: Array<Scalars['String']['input']>;
  OriginalDescription: Scalars['String']['input'];
  ProductTitle: Scalars['String']['input'];
  Professional: Scalars['String']['input'];
  Prompt: Scalars['String']['input'];
  Tone?: InputMaybe<AiTone>;
};


export type QueryAiProjectDescriptionGenerateArgs = {
  Awards: Array<ProjectAward>;
  BuildingStyle: Scalars['String']['input'];
  Categories: Array<Scalars['String']['input']>;
  ClientName: Scalars['String']['input'];
  FeaturedProducts: Array<Scalars['String']['input']>;
  FeaturedProfessionals: Array<Scalars['String']['input']>;
  OriginalDescription: Scalars['String']['input'];
  Professional: Scalars['String']['input'];
  ProfessionalCategory: Scalars['String']['input'];
  ProfessionalTitle: Scalars['String']['input'];
  ProjectTitle: Scalars['String']['input'];
  Prompt: Scalars['String']['input'];
  Tone?: InputMaybe<AiTone>;
  YearOfCompletion: Scalars['Int']['input'];
};


export type QueryAirtableAdScheduleArgs = {
  Professional: Scalars['String']['input'];
  ProfessionalID: Scalars['Int']['input'];
};


export type QueryArcherCommentsArgs = {
  AuthorID?: InputMaybe<Scalars['Int']['input']>;
  ProductID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArticlesArgs = {
  Link: Scalars['String']['input'];
  filters?: InputMaybe<Array<ListArticlesFilter>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ArticlesSimpleSortFields>;
};


export type QueryAttributeArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryAttributesArgs = {
  ProductID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalURLSegment?: InputMaybe<Scalars['StringInput']['input']>;
};


export type QueryBaReportDashboardArgs = {
  ProfessionalID: Scalars['Int']['input'];
};


export type QueryCountriesArgs = {
  filter?: InputMaybe<Countries_Filters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Countries_SortFields>;
};


export type QueryCouriersArgs = {
  CountryCode?: InputMaybe<Scalars['StringInput']['input']>;
};


export type QueryDigitalPublicationFiltersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEditorialAuthorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EditorialAuthorsSimpleSortFields>;
};


export type QueryExistingProductCountArgs = {
  Products: Array<ProductSummaryInputType>;
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryFacetArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryFacetsArgs = {
  ProductCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryFeaturedDirectoryItemArgs = {
  Directory: DirectoryItemEnumType;
};


export type QueryIntegratedPlatformsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Offset?: InputMaybe<Scalars['Int']['input']>;
  Professional: Scalars['String']['input'];
};


export type QueryIntegrationRequestFileArgs = {
  Professional: Scalars['String']['input'];
  RequestID: Scalars['String']['input'];
};


export type QueryIntegrationSettingsArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type QueryLastUpdatedArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type QueryListCombinedUnreadNotificationsArgs = {
  IncludeCollaboratorConversations?: InputMaybe<Scalars['Boolean']['input']>;
  IncludeDirectConversations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListProfessionalProjectsArgs = {
  ListType: ProfessionalProjectsTypeEnum;
  Sort?: InputMaybe<Scalars['String']['input']>;
  URLSegment: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListProfessionalProjectsSimpleSortFields>;
};


export type QueryLocalitiesArgs = {
  Coordinates?: InputMaybe<CoordinateInput>;
  CountryCode?: InputMaybe<Scalars['StringInput']['input']>;
  Query?: InputMaybe<Scalars['StringInput']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<LocalitiesSimpleSortFields>;
};


export type QueryMaterialsArgs = {
  SearchTerm: Scalars['String']['input'];
};


export type QueryMemberOrdersArgs = {
  SearchString?: InputMaybe<Scalars['String']['input']>;
  Shipping?: InputMaybe<Array<Scalars['String']['input']>>;
  Sort?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<MemberOrdersSimpleSortFields>;
};


export type QueryModulePresetsArgs = {
  ContentBuilderType: ContentBuilderTypeEnum;
};


export type QueryMonthlyTotalUsersArgs = {
  CombinedCount: Scalars['Boolean']['input'];
};


export type QueryOrderArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryPaymentOptionsArgs = {
  Provider?: InputMaybe<PaymentProviderEnum>;
};


export type QueryPlaceByCoordinateArgs = {
  Latitude: Scalars['Float']['input'];
  Longitude: Scalars['Float']['input'];
  Type?: InputMaybe<FindPlaceTypeEnum>;
};


export type QueryPlatformConnectionArgs = {
  Platform: IntegratedPlatformEnum;
  URLSegment: Scalars['String']['input'];
};


export type QueryPostcodeArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
  Postcode?: InputMaybe<Scalars['StringInput']['input']>;
};


export type QueryPostcodeGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductAttributeOptionsArgs = {
  ID: Scalars['Int']['input'];
  SyncOptions?: InputMaybe<Scalars['Boolean']['input']>;
  URLSegment?: InputMaybe<Scalars['StringInput']['input']>;
};


export type QueryProductImprovementLatestTaskArgs = {
  ProductID: Scalars['Int']['input'];
};


export type QueryProjectsArgs = {
  CountryAgnostic?: InputMaybe<Scalars['Boolean']['input']>;
  Filters?: InputMaybe<Array<ListProjectsFilter>>;
  Link: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProjectsSimpleSortFields>;
};


export type QueryPublicUserArgs = {
  email: Scalars['Email']['input'];
};


export type QueryQbrByLinkArgs = {
  Link: Scalars['String']['input'];
};


export type QueryRegionsArgs = {
  Country?: InputMaybe<Scalars['String']['input']>;
  ParentID?: InputMaybe<Scalars['Int']['input']>;
  Public?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySavedModuleVersionArgs = {
  ID: Scalars['Int']['input'];
  Version: Scalars['Int']['input'];
};


export type QuerySavedModuleVersionsArgs = {
  ID: Scalars['Int']['input'];
};


export type QuerySavedModulesArgs = {
  ContentBuilderType: ContentBuilderTypeEnum;
  ProfessionalID: Scalars['Int']['input'];
};


export type QueryShippingProfileArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryShippingZoneArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShoppingCartArgs = {
  UUID?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierOrderArgs = {
  OrderNumber: Scalars['String']['input'];
};


export type QuerySupplierOrdersArgs = {
  Attention?: InputMaybe<Array<Scalars['String']['input']>>;
  LastModifiedAfter?: InputMaybe<Scalars['String']['input']>;
  SearchString?: InputMaybe<Scalars['String']['input']>;
  Shipping?: InputMaybe<Array<Scalars['String']['input']>>;
  Sort?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<Array<Scalars['String']['input']>>;
  URLSegment: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SupplierOrdersSimpleSortFields>;
};


export type QuerySyncEnquiryOAuthEmailArgs = {
  ProfessionalID: Scalars['Int']['input'];
  SyncGapInSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySyncStatusArgs = {
  Platform: IntegratedPlatformEnum;
  Professional: Scalars['String']['input'];
};


export type QueryTopTrendingCategoriesArgs = {
  count: Scalars['Int']['input'];
};


export type QueryTrendingCategoriesArgs = {
  Directory: DirectoryItemEnumType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVariantArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryVariantShippingArgs = {
  IsSample: Scalars['Boolean']['input'];
  MethodIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  Quantity: Scalars['Int']['input'];
  VariantID: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVerifyEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryVerifyUrlAccessTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWhoAmIArgs = {
  Professional: Scalars['String']['input'];
};


export type QueryWooCommerceLastUpdatedArgs = {
  Professional: Scalars['String']['input'];
};


export type QueryWooCommerceSyncCountsArgs = {
  Professional: Scalars['String']['input'];
};


export type QueryWooCommerceTagsArgs = {
  Professional: Scalars['String']['input'];
};


export type QueryAddOnCartPackCheckoutPreferenceArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryAddOnCartStripeCalcInvoiceIdArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryBillingPaymentMethodsArgs = {
  ProfessionalID: Scalars['Int']['input'];
};


export type QueryBillingRecipientsArgs = {
  ProfessionalID: Scalars['Int']['input'];
};


export type QueryBmEventExhibitorsForProfessionalArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmEventForProfessionalArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmEventSubmissionForProfessionalArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  SubmissionID: Scalars['ID']['input'];
};


export type QueryBmEventSubmissionsForProfessionalArgs = {
  ApplicationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  CreatedFrom?: InputMaybe<Scalars['String']['input']>;
  CreatedTo?: InputMaybe<Scalars['String']['input']>;
  EventID: Scalars['ID']['input'];
  HasTicket?: InputMaybe<Scalars['Boolean']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Offset?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  Search?: InputMaybe<Scalars['String']['input']>;
  SortBy?: InputMaybe<Scalars['String']['input']>;
  Statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryBmEventTicketIssuersForProfessionalArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmEventTicketProfessionalsForProfessionalArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmEventTicketsForProfessionalArgs = {
  CreatedFrom?: InputMaybe<Scalars['String']['input']>;
  CreatedTo?: InputMaybe<Scalars['String']['input']>;
  EventID: Scalars['ID']['input'];
  IssuedByMemberIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Offset?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalID: Scalars['ID']['input'];
  ProfessionalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  Scanned?: InputMaybe<Scalars['String']['input']>;
  Search?: InputMaybe<Scalars['String']['input']>;
  SortBy?: InputMaybe<Scalars['String']['input']>;
  Types?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryBmExhibitingEventsForProfessionalArgs = {
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmExhibitingTicketsForEventArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmHdePrintLibraryItemArgs = {
  LibraryItemID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmHdePrintTicketArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  TicketID: Scalars['ID']['input'];
};


export type QueryBmHdePrintTicketsArgs = {
  EventID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
  TicketIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryBmIssuedTicketsForProfessionalArgs = {
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmOwnedEventsForProfessionalArgs = {
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBmSearchProfessionalsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  SearchTerm: Scalars['String']['input'];
};


export type QueryBmUpcomingEventsForProfessionalArgs = {
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryBuildHubByLinkArgs = {
  UrlSegment: Scalars['String']['input'];
};


export type QueryBuildHubFileCommentsArgs = {
  CommentTargetID: Scalars['ID']['input'];
};


export type QueryBuildHubsArgs = {
  filter?: InputMaybe<BuildHubsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCardsArgs = {
  category?: InputMaybe<Array<CardTypeCategory>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  link: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CardsSimpleSortFields>;
  state?: InputMaybe<Array<CardState>>;
};


export type QueryCheckPinMembershipArgs = {
  pinId: Scalars['ID']['input'];
  pinType: PinTypeEnum;
};


export type QueryConversionRulesArgs = {
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryEditableImageArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryEmailTemplateByLinkArgs = {
  Link: Scalars['String']['input'];
};


export type QueryFindAddressArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Query: Scalars['String']['input'];
  Type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindPlaceArgs = {
  apiProvider?: InputMaybe<FindPlaceApiProviderEnum>;
  apiVersion?: InputMaybe<Scalars['String']['input']>;
  country: SupportedCountry;
  includeParents?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  parentIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<FindPlaceTypeEnum>;
};


export type QueryGenerateExternalLinkArgs = {
  Input?: InputMaybe<GeneratedExternalLinkInput>;
};


export type QueryGetAddressArgs = {
  ID: Scalars['String']['input'];
};


export type QueryGetAnalyticsDemoBookingUrlArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetBlockListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetBookingByEventIdArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryGetBrandImpressionTopPerformersArgs = {
  Months: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetBuildingGuideArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetBuildingGuideSectionArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetBusinessTermsByIdArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryGetBusinessTermsByUrlSegmentArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
  URLSegment: Scalars['String']['input'];
};


export type QueryGetBusinessTermsVersionForEditorArgs = {
  ID: Scalars['Int']['input'];
  Version: Scalars['Int']['input'];
};


export type QueryGetCalendarAvailabilityArgs = {
  originalEventId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCalendarConnectionArgs = {
  provider: Scalars['String']['input'];
};


export type QueryGetCalendarDataArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  provider: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCalendarSessionArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryGetCalendarSessionByUrlSegmentArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetCampaignMetaAdsArgs = {
  ProfessionalID: Scalars['Int']['input'];
  UTM: Scalars['String']['input'];
};


export type QueryGetCategoryArgs = {
  Link: Scalars['String']['input'];
};


export type QueryGetContactsListArgs = {
  ExcludeMemberIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  Search?: InputMaybe<Scalars['StringInput']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetConversationArgs = {
  ID: Scalars['Int']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetConversationByParticipantsArgs = {
  MemberIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  ProfessionalIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGetConversationMessageArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryGetConversationsArgs = {
  BranchProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  BuildHubIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  IsArchived?: InputMaybe<Scalars['Boolean']['input']>;
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  Search?: InputMaybe<Scalars['StringInput']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDashboardAudienceArgs = {
  Months: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetDashboardOverviewArgs = {
  Months: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetDashboardProfilePagesArgs = {
  Months: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetDashboardPublicationsArgs = {
  Months: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetDashboardSocialAdsArgs = {
  Months: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
  Type?: InputMaybe<SocialAdTypeEnum>;
};


export type QueryGetDesignBoardArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetDigitalPublicationDetailsArgs = {
  CampaignID: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetDirectoryCompaniesArgs = {
  Category?: InputMaybe<Array<Scalars['String']['input']>>;
  Purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  Region?: InputMaybe<Array<Scalars['String']['input']>>;
  Url: Scalars['String']['input'];
};


export type QueryGetDirectoryItemsArgs = {
  IDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  URLSegments?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetDirectoryPageMetaArgs = {
  Url: Scalars['String']['input'];
};


export type QueryGetDirectoryProfessionsArgs = {
  ProfessionalURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  Url: Scalars['String']['input'];
};


export type QueryGetDirectoryRegionsArgs = {
  Country: Scalars['String']['input'];
  ProfessionalURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  Url: Scalars['String']['input'];
};


export type QueryGetEngagementEventsSummaryArgs = {
  Months: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetEngagementTopPerformersArgs = {
  Months: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetEngagementsOverTimeArgs = {
  Days: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
  Title: Scalars['String']['input'];
};


export type QueryGetEnquiryConversationArgs = {
  ID: Scalars['ID']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetHubspotCompanyArgs = {
  HubspotID: Scalars['String']['input'];
};


export type QueryGetImportMapArgs = {
  Professional: Scalars['String']['input'];
};


export type QueryGetInboxStateArgs = {
  ProfessionalID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetIntegrationRequestArgs = {
  RequestID: Scalars['String']['input'];
};


export type QueryGetInviteInfoArgs = {
  InviteHash: Scalars['String']['input'];
};


export type QueryGetItemToAmplifyArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Link: Scalars['String']['input'];
};


export type QueryGetLeadExportJobArgs = {
  JobID: Scalars['Int']['input'];
};


export type QueryGetLibraryImagesArgs = {
  IDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryGetLinkPreviewArgs = {
  URL: Scalars['String']['input'];
};


export type QueryGetMembershipTermArgs = {
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetModulePageArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetOverwriteBlacklistArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetPageBulkCloneJobArgs = {
  JobID: Scalars['Int']['input'];
};


export type QueryGetPageSeoSchemaArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryGetProductArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetProductInstallersArgs = {
  CategoryID?: InputMaybe<Scalars['Int']['input']>;
  URLSegment: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GetProductInstallersSimpleSortFields>;
};


export type QueryGetProductSwatchesArgs = {
  URLSegment?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProductsCsvArgs = {
  input?: InputMaybe<GetProductsCsvInputType>;
};


export type QueryGetProfessionalArgs = {
  ID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProfessionalByUrlSegmentArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetProfessionalForTeamMembersArgs = {
  ID: Scalars['Int']['input'];
};


export type QueryGetProfessionalLeadsCsvArgs = {
  input: LeadExportInput;
};


export type QueryGetProfessionalServicesArgs = {
  CategoryPageIDs?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetPromotionalStatsArgs = {
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryGetPublicationDetailsArgs = {
  ProfessionalURL: Scalars['String']['input'];
  Title: Scalars['String']['input'];
};


export type QueryGetRecentlyViewedDirectoryItemArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type: DirectoryItemEnumType;
};


export type QueryGetShareLinkArgs = {
  ExtraClaims?: InputMaybe<Array<ShareLinkExtraClaimEnum>>;
  Link: Scalars['String']['input'];
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  ValidDurationSeconds: Scalars['Int']['input'];
};


export type QueryGetSidePromoArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryGetSocialAdDetailsArgs = {
  ID: Scalars['String']['input'];
  ProfessionalURLSegment: Scalars['String']['input'];
  Type: SocialAdTypeEnum;
};


export type QueryGetUpscaleConfigArgs = {
  ExpectedWidth?: InputMaybe<Scalars['Int']['input']>;
  NoCache?: InputMaybe<Scalars['Boolean']['input']>;
  Options?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUpscaleOriginalImageUrlArgs = {
  CurrentImageUrl: Scalars['String']['input'];
  LibraryImageID: Scalars['Int']['input'];
};


export type QueryGetUserActiveStatusesArgs = {
  MemberIDs: Array<Scalars['Int']['input']>;
};


export type QueryGetUsersOnPageArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryHdeEventLeadStatsArgs = {
  EventDetailsID: Scalars['ID']['input'];
};


export type QueryHdeEventLeadsArgs = {
  EventDetailsID: Scalars['ID']['input'];
};


export type QueryHomeHeroArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHomeIntroArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHomeMediaArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInboxUnreadCountArgs = {
  IncludeCollaboratorConversations?: InputMaybe<Scalars['Boolean']['input']>;
  IncludeDirectConversations?: InputMaybe<Scalars['Boolean']['input']>;
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInspirationByLinkArgs = {
  UrlSegment: Scalars['String']['input'];
};


export type QueryInvoiceByPaymentUuidArgs = {
  ProposalLink?: InputMaybe<Scalars['String']['input']>;
  Uuid: Scalars['String']['input'];
};


export type QueryInvoiceByUuidArgs = {
  Uuid: Scalars['String']['input'];
};


export type QueryInvoiceEmailSnapshotByUuidArgs = {
  Uuid: Scalars['String']['input'];
};


export type QueryInvoiceHasProcessingPaymentArgs = {
  InvoiceId: Scalars['Int']['input'];
};


export type QueryInvoiceLogListArgs = {
  InvoiceID: Scalars['Int']['input'];
  Level?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLibraryItemQrUrlArgs = {
  LibraryItemID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryListAllDirectoryCategoriesArgs = {
  Directory?: InputMaybe<DirectoryItemEnumType>;
};


export type QueryListClickEngagementEventsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Months: Scalars['Int']['input'];
  Offset?: InputMaybe<Scalars['String']['input']>;
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryListDesignBoardCollaboratorsArgs = {
  DesignBoardID: Scalars['Int']['input'];
};


export type QueryListDesignBoardCommentsArgs = {
  DesignBoardID: Scalars['Int']['input'];
};


export type QueryListDesignBoardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListDesignBoardsSimpleSortFields>;
};


export type QueryListDigitalPublicationRecipientClicksArgs = {
  CampaignID: Scalars['Int']['input'];
  ProfessionalURL: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListDirectoryCategoriesArgs = {
  Directory?: InputMaybe<DirectoryItemEnumType>;
  IncludeRelatedItems?: InputMaybe<Scalars['Boolean']['input']>;
  IncludeUnlistedItems?: InputMaybe<Scalars['Boolean']['input']>;
  LeafCategoriesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  LibraryItemIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  NonEmptyCategoriesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  OnlyVisible?: InputMaybe<Scalars['Boolean']['input']>;
  ProfessionalCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  ProfessionalURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  Purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  Regions?: InputMaybe<Array<Scalars['String']['input']>>;
  Sort?: InputMaybe<Scalars['String']['input']>;
  Source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListDirectoryItemsArgs = {
  Directory: DirectoryItemEnumType;
  Filters?: InputMaybe<Array<ListDirectoryItemsFilter>>;
  IncludeAllCountries?: InputMaybe<Scalars['Boolean']['input']>;
  ProfessionalURLs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Regions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ShowUnlistedItems?: InputMaybe<Scalars['Boolean']['input']>;
  Sort?: InputMaybe<Scalars['String']['input']>;
  Title?: InputMaybe<Scalars['String']['input']>;
  URLSegment: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  professionalCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<ListDirectoryItemsSimpleSortFields>;
};


export type QueryListDirectoryItemsByCategoryArgs = {
  CategoryID?: InputMaybe<Scalars['Int']['input']>;
  DirectoryItemIDWhitelist?: InputMaybe<Array<Scalars['Int']['input']>>;
  EditMode?: InputMaybe<Scalars['Boolean']['input']>;
  Filter?: InputMaybe<DirectoryItemsFilterEnum>;
  KeyUniquify?: InputMaybe<Scalars['String']['input']>;
  ListType?: InputMaybe<DirectoryItemsByCategoryListTypeEnum>;
  Sort?: InputMaybe<Scalars['String']['input']>;
  Source: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListDirectoryItemsByCategorySimpleSortFields>;
};


export type QueryListEngagementEventsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Months: Scalars['Int']['input'];
  Offset?: InputMaybe<Scalars['String']['input']>;
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryListEnquiryConversationsArgs = {
  All?: InputMaybe<Scalars['Boolean']['input']>;
  URLSegment?: InputMaybe<Scalars['StringInput']['input']>;
  filter?: InputMaybe<Array<EnquiryConversationsFilterFieldsType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListEnquiryConversationsSimpleSortFields>;
};


export type QueryListIntegrationRequestsArgs = {
  EndTimestamp?: InputMaybe<Scalars['Int']['input']>;
  IntegrationType?: InputMaybe<Scalars['String']['input']>;
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Offset?: InputMaybe<Scalars['Int']['input']>;
  Professional: Scalars['String']['input'];
  Source?: InputMaybe<Scalars['String']['input']>;
  StartTimestamp?: InputMaybe<Scalars['Int']['input']>;
  Status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListLibraryDownloadsArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryListLibraryImagesArgs = {
  ProfessionalURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  Sort?: InputMaybe<Scalars['String']['input']>;
  URLSegment: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListLibraryImagesSimpleSortFields>;
};


export type QueryListLibraryRangeItemsArgs = {
  CategoryID?: InputMaybe<Scalars['Int']['input']>;
  EditMode?: InputMaybe<Scalars['Boolean']['input']>;
  ID: Scalars['Int']['input'];
  Sort?: InputMaybe<Scalars['String']['input']>;
  Source?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListLibraryRangeItemsSimpleSortFields>;
};


export type QueryListLibraryRangesArgs = {
  IsInUse?: InputMaybe<Scalars['Boolean']['input']>;
  URLSegment: Scalars['String']['input'];
};


export type QueryListLibraryTabsArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryListPinCommentsArgs = {
  PinID: Scalars['Int']['input'];
};


export type QueryListPinsArgs = {
  URLSegment?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListProductBrandsArgs = {
  URLSegment: Scalars['String']['input'];
};


export type QueryListProductSwatchesArgs = {
  URLSegment: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListProfessionalNetworkSuggestionsArgs = {
  Input?: InputMaybe<ListProfessionalNetworkSuggestionsInputType>;
  URLSegment: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListProfessionalPartnersArgs = {
  URLSegment: Scalars['String']['input'];
  filter?: InputMaybe<ListProfessionalPartnersFilterType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListProjectGroupsArgs = {
  IncludeInvisible?: InputMaybe<Scalars['Boolean']['input']>;
  ProjectID: Scalars['ID']['input'];
};


export type QueryListPublicationClickedRecipientsArgs = {
  ProfessionalURL: Scalars['String']['input'];
  Title: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListPublicationOpenedRecipientsArgs = {
  Title: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListPublicationRecipientClicksArgs = {
  ProfessionalURL: Scalars['String']['input'];
  Title: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListPublicationRecipientOpensArgs = {
  ProfessionalURL: Scalars['String']['input'];
  Title: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryListPublicationsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Months: Scalars['Int']['input'];
  Offset?: InputMaybe<Scalars['String']['input']>;
  ProfessionalURL: Scalars['String']['input'];
};


export type QueryListRecommendedCategoriesArgs = {
  type: DirectoryItemEnumType;
};


export type QueryListSocialAdsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Months: Scalars['Int']['input'];
  Offset?: InputMaybe<Scalars['String']['input']>;
  ProfessionalURL: Scalars['String']['input'];
  Type: SocialAdTypeEnum;
};


export type QueryListTeamMembersByUrlSegmentArgs = {
  URLSegment: Scalars['String']['input'];
  filter?: InputMaybe<ListTeamMembersByUrlSegmentFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ListTeamMembersByUrlSegmentSimpleSortFields>;
};


export type QueryListTeamRolesWithPermissionsArgs = {
  ProfessionalID: Scalars['Int']['input'];
};


export type QueryListWebsiteNotificationsArgs = {
  IsRead?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMemberReadRecordGetArgs = {
  Name: Scalars['String']['input'];
};


export type QueryMgeGuestEmailRegisteredOnEventArgs = {
  Email: Scalars['String']['input'];
  EventID: Scalars['Int']['input'];
  ExcludeSubmissionID?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryModerationReasonsArgs = {
  EntityTypes: Array<ModerationEntityTypeEnum>;
};


export type QueryMyMgeIsEventGuestArgs = {
  EventID: Scalars['Int']['input'];
};


export type QueryMyMgeSubmissionForEventArgs = {
  EventID: Scalars['Int']['input'];
};


export type QueryPageEmbeddingArgs = {
  pageId: Scalars['Int']['input'];
};


export type QueryPersonalMoodBoardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PersonalMoodBoardsSimpleSortFields>;
};


export type QueryPlacementFeaturedItemsArgs = {
  content: FeaturedItemContent;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  placement: FeaturedItemPlacement;
  sort?: InputMaybe<PlacementFeaturedItemsSimpleSortFields>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlacementPotMsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  placement: PotmPlacement;
  sort?: InputMaybe<PlacementPotMsSimpleSortFields>;
};


export type QueryPremiumFeatureAvailableArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryPremiumFeatureCartArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryPremiumFeatureCheckoutPaymentMethodsArgs = {
  ProfessionalID: Scalars['Int']['input'];
};


export type QueryPremiumFeatureCheckoutPollArgs = {
  InvoiceID: Scalars['Int']['input'];
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryPremiumFeatureCheckoutStateArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryPremiumFeatureInstallationsArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryPremiumFeatureSlidesArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryPremiumFeatureStripeCheckoutPollArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
  StripeInvoiceID: Scalars['String']['input'];
};


export type QueryPreviewConversionRuleArgs = {
  ID: Scalars['ID']['input'];
  ProfessionalID: Scalars['ID']['input'];
};


export type QueryProfessionalBacklinksArgs = {
  ProfessionalID: Scalars['Int']['input'];
  Refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProfessionalCategoriesInLocationArgs = {
  location: Scalars['String']['input'];
};


export type QueryProfessionalsByKeywordOrTeamMemberNameArgs = {
  Keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProfessionalsByKeywordOrTeamMemberNameSimpleSortFields>;
};


export type QueryProfessionalsLocationArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProposalEmailPreviewArgs = {
  QuoteContentID: Scalars['ID']['input'];
  RecipientEmail: Scalars['String']['input'];
  RecipientFirstName: Scalars['String']['input'];
  RecipientSurname: Scalars['String']['input'];
};


export type QueryPurchasedAddOnEntitledForSkuArgs = {
  clientProfessionalId?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
  urlSegment?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReadFeatureBookingsArgs = {
  TitlePrefix?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReadOneEventDetailsArgs = {
  ID: Scalars['ID']['input'];
};


export type QueryReadOneFeatureBookingByPlacementArgs = {
  PlacementTitle: Scalars['String']['input'];
};


export type QueryReceiptByPaymentUuidArgs = {
  ProposalLink?: InputMaybe<Scalars['String']['input']>;
  Uuid: Scalars['String']['input'];
};


export type QueryReceivedInvoicesArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
  Offset?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryReminderSettingsArgs = {
  ProfessionalID: Scalars['Int']['input'];
};


export type QuerySavedQuoteByLinkArgs = {
  Link: Scalars['String']['input'];
};


export type QueryScanResolutionArgs = {
  Token: Scalars['String']['input'];
};


export type QuerySearchClassifyArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchEmbeddingArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySubscriptionPacksArgs = {
  ProfessionalURLSegment: Scalars['String']['input'];
};


export type QueryTemplateTokenBindingsArgs = {
  TemplateID: Scalars['ID']['input'];
  TemplateType: TokenTemplateType;
};


export type QueryTemplateTokensArgs = {
  TemplateID: Scalars['ID']['input'];
  TemplateType: TokenTemplateType;
};


export type QueryUserFollowedMoodBoardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserFollowedMoodBoardsSimpleSortFields>;
};


export type QueryUserMoodBoardItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserMoodBoardsArgs = {
  buildHubId?: InputMaybe<Scalars['Int']['input']>;
  canEdit?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<UserMoodBoardsFilterEnum>;
  includeFollowed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nonProjectOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<UserMoodBoardsSimpleSortFields>;
};

/** A quote content contains modules, including the invoice module which contains draft or template data representing a quote that can be sent and later transition into an invoice. */
export type QuoteContent = ContentBuilder & {
  __typename?: 'QuoteContent';
  CanCreate: Scalars['Boolean']['output'];
  CanDelete: Scalars['Boolean']['output'];
  CanEdit: Scalars['Boolean']['output'];
  CanSend: Scalars['Boolean']['output'];
  ClassName: Scalars['String']['output'];
  ContentArea: ContentArea;
  ContentBuilderType: ContentBuilderTypeEnum;
  Created: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  Invoiceable?: Maybe<Invoiceable>;
  IsTemplate: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  Link: Scalars['String']['output'];
  Owner?: Maybe<Member>;
  Professional: Professional;
  QuoteAccepted: Scalars['Boolean']['output'];
  Status: InvoiceStatusEnum;
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};

export enum QuoteDecisionEnum {
  Accept = 'Accept',
  Decline = 'Decline'
}

export type QuoteModule = FlexibleModule & {
  __typename?: 'QuoteModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type QuoteModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type QuoteTemplate = Invoiceable & ModuleColumn & SortableItem & {
  __typename?: 'QuoteTemplate';
  AccountDetails?: Maybe<TokenisedField>;
  ApplicableCountries: Array<Country>;
  BankTransferTerms?: Maybe<TokenisedField>;
  BusinessTermsVersions: Array<BusinessTermsVersion>;
  /** Whether the current member may edit the invoice summary (description/subheadline) only; full editing requires FullAccess. */
  CanEditSummary: Scalars['Boolean']['output'];
  Contact?: Maybe<Contact>;
  ContactInfo?: Maybe<TokenisedField>;
  Created: Scalars['Date']['output'];
  CreditCardTerms?: Maybe<TokenisedField>;
  Currency: Scalars['String']['output'];
  Description?: Maybe<TokenisedField>;
  Discounts: CurrencyAmount;
  ExpiryAutoSetOnSend?: Maybe<Scalars['Boolean']['output']>;
  ExpiryDate?: Maybe<Scalars['Date']['output']>;
  /** Whether the current member has full (delete-tier) BM access for this invoice, quote, or template. */
  FullAccess: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  IsEmpty: Scalars['Boolean']['output'];
  LastEdited: Scalars['Date']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleID: Scalars['Int']['output'];
  Notes?: Maybe<TokenisedField>;
  PaymentTerms?: Maybe<TokenisedField>;
  Payments: Array<InvoicePayment>;
  Professional?: Maybe<Professional>;
  ReadOnly: Scalars['Boolean']['output'];
  References?: Maybe<TokenisedField>;
  Scope?: Maybe<TokenisedField>;
  SelectedBusinessTermsCategories: Array<BusinessTermsCategory>;
  Services: Array<InvoiceServiceItem>;
  SubTotal: CurrencyAmount;
  Tax: CurrencyAmount;
  TaxBehavior?: Maybe<Scalars['String']['output']>;
  Thumb?: Maybe<LibraryImage>;
  Title?: Maybe<TokenisedField>;
  Total: CurrencyAmount;
  WordCount: Scalars['Int']['output'];
};

/** Indicates if a reaction is positive or negative or neutral. */
export enum ReactionPolarityEnum {
  Negative = 'Negative',
  Neutral = 'Neutral',
  Positive = 'Positive'
}

/** Allowed reactions configured in YAML */
export enum ReactionTypeEnum {
  Angry = 'angry',
  Checkmark = 'checkmark',
  DownVote = 'down_vote',
  Eyes = 'eyes',
  Heart = 'heart',
  Laugh = 'laugh',
  RaisedHands = 'raised_hands',
  Sad = 'sad',
  ThumbsUp = 'thumbs_up',
  UpVote = 'up_vote',
  Wave = 'wave'
}

export type ReadStatus = {
  __typename?: 'ReadStatus';
  ID: Scalars['String']['output'];
  ReadBy: Scalars['String']['output'];
  ReadOn: Scalars['String']['output'];
  Source: Scalars['String']['output'];
};

export type RearrangeItems = {
  ID: Scalars['Int']['input'];
  /** This is the current sort order */
  MemberSortOrder: Scalars['Int']['input'];
};

export type ReceiptResponse = InvoicePayment | NotAuthorizedError | NotFoundError | ServerError | UserError;

/** Return data associated with recently viewed content */
export type RecentlyViewedContent = {
  __typename?: 'RecentlyViewedContent';
  RecentlyViewedAll: Array<DirectoryItem>;
  RecentlyViewedArticles: Array<Article>;
  RecentlyViewedProducts: Array<Product>;
  RecentlyViewedProfessionals: Array<Professional>;
  RecentlyViewedProjects: Array<Project>;
};

/** Return recently viewed image */
export type RecentlyViewedImage = {
  __typename?: 'RecentlyViewedImage';
  IsMultiplied?: Maybe<Scalars['Boolean']['output']>;
  LibraryImageFile?: Maybe<LibraryImageFile>;
};

export type RecipientOverview = {
  __typename?: 'RecipientOverview';
  Clicked: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Opened: Scalars['Int']['output'];
};

export type RecommendationModule = ModuleType & {
  __typename?: 'RecommendationModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  BackgroundDesktop?: Maybe<LibraryImageFile>;
  BackgroundMobile?: Maybe<LibraryImageFile>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Logo?: Maybe<LibraryImageFile>;
  LogoLink?: Maybe<Scalars['String']['output']>;
  MobileBackgroundPosition?: Maybe<Scalars['String']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  Code: Scalars['Int']['output'];
  URL: Scalars['String']['output'];
};

/** Queue result for stale external URL refresh requests. */
export type RefreshStaleExternalUrlPinsResult = {
  __typename?: 'RefreshStaleExternalUrlPinsResult';
  checkedCount: Scalars['Int']['output'];
  queuedCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type Region = {
  __typename?: 'Region';
  Country: Country;
  ID: Scalars['Int']['output'];
  ParentID: Scalars['Int']['output'];
  PrimaryLocality?: Maybe<Locality>;
  Regions: ChildRegionsConnection;
  SortOrder: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};


export type RegionRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RegionOption = {
  __typename?: 'RegionOption';
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
};

export type ReminderResult = {
  __typename?: 'ReminderResult';
  Message?: Maybe<Scalars['String']['output']>;
  Success: Scalars['Boolean']['output'];
};

export type RemoveFacetOptionInput = {
  /** ID of the facet to add the option too. */
  FacetOptionID: Scalars['Int']['input'];
  URLSegment: Scalars['StringInput']['input'];
};

export type RemoveNetworkParticipantCreateData = {
  /** ID of the participant to remove */
  participantId: Scalars['ID']['input'];
};

export type RenewalDealOwnerOption = {
  __typename?: 'RenewalDealOwnerOption';
  ID: Scalars['ID']['output'];
  Label: Scalars['String']['output'];
};

export type RepliesConnection = {
  __typename?: 'RepliesConnection';
  edges: Array<RepliesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type RepliesConnectionEdge = {
  __typename?: 'RepliesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ArcherReply;
};

/** The message being replied to. Can be a `TextMessage` or `FileAttachmentMessage`. */
export type ReplyToMessageUnion = FileAttachmentMessage | TextMessage;

export enum ReportCategory {
  Acquisition = 'Acquisition',
  Benchmarks = 'Benchmarks',
  Campaigns = 'Campaigns',
  CategoryPlacement = 'CategoryPlacement',
  Demographics = 'Demographics',
  EnhancedConversions = 'EnhancedConversions',
  GoogleSeo = 'GoogleSeo',
  LeadFunnel = 'LeadFunnel',
  LeadsPipeline = 'LeadsPipeline',
  Overview = 'Overview',
  PixelConversions = 'PixelConversions',
  ProductTags = 'ProductTags',
  ProfilePages = 'ProfilePages',
  Roi = 'Roi',
  Sales = 'Sales'
}

export type ReportDirectoryItemResponse = ModerationContentReportCreated | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type ReportUserResponse = ModerationUserReportCreated | NotAuthorizedError | NotFoundError | ServerError | UserError;

export enum ResourceType {
  Member = 'Member',
  Professional = 'Professional',
  TeamMember = 'TeamMember'
}

export type ResponsiveImage = {
  __typename?: 'ResponsiveImage';
  Desktop?: Maybe<Scalars['String']['output']>;
  Desktop2x?: Maybe<Scalars['String']['output']>;
  DesktopPreload?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
  Mobile?: Maybe<Scalars['String']['output']>;
  Mobile2x?: Maybe<Scalars['String']['output']>;
  MobilePreload?: Maybe<Scalars['String']['output']>;
};

export type ResponsiveSingleImage = {
  __typename?: 'ResponsiveSingleImage';
  Height?: Maybe<Scalars['Int']['output']>;
  URL?: Maybe<Scalars['String']['output']>;
  Width?: Maybe<Scalars['Int']['output']>;
};

export type ResponsiveVariantImage = {
  __typename?: 'ResponsiveVariantImage';
  DesktopOriginalDimension?: Maybe<ImageDimension>;
  DesktopVariant?: Maybe<ResponsiveImage>;
  MobileOriginalDimension?: Maybe<ImageDimension>;
  MobileVariant?: Maybe<ResponsiveImage>;
};

/** Message sent when a professional reveals the enquirer's contact details. */
export type RevealContactDetailsMessage = Message & {
  __typename?: 'RevealContactDetailsMessage';
  Content: Scalars['String']['output'];
  ConversationID: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  CreatedBy: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
};

export type ReviewAction = {
  __typename?: 'ReviewAction';
  ID: Scalars['Int']['output'];
  IsDone: Scalars['Boolean']['output'];
  Task: Scalars['String']['output'];
};

export type RichTextModule = ModuleType & {
  __typename?: 'RichTextModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']['output']>;
  ExternalLink?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Image?: Maybe<ResponsiveVariantImage>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};

export type RowData = {
  __typename?: 'RowData';
  ID: Scalars['String']['output'];
  Values: Array<Datum>;
};

export type SalesConversionsFilters = {
  DATE__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SalesReports = {
  __typename?: 'SalesReports';
  ID: Scalars['Int']['output'];
  LibraryPageKPI?: Maybe<RowData>;
  LibraryPagePublicKPI?: Maybe<RowData>;
  MonthlyUserCount?: Maybe<RowData>;
  SalesConversions?: Maybe<TableData>;
};


export type SalesReportsLibraryPageKpiArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SalesReportsLibraryPagePublicKpiArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SalesReportsSalesConversionsArgs = {
  filters?: InputMaybe<SalesConversionsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SampleEnquiryInput = {
  Address?: InputMaybe<Scalars['StringInput']['input']>;
  Company?: InputMaybe<Scalars['StringInput']['input']>;
  CustomAddressPlaceholder?: InputMaybe<Scalars['StringInput']['input']>;
  CustomMessagePlaceholder?: InputMaybe<Scalars['StringInput']['input']>;
  Email: Scalars['Email']['input'];
  Message: Scalars['StringInput']['input'];
  Name: Scalars['StringInput']['input'];
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
};

export type SavedModule = FlexibleModule & SortableItem & {
  __typename?: 'SavedModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  ContentBuilderType: ContentBuilderTypeEnum;
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup: ModuleGroupEnum;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  PreviewImage?: Maybe<ResponsiveImage>;
  ProfessionalID: Scalars['Int']['output'];
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
  Version?: Maybe<Scalars['Int']['output']>;
};


export type SavedModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type SavedModuleVersion = {
  __typename?: 'SavedModuleVersion';
  Author?: Maybe<Member>;
  LastEdited?: Maybe<Scalars['String']['output']>;
  Version: Scalars['Int']['output'];
};

export type SavedQuoteResponse = NotAuthorizedError | NotFoundError | QuoteContent | ServerError | UserError;

/** Generic preview of any LibraryItem (Project, Product, Article, Professional) returned by a supplier-QR scan, kept polymorphic so the schema doesn't need to know which subclass was scanned. */
export type ScanLibraryItemPreview = {
  __typename?: 'ScanLibraryItemPreview';
  ID: Scalars['ID']['output'];
  ThumbnailUrl?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  /** Concrete subclass name (Project, Product, BlogPost, Professional). */
  Type?: Maybe<Scalars['String']['output']>;
  /** Public canonical URL of the library item (the desktop fallback links to this). */
  Url?: Maybe<Scalars['String']['output']>;
};

/** Side-effect-free preview of a decoded HDE QR token. Used by the in-app and Remix landing UIs. */
export type ScanResolution = {
  __typename?: 'ScanResolution';
  /** Discriminator. One of MemberTicket, LibraryItem, Invalid. */
  Kind: Scalars['String']['output'];
  /** Resolved library item preview when Kind=LibraryItem. */
  LibraryItem?: Maybe<ScanLibraryItemPreview>;
  /** Owning professional for Kind=LibraryItem scans. */
  Professional?: Maybe<Professional>;
  /** Human-readable reason when Kind=Invalid. */
  Reason?: Maybe<Scalars['String']['output']>;
  /** Resolved ticket when Kind=MemberTicket. */
  Ticket?: Maybe<EventTicket>;
};

/** Outcome of a processScan mutation, including the side effects applied (lead + pin IDs). */
export type ScanResult = {
  __typename?: 'ScanResult';
  /** Discriminator. One of MemberTicket, LibraryItem, Invalid. */
  Kind: Scalars['String']['output'];
  /** ID of the LeadActivity row created on the exhibitor's professional (lead-mode scans only). */
  LeadID?: Maybe<Scalars['ID']['output']>;
  LibraryItem?: Maybe<ScanLibraryItemPreview>;
  Message?: Maybe<Scalars['String']['output']>;
  /** ID of the IdeasBookItem pin created on the recipient's design board. */
  PinID?: Maybe<Scalars['ID']['output']>;
  Professional?: Maybe<Professional>;
  Success: Scalars['Boolean']['output'];
  Ticket?: Maybe<EventTicket>;
};

export type ScannerContextInput = {
  /** One of LEAD or DOOR. LEAD records exchanged contact info; DOOR is staff-only ticket validation. */
  Mode: Scalars['String']['input'];
};

/** The classification result of a search query. */
export type SearchClassification = {
  __typename?: 'SearchClassification';
  /** The color. Only set if the searchType is \"PRODUCTS\". */
  color?: Maybe<Scalars['String']['output']>;
  /** The modified search query. This is `null` if the query was not modified. */
  modifiedQuery?: Maybe<Scalars['String']['output']>;
  /** The search type. */
  searchType?: Maybe<SearchTypeEnum>;
};

export type SearchEmbedding = {
  __typename?: 'SearchEmbedding';
  Embedding: Scalars['String']['output'];
  SearchTerm: Scalars['String']['output'];
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  ID: Scalars['Int']['output'];
  Keyword: Scalars['String']['output'];
};

export type SearchTag = {
  __typename?: 'SearchTag';
  ID: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Text: Scalars['String']['output'];
};

/** The search type for Service Service queries. */
export enum SearchTypeEnum {
  Articles = 'ARTICLES',
  Products = 'PRODUCTS',
  Professionals = 'PROFESSIONALS',
  Projects = 'PROJECTS'
}

export type SecuritySettings = {
  __typename?: 'SecuritySettings';
  MfaEnabled: Scalars['Boolean']['output'];
};

export type SendHubspotMarketingPreferencesEmailInputType = {
  email: Scalars['Email']['input'];
};

export type SendHubspotMarketingPreferencesEmailResultType = {
  __typename?: 'SendHubspotMarketingPreferencesEmailResultType';
  recipient?: Maybe<Scalars['String']['output']>;
};

export type ServerError = ErrorInterface & {
  __typename?: 'ServerError';
  Message: Scalars['String']['output'];
};

export type ServiceAreaInput = {
  AddressID?: InputMaybe<Scalars['StringInput']['input']>;
  City?: InputMaybe<Scalars['StringInput']['input']>;
  Country?: InputMaybe<Scalars['StringInput']['input']>;
  District?: InputMaybe<Scalars['StringInput']['input']>;
  FullAddress?: InputMaybe<Scalars['StringInput']['input']>;
  Latitude?: InputMaybe<Scalars['Float']['input']>;
  Longitude?: InputMaybe<Scalars['Float']['input']>;
  PlaceName?: InputMaybe<Scalars['StringInput']['input']>;
  PlaceType?: InputMaybe<Scalars['StringInput']['input']>;
  PostCode?: InputMaybe<Scalars['StringInput']['input']>;
  Region?: InputMaybe<Scalars['StringInput']['input']>;
  ServiceableAreaID?: InputMaybe<Scalars['Int']['input']>;
  State?: InputMaybe<Scalars['StringInput']['input']>;
  Suburb?: InputMaybe<Scalars['StringInput']['input']>;
};

/** Quantifiable services a professional provides */
export type ServiceOffering = {
  __typename?: 'ServiceOffering';
  Description?: Maybe<Scalars['String']['output']>;
  /** HubSpot URL for the service offering, if linked to HubSpot */
  HubspotURL?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  PhotoSrc?: Maybe<Scalars['String']['output']>;
  Quantity?: Maybe<Scalars['Int']['output']>;
  SKU: Scalars['String']['output'];
  ServicePriceAmount?: Maybe<Scalars['Float']['output']>;
  Title: Scalars['String']['output'];
  Unit?: Maybe<Scalars['String']['output']>;
  UnitPriceAmount?: Maybe<Scalars['Float']['output']>;
};

export type ServiceOfferingResponse = NotAuthorizedError | NotFoundError | ServerError | ServiceOffering | UserError;

export type SetDirectoryFeaturedProjectResult = DirectoryFeaturedProject | NotAuthorizedError | UserError;

export type SetParticipantStatusInput = {
  /** The ID of the conversation. */
  ID: Scalars['ID']['input'];
  /** The professional ID if in a company inbox context. */
  ProfessionalID?: InputMaybe<Scalars['Int']['input']>;
  /** The status(es) to update. */
  Status: SetParticipantStatusStatusField;
};

export type SetParticipantStatusStatusField = {
  Archived?: InputMaybe<Scalars['Boolean']['input']>;
  Important?: InputMaybe<Scalars['Boolean']['input']>;
  MarkAsDone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetProductInLibraryResult = NotAuthorizedError | Product | UserError;

export type SetProjectInLibraryResult = NotAuthorizedError | Project | UserError;

export type SetupIntent = {
  __typename?: 'SetupIntent';
  ClientSecret: Scalars['String']['output'];
  ID: Scalars['String']['output'];
};

export type SetupIntentResponse = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | SetupIntent | UserError;

export type ShareEnquiryConversationInput = {
  Emails: Array<Scalars['Email']['input']>;
  ID: Scalars['ID']['input'];
  Message?: InputMaybe<Scalars['String']['input']>;
  RedirectNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShareEnquiryConversationResult = {
  __typename?: 'ShareEnquiryConversationResult';
  Conversation?: Maybe<EnquiryConversation>;
};

export enum ShareItemType {
  Board = 'board',
  Directoryitem = 'directoryitem',
  Pin = 'pin'
}

export enum ShareLinkExtraClaimEnum {
  AutoJoinTeam = 'AutoJoinTeam',
  RequireLogin = 'RequireLogin'
}

export enum ShareType {
  Email = 'email',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Pinterest = 'pinterest',
  Whatsapp = 'whatsapp'
}

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  DeliveryEstimate: MinMax;
  DeliveryEstimateText: Scalars['String']['output'];
  FreeThresholdEnabled: Scalars['Boolean']['output'];
  /** Whether this shipping method is fulfilled with shipping rates */
  Fulfilled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  QuotedSeparately: Scalars['Boolean']['output'];
  ShippingCost?: Maybe<CurrencyAmount>;
  ShippingCostText: Scalars['String']['output'];
  ShippingProfile?: Maybe<ShippingProfile>;
  ShippingProvider?: Maybe<ShippingProviderEnum>;
  ShippingRates: Array<ShippingRate>;
  ShippingZoneRates: ShippingZoneRatesConnection;
  Title: Scalars['String']['output'];
};


export type ShippingMethodShippingZoneRatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingMethodInput = {
  DeliveryEstimate?: InputMaybe<MinMaxInput>;
  FreeThresholdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ID: Scalars['Int']['input'];
  ShippingRates?: InputMaybe<Array<ShippingRateInput>>;
  ShippingZoneRates?: InputMaybe<Array<ShippingZoneRateInput>>;
  Title?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingPriceBreak = {
  __typename?: 'ShippingPriceBreak';
  Breakpoint: Scalars['Int']['output'];
  ID: Scalars['Int']['output'];
  Rate: CurrencyAmount;
};

export type ShippingPriceBreakInput = {
  Breakpoint: Scalars['Int']['input'];
  Rate: Scalars['Int']['input'];
};

export type ShippingPriceBreaksConnection = {
  __typename?: 'ShippingPriceBreaksConnection';
  edges: Array<ShippingPriceBreaksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ShippingPriceBreaksConnectionEdge = {
  __typename?: 'ShippingPriceBreaksConnectionEdge';
  /** The node at the end of the collections edge */
  node: ShippingPriceBreak;
};

export type ShippingProfile = {
  __typename?: 'ShippingProfile';
  ApplyRatePerItem: Scalars['Boolean']['output'];
  Default: Scalars['Boolean']['output'];
  ExcludePromotions: Scalars['Boolean']['output'];
  FreeShipping: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  NoShipping: Scalars['Boolean']['output'];
  ShippingMethods: Array<ShippingMethod>;
  Title: Scalars['String']['output'];
};


export type ShippingProfileShippingMethodsArgs = {
  Deliverable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingPromotion = {
  __typename?: 'ShippingPromotion';
  ID: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
};

export type ShippingProvider = {
  __typename?: 'ShippingProvider';
  AccountID: Scalars['String']['output'];
  Countries: Array<Scalars['String']['output']>;
  Enabled: Scalars['Boolean']['output'];
  FreeThresholdEnabled: Scalars['Boolean']['output'];
  HasAccountSecret: Scalars['Boolean']['output'];
  HelpText?: Maybe<Scalars['String']['output']>;
  ID: Scalars['String']['output'];
  Locations: ShippingProviderLocationsConnection;
  LogoUrl: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  ShippingProvider: ShippingProviderEnum;
  Title: Scalars['String']['output'];
  ValidationRegex: Scalars['String']['output'];
};


export type ShippingProviderLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum ShippingProviderEnum {
  Onsend = 'ONSEND'
}

export type ShippingProviderLocation = {
  __typename?: 'ShippingProviderLocation';
  ID: Scalars['Int']['output'];
  Location: LibraryLocation;
  SiteCode: Scalars['String']['output'];
};

export type ShippingProviderLocationInput = {
  /** The LibraryLocation ID */
  LocationID: Scalars['Int']['input'];
  /** The Shipping Provider's site code for the location */
  SiteCode: Scalars['StringInput']['input'];
};

export type ShippingProviderLocationsConnection = {
  __typename?: 'ShippingProviderLocationsConnection';
  edges: Array<ShippingProviderLocationsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ShippingProviderLocationsConnectionEdge = {
  __typename?: 'ShippingProviderLocationsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ShippingProviderLocation;
};

export type ShippingRate = {
  __typename?: 'ShippingRate';
  Available: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Rate: CurrencyAmount;
  Region: Region;
  ShippingMethod: ShippingMethod;
};

export type ShippingRateInput = {
  Rate: Scalars['Int']['input'];
  RegionID: Scalars['Int']['input'];
};

export enum ShippingRateTypeEnum {
  Flatrate = 'FLATRATE',
  Quoted = 'QUOTED',
  Weight = 'WEIGHT'
}

export type ShippingZone = {
  __typename?: 'ShippingZone';
  ExcludedPostcodes: ExcludedPostcodesConnection;
  ID: Scalars['Int']['output'];
  Locations: LocationsConnection;
  PostcodeGroups: PostcodeGroupsConnection;
  /** Delivery radius from dispatch locations, stored in kilometres. */
  Radius: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  Type: ShippingZoneTypeEnum;
};


export type ShippingZoneExcludedPostcodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ShippingZoneLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ShippingZonePostcodeGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingZoneCreateResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | ShippingZone | UserError;

export type ShippingZoneDeleteResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | ShippingZone | UserError;

export type ShippingZoneInput = {
  ExcludedPostcodes?: InputMaybe<Scalars['StringInput']['input']>;
  /** A list of LibraryLocation (IDs) to link to this shipping zone. */
  Locations?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** A list of postcode groups (IDs) to link to this shipping zone. */
  PostcodeGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Delivery radius from dispatch locations, stored in kilometres. */
  Radius?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  Type: ShippingZoneTypeEnum;
};

export type ShippingZoneRate = {
  __typename?: 'ShippingZoneRate';
  ID: Scalars['Int']['output'];
  PriceBreaks: ShippingPriceBreaksConnection;
  Rate: CurrencyAmount;
  ShippingMethod: ShippingMethod;
  ShippingZone: ShippingZone;
  Type: ShippingRateTypeEnum;
};


export type ShippingZoneRatePriceBreaksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ShippingZoneRateInput = {
  PriceBreaks?: InputMaybe<Array<ShippingPriceBreakInput>>;
  Rate: Scalars['Int']['input'];
  Type: ShippingRateTypeEnum;
  ZoneID: Scalars['Int']['input'];
};

export type ShippingZoneRatesConnection = {
  __typename?: 'ShippingZoneRatesConnection';
  edges: Array<ShippingZoneRatesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ShippingZoneRatesConnectionEdge = {
  __typename?: 'ShippingZoneRatesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ShippingZoneRate;
};

export type ShippingZoneResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | ShippingZone | UserError;

export enum ShippingZoneTypeEnum {
  Postcode = 'POSTCODE',
  Radius = 'RADIUS'
}

export type ShippingZoneUpdateResult = NotAuthenticatedError | NotAuthorizedError | NotFoundError | ServerError | ShippingZone | UserError;

export type ShippingZonesConnection = {
  __typename?: 'ShippingZonesConnection';
  edges: Array<ShippingZonesConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type ShippingZonesConnectionEdge = {
  __typename?: 'ShippingZonesConnectionEdge';
  /** The node at the end of the collections edge */
  node: ShippingZone;
};

export type ShopifySyncStatus = SyncStatus & {
  __typename?: 'ShopifySyncStatus';
  /** @deprecated No longer provided */
  BulkImportID?: Maybe<Scalars['String']['output']>;
  ErrorDismissed: Scalars['Boolean']['output'];
  Errors: Array<ImportError>;
  Finished: Scalars['Boolean']['output'];
  RequestID: Scalars['String']['output'];
  StartedTimestamp?: Maybe<Scalars['Int']['output']>;
  SuccessDismissed: Scalars['Boolean']['output'];
  SuccessfullySyncedCount: Scalars['Int']['output'];
  TotalProcessed: Scalars['Int']['output'];
  TotalToSync?: Maybe<Scalars['Int']['output']>;
};

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  BillingAddress?: Maybe<Address>;
  CartSuppliers: Array<CartSupplier>;
  CartTotal?: Maybe<CurrencyAmount>;
  Currency: Scalars['String']['output'];
  DeliveryAddress?: Maybe<Address>;
  Email: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  ItemCount: Scalars['Int']['output'];
  ItemTotal?: Maybe<CurrencyAmount>;
  LastAddedItems: Array<CartItem>;
  LastEdited?: Maybe<Scalars['String']['output']>;
  Locality?: Maybe<Locality>;
  LoginRequired: Scalars['Boolean']['output'];
  ModifiedOnRefresh: Scalars['Boolean']['output'];
  ReadOnlyEmail: Scalars['Boolean']['output'];
  Region?: Maybe<Region>;
  ShippingTotal?: Maybe<CurrencyAmount>;
  TaxSystem: Scalars['String']['output'];
  TaxTotal?: Maybe<CurrencyAmount>;
};


export type ShoppingCartLastAddedItemsArgs = {
  Limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SidePromo = {
  __typename?: 'SidePromo';
  Content?: Maybe<Scalars['String']['output']>;
  FirstPromoImage?: Maybe<ResponsiveVariantImage>;
  FirstPromoLink?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  SecondPromoImage?: Maybe<ResponsiveVariantImage>;
  SecondPromoLink?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type SignupData = {
  __typename?: 'SignupData';
  HomeownerBudget: HomeownerBudgetConnection;
  HomeownerPurpose: HomeownerPurposeConnection;
  HomeownerStage: HomeownerStageConnection;
  SignupCategories: OnboardingProfessionalCategoryConnection;
};


export type SignupDataHomeownerBudgetArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SignupDataHomeownerPurposeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SignupDataHomeownerStageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type SignupDataSignupCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SingleImageModule = FlexibleModule & {
  __typename?: 'SingleImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type SingleImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type SingleParagraphModule = FlexibleModule & {
  __typename?: 'SingleParagraphModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type SingleParagraphModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type SingleVideoModule = FlexibleModule & {
  __typename?: 'SingleVideoModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type SingleVideoModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type SiteConfig = {
  __typename?: 'SiteConfig';
  SiteOutageAlertForClients?: Maybe<Scalars['String']['output']>;
};

export type SiteTree = {
  __typename?: 'SiteTree';
  ID: Scalars['Int']['output'];
  Link: Scalars['String']['output'];
  Meta?: Maybe<Meta>;
  PageType: Scalars['String']['output'];
  ParentID: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
  versions?: Maybe<LibraryPageVersionConnection>;
};


export type SiteTreeVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<VersionsSimpleSortFields>;
};

export type SiteTreeLink = {
  __typename?: 'SiteTreeLink';
  Anchor?: Maybe<Scalars['String']['output']>;
  ExternalLink?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  LinkToLoginModal?: Maybe<Scalars['Boolean']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
  URL?: Maybe<Scalars['String']['output']>;
};

export type SocialAd = {
  BodyText: Scalars['String']['output'];
  Date: Scalars['String']['output'];
  Engagements: AdEngagements;
  ExternalID: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  Image: Scalars['String']['output'];
  Performance: AdPerformance;
  PreviewImage: Scalars['String']['output'];
  PreviewShareableLink: Scalars['String']['output'];
  Thumbnail?: Maybe<Scalars['String']['output']>;
  Title: Scalars['String']['output'];
  Top10: Scalars['Boolean']['output'];
  Type: Scalars['String']['output'];
};

export enum SocialAdTypeEnum {
  Facebook = 'Facebook',
  FacebookAd = 'FacebookAd',
  FacebookCampaign = 'FacebookCampaign',
  InstagramMedia = 'InstagramMedia',
  NativeDriver = 'NativeDriver',
  Pinterest = 'Pinterest'
}

export type SocialAdUnion = FacebookSocialAd | FacebookSocialCampaign | InstagramMediaSocialAd;

export type SocialAdsSummary = {
  __typename?: 'SocialAdsSummary';
  ClickThroughRate: Scalars['Float']['output'];
  Clicks: Scalars['Int']['output'];
  ConversionRate: Scalars['Float']['output'];
  ID: Scalars['String']['output'];
  Impressions: Scalars['Int']['output'];
  Reach: Scalars['Int']['output'];
};

export type SocialLoginInput = {
  AccessToken?: InputMaybe<Scalars['String']['input']>;
  Email?: InputMaybe<Scalars['Email']['input']>;
  FirstName?: InputMaybe<Scalars['String']['input']>;
  LastName?: InputMaybe<Scalars['String']['input']>;
  Provider: Scalars['String']['input'];
  ProviderUserId: Scalars['String']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Enum for sorting direction */
export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  ID: Scalars['Int']['input'];
  SortOrder: Scalars['Int']['input'];
};

export type SortableItem = {
  ID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
};

export enum SortableItemEnum {
  Article = 'Article',
  Award = 'Award',
  DiagramImage = 'DiagramImage',
  LibraryDownload = 'LibraryDownload',
  LibraryImage = 'LibraryImage',
  LibraryLocation = 'LibraryLocation',
  LibraryVideo = 'LibraryVideo',
  ModuleColumn = 'ModuleColumn',
  MultiColumnModule = 'MultiColumnModule',
  Product = 'Product',
  ProfessionalService = 'ProfessionalService',
  Project = 'Project',
  TeamMember = 'TeamMember',
  Testimonial = 'Testimonial'
}

export type SpeakerLineupEvents_Connection = {
  __typename?: 'SpeakerLineupEvents_Connection';
  edges: Array<SpeakerLineupEvents_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type SpeakerLineupEvents_ConnectionEdge = {
  __typename?: 'SpeakerLineupEvents_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventDetails;
};

export type SpeakerLineupEvents_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type SpeakerLineupModule = ModuleType & {
  __typename?: 'SpeakerLineupModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  Date?: Maybe<Scalars['String']['output']>;
  DisplayTitle?: Maybe<Scalars['String']['output']>;
  /** HDE events this lineup module is linked to */
  Events: SpeakerLineupEvents_Connection;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  HideSpeakers?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['ID']['output'];
  IsPublic?: Maybe<Scalars['Boolean']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  PanelDescription?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  /** The speaker lineup at an event */
  Speakers: KeynoteSpeakers_Connection;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
};


export type SpeakerLineupModuleEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SpeakerLineupEvents_SortFields>;
};


export type SpeakerLineupModuleSpeakersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<KeynoteSpeakers_SortFields>;
};

export type SpeakersSimpleSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export enum SpecialtyPriceTypeEnum {
  Customer = 'CUSTOMER',
  Trade = 'TRADE'
}

export type SpecialtyRateCategories = {
  __typename?: 'SpecialtyRateCategories';
  Category?: Maybe<Array<Category>>;
  CustomerRate: Scalars['Float']['output'];
  ID: Scalars['Int']['output'];
  TradeProductRate: Scalars['Float']['output'];
  TradeSampleRate: Scalars['Float']['output'];
};

export type SpecialtyRateCategoriesInput = {
  CustomerPriceProducts: Scalars['Float']['input'];
  ID: Scalars['Int']['input'];
  TradePriceProducts: Scalars['Float']['input'];
  TradePriceSamples: Scalars['Float']['input'];
};

export type SquarespaceSyncStatus = SyncStatus & {
  __typename?: 'SquarespaceSyncStatus';
  /** @deprecated No longer provided */
  BulkImportID?: Maybe<Scalars['String']['output']>;
  Errors: Array<ImportError>;
  Finished: Scalars['Boolean']['output'];
  RequestID: Scalars['String']['output'];
  StartedTimestamp?: Maybe<Scalars['Int']['output']>;
  SuccessfullySyncedCount: Scalars['Int']['output'];
  TotalProcessed: Scalars['Int']['output'];
  TotalToSync?: Maybe<Scalars['Int']['output']>;
};

export type StaticGalleryModule = ModuleType & {
  __typename?: 'StaticGalleryModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  Content?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  FirstDesktopImage?: Maybe<LibraryImageFile>;
  FirstMobileImage?: Maybe<LibraryImageFile>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SecondDesktopImage?: Maybe<LibraryImageFile>;
  SecondMobileImage?: Maybe<LibraryImageFile>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  ThirdDesktopImage?: Maybe<LibraryImageFile>;
  ThirdMobileImage?: Maybe<LibraryImageFile>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type StockInfo = {
  __typename?: 'StockInfo';
  DeliveryAvailable: Scalars['Boolean']['output'];
  InStock: Scalars['Boolean']['output'];
  SampleAvailable: Scalars['Boolean']['output'];
};

export type StrategyDashboard = {
  __typename?: 'StrategyDashboard';
  AccountCreationsByClassification?: Maybe<ChartCollection>;
  AccountCreationsByClassificationTrend?: Maybe<ChartCollection>;
  AccountCreationsByMethod?: Maybe<ChartCollection>;
  AccountCreationsByMethodTrend?: Maybe<ChartCollection>;
  AccountCreationsByProfessionalCategory?: Maybe<ChartCollection>;
  AccountCreationsKPIs?: Maybe<ChartCollection>;
  AccountCreationsOnboardingTrend?: Maybe<ChartCollection>;
  AccountCreationsTotalTrend?: Maybe<ChartCollection>;
  AccountCreationsTotalTrendByMethod?: Maybe<ChartCollection>;
  AccountCreationsTrend?: Maybe<ChartCollection>;
  Acquisition?: Maybe<ChartCollection>;
  ByCategory?: Maybe<ChartCollection>;
  ByCohort?: Maybe<ChartCollection>;
  ByCountry?: Maybe<ChartCollection>;
  ByLocation?: Maybe<ChartCollection>;
  ByProfessionalType?: Maybe<ChartCollection>;
  BySource?: Maybe<ChartCollection>;
  ByStage?: Maybe<ChartCollection>;
  ByType?: Maybe<ChartCollection>;
  CanAccess: Scalars['Boolean']['output'];
  ChurnRate?: Maybe<ChartCollection>;
  ConversionByDevice?: Maybe<ChartCollection>;
  ConversionByPageType?: Maybe<ChartCollection>;
  ConversionBySource?: Maybe<ChartCollection>;
  ConversionKPIs?: Maybe<ChartCollection>;
  ConversionPageTypeTrend?: Maybe<ChartCollection>;
  ConversionTrend?: Maybe<ChartCollection>;
  DailyConversionEmailActivityBreakdown?: Maybe<ChartCollection>;
  DailyConversionEmailByDayOfWeek?: Maybe<ChartCollection>;
  DailyConversionEmailCampaignKPIs?: Maybe<ChartCollection>;
  DailyConversionEmailDeliveryPipeline?: Maybe<ChartCollection>;
  DailyConversionEmailDisabledList?: Maybe<ChartCollection>;
  DailyConversionEmailKPIs?: Maybe<ChartCollection>;
  DailyConversionEmailNoNotificationEmailList?: Maybe<ChartCollection>;
  DailyConversionEmailNotManufacturerList?: Maybe<ChartCollection>;
  DailyConversionEmailTodayPipeline?: Maybe<ChartCollection>;
  DailyConversionEmailVolumeTrend?: Maybe<ChartCollection>;
  DailyConversionEmailYesterdayPipeline?: Maybe<ChartCollection>;
  DaysToFirstPayment?: Maybe<ChartCollection>;
  Enquiries?: Maybe<ChartCollection>;
  Funnel?: Maybe<ChartCollection>;
  HDEDailyFormFills?: Maybe<ChartCollection>;
  HDEDoorScansByType?: Maybe<ChartCollection>;
  HDEEventFilterOptions: Array<HdeEventOption>;
  HDEExhibitorMetrics?: Maybe<ChartCollection>;
  HDEFormFillsByCity?: Maybe<TableData>;
  HDEFormFillsByType?: Maybe<ChartCollection>;
  HDEProjectAttendanceReasons?: Maybe<ChartCollection>;
  HDEProjectBudgets?: Maybe<ChartCollection>;
  HDEProjectBuildType?: Maybe<ChartCollection>;
  HDEProjectProductInterests?: Maybe<ChartCollection>;
  HDEProjectStages?: Maybe<ChartCollection>;
  HDEProjectTypes?: Maybe<ChartCollection>;
  HDEProjectValueEstimate?: Maybe<ChartCollection>;
  HDERoomFormFillsByType?: Maybe<ChartCollection>;
  HDERoomProjectAttendanceReasons?: Maybe<ChartCollection>;
  HDERoomProjectBuildType?: Maybe<ChartCollection>;
  HDERoomProjectStages?: Maybe<ChartCollection>;
  HDERoomProjectTypes?: Maybe<ChartCollection>;
  HDERoomProjectValueEstimate?: Maybe<ChartCollection>;
  HDESessionsByCity?: Maybe<TableData>;
  HDETrafficKPIs?: Maybe<ChartCollection>;
  HDETrafficSessions?: Maybe<ChartCollection>;
  ImageUpscaleByType?: Maybe<ChartCollection>;
  ImageUpscaleDimensions?: Maybe<ChartCollection>;
  ImageUpscaleKPIs?: Maybe<ChartCollection>;
  ImageUpscaleProcessingTimeDist?: Maybe<ChartCollection>;
  ImageUpscaleSource?: Maybe<ChartCollection>;
  ImageUpscaleTimeOfDay?: Maybe<ChartCollection>;
  ImageUpscaleTopMembers?: Maybe<ChartCollection>;
  ImageUpscaleTopProfessionals?: Maybe<ChartCollection>;
  ImageUpscaleTrend?: Maybe<ChartCollection>;
  InstalmentsByCategory?: Maybe<ChartCollection>;
  InvoiceActivityLog?: Maybe<TableData>;
  InvoiceFunnel?: Maybe<ChartCollection>;
  InvoiceKPIs?: Maybe<ChartCollection>;
  InvoiceRevenueTrend?: Maybe<ChartCollection>;
  OverduePayments?: Maybe<TableData>;
  PaymentStatusByWeek?: Maybe<ChartCollection>;
  PaymentsReceivedTrend?: Maybe<ChartCollection>;
  ProfessionalProvenanceActiveTrend?: Maybe<ChartCollection>;
  ProfessionalProvenanceCreatedTrend?: Maybe<ChartCollection>;
  ProfessionalProvenanceKPIs?: Maybe<ChartCollection>;
  ProjectProvenanceActiveTrend?: Maybe<ChartCollection>;
  ProjectProvenanceCreatedTrend?: Maybe<ChartCollection>;
  ProjectProvenanceKPIs?: Maybe<ChartCollection>;
  ProjectsCreated?: Maybe<ChartCollection>;
  QDDByDevice?: Maybe<ChartCollection>;
  QDDByDeviceTrend?: Maybe<ChartCollection>;
  QDDByPageType?: Maybe<ChartCollection>;
  QDDBySource?: Maybe<ChartCollection>;
  QDDByUserCountry?: Maybe<TableData>;
  QDDDenominators?: Maybe<ChartCollection>;
  QDDDistribution?: Maybe<ChartCollection>;
  QDDEnquiries?: Maybe<ChartCollection>;
  QDDPageTypeTrend?: Maybe<ChartCollection>;
  QDDPeriodComparison?: Maybe<PeriodComparison>;
  QDDReferrals?: Maybe<ChartCollection>;
  QDDTopClients?: Maybe<TableData>;
  QDDTopEnquirySources?: Maybe<TableData>;
  QDDTopReferralSources?: Maybe<TableData>;
  QDDZeroClients?: Maybe<TableData>;
  QuoteConversionByCategory?: Maybe<TableData>;
  QuoteValueDistribution?: Maybe<ChartCollection>;
  QuotesAcceptedTrend?: Maybe<ChartCollection>;
  QuotesSentTrend?: Maybe<ChartCollection>;
  RenewalAtRiskByCategory?: Maybe<ChartCollection>;
  RenewalAtRiskList?: Maybe<TableData>;
  RenewalClosedLostCountByMonth?: Maybe<ChartCollection>;
  RenewalClosedLostRateByMonth?: Maybe<ChartCollection>;
  RenewalClosedWonRateByMonth?: Maybe<ChartCollection>;
  RenewalDealOwnerFilterOptions: Array<RenewalDealOwnerOption>;
  RenewalDealsForPeriod?: Maybe<TableData>;
  RenewalOpenCountByMonth?: Maybe<ChartCollection>;
  RenewalOpenRateByMonth?: Maybe<ChartCollection>;
  RenewalOpenValue?: Maybe<ChartCollection>;
  RenewalOutcomeCounts?: Maybe<ChartCollection>;
  RenewalOutcomeRate?: Maybe<ChartCollection>;
  RenewalPredictedLossesOpen?: Maybe<TableData>;
  RenewalPredictedVsActual?: Maybe<ChartCollection>;
  RenewalPredictedWinsOpen?: Maybe<TableData>;
  RenewalRateByOwner?: Maybe<TableData>;
  RenewalSummaryForPeriod?: Maybe<ChartCollection>;
  RenewalTotalCountByMonth?: Maybe<ChartCollection>;
  RenewalUnexpectedLosses?: Maybe<TableData>;
  RenewalUnexpectedWins?: Maybe<TableData>;
  ResponseRate?: Maybe<ChartCollection>;
  Retention?: Maybe<ChartCollection>;
  SearchDiscoveryCatalogueImpressionElasticity?: Maybe<ChartCollection>;
  SearchDiscoveryConcentrationCurve?: Maybe<ChartCollection>;
  SearchDiscoveryExposureVsCatalogueSize?: Maybe<ChartCollection>;
  SearchDiscoveryHighCtrQueries?: Maybe<TableData>;
  SearchDiscoveryImpressionConcentrationIndex?: Maybe<ChartCollection>;
  SearchDiscoveryImpressionConcentrationIndexTrend?: Maybe<ChartCollection>;
  SearchDiscoveryImpressionsPerListingByBucket?: Maybe<ChartCollection>;
  SearchDiscoveryLowCtrQueries?: Maybe<TableData>;
  SearchDiscoveryLowExposureProfessionals?: Maybe<TableData>;
  SearchDiscoveryMedianImpressionShareTrend?: Maybe<ChartCollection>;
  SearchDiscoveryProfessionalClickShareDistribution?: Maybe<ChartCollection>;
  SearchDiscoveryProfessionalImpressionShareDistribution?: Maybe<ChartCollection>;
  SearchDiscoveryReformulationRate?: Maybe<ChartCollection>;
  SearchDiscoveryReformulationRateTrend?: Maybe<ChartCollection>;
  SearchDiscoverySearchCtr?: Maybe<ChartCollection>;
  SearchDiscoverySearchCtrTrend?: Maybe<ChartCollection>;
  SearchDiscoverySearchUsageRate?: Maybe<ChartCollection>;
  SearchDiscoverySearchUsageRateTrend?: Maybe<ChartCollection>;
  SearchDiscoverySmallCatalogueImpressionShare?: Maybe<ChartCollection>;
  SearchDiscoveryTopDecileImpressionShare?: Maybe<ChartCollection>;
  SearchDiscoveryTopDecileImpressionShareTrend?: Maybe<ChartCollection>;
  SearchDiscoveryTopProfessionals?: Maybe<TableData>;
  SearchDiscoveryTopQueries?: Maybe<TableData>;
  SearchDiscoveryTotalSearches?: Maybe<ChartCollection>;
  SearchDiscoveryTotalSearchesTrend?: Maybe<ChartCollection>;
  SearchDiscoveryZeroClicks?: Maybe<ChartCollection>;
  SearchDiscoveryZeroImpressions?: Maybe<ChartCollection>;
  SearchDiscoveryZeroResultQueries?: Maybe<TableData>;
  SearchDiscoveryZeroResultsRate?: Maybe<ChartCollection>;
  SeoProfessionalContentGapOpportunities?: Maybe<TableData>;
  SeoProfessionalContentGeneratedTrend?: Maybe<ChartCollection>;
  SeoProfessionalContentQueueStatus?: Maybe<ChartCollection>;
  SeoProfessionalCoverageByCategory?: Maybe<TableData>;
  SeoProfessionalCoverageByMarket?: Maybe<TableData>;
  SeoProfessionalMeshCoverageKPIs?: Maybe<ChartCollection>;
  TopProfessionalsByVolume?: Maybe<TableData>;
  TrafficByDevice?: Maybe<ChartCollection>;
  TrafficByDeviceTrend?: Maybe<ChartCollection>;
  TrafficByPageType?: Maybe<ChartCollection>;
  TrafficBySource?: Maybe<ChartCollection>;
  TrafficKPIs?: Maybe<ChartCollection>;
  TrafficPagesPerSession?: Maybe<ChartCollection>;
  TrafficPagesPerSessionByDeviceTrend?: Maybe<ChartCollection>;
  TrafficPagesPerSessionBySource?: Maybe<ChartCollection>;
  TrafficPageviews?: Maybe<ChartCollection>;
  TrafficSessions?: Maybe<ChartCollection>;
  TrafficSessionsByDeviceTrend?: Maybe<ChartCollection>;
  TrafficSessionsBySource?: Maybe<ChartCollection>;
  TrafficUniqueDevices?: Maybe<ChartCollection>;
  TrafficUniqueDevicesByDeviceTrend?: Maybe<ChartCollection>;
  TrafficUniqueDevicesBySource?: Maybe<ChartCollection>;
  UserEngagement?: Maybe<ChartCollection>;
};


export type StrategyDashboardAccountCreationsByClassificationArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsByClassificationTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsByMethodArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsByMethodTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsByProfessionalCategoryArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsOnboardingTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsTotalTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsTotalTrendByMethodArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAccountCreationsTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardAcquisitionArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardByCategoryArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardByCohortArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardByCountryArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardByLocationArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardByProfessionalTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardBySourceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardByStageArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardByTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardChurnRateArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardConversionByDeviceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardConversionByPageTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardConversionBySourceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardConversionKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardConversionPageTypeTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardConversionTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailActivityBreakdownArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailByDayOfWeekArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailCampaignKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailDeliveryPipelineArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailDisabledListArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailNoNotificationEmailListArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailNotManufacturerListArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailTodayPipelineArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailVolumeTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDailyConversionEmailYesterdayPipelineArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardDaysToFirstPaymentArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardEnquiriesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardFunnelArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeDailyFormFillsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeDoorScansByTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeEventFilterOptionsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeExhibitorMetricsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeFormFillsByCityArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeFormFillsByTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeProjectAttendanceReasonsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeProjectBudgetsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeProjectBuildTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeProjectProductInterestsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeProjectStagesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeProjectTypesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeProjectValueEstimateArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeRoomFormFillsByTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeRoomProjectAttendanceReasonsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeRoomProjectBuildTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeRoomProjectStagesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeRoomProjectTypesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeRoomProjectValueEstimateArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeSessionsByCityArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeTrafficKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardHdeTrafficSessionsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleByTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleDimensionsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleProcessingTimeDistArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleSourceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleTimeOfDayArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleTopMembersArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleTopProfessionalsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardImageUpscaleTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardInstalmentsByCategoryArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardInvoiceActivityLogArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardInvoiceFunnelArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardInvoiceKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardInvoiceRevenueTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardOverduePaymentsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardPaymentStatusByWeekArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardPaymentsReceivedTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardProfessionalProvenanceActiveTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardProfessionalProvenanceCreatedTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardProfessionalProvenanceKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardProjectProvenanceActiveTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardProjectProvenanceCreatedTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardProjectProvenanceKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardProjectsCreatedArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddByDeviceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddByDeviceTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddByPageTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddBySourceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddByUserCountryArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddDenominatorsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddDistributionArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddEnquiriesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddPageTypeTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddPeriodComparisonArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddReferralsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddTopClientsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddTopEnquirySourcesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddTopReferralSourcesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQddZeroClientsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQuoteConversionByCategoryArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQuoteValueDistributionArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQuotesAcceptedTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardQuotesSentTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalAtRiskByCategoryArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalAtRiskListArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalClosedLostCountByMonthArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalClosedLostRateByMonthArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalClosedWonRateByMonthArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalDealOwnerFilterOptionsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalDealsForPeriodArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalOpenCountByMonthArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalOpenRateByMonthArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalOpenValueArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalOutcomeCountsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalOutcomeRateArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalPredictedLossesOpenArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalPredictedVsActualArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalPredictedWinsOpenArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalRateByOwnerArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalSummaryForPeriodArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalTotalCountByMonthArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalUnexpectedLossesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRenewalUnexpectedWinsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardResponseRateArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardRetentionArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryCatalogueImpressionElasticityArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryConcentrationCurveArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryExposureVsCatalogueSizeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryHighCtrQueriesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryImpressionConcentrationIndexArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryImpressionConcentrationIndexTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryImpressionsPerListingByBucketArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryLowCtrQueriesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryLowExposureProfessionalsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryMedianImpressionShareTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryProfessionalClickShareDistributionArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryProfessionalImpressionShareDistributionArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryReformulationRateArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryReformulationRateTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoverySearchCtrArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoverySearchCtrTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoverySearchUsageRateArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoverySearchUsageRateTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoverySmallCatalogueImpressionShareArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryTopDecileImpressionShareArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryTopDecileImpressionShareTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryTopProfessionalsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryTopQueriesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryTotalSearchesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryTotalSearchesTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryZeroClicksArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryZeroImpressionsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryZeroResultQueriesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSearchDiscoveryZeroResultsRateArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSeoProfessionalContentGapOpportunitiesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSeoProfessionalContentGeneratedTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSeoProfessionalContentQueueStatusArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSeoProfessionalCoverageByCategoryArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSeoProfessionalCoverageByMarketArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardSeoProfessionalMeshCoverageKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTopProfessionalsByVolumeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficByDeviceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficByDeviceTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficByPageTypeArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficBySourceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficKpIsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficPagesPerSessionArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficPagesPerSessionByDeviceTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficPagesPerSessionBySourceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficPageviewsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficSessionsArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficSessionsByDeviceTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficSessionsBySourceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficUniqueDevicesArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficUniqueDevicesByDeviceTrendArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardTrafficUniqueDevicesBySourceArgs = {
  filters?: InputMaybe<StrategyFilters>;
};


export type StrategyDashboardUserEngagementArgs = {
  filters?: InputMaybe<StrategyFilters>;
};

export type StrategyFilters = {
  ClientType?: InputMaybe<Scalars['String']['input']>;
  Country?: InputMaybe<Scalars['String']['input']>;
  CreationMethod?: InputMaybe<Scalars['String']['input']>;
  DealOwner?: InputMaybe<Scalars['String']['input']>;
  Device?: InputMaybe<Scalars['String']['input']>;
  EndDate?: InputMaybe<Scalars['String']['input']>;
  EventIDs?: InputMaybe<Scalars['String']['input']>;
  EventType?: InputMaybe<Scalars['String']['input']>;
  FunnelCohortAxis?: InputMaybe<Scalars['String']['input']>;
  Granularity?: InputMaybe<Scalars['String']['input']>;
  Limit?: InputMaybe<Scalars['String']['input']>;
  Normalisation?: InputMaybe<Scalars['String']['input']>;
  Offset?: InputMaybe<Scalars['String']['input']>;
  PageType?: InputMaybe<Scalars['String']['input']>;
  RenewalGranularity?: InputMaybe<Scalars['String']['input']>;
  RenewalPeriod?: InputMaybe<Scalars['String']['input']>;
  StartDate?: InputMaybe<Scalars['String']['input']>;
};

export enum SubscriptionPackCheckoutMode {
  AttachExisting = 'attach_existing',
  NewAnnual = 'new_annual',
  NewDaily = 'new_daily',
  NewMonthly = 'new_monthly'
}

export type SubscriptionPackInvoiceSummary = {
  __typename?: 'SubscriptionPackInvoiceSummary';
  /** pack_linked — ArchiPro invoice with SubscriptionPackID set; merged_membership — membership instalment InvoicePayment with SubscriptionPackID set for this pack */
  BillingSource: Scalars['String']['output'];
  DueDate?: Maybe<Scalars['String']['output']>;
  /** Status of that payment (e.g. FullyPaid) for receipt availability */
  FirstPaymentStatus?: Maybe<Scalars['String']['output']>;
  /** First invoice payment by SortOrder then ID; used for generate-pdf / receipt APIs */
  FirstPaymentUuid?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  /** Merged membership instalment row id when BillingSource is merged_membership; null for pack-linked add-on invoices */
  InvoicePaymentID?: Maybe<Scalars['Int']['output']>;
  /** FailureReason from the latest failed InvoicePaymentStripeAttempt on that instalment when unpaid; null when paid, no instalment, or no failed attempt */
  LastPaymentStripeAttemptError?: Maybe<Scalars['String']['output']>;
  /** Datetime when auto-bill retry cron may charge this instalment again (InvoicePayment.NextPaymentAttempt); null when paid, no instalment, or no retry scheduled */
  NextPaymentAttempt?: Maybe<Scalars['String']['output']>;
  PaidDate?: Maybe<Scalars['String']['output']>;
  /** InvoicePayment.AttemptCount for the linked instalment (total charge tries, including manual pay and legacy charges before InvoicePaymentStripeAttempt rows); null when paid or no instalment could be resolved. May differ from the number of InvoicePaymentStripeAttempt rows. */
  PaymentStripeAttemptCount?: Maybe<Scalars['Int']['output']>;
  /** Slug for /proposal/{segment} and membership PDF download query params */
  ProposalUrlSegment: Scalars['String']['output'];
  Status: Scalars['String']['output'];
  TotalAmount: Scalars['Float']['output'];
};

export type SubscriptionPackItemSummary = {
  __typename?: 'SubscriptionPackItemSummary';
  AddedDate?: Maybe<Scalars['String']['output']>;
  PriceAmount: Scalars['Float']['output'];
  /** BM installation row id for this SKU (when present); null if no matching PurchasedAddOn installation */
  PurchasedAddOnID?: Maybe<Scalars['Int']['output']>;
  Qty: Scalars['Int']['output'];
  SKU: Scalars['String']['output'];
  Title: Scalars['String']['output'];
};

export type SubscriptionPackSummary = {
  __typename?: 'SubscriptionPackSummary';
  /** True when Business Manager may offer removing a subscription pack; mirrors SubscriptionPackService::isBusinessManagerSubscriptionPackRemovalAllowed */
  BmPackRemovalAllowed: Scalars['Boolean']['output'];
  Currency: Scalars['String']['output'];
  EndDate?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  /** ArchiPro invoices for this pack (due date descending): pack-linked add-on invoices plus one row per membership instalment merged with this pack (InvoicePayment.SubscriptionPackID); merged rows use instalment amount and dates; pack-linked rows aggregate invoice payments */
  Invoices: Array<SubscriptionPackInvoiceSummary>;
  ItemCount: Scalars['Int']['output'];
  /** Catalogue line items snapshotted on this pack (SKU, title, quantity, unit price) */
  Items: Array<SubscriptionPackItemSummary>;
  /** For MSP packs when MembershipSplitAttachEligible is false, a short UI reason. */
  MembershipPackDisabledReason?: Maybe<Scalars['String']['output']>;
  /** For MSP packs, Y-m-d instalment coverage end (first unpaid payment’s EndDate/DueDate) when known. Attach checkout proration uses NextInvoiceDate (next instalment due); this field is the wider coverage boundary. */
  MembershipPackNextDue?: Maybe<Scalars['String']['output']>;
  /** For MSP packs, true when the membership invoice is split and has an unpaid instalment. */
  MembershipSplitAttachEligible: Scalars['Boolean']['output'];
  NextInvoiceDate?: Maybe<Scalars['String']['output']>;
  PackCode: Scalars['String']['output'];
  Period: Scalars['String']['output'];
  /** Present for MSP (membership subscription pack) rows; links to ProfessionalMembership. */
  ProfessionalMembershipID?: Maybe<Scalars['Int']['output']>;
  StartDate?: Maybe<Scalars['String']['output']>;
  Status: Scalars['String']['output'];
  StripeDraftInvoiceID?: Maybe<Scalars['String']['output']>;
  /** Stripe PaymentMethod id used for pack checkout and scheduled charges when set */
  StripePaymentMethodID?: Maybe<Scalars['String']['output']>;
};

export type SupplierOrder = {
  __typename?: 'SupplierOrder';
  Actions: Array<SupplierOrderAction>;
  BillingAddress?: Maybe<Address>;
  Comment: Scalars['String']['output'];
  Consignments: ConsignmentsConnection;
  Created: Scalars['String']['output'];
  DeclinedReturnCount: Scalars['Int']['output'];
  DeliveryAddress?: Maybe<Address>;
  Dispatches: Array<Dispatch>;
  Events: Array<OrderEvent>;
  ExternalOrderReference?: Maybe<Scalars['String']['output']>;
  HasClickAndCollect: Scalars['Boolean']['output'];
  HasDelivery: Scalars['Boolean']['output'];
  HasRefunds: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  IsNew: Scalars['Boolean']['output'];
  ItemTotal: CurrencyAmount;
  ItemsCount: Scalars['Int']['output'];
  ItemsProcessed: Scalars['Int']['output'];
  NotifyCustomer: Scalars['Boolean']['output'];
  Order: Order;
  OrderCompleted: Scalars['String']['output'];
  OrderGrossTotal: CurrencyAmount;
  OrderItems: Array<OrderItem>;
  OrderNumber: Scalars['String']['output'];
  OrderTotal: CurrencyAmount;
  PaymentExpired: Scalars['Boolean']['output'];
  PendingReturnCount: Scalars['Int']['output'];
  PickupEstimate?: Maybe<Scalars['String']['output']>;
  PickupLocation?: Maybe<LibraryLocation>;
  PickupLocationLabel: Scalars['String']['output'];
  RefundableShipping: CurrencyAmount;
  ShippingCost: CurrencyAmount;
  ShippingRefunded: CurrencyAmount;
  Status: OrderStatusEnum;
  StatusText: Scalars['String']['output'];
  Supplier: Professional;
  TaxRate: Scalars['Float']['output'];
  TaxSystem: Scalars['String']['output'];
  TaxTotal: CurrencyAmount;
  TotalRefunded: CurrencyAmount;
};


export type SupplierOrderConsignmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierOrderAction = {
  __typename?: 'SupplierOrderAction';
  Action: SupplierOrderActionEnum;
  ByMember?: Maybe<Member>;
  Created: Scalars['String']['output'];
  Events: Array<OrderEvent>;
  ID: Scalars['Int']['output'];
  Message: Scalars['String']['output'];
  Reason: Scalars['String']['output'];
  SupplierOrder: SupplierOrder;
};

export enum SupplierOrderActionEnum {
  Cancel = 'CANCEL',
  Confirm = 'CONFIRM',
  Edit = 'EDIT'
}

export type SupplierOrdersConnection = {
  __typename?: 'SupplierOrdersConnection';
  ID: Scalars['String']['output'];
  edges: Array<SupplierOrdersConnectionEdge>;
  nodes: Array<SupplierOrder>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type SupplierOrdersConnectionEdge = {
  __typename?: 'SupplierOrdersConnectionEdge';
  /** The node at the end of the collections edge */
  node: SupplierOrder;
};

export type SupplierOrdersSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  OrderNumber?: InputMaybe<SortDirection>;
};

export enum SupportedCountry {
  Au = 'AU',
  Nz = 'NZ',
  Us = 'US'
}

export type SyncEnquiryOAuthEmailType = {
  __typename?: 'SyncEnquiryOAuthEmailType';
  /** Whether the sync operation completed successfully */
  success: Scalars['Boolean']['output'];
  /** IDs of the OAuth accounts that were successfully synced */
  syncedOAuthIDs?: Maybe<Array<Scalars['Int']['output']>>;
  /** Number of email replies that were synced */
  syncedReplyCount: Scalars['Int']['output'];
  /** Total duration of the sync operation in seconds */
  totalSyncDuration: Scalars['Float']['output'];
};

export type SyncStatus = {
  /** @deprecated No longer provided */
  BulkImportID?: Maybe<Scalars['String']['output']>;
  Errors: Array<ImportError>;
  Finished: Scalars['Boolean']['output'];
  RequestID: Scalars['String']['output'];
  StartedTimestamp?: Maybe<Scalars['Int']['output']>;
  SuccessfullySyncedCount: Scalars['Int']['output'];
  TotalProcessed: Scalars['Int']['output'];
  TotalToSync?: Maybe<Scalars['Int']['output']>;
};

export type SynonymsConnection = {
  __typename?: 'SynonymsConnection';
  edges: Array<SynonymsConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type SynonymsConnectionEdge = {
  __typename?: 'SynonymsConnectionEdge';
  /** The node at the end of the collections edge */
  node: ProductColorSynonym;
};

/** Message representing changes to a conversation (e.g. The settings were updated). */
export type SystemMessage = Message & {
  __typename?: 'SystemMessage';
  ConversationID: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  CreatedBy: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
  /** The type of system message. */
  Type: SystemMessageType;
  /** The value of the system message. Only exists for certain types. */
  Value?: Maybe<Scalars['String']['output']>;
  /** The BuildHub project linked to the system message. Only exists for the `BuildHubChanged` type. */
  ValueBuildHub?: Maybe<BuildHub>;
  /** The conversation linked to the system message. Only exists for the `MessagesMovedOut` and `MessagesMovedIn` types. */
  ValueConversation?: Maybe<DirectConversation>;
  /** The value ID of the system message. Only exists for certain types. */
  ValueID: Scalars['Int']['output'];
  /** The participant linked to the system message. Only exists for the `ParticipantAdded` and `ParticipantRemoved` types. */
  ValueParticipant?: Maybe<DirectParticipant>;
};

/** The type of system message. */
export enum SystemMessageType {
  /** The linked BuildHub project was changed. */
  BuildHubChanged = 'BuildHubChanged',
  /** The BuildHub shared group chat was lazily created. */
  BuildHubGroupChatCreated = 'BuildHubGroupChatCreated',
  /** The BuildHub pro-team side-channel chat was lazily created. */
  BuildHubProTeamChatCreated = 'BuildHubProTeamChatCreated',
  /** Messages were moved into this conversation from another. */
  MessagesMovedIn = 'MessagesMovedIn',
  /** Messages were moved from this conversation to another. */
  MessagesMovedOut = 'MessagesMovedOut',
  /** The conversation title was updated. */
  NameChanged = 'NameChanged',
  /** A participant was added to the conversation. */
  ParticipantAdded = 'ParticipantAdded',
  /** A participant was removed from the conversation. */
  ParticipantRemoved = 'ParticipantRemoved',
  /** The conversation thumbnail was changed. */
  ThumbnailChanged = 'ThumbnailChanged',
  /** Placeholder when the database Type is empty or not recognised by this deployment (e.g. shared dev DB with newer SystemMessage types). */
  Unknown = 'Unknown'
}

export type TableData = {
  __typename?: 'TableData';
  ID: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  Values: Array<RowData>;
};

export type TagTarget = {
  ID: Scalars['Int']['output'];
};

export type TaggedProductsByRecordFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PARENT_ID__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type TaggedRecordsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

export type TaggedRecordsSort = {
  CLICK_THROUGH_RATE?: InputMaybe<PrioritySort>;
  CONVERSIONS?: InputMaybe<PrioritySort>;
  CONVERSION_RATE?: InputMaybe<PrioritySort>;
  IMPRESSIONS?: InputMaybe<PrioritySort>;
  OWNER?: InputMaybe<PrioritySort>;
  PAGE_NAME?: InputMaybe<PrioritySort>;
  PRODUCT_TAGS?: InputMaybe<PrioritySort>;
  PRODUCT_VIEWS?: InputMaybe<PrioritySort>;
  SESSIONS?: InputMaybe<PrioritySort>;
  TOTAL_TIME_ON_PAGES?: InputMaybe<PrioritySort>;
  USERS?: InputMaybe<PrioritySort>;
};

export type TeamMember = PermissionInterface & SortableItem & {
  __typename?: 'TeamMember';
  Approved: Scalars['Int']['output'];
  /** Notification category when this team member is a billing recipient; null if not a billing recipient. */
  BillingRecipientTag?: Maybe<BillingRecipientTag>;
  /** Booking URL for this team member's first active CalendarSession, or empty string if none. */
  BookingUrl: Scalars['String']['output'];
  CalendarConnection?: Maybe<Array<CalendarConnectionSummary>>;
  Email: Scalars['String']['output'];
  HasInboxAccess: Scalars['Int']['output'];
  HideEmail: Scalars['Boolean']['output'];
  HideJobTitle: Scalars['Boolean']['output'];
  HideLinkedInLink: Scalars['Boolean']['output'];
  HidePhone: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  /** Headshot horizontal framing percentage (50 = centred). */
  ImageScrollPosX: Scalars['Int']['output'];
  /** Headshot vertical framing percentage (50 = centred). */
  ImageScrollPosY: Scalars['Int']['output'];
  /** Headshot zoom percentage (100 = no zoom). */
  ImageZoomFactor: Scalars['Int']['output'];
  IsOwner: Scalars['Int']['output'];
  IsPublic: Scalars['Boolean']['output'];
  JobTitle?: Maybe<Scalars['String']['output']>;
  LicenseNumber?: Maybe<Scalars['String']['output']>;
  LinkedInLink?: Maybe<Scalars['String']['output']>;
  MeetingImage?: Maybe<MemberImage>;
  /** Linked login account when this team member has completed sign-up; null for pending invites. */
  Member?: Maybe<Member>;
  MemberID: Scalars['Int']['output'];
  MemberImage?: Maybe<MemberImage>;
  MemberOAuths?: Maybe<Array<MemberOAuth>>;
  MemberSortOrder: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
  Permissions: Array<PermissionEnum>;
  Phone?: Maybe<Scalars['String']['output']>;
  Professional: Professional;
  SortOrder: Scalars['Int']['output'];
  Summary?: Maybe<Scalars['String']['output']>;
  /** The first role (team) this team member belongs to, or null if unassigned */
  TeamMemberRole?: Maybe<TeamMemberRole>;
  /** All roles (teams) this team member belongs to */
  TeamMemberRoles: Array<TeamMemberRole>;
  /** Team permissions using the new team permission system (BusinessManagerPolicy). Use this field for new code instead of Permissions (legacy). */
  TeamPermissions: Array<BusinessManagementActions>;
};

export type TeamMemberInput = {
  Email?: InputMaybe<Scalars['StringInput']['input']>;
  HideEmail?: InputMaybe<Scalars['Boolean']['input']>;
  HideJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  HideLinkedInLink?: InputMaybe<Scalars['Boolean']['input']>;
  HidePhone?: InputMaybe<Scalars['Boolean']['input']>;
  ID?: InputMaybe<Scalars['Int']['input']>;
  Image?: InputMaybe<Scalars['Upload']['input']>;
  IsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  JobTitle?: InputMaybe<Scalars['StringInput']['input']>;
  LicenseNumber?: InputMaybe<Scalars['StringInput']['input']>;
  LinkedInLink?: InputMaybe<Scalars['StringInput']['input']>;
  Message?: InputMaybe<Scalars['StringInput']['input']>;
  Name?: InputMaybe<Scalars['StringInput']['input']>;
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  Summary?: InputMaybe<Scalars['StringInput']['input']>;
};

export type TeamMemberNotification = WebsiteNotificationInterface & {
  __typename?: 'TeamMemberNotification';
  Action: WebsiteNotificationAction;
  CreatedAt: Scalars['String']['output'];
  CreatedBy: Member;
  ID: Scalars['ID']['output'];
  IsRead: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  PhotoTileURL?: Maybe<Scalars['String']['output']>;
  Professional: Professional;
  TeamMember: TeamMember;
};

export type TeamMemberRole = {
  __typename?: 'TeamMemberRole';
  /** Whether the current user has BM_ADMIN_DELETE / Full Access (BAU delete — can delete any non-owner role regardless of member count) */
  CanDeleteWithPermission: Scalars['Boolean']['output'];
  Created: Scalars['String']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  /** Whether the current user is a high admin / AP staff (staff override — can delete empty non-owner roles) */
  HasStaffDeleteOverride: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  /** Whether this is the special \"Admins\" role that cannot be edited or deleted */
  IsOwnerRole: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  PermissionGroupFeatures: Array<PermissionGroupFeature>;
  Professional: Professional;
  /** Sort order for drag-and-drop reordering (from SortableObjectExtension) */
  SortOrder: Scalars['Int']['output'];
  /** Team members assigned to this role */
  TeamMembers: Array<TeamMember>;
};

export type TeamMembersConnection = {
  __typename?: 'TeamMembersConnection';
  edges: Array<TeamMembersConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type TeamMembersConnectionEdge = {
  __typename?: 'TeamMembersConnectionEdge';
  /** The node at the end of the collections edge */
  node: TeamMember;
};

export type TeamMembersFilters = {
  /** Filter team members that are approved */
  Approved__in?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter team members that are publicy visible */
  Ispublic__in?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter team members partial matched by Name */
  Name__partial_match?: InputMaybe<Scalars['String']['input']>;
};

export type TeamMembersSortFields = {
  MemberSortOrder?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
};

export type TemplateToken = {
  __typename?: 'TemplateToken';
  class: Scalars['String']['output'];
  resolveAt: TokenResolveAt;
  root: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type TemplateTokenBinding = {
  __typename?: 'TemplateTokenBinding';
  class: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type Testimonial = SortableItem & {
  __typename?: 'Testimonial';
  Content: Scalars['String']['output'];
  ID: Scalars['Int']['output'];
  Location: Scalars['String']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  Rating: Scalars['Int']['output'];
  SortOrder: Scalars['Int']['output'];
  Source?: Maybe<Scalars['String']['output']>;
};

export type TestimonialModule = ModuleType & {
  __typename?: 'TestimonialModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  /** List of testimonials */
  Testimonials: Testimonials_Connection;
  ThemeColour: ThemedElementColourType;
};


export type TestimonialModuleTestimonialsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Testimonials_SortFields>;
};

export type TestimonialsList = {
  Content?: InputMaybe<Scalars['StringInput']['input']>;
  ID: Scalars['Int']['input'];
  Location?: InputMaybe<Scalars['StringInput']['input']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']['input']>;
  Rating?: InputMaybe<Scalars['Int']['input']>;
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Source?: InputMaybe<Scalars['StringInput']['input']>;
};

export type Testimonials_Connection = {
  __typename?: 'Testimonials_Connection';
  edges: Array<Testimonials_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Testimonials_ConnectionEdge = {
  __typename?: 'Testimonials_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventTestimonial;
};

export type Testimonials_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type TextCarouselItem = {
  __typename?: 'TextCarouselItem';
  CTA?: Maybe<SiteTreeLink>;
  Content?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  Links: TextCarouselItem_LinksConnection;
  LinksTitle?: Maybe<Scalars['String']['output']>;
  Subtitle?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};


export type TextCarouselItemLinksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TextCarouselItem_LinksSortFields>;
};

export type TextCarouselItem_LinksConnection = {
  __typename?: 'TextCarouselItem_LinksConnection';
  edges: Array<TextCarouselItem_LinksConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type TextCarouselItem_LinksConnectionEdge = {
  __typename?: 'TextCarouselItem_LinksConnectionEdge';
  /** The node at the end of the collections edge */
  node: ExternalLink;
};

export type TextCarouselItem_LinksSortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type TextColumn = ModuleColumn & SortableItem & {
  __typename?: 'TextColumn';
  Content?: Maybe<Scalars['String']['output']>;
  ID: Scalars['Int']['output'];
  IsEmpty: Scalars['Boolean']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleID: Scalars['Int']['output'];
  ProductID?: Maybe<Scalars['Int']['output']>;
  ReadOnly: Scalars['Boolean']['output'];
  TextType: TextTypeEnum;
  WordCount: Scalars['Int']['output'];
};

/** A generic message with text content. */
export type TextMessage = Message & {
  __typename?: 'TextMessage';
  Content: Scalars['String']['output'];
  ConversationID: Scalars['Int']['output'];
  Created: Scalars['String']['output'];
  CreatedBy: Scalars['String']['output'];
  ID: Scalars['ID']['output'];
  IsHTML: Scalars['Boolean']['output'];
  MemberEnquiryEmail?: Maybe<MemberEnquiryEmail>;
  Participant: Participant;
  /** Emoji reactions on this message. */
  Reactions: Array<MessageReaction>;
  /** The message this message is replying to, if any. */
  ReplyTo?: Maybe<ReplyToMessageUnion>;
};

export enum TextTypeEnum {
  H3 = 'h3',
  Paragraph = 'paragraph',
  Quote = 'quote'
}

export enum ThemedElementColourType {
  Dark = 'dark',
  Grey = 'grey',
  Light = 'light',
  Sage = 'sage',
  Transparent = 'transparent'
}

export type Thumbnails_Connection = {
  __typename?: 'Thumbnails_Connection';
  edges: Array<Thumbnails_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type Thumbnails_ConnectionEdge = {
  __typename?: 'Thumbnails_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryImageFile;
};

export type Thumbnails_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type TimeSpent = {
  __typename?: 'TimeSpent';
  Glanced: Scalars['Int']['output'];
  ID: Scalars['String']['output'];
  Read: Scalars['Int']['output'];
  Skimmed: Scalars['Int']['output'];
};

export type TimezoneFreeDaysType = {
  __typename?: 'TimezoneFreeDaysType';
  days: Array<FreeDayType>;
  timezone: Scalars['String']['output'];
};

export type TitleWithUrlSegment = {
  __typename?: 'TitleWithURLSegment';
  ID: Scalars['Int']['output'];
  Title: Scalars['String']['output'];
  URLSegment: Scalars['String']['output'];
};

export enum TokenResolveAt {
  Authoring = 'Authoring',
  Sending = 'Sending'
}

export enum TokenTemplateType {
  BusinessTerms = 'BusinessTerms',
  Email = 'Email',
  Invoice = 'Invoice'
}

/** A tokenised field is an editable field that contains tokens which renders out with different content than the input */
export type TokenisedField = {
  __typename?: 'TokenisedField';
  Raw: Scalars['String']['output'];
  Render: Scalars['String']['output'];
};

export type TopClickedTagsFilters = {
  EVENT_DATE_HOST__BETWEEN?: InputMaybe<Array<Scalars['String']['input']>>;
  INLIBRARY__EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PARENT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PARENT_TAG__EQUAL?: InputMaybe<Scalars['String']['input']>;
  PRODUCT_NAME__EQUAL?: InputMaybe<Scalars['String']['input']>;
};

/** Return most recently created items */
export type TopLibraryItems = {
  __typename?: 'TopLibraryItems';
  Articles?: Maybe<Array<DirectoryItem>>;
  Products?: Maybe<Array<DirectoryItem>>;
  Professionals?: Maybe<Array<DirectoryItem>>;
  Projects?: Maybe<Array<DirectoryItem>>;
};

export type TopPerformer = {
  __typename?: 'TopPerformer';
  Count: Scalars['Int']['output'];
  DirectoryItem: DirectoryItem;
  ID: Scalars['String']['output'];
};

export type TrendingCategories_Connection = {
  __typename?: 'TrendingCategories_Connection';
  ID: Scalars['String']['output'];
  edges: Array<TrendingCategories_ConnectionEdge>;
  nodes: Array<Category>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type TrendingCategories_ConnectionEdge = {
  __typename?: 'TrendingCategories_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: Category;
};

export type TrioImageModule = FlexibleModule & {
  __typename?: 'TrioImageModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type TrioImageModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type UnionModulePage = GuestHomePage | ModulePage;

export type UnlinkAwardFromEntityMutationType = Award | NotAuthorizedError | NotFoundError;

export type UpdateCalendarSessionInput = {
  availability?: InputMaybe<Array<CalendarSessionAvailabilityInput>>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  customizedReminder?: InputMaybe<Scalars['String']['input']>;
  durations?: InputMaybe<Array<CalendarSessionDurationInput>>;
  emailReminders?: InputMaybe<Array<CalendarSessionEmailReminderInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationString?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  meetingCover?: InputMaybe<Scalars['String']['input']>;
  meetingType?: InputMaybe<Scalars['String']['input']>;
  oneOnOneTeamMemberId?: InputMaybe<Scalars['Int']['input']>;
  sessionName?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  unavailableDateRanges?: InputMaybe<Array<CalendarSessionUnavailableDateRangeInput>>;
};

/** The result of update conversation mutations. */
export type UpdateConversationPayload = {
  __typename?: 'UpdateConversationPayload';
  /** The updated conversation. */
  Conversation: DirectConversation;
  /** The system messages created as a result of the update. */
  SystemMessages: Array<SystemMessage>;
};

export type UpdateEnquiryParticipantStatusResult = {
  __typename?: 'UpdateEnquiryParticipantStatusResult';
  Conversation: EnquiryConversation;
  Participant?: Maybe<EnquiryParticipant>;
};

export type UpdateLibraryImageInput = {
  /** Full screen width (no padding) */
  FullScreen?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the LibrayImage you are updating */
  ID: Scalars['Int']['input'];
  /** Show overlay on banner image */
  Overlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Professional ID for photo credit */
  PhotoCreditID?: InputMaybe<Scalars['Int']['input']>;
  /** custom string photo credit not associated with Professional */
  PhotoCreditName?: InputMaybe<Scalars['StringInput']['input']>;
  /** Regenerate the image with watermark reflective of photo credit */
  Regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMeInput = {
  AgeGroup?: InputMaybe<Scalars['StringInput']['input']>;
  AssociationNumber?: InputMaybe<Scalars['StringInput']['input']>;
  Budget?: InputMaybe<Scalars['StringInput']['input']>;
  BuildStatus?: InputMaybe<Scalars['StringInput']['input']>;
  Company?: InputMaybe<Scalars['StringInput']['input']>;
  Email?: InputMaybe<Scalars['Email']['input']>;
  FirstName?: InputMaybe<Scalars['StringInput']['input']>;
  HomeownerBudgetID?: InputMaybe<Scalars['Int']['input']>;
  HomeownerPurposeID?: InputMaybe<Scalars['Int']['input']>;
  HomeownerStageID?: InputMaybe<Scalars['Int']['input']>;
  Industry?: InputMaybe<Scalars['Int']['input']>;
  JobTitle?: InputMaybe<Scalars['StringInput']['input']>;
  OnboardingDismissed?: InputMaybe<Scalars['StringInput']['input']>;
  Phone?: InputMaybe<Scalars['StringInput']['input']>;
  PostSignupQuestionnaireSeen?: InputMaybe<Scalars['Boolean']['input']>;
  ProfessionalCategoryID?: InputMaybe<Scalars['Int']['input']>;
  ProfessionalIndustry?: InputMaybe<Scalars['StringInput']['input']>;
  ProfessionalListingInterest?: InputMaybe<Scalars['Boolean']['input']>;
  ProfessionalTargetMarket?: InputMaybe<ProfessionalTargetMarketType>;
  ProfilePicture?: InputMaybe<Scalars['Upload']['input']>;
  Region?: InputMaybe<Scalars['StringInput']['input']>;
  Section?: InputMaybe<Scalars['Boolean']['input']>;
  SignupComments?: InputMaybe<Scalars['StringInput']['input']>;
  Style?: InputMaybe<Scalars['StringInput']['input']>;
  Suburb?: InputMaybe<Scalars['StringInput']['input']>;
  Surname?: InputMaybe<Scalars['StringInput']['input']>;
  UserClassification?: InputMaybe<UserClassificationType>;
  Website?: InputMaybe<Scalars['StringInput']['input']>;
  When?: InputMaybe<Scalars['StringInput']['input']>;
  Where?: InputMaybe<Scalars['StringInput']['input']>;
};

export type UpdateMessageReactionResponse = DeletedMessage | FileAttachmentMessage | NotAuthorizedError | NotFoundError | ServerError | TextMessage | UserError;

export type UpdateMetaInput = {
  MetaDescription?: InputMaybe<Scalars['StringInput']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
};

export type UpdateOrganizationNetworkParticipantData = {
  /** ID of the participant that is being updated */
  participantId: Scalars['ID']['input'];
  updates: OrganizationNetworkParticipantUpdateData;
};

export type UpdatePasswordInput = {
  Current: Scalars['String']['input'];
  New: Scalars['String']['input'];
};

export type UpdateProductPricingInput = {
  ID: Scalars['Int']['input'];
  Maximum?: InputMaybe<Scalars['Int']['input']>;
  Minimum?: InputMaybe<Scalars['Int']['input']>;
  PricingType?: InputMaybe<ProductPricingTypeEnum>;
  Retail?: InputMaybe<Scalars['Int']['input']>;
  Sale?: InputMaybe<Scalars['Int']['input']>;
  Sample?: InputMaybe<Scalars['Int']['input']>;
  SampleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  SampleShippingID?: InputMaybe<Scalars['Int']['input']>;
  Trade?: InputMaybe<Scalars['Int']['input']>;
  Unit?: InputMaybe<PriceUnitEnum>;
};

export type UpdateProfessionalAwardInput = {
  AwardingInstitutionTitle?: InputMaybe<Scalars['StringInput']['input']>;
  File?: InputMaybe<Scalars['Upload']['input']>;
  MemberSortOrder?: InputMaybe<Scalars['Int']['input']>;
  Title?: InputMaybe<Scalars['StringInput']['input']>;
  YearAwarded?: InputMaybe<Scalars['StringInput']['input']>;
};

export enum UploadErrorCodeEnum {
  CorruptedFile = 'CorruptedFile',
  EmptyFile = 'EmptyFile',
  FileTypeMismatch = 'FileTypeMismatch',
  InvalidLandscapeImageDimension = 'InvalidLandscapeImageDimension',
  InvalidPortraitImageDimension = 'InvalidPortraitImageDimension',
  ModuleExceedLimit = 'ModuleExceedLimit',
  NoPermission = 'NoPermission',
  UnknownError = 'UnknownError',
  UnsupportedFileType = 'UnsupportedFileType'
}

export type UpscaleConfig = {
  __typename?: 'UpscaleConfig';
  /** Number of seconds to wait before automatically closing the comparison curtain. Set to 0 to disable auto-close. */
  AutoCloseComparisonSec: Scalars['Int']['output'];
  /** Number of seconds to wait before automatically submitting upscale request. Set to 0 to disable auto-submit. */
  AutoSubmitWaitSec: Scalars['Int']['output'];
  /** Maximum file size for processed images (in MB) */
  ExpectMaxSizeMB: Scalars['Float']['output'];
  /** Extra parameters for the AI service */
  ExtraParameters?: Maybe<Scalars['String']['output']>;
  /** Maximum file size for processed images (in MB) */
  MaxSizeMB: Scalars['Float']['output'];
  /** Maximum output width for processed images (in pixels) */
  MaxWidth: Scalars['Int']['output'];
  /** Minimum width ratio of expected width */
  MinUploadWidthRatio: Scalars['Float']['output'];
  /** Minimum allowed image width (in pixels). Images smaller than this cannot be processed. */
  MinWidth: Scalars['Int']['output'];
  /** Old library image ID */
  OldLibraryImageID?: Maybe<Scalars['Int']['output']>;
  /** Original filename */
  OriginalFilename?: Maybe<Scalars['String']['output']>;
  /** Original MIME type */
  OriginalMimeType?: Maybe<Scalars['String']['output']>;
  /** Whether to process a new file */
  ProcessNewFile: Scalars['Boolean']['output'];
  /** Professional ID associated with the image */
  ProfessionalID?: Maybe<Scalars['Int']['output']>;
  /** AI service to use for upscaling images (TopazLabs, StabilityAI, Photoroom, ImageKit) */
  ServiceName: Scalars['String']['output'];
  /** Expected width in pixels (used as default for shouldUpscaleWidth) */
  ShouldUpscaleWidth: Scalars['Int']['output'];
  /** Temporary file prefix */
  TempPrefix: Scalars['String']['output'];
  /** Timeout in seconds for AI processing */
  TimeoutInSeconds: Scalars['Int']['output'];
  /** Upscale mode (service-specific) */
  UpscaleMode?: Maybe<Scalars['String']['output']>;
  /** Default upscale ratio (e.g., 1.2 for 120% of expected width) */
  UpscaleRatio: Scalars['Float']['output'];
  /** Target width to upscale to */
  UpscaleToWidth: Scalars['Int']['output'];
};

export type UpscaleImageColumnResult = {
  __typename?: 'UpscaleImageColumnResult';
  error?: Maybe<Scalars['String']['output']>;
  needsProcessing?: Maybe<Scalars['Boolean']['output']>;
  newLibraryImageID?: Maybe<Scalars['Int']['output']>;
  oldLibraryImageID?: Maybe<Scalars['Int']['output']>;
  originalHeight?: Maybe<Scalars['Int']['output']>;
  originalSizeMB?: Maybe<Scalars['Float']['output']>;
  originalWidth?: Maybe<Scalars['Int']['output']>;
  processedHeight?: Maybe<Scalars['Int']['output']>;
  processedSizeMB?: Maybe<Scalars['Float']['output']>;
  processedWidth?: Maybe<Scalars['Int']['output']>;
  processingReason?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  processingTime?: Maybe<Scalars['Float']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
  sizeIncreasePercentage?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
  upscalePercentage?: Maybe<Scalars['Float']['output']>;
  upscaleRecordID?: Maybe<Scalars['Int']['output']>;
};

export type UpscaleOriginalImageResult = {
  __typename?: 'UpscaleOriginalImageResult';
  /** Height in pixels of the original (pre-upscale) image file */
  originalHeight: Scalars['Int']['output'];
  /** URL of the original (pre-upscale) image with the same crop/zoom/filter as the current image */
  originalImageUrl: Scalars['String']['output'];
  /** LibraryImage ID of the original (pre-upscale) image */
  originalLibraryImageId: Scalars['Int']['output'];
  /** Width in pixels of the original (pre-upscale) image file */
  originalWidth: Scalars['Int']['output'];
  /** LibraryImage ID of the current (upscaled) image */
  upscaledLibraryImageId: Scalars['Int']['output'];
};

export type User = {
  APID: Scalars['String']['output'];
  DesignBoard: DesignBoardResult;
  DesignBoardsPins: DesignBoardPinsConnection;
  EcommerceBookingURL: Scalars['String']['output'];
  Enrichment?: Maybe<Scalars['String']['output']>;
  FeatureFlags?: Maybe<Array<FeatureFlag>>;
  ID: Scalars['Int']['output'];
  ShoppingCart?: Maybe<ShoppingCart>;
};


export type UserDesignBoardArgs = {
  Link: Scalars['String']['input'];
};


export type UserDesignBoardsPinsArgs = {
  filter?: InputMaybe<DesignBoardsPinsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DesignBoardsPinsSimpleSortFields>;
};

/** The ID and active/online status of a user. */
export type UserActiveStatus = {
  __typename?: 'UserActiveStatus';
  MemberID: Scalars['Int']['output'];
  Status?: Maybe<UserActiveStatusEnum>;
};

/** The user's active/online status. */
export enum UserActiveStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum UserClassificationType {
  Homeowner = 'Homeowner',
  Professional = 'Professional'
}

export type UserError = ErrorInterface & {
  __typename?: 'UserError';
  Message: Scalars['String']['output'];
};

export type UserFollowedMoodBoardsSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

/** Filter options for user mood boards. */
export enum UserMoodBoardsFilterEnum {
  CollaboratedProject = 'CollaboratedProject',
  DocumentCollaborated = 'DocumentCollaborated',
  Followed = 'Followed',
  OwnedProject = 'OwnedProject',
  Personal = 'Personal'
}

/** Lightweight metadata flags for current user's mood board filters. */
export type UserMoodBoardsMeta = {
  __typename?: 'UserMoodBoardsMeta';
  hasCollaboratedBoards: Scalars['Boolean']['output'];
  hasFollowedBoards: Scalars['Boolean']['output'];
};

export type UserMoodBoardsSimpleSortFields = {
  Created?: InputMaybe<SortDirection>;
  LastActivity?: InputMaybe<SortDirection>;
  LastEdited?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
};

/** registered device info on the current user, Expo token is omitted intentionally to avoid leaking. */
export type UserPushDevice = {
  __typename?: 'UserPushDevice';
  AppVersion?: Maybe<Scalars['String']['output']>;
  DeviceID: Scalars['String']['output'];
  Enabled: Scalars['Boolean']['output'];
};

export type UserPushDevicesResponse = MyPushDevices | NotAuthorizedError | NotFoundError | ServerError | UserError;

export type UsersSummary = {
  __typename?: 'UsersSummary';
  AvgDailyUsers: Scalars['Int']['output'];
  AvgSessionDuration: Scalars['String']['output'];
  ID: Scalars['String']['output'];
  NewUsers: Scalars['Int']['output'];
  Sessions: Scalars['Int']['output'];
  TotalUsers: Scalars['Int']['output'];
};

export type Variant = {
  __typename?: 'Variant';
  AllowsBackOrder: Scalars['Boolean']['output'];
  AvailableSampleStock: Scalars['Int']['output'];
  AvailableStock: Scalars['Int']['output'];
  Barcode: Scalars['String']['output'];
  CanPurchase: Scalars['Boolean']['output'];
  CoverageArea: Scalars['Int']['output'];
  HasUnlimitedSample: Scalars['Boolean']['output'];
  HasUnlimitedStock: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  Image?: Maybe<LibraryImage>;
  IsHidden: Scalars['Boolean']['output'];
  IsOnSale: Scalars['Boolean']['output'];
  IsPublished?: Maybe<Scalars['Boolean']['output']>;
  IsTradeOnly: Scalars['Boolean']['output'];
  LeadTime: Scalars['Int']['output'];
  LeadTimeUnit?: Maybe<LeadTimeUnitEnum>;
  MaxPrice: CurrencyAmount;
  MemberPrice?: Maybe<CurrencyAmount>;
  /** Deprecated. */
  Name?: Maybe<Scalars['String']['output']>;
  Options: Array<AttributeOption>;
  Price: CurrencyAmount;
  PriceType: Scalars['String']['output'];
  PriceUnit?: Maybe<PriceUnitEnum>;
  Product: Product;
  ProjectedSamplePrice: CurrencyAmount;
  QuantityPerUnit: Scalars['Int']['output'];
  RetailPrice: CurrencyAmount;
  SKU?: Maybe<Scalars['String']['output']>;
  SaleFinish?: Maybe<Scalars['String']['output']>;
  SalePrice: CurrencyAmount;
  SaleStart?: Maybe<Scalars['String']['output']>;
  SampleEnabled: Scalars['Boolean']['output'];
  SamplePrice: CurrencyAmount;
  SampleShippingProfile?: Maybe<ShippingProfile>;
  ShippingProfile?: Maybe<ShippingProfile>;
  Size?: Maybe<ProductSize>;
  SortOrder?: Maybe<Scalars['Int']['output']>;
  SpecialtyPricingApplied?: Maybe<AppliedSpecialtyDiscountEnum>;
  StockLevels: Array<VariantStock>;
  StockType?: Maybe<VariantStockTypeEnum>;
  SupplierSKU?: Maybe<Scalars['String']['output']>;
  SupplierVariantID?: Maybe<Scalars['String']['output']>;
  Thumbnail?: Maybe<ResponsiveImage>;
  TradeOnlyEnabled: Scalars['Boolean']['output'];
  TradePrice?: Maybe<CurrencyAmount>;
  TradeSamplePrice?: Maybe<CurrencyAmount>;
};


export type VariantAvailableSampleStockArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariantAvailableStockArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariantPriceArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariantPriceTypeArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariantSampleShippingProfileArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariantShippingProfileArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariantSpecialtyPricingAppliedArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariantStockLevelsArgs = {
  ValidOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type VariantTradePriceArgs = {
  Raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VariantInput = {
  AllowsBackOrder?: InputMaybe<Scalars['Boolean']['input']>;
  Barcode?: InputMaybe<Scalars['StringInput']['input']>;
  CoverageArea?: InputMaybe<Scalars['Int']['input']>;
  ID: Scalars['Int']['input'];
  IsHidden?: InputMaybe<Scalars['Boolean']['input']>;
  IsOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  LeadTime?: InputMaybe<Scalars['Int']['input']>;
  LeadTimeUnit?: InputMaybe<LeadTimeUnitEnum>;
  LowStockThreshold?: InputMaybe<Scalars['Int']['input']>;
  MaxPrice?: InputMaybe<Scalars['Int']['input']>;
  Name?: InputMaybe<Scalars['StringInput']['input']>;
  Price?: InputMaybe<Scalars['Int']['input']>;
  PriceUnit?: InputMaybe<PriceUnitEnum>;
  QuantityPerUnit?: InputMaybe<Scalars['Int']['input']>;
  SKU?: InputMaybe<Scalars['StringInput']['input']>;
  SaleFinish?: InputMaybe<Scalars['StringInput']['input']>;
  SalePrice?: InputMaybe<Scalars['Int']['input']>;
  SaleStart?: InputMaybe<Scalars['StringInput']['input']>;
  SampleEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  SamplePrice?: InputMaybe<Scalars['Int']['input']>;
  SampleShippingProfile?: InputMaybe<Scalars['Int']['input']>;
  SampleStock?: InputMaybe<Scalars['Int']['input']>;
  ShippingProfile?: InputMaybe<Scalars['Int']['input']>;
  SortOrder?: InputMaybe<Scalars['Int']['input']>;
  Stock?: InputMaybe<Scalars['Int']['input']>;
  StockType?: InputMaybe<VariantStockTypeEnum>;
  SupplierSKU?: InputMaybe<Scalars['StringInput']['input']>;
  TradeOnlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  TradePrice?: InputMaybe<Scalars['Int']['input']>;
};

export type VariantOptionGroupInput = {
  Attribute: Scalars['Int']['input'];
  Options: Array<Scalars['Int']['input']>;
};

export type VariantShipping = {
  __typename?: 'VariantShipping';
  ID: Scalars['String']['output'];
  Quantity: Scalars['Int']['output'];
  ShippingCost: CurrencyAmount;
  ShippingCostText: Scalars['String']['output'];
  ShippingMethod: ShippingMethod;
};

export type VariantShippingsConnection = {
  __typename?: 'VariantShippingsConnection';
  ID: Scalars['String']['output'];
  edges: Array<VariantShippingsConnectionEdge>;
  nodes: Array<VariantShipping>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type VariantShippingsConnectionEdge = {
  __typename?: 'VariantShippingsConnectionEdge';
  /** The node at the end of the collections edge */
  node: VariantShipping;
};

export type VariantStock = {
  __typename?: 'VariantStock';
  AllowPickup?: Maybe<Scalars['Boolean']['output']>;
  AllowPostal?: Maybe<Scalars['Boolean']['output']>;
  ID: Scalars['Int']['output'];
  LastChecked?: Maybe<Scalars['String']['output']>;
  LowStockThreshold: Scalars['Int']['output'];
  SampleStock: Scalars['Int']['output'];
  Stock: Scalars['Int']['output'];
  Variant?: Maybe<Variant>;
};

export enum VariantStockTypeEnum {
  InStock = 'InStock',
  Indent = 'Indent',
  MadeToOrder = 'MadeToOrder'
}

export type VersionsSimpleSortFields = {
  version?: InputMaybe<SortDirection>;
};

export type VideoColumn = ModuleColumn & SortableItem & {
  __typename?: 'VideoColumn';
  ColumnDimension?: Maybe<ColumnDimension>;
  ID: Scalars['Int']['output'];
  IsEmpty: Scalars['Boolean']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleID: Scalars['Int']['output'];
  ProductID?: Maybe<Scalars['Int']['output']>;
  ReadOnly: Scalars['Boolean']['output'];
  Video?: Maybe<LibraryVideo>;
  WordCount: Scalars['Int']['output'];
};

export type VideoModule = ModuleType & {
  __typename?: 'VideoModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  AutoPlay?: Maybe<Scalars['Boolean']['output']>;
  AutoPlayRedirect?: Maybe<Scalars['String']['output']>;
  AutoPlayRedirectRequireLogin?: Maybe<Scalars['Boolean']['output']>;
  ExternalVideoLink?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  PlaysInline?: Maybe<Scalars['Boolean']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
  VideoCover?: Maybe<ResponsiveVariantImage>;
  VideoID?: Maybe<Scalars['String']['output']>;
  VideoPlatform?: Maybe<Scalars['String']['output']>;
};

export type VideoParagraphModule = FlexibleModule & {
  __typename?: 'VideoParagraphModule';
  Columns: ColumnsConnection;
  ContentAreaID: Scalars['Int']['output'];
  CreatedFromID?: Maybe<Scalars['Int']['output']>;
  CreatedFromVersion?: Maybe<Scalars['Int']['output']>;
  DetachedFromSavedModule?: Maybe<Scalars['Boolean']['output']>;
  EcommerceEnabled: Scalars['Boolean']['output'];
  ID: Scalars['Int']['output'];
  LibraryItemID: Scalars['Int']['output'];
  MemberSortOrder: Scalars['Int']['output'];
  ModuleGroup?: Maybe<ModuleGroupEnum>;
  PossibleColumnDimensions: Array<ColumnDimension>;
  PresetName: Scalars['String']['output'];
  PresetType: FlexibleModuleEnum;
  SortableColumns: Scalars['Boolean']['output'];
  Swappable: Scalars['Boolean']['output'];
};


export type VideoParagraphModuleColumnsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ColumnsSortFields>;
};

export type VideosConnection = {
  __typename?: 'VideosConnection';
  edges: Array<VideosConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type VideosConnectionEdge = {
  __typename?: 'VideosConnectionEdge';
  /** The node at the end of the collections edge */
  node: LibraryVideo;
};

export type VideosSortFields = {
  Created?: InputMaybe<SortDirection>;
  Featured?: InputMaybe<SortDirection>;
  MemberSortOrder?: InputMaybe<SortDirection>;
  SortOrder?: InputMaybe<SortDirection>;
  Title?: InputMaybe<SortDirection>;
  Type?: InputMaybe<SortDirection>;
};

export type WebsiteEvent = {
  Action: Scalars['String']['input'];
  Created: Scalars['Int']['input'];
  EventID: Scalars['String']['input'];
  MemberID: Scalars['Int']['input'];
  Professional: Scalars['String']['input'];
  Resource: Scalars['String']['input'];
  ResourceID: Scalars['String']['input'];
};

export type WebsiteNotification = DesignBoardNotification | EnquiryNotification | GenericNotification | TeamMemberNotification;

export enum WebsiteNotificationAction {
  ContactDetailsRevealed = 'ContactDetailsRevealed',
  DesignBoardShared = 'DesignBoardShared',
  EnquiryConversationInviteAccepted = 'EnquiryConversationInviteAccepted',
  EnquiryConversationMemberInvited = 'EnquiryConversationMemberInvited',
  GenericNotification = 'GenericNotification',
  InviteAccepted = 'InviteAccepted',
  MemberInvited = 'MemberInvited',
  NewDesignBoardComment = 'NewDesignBoardComment',
  NewEnquiry = 'NewEnquiry',
  NewEnquiryComment = 'NewEnquiryComment',
  NewFollower = 'NewFollower',
  NewMemberUpload = 'NewMemberUpload',
  NewPin = 'NewPin',
  NewPinComment = 'NewPinComment',
  PinShared = 'PinShared',
  TeamMemberInvitationSent = 'TeamMemberInvitationSent'
}

export type WebsiteNotificationInterface = {
  Action: WebsiteNotificationAction;
  CreatedAt: Scalars['String']['output'];
  CreatedBy: Member;
  ID: Scalars['ID']['output'];
  IsRead: Scalars['Boolean']['output'];
  LastEdited: Scalars['String']['output'];
  PhotoTileURL?: Maybe<Scalars['String']['output']>;
};

export type WelcomeEvents_Connection = {
  __typename?: 'WelcomeEvents_Connection';
  edges: Array<WelcomeEvents_ConnectionEdge>;
  pageInfo: PageInfo;
};

/** The collections edge */
export type WelcomeEvents_ConnectionEdge = {
  __typename?: 'WelcomeEvents_ConnectionEdge';
  /** The node at the end of the collections edge */
  node: EventDetails;
};

export type WelcomeEvents_SortFields = {
  SortOrder?: InputMaybe<SortDirection>;
};

export type WelcomeModule = ModuleType & {
  __typename?: 'WelcomeModule';
  AnchorTag?: Maybe<Scalars['String']['output']>;
  BackgroundImages: BackgroundImages_Connection;
  /** URL of the background video */
  BackgroundVideo?: Maybe<Scalars['String']['output']>;
  CTA?: Maybe<SiteTreeLink>;
  /** Events for registration */
  Events: WelcomeEvents_Connection;
  ExtraCTAText?: Maybe<Scalars['String']['output']>;
  ExtraClass?: Maybe<Scalars['String']['output']>;
  ID: Scalars['ID']['output'];
  /** URL of the mobile background video (portrait mode) */
  MobileBackgroundVideo?: Maybe<Scalars['String']['output']>;
  NavigationLabel?: Maybe<Scalars['String']['output']>;
  PhotographyCredits?: Maybe<Scalars['String']['output']>;
  Slogan?: Maybe<Scalars['String']['output']>;
  SpacingBelow?: Maybe<Scalars['String']['output']>;
  SpacingBelowMobile?: Maybe<Scalars['String']['output']>;
  SponsorLogo?: Maybe<LibraryImageFile>;
  ThemeColour: ThemedElementColourType;
  Title?: Maybe<Scalars['String']['output']>;
  TitleImageDesktop?: Maybe<LibraryImageFile>;
  TitleImageMobile?: Maybe<LibraryImageFile>;
};


export type WelcomeModuleBackgroundImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<BackgroundImages_SortFields>;
};


export type WelcomeModuleEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<WelcomeEvents_SortFields>;
};

export type WooCommerceSyncCounts = {
  __typename?: 'WooCommerceSyncCounts';
  Imported: Scalars['Int']['output'];
  Total: Scalars['Int']['output'];
};

export type WooCommerceSyncStatus = SyncStatus & {
  __typename?: 'WooCommerceSyncStatus';
  /** @deprecated No longer provided */
  BulkImportID?: Maybe<Scalars['String']['output']>;
  Errors: Array<ImportError>;
  Finished: Scalars['Boolean']['output'];
  RequestID: Scalars['String']['output'];
  StartedTimestamp?: Maybe<Scalars['Int']['output']>;
  SuccessfullySyncedCount: Scalars['Int']['output'];
  TotalProcessed: Scalars['Int']['output'];
  TotalToSync?: Maybe<Scalars['Int']['output']>;
};

export type WooCommerceTag = {
  __typename?: 'WooCommerceTag';
  ID: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
  Slug: Scalars['String']['output'];
};

export type YearAndMonthsType = {
  __typename?: 'YearAndMonthsType';
  Months: Array<Scalars['Int']['output']>;
  Year: Scalars['Int']['output'];
};

export type YearAndMonthsTypeConnection = {
  __typename?: 'YearAndMonthsTypeConnection';
  ID: Scalars['String']['output'];
  edges: Array<YearAndMonthsTypeConnectionEdge>;
  nodes: Array<YearAndMonthsType>;
  pageInfo: ApPageInfo;
};

/** The collections edge */
export type YearAndMonthsTypeConnectionEdge = {
  __typename?: 'YearAndMonthsTypeConnectionEdge';
  /** The node at the end of the collections edge */
  node: YearAndMonthsType;
};

export type Zone = {
  __typename?: 'Zone';
  Country: Country;
};

export type CurrentMemberFragment = { __typename?: 'Me', ID: number, APID: string, ArchiproProfilePage: string, Company: string, Email: string, FirstName: string, HashedEmail: string, IsActive: boolean, LastName: string, Initials?: string | null, IsArchiproStaff: boolean, IsStaffAdmin: boolean, IsHighAdmin: boolean, IsLeadershipTeam: boolean, Name: string, Phone: string, ProfileImage: string, ProfileImageComments: string, Region: string, Suburb?: string | null, TempPassword: boolean, Website: string, ProfessionalType: string, UserType: string, EcommerceBookingURL: string, ProfileImageLink?: string | null, JobTitle?: string | null, AgeGroup?: string | null, BuildStatus?: string | null, When?: string | null, Where?: string | null, Budget?: string | null, Style?: string | null, Section?: boolean | null, Permissions: Array<PermissionEnum>, PostSignupQuestionnaireSeen: boolean, OnboardingDismissed?: string | null, UserClassification?: UserClassificationType | null, MfaType?: MfaConfigEnumType | null, OrderNotificationCount: number, HasNonPersonalBuildHubAccess: boolean, Professionals: Array<{ __typename?: 'MemberProfessional', ID: number, Title: string, URLSegment: string, Link: string, CanEdit: boolean, HasInboxAccess: boolean, CompanyLogo: string, CompanyLogo48Resized?: string | null, CompanyLogo96Resized?: string | null, LogoBackgroundColor?: string | null, AnalyticsEnabled: boolean, EcommerceEnabled: boolean, Website: string, Country: string, IsCloned: boolean, HasClones: boolean, IsManufacturer: boolean, BusinessFocus: string, ServiceableAreasCount: number, AnalyticsStatus: AnalyticsStatusEnum, StripeAccountEnabled: boolean, LibraryLocationsCount: number, HasEcommerceEmail: boolean, PrimaryDomain: string, MetaData: { __typename?: 'ProfessionalMetaData', AverageScore: number }, TradePricing: Array<{ __typename?: 'SpecialtyRateCategories', ID: number, TradeProductRate: number, TradeSampleRate: number }>, HubspotCompany?: { __typename?: 'HubspotCompany', ClientDirectorTeamMember?: { __typename?: 'TeamMember', ID: number, Name: string, JobTitle?: string | null, Email: string, Phone?: string | null, MemberImage?: { __typename?: 'MemberImage', ID: number, LargeAvatar?: string | null, TeamMemberDisplay?: string | null } | null } | null } | null, Network?: { __typename?: 'OrganizationNetwork', id: string, participants: { __typename?: 'OrganizationNetworkParticipantConnection', nodes: Array<{ __typename?: 'OrganizationNetworkParticipant', identity: { __typename?: 'Professional', ID: number, Title: string, CompanyLogo?: string | null, LogoBackgroundColor?: string | null } }> } } | null }>, MemberImage?: { __typename?: 'MemberImage', ID: number, FileName?: string | null, LargeAvatar?: string | null } | null, TeamMembers: Array<{ __typename?: 'TeamMember', ID: number, Permissions: Array<PermissionEnum>, TeamPermissions: Array<BusinessManagementActions>, TeamMemberRoles: Array<{ __typename?: 'TeamMemberRole', ID: number, Name: string }>, Professional: { __typename?: 'Professional', ID: number, Permissions: Array<PermissionEnum>, AnalyticsStatus: AnalyticsStatusEnum, Country: string, ProductsAllowed: boolean, URLSegment: string, Title: string, Link: string, CompanyLogo?: string | null, CompanyLogo48Resized?: string | null, CompanyLogo96Resized?: string | null, LogoBackgroundColor?: string | null, HasRunningAds: boolean, EcommerceEnabled: boolean, Categories: Array<{ __typename?: 'Category', ID: number }> } }>, ProfessionalCategory?: { __typename?: 'ProfessionalCategory', ID: number, Title: string } | null, FeatureFlags: Array<{ __typename?: 'FeatureFlag', Name: string, Enabled: boolean, Title: string, CanToggle: boolean, ToggleArgs: string }>, TrackedGuest?: { __typename?: 'Guest', ID: number } | null, LastViewedBuildHub?: { __typename: 'BuildHub', ID: string, Title: string, URLSegment: string, IsPersonalWorkspace: boolean } | null, OwnedBuildHubs: Array<{ __typename: 'BuildHub', ID: string, Title: string, URLSegment: string, IsPersonalWorkspace: boolean }> };

export type GuestUserFragment = { __typename?: 'Guest', ID: number, APID: string, EcommerceBookingURL: string, FeatureFlags: Array<{ __typename?: 'FeatureFlag', Name: string, Enabled: boolean }> };

export type GetMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberQuery = { __typename?: 'Query', getMember:
    | { __typename?: 'Guest', ID: number, APID: string, EcommerceBookingURL: string, FeatureFlags: Array<{ __typename?: 'FeatureFlag', Name: string, Enabled: boolean }> }
    | { __typename?: 'Me', ID: number, APID: string, ArchiproProfilePage: string, Company: string, Email: string, FirstName: string, HashedEmail: string, IsActive: boolean, LastName: string, Initials?: string | null, IsArchiproStaff: boolean, IsStaffAdmin: boolean, IsHighAdmin: boolean, IsLeadershipTeam: boolean, Name: string, Phone: string, ProfileImage: string, ProfileImageComments: string, Region: string, Suburb?: string | null, TempPassword: boolean, Website: string, ProfessionalType: string, UserType: string, EcommerceBookingURL: string, ProfileImageLink?: string | null, JobTitle?: string | null, AgeGroup?: string | null, BuildStatus?: string | null, When?: string | null, Where?: string | null, Budget?: string | null, Style?: string | null, Section?: boolean | null, Permissions: Array<PermissionEnum>, PostSignupQuestionnaireSeen: boolean, OnboardingDismissed?: string | null, UserClassification?: UserClassificationType | null, MfaType?: MfaConfigEnumType | null, OrderNotificationCount: number, HasNonPersonalBuildHubAccess: boolean, Professionals: Array<{ __typename?: 'MemberProfessional', ID: number, Title: string, URLSegment: string, Link: string, CanEdit: boolean, HasInboxAccess: boolean, CompanyLogo: string, CompanyLogo48Resized?: string | null, CompanyLogo96Resized?: string | null, LogoBackgroundColor?: string | null, AnalyticsEnabled: boolean, EcommerceEnabled: boolean, Website: string, Country: string, IsCloned: boolean, HasClones: boolean, IsManufacturer: boolean, BusinessFocus: string, ServiceableAreasCount: number, AnalyticsStatus: AnalyticsStatusEnum, StripeAccountEnabled: boolean, LibraryLocationsCount: number, HasEcommerceEmail: boolean, PrimaryDomain: string, MetaData: { __typename?: 'ProfessionalMetaData', AverageScore: number }, TradePricing: Array<{ __typename?: 'SpecialtyRateCategories', ID: number, TradeProductRate: number, TradeSampleRate: number }>, HubspotCompany?: { __typename?: 'HubspotCompany', ClientDirectorTeamMember?: { __typename?: 'TeamMember', ID: number, Name: string, JobTitle?: string | null, Email: string, Phone?: string | null, MemberImage?: { __typename?: 'MemberImage', ID: number, LargeAvatar?: string | null, TeamMemberDisplay?: string | null } | null } | null } | null, Network?: { __typename?: 'OrganizationNetwork', id: string, participants: { __typename?: 'OrganizationNetworkParticipantConnection', nodes: Array<{ __typename?: 'OrganizationNetworkParticipant', identity: { __typename?: 'Professional', ID: number, Title: string, CompanyLogo?: string | null, LogoBackgroundColor?: string | null } }> } } | null }>, MemberImage?: { __typename?: 'MemberImage', ID: number, FileName?: string | null, LargeAvatar?: string | null } | null, TeamMembers: Array<{ __typename?: 'TeamMember', ID: number, Permissions: Array<PermissionEnum>, TeamPermissions: Array<BusinessManagementActions>, TeamMemberRoles: Array<{ __typename?: 'TeamMemberRole', ID: number, Name: string }>, Professional: { __typename?: 'Professional', ID: number, Permissions: Array<PermissionEnum>, AnalyticsStatus: AnalyticsStatusEnum, Country: string, ProductsAllowed: boolean, URLSegment: string, Title: string, Link: string, CompanyLogo?: string | null, CompanyLogo48Resized?: string | null, CompanyLogo96Resized?: string | null, LogoBackgroundColor?: string | null, HasRunningAds: boolean, EcommerceEnabled: boolean, Categories: Array<{ __typename?: 'Category', ID: number }> } }>, ProfessionalCategory?: { __typename?: 'ProfessionalCategory', ID: number, Title: string } | null, FeatureFlags: Array<{ __typename?: 'FeatureFlag', Name: string, Enabled: boolean, Title: string, CanToggle: boolean, ToggleArgs: string }>, TrackedGuest?: { __typename?: 'Guest', ID: number } | null, LastViewedBuildHub?: { __typename: 'BuildHub', ID: string, Title: string, URLSegment: string, IsPersonalWorkspace: boolean } | null, OwnedBuildHubs: Array<{ __typename: 'BuildHub', ID: string, Title: string, URLSegment: string, IsPersonalWorkspace: boolean }> }
   };
